webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Snappy = {

  init: function init() {
    document.addEventListener('DOMContentLoaded', this.onDOMLoaded.bind(this));
    (0, _jquery2.default)(window).on('content:updated', this.renderComponents.bind(this));
  },

  onDOMLoaded: function onDOMLoaded(event) {
    this.renderComponents();
  },

  renderComponents: function renderComponents() {
    var _this = this;

    var _loop = function _loop(key) {
      var elements = document.querySelectorAll('[data-' + _this.Component[key].tagName + ']:not([data-defer-snappy])');
      elements = Array.prototype.slice.call(elements);

      elements.forEach(function (element) {
        var isInited = element.getAttribute('data-' + this.Component[key].tagName + '-inited');

        if (typeof isInited === 'string') {
          return;
        }

        var component = new this.Component[key](element);
        element.component = component;
        element.setAttribute('data-' + this.Component[key].tagName + '-inited', '');
        component.render();
      }.bind(_this));
    };

    for (var key in this.Component) {
      _loop(key);
    }
  },

  Component: {},

  BaseComponent: function BaseComponent(element) {
    _classCallCheck(this, BaseComponent);

    this.element = element;

    if (_jquery2.default) {
      this.$element = (0, _jquery2.default)(element);
      this.$window = (0, _jquery2.default)(window);
      this.$body = (0, _jquery2.default)('body');
    }
  }

};

exports.default = Snappy;

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.BrowserSpriteSymbol = factory());
}(this, (function () { 'use strict';

var SpriteSymbol = function SpriteSymbol(ref) {
  var id = ref.id;
  var viewBox = ref.viewBox;
  var content = ref.content;

  this.id = id;
  this.viewBox = viewBox;
  this.content = content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.stringify = function stringify () {
  return this.content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.toString = function toString () {
  return this.stringify();
};

SpriteSymbol.prototype.destroy = function destroy () {
    var this$1 = this;

  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
};

/**
 * @param {string} content
 * @return {Element}
 */
var parse = function (content) {
  var hasImportNode = !!document.importNode;
  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;

  /**
   * Fix for browser which are throwing WrongDocumentError
   * if you insert an element which is not part of the document
   * @see http://stackoverflow.com/a/7986519/4624403
   */
  if (hasImportNode) {
    return document.importNode(doc, true);
  }

  return doc;
};

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var deepmerge = createCommonjsModule(function (module, exports) {
(function (root, factory) {
    if (false) {
        undefined(factory);
    } else {
        module.exports = factory();
    }
}(commonjsGlobal, function () {

function isMergeableObject(val) {
    var nonNullObject = val && typeof val === 'object';

    return nonNullObject
        && Object.prototype.toString.call(val) !== '[object RegExp]'
        && Object.prototype.toString.call(val) !== '[object Date]'
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var array = Array.isArray(source);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var arrayMerge = options.arrayMerge || defaultArrayMerge;

    if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

return deepmerge

}));
});

var namespaces_1 = createCommonjsModule(function (module, exports) {
var namespaces = {
  svg: {
    name: 'xmlns',
    uri: 'http://www.w3.org/2000/svg'
  },
  xlink: {
    name: 'xmlns:xlink',
    uri: 'http://www.w3.org/1999/xlink'
  }
};

exports.default = namespaces;
module.exports = exports.default;
});

/**
 * @param {Object} attrs
 * @return {string}
 */
var objectToAttrsString = function (attrs) {
  return Object.keys(attrs).map(function (attr) {
    var value = attrs[attr].toString().replace(/"/g, '&quot;');
    return (attr + "=\"" + value + "\"");
  }).join(' ');
};

var svg = namespaces_1.svg;
var xlink = namespaces_1.xlink;

var defaultAttrs = {};
defaultAttrs[svg.name] = svg.uri;
defaultAttrs[xlink.name] = xlink.uri;

/**
 * @param {string} [content]
 * @param {Object} [attributes]
 * @return {string}
 */
var wrapInSvgString = function (content, attributes) {
  if ( content === void 0 ) content = '';

  var attrs = deepmerge(defaultAttrs, attributes || {});
  var attrsRendered = objectToAttrsString(attrs);
  return ("<svg " + attrsRendered + ">" + content + "</svg>");
};

var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
  function BrowserSpriteSymbol () {
    SpriteSymbol$$1.apply(this, arguments);
  }

  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;

  var prototypeAccessors = { isMounted: {} };

  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * @param {Element} node
   * @return {BrowserSpriteSymbol}
   */
  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
    return new BrowserSpriteSymbol({
      id: node.getAttribute('id'),
      viewBox: node.getAttribute('viewBox'),
      content: node.outerHTML
    });
  };

  BrowserSpriteSymbol.prototype.destroy = function destroy () {
    if (this.isMounted) {
      this.unmount();
    }
    SpriteSymbol$$1.prototype.destroy.call(this);
  };

  /**
   * @param {Element|string} target
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.mount = function mount (target) {
    if (this.isMounted) {
      return this.node;
    }

    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
    var node = this.render();
    this.node = node;

    mountTarget.appendChild(node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.render = function render () {
    var content = this.stringify();
    return parse(wrapInSvgString(content)).childNodes[0];
  };

  BrowserSpriteSymbol.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );

  return BrowserSpriteSymbol;
}(SpriteSymbol));

return BrowserSpriteSymbol;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.BrowserSprite = factory());
}(this, (function () { 'use strict';

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var index = createCommonjsModule(function (module, exports) {
(function (root, factory) {
    if (false) {
        undefined(factory);
    } else {
        module.exports = factory();
    }
}(commonjsGlobal, function () {

function isMergeableObject(val) {
    var nonNullObject = val && typeof val === 'object';

    return nonNullObject
        && Object.prototype.toString.call(val) !== '[object RegExp]'
        && Object.prototype.toString.call(val) !== '[object Date]'
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var array = Array.isArray(source);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var arrayMerge = options.arrayMerge || defaultArrayMerge;

    if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

return deepmerge

}));
});

//      
// An event handler can take an optional event argument
// and should not return a value
                                          
// An array of all currently registered event handlers for a type
                                            
// A map of event types and their corresponding event handlers.
                        
                                   
  

/** Mitt: Tiny (~200b) functional event emitter / pubsub.
 *  @name mitt
 *  @returns {Mitt}
 */
function mitt(all                 ) {
	all = all || Object.create(null);

	return {
		/**
		 * Register an event handler for the given type.
		 *
		 * @param  {String} type	Type of event to listen for, or `"*"` for all events
		 * @param  {Function} handler Function to call in response to given event
		 * @memberOf mitt
		 */
		on: function on(type        , handler              ) {
			(all[type] || (all[type] = [])).push(handler);
		},

		/**
		 * Remove an event handler for the given type.
		 *
		 * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
		 * @param  {Function} handler Handler function to remove
		 * @memberOf mitt
		 */
		off: function off(type        , handler              ) {
			if (all[type]) {
				all[type].splice(all[type].indexOf(handler) >>> 0, 1);
			}
		},

		/**
		 * Invoke all handlers for the given type.
		 * If present, `"*"` handlers are invoked after type-matched handlers.
		 *
		 * @param {String} type  The event type to invoke
		 * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
		 * @memberof mitt
		 */
		emit: function emit(type        , evt     ) {
			(all[type] || []).map(function (handler) { handler(evt); });
			(all['*'] || []).map(function (handler) { handler(type, evt); });
		}
	};
}

var namespaces_1 = createCommonjsModule(function (module, exports) {
var namespaces = {
  svg: {
    name: 'xmlns',
    uri: 'http://www.w3.org/2000/svg'
  },
  xlink: {
    name: 'xmlns:xlink',
    uri: 'http://www.w3.org/1999/xlink'
  }
};

exports.default = namespaces;
module.exports = exports.default;
});

/**
 * @param {Object} attrs
 * @return {string}
 */
var objectToAttrsString = function (attrs) {
  return Object.keys(attrs).map(function (attr) {
    var value = attrs[attr].toString().replace(/"/g, '&quot;');
    return (attr + "=\"" + value + "\"");
  }).join(' ');
};

var svg = namespaces_1.svg;
var xlink = namespaces_1.xlink;

var defaultAttrs = {};
defaultAttrs[svg.name] = svg.uri;
defaultAttrs[xlink.name] = xlink.uri;

/**
 * @param {string} [content]
 * @param {Object} [attributes]
 * @return {string}
 */
var wrapInSvgString = function (content, attributes) {
  if ( content === void 0 ) content = '';

  var attrs = index(defaultAttrs, attributes || {});
  var attrsRendered = objectToAttrsString(attrs);
  return ("<svg " + attrsRendered + ">" + content + "</svg>");
};

var svg$1 = namespaces_1.svg;
var xlink$1 = namespaces_1.xlink;

var defaultConfig = {
  attrs: ( obj = {
    style: ['position: absolute', 'width: 0', 'height: 0'].join('; ')
  }, obj[svg$1.name] = svg$1.uri, obj[xlink$1.name] = xlink$1.uri, obj )
};
var obj;

var Sprite = function Sprite(config) {
  this.config = index(defaultConfig, config || {});
  this.symbols = [];
};

/**
 * Add new symbol. If symbol with the same id exists it will be replaced.
 * @param {SpriteSymbol} symbol
 * @return {boolean} `true` - symbol was added, `false` - replaced
 */
Sprite.prototype.add = function add (symbol) {
  var ref = this;
    var symbols = ref.symbols;
  var existing = this.find(symbol.id);

  if (existing) {
    symbols[symbols.indexOf(existing)] = symbol;
    return false;
  }

  symbols.push(symbol);
  return true;
};

/**
 * Remove symbol & destroy it
 * @param {string} id
 * @return {boolean} `true` - symbol was found & successfully destroyed, `false` - otherwise
 */
Sprite.prototype.remove = function remove (id) {
  var ref = this;
    var symbols = ref.symbols;
  var symbol = this.find(id);

  if (symbol) {
    symbols.splice(symbols.indexOf(symbol), 1);
    symbol.destroy();
    return true;
  }

  return false;
};

/**
 * @param {string} id
 * @return {SpriteSymbol|null}
 */
Sprite.prototype.find = function find (id) {
  return this.symbols.filter(function (s) { return s.id === id; })[0] || null;
};

/**
 * @param {string} id
 * @return {boolean}
 */
Sprite.prototype.has = function has (id) {
  return this.find(id) !== null;
};

/**
 * @return {string}
 */
Sprite.prototype.stringify = function stringify () {
  var ref = this.config;
    var attrs = ref.attrs;
  var stringifiedSymbols = this.symbols.map(function (s) { return s.stringify(); }).join('');
  return wrapInSvgString(stringifiedSymbols, attrs);
};

/**
 * @return {string}
 */
Sprite.prototype.toString = function toString () {
  return this.stringify();
};

Sprite.prototype.destroy = function destroy () {
  this.symbols.forEach(function (s) { return s.destroy(); });
};

var SpriteSymbol = function SpriteSymbol(ref) {
  var id = ref.id;
  var viewBox = ref.viewBox;
  var content = ref.content;

  this.id = id;
  this.viewBox = viewBox;
  this.content = content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.stringify = function stringify () {
  return this.content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.toString = function toString () {
  return this.stringify();
};

SpriteSymbol.prototype.destroy = function destroy () {
    var this$1 = this;

  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
};

/**
 * @param {string} content
 * @return {Element}
 */
var parse = function (content) {
  var hasImportNode = !!document.importNode;
  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;

  /**
   * Fix for browser which are throwing WrongDocumentError
   * if you insert an element which is not part of the document
   * @see http://stackoverflow.com/a/7986519/4624403
   */
  if (hasImportNode) {
    return document.importNode(doc, true);
  }

  return doc;
};

var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
  function BrowserSpriteSymbol () {
    SpriteSymbol$$1.apply(this, arguments);
  }

  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;

  var prototypeAccessors = { isMounted: {} };

  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * @param {Element} node
   * @return {BrowserSpriteSymbol}
   */
  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
    return new BrowserSpriteSymbol({
      id: node.getAttribute('id'),
      viewBox: node.getAttribute('viewBox'),
      content: node.outerHTML
    });
  };

  BrowserSpriteSymbol.prototype.destroy = function destroy () {
    if (this.isMounted) {
      this.unmount();
    }
    SpriteSymbol$$1.prototype.destroy.call(this);
  };

  /**
   * @param {Element|string} target
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.mount = function mount (target) {
    if (this.isMounted) {
      return this.node;
    }

    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
    var node = this.render();
    this.node = node;

    mountTarget.appendChild(node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.render = function render () {
    var content = this.stringify();
    return parse(wrapInSvgString(content)).childNodes[0];
  };

  BrowserSpriteSymbol.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );

  return BrowserSpriteSymbol;
}(SpriteSymbol));

var defaultConfig$1 = {
  /**
   * Should following options be automatically configured:
   * - `syncUrlsWithBaseTag`
   * - `locationChangeAngularEmitter`
   * - `moveGradientsOutsideSymbol`
   * @type {boolean}
   */
  autoConfigure: true,

  /**
   * Default mounting selector
   * @type {string}
   */
  mountTo: 'body',

  /**
   * Fix disappearing SVG elements when <base href> exists.
   * Executes when sprite mounted.
   * @see http://stackoverflow.com/a/18265336/796152
   * @see https://github.com/everdimension/angular-svg-base-fix
   * @see https://github.com/angular/angular.js/issues/8934#issuecomment-56568466
   * @type {boolean}
   */
  syncUrlsWithBaseTag: false,

  /**
   * Should sprite listen custom location change event
   * @type {boolean}
   */
  listenLocationChangeEvent: true,

  /**
   * Custom window event name which should be emitted to update sprite urls
   * @type {string}
   */
  locationChangeEvent: 'locationChange',

  /**
   * Emit location change event in Angular automatically
   * @type {boolean}
   */
  locationChangeAngularEmitter: false,

  /**
   * Selector to find symbols usages when updating sprite urls
   * @type {string}
   */
  usagesToUpdate: 'use[*|href]',

  /**
   * Fix Firefox bug when gradients and patterns don't work if they are within a symbol.
   * Executes when sprite is rendered, but not mounted.
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=306674
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=353575
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1235364
   * @type {boolean}
   */
  moveGradientsOutsideSymbol: false
};

/**
 * @param {*} arrayLike
 * @return {Array}
 */
var arrayFrom = function (arrayLike) {
  return Array.prototype.slice.call(arrayLike, 0);
};

var ua = navigator.userAgent;

var browser = {
  isChrome: /chrome/i.test(ua),
  isFirefox: /firefox/i.test(ua),

  // https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
  isIE: /msie/i.test(ua) || /trident/i.test(ua),
  isEdge: /edge/i.test(ua)
};

/**
 * @param {string} name
 * @param {*} data
 */
var dispatchEvent = function (name, data) {
  var event = document.createEvent('CustomEvent');
  event.initCustomEvent(name, false, false, data);
  window.dispatchEvent(event);
};

/**
 * IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
 * This trick will trigger IE to read and use any existing SVG <style> tags.
 * @see https://github.com/iconic/SVGInjector/issues/23
 * @see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10898469/
 *
 * @param {Element} node DOM Element to search <style> tags in
 * @return {Array<HTMLStyleElement>}
 */
var evalStylesIEWorkaround = function (node) {
  var updatedNodes = [];

  arrayFrom(node.querySelectorAll('style'))
    .forEach(function (style) {
      style.textContent += '';
      updatedNodes.push(style);
    });

  return updatedNodes;
};

/**
 * @param {string} [url] If not provided - current URL will be used
 * @return {string}
 */
var getUrlWithoutFragment = function (url) {
  return (url || window.location.href).split('#')[0];
};

/* global angular */
/**
 * @param {string} eventName
 */
var locationChangeAngularEmitter = function (eventName) {
  angular.module('ng').run(['$rootScope', function ($rootScope) {
    $rootScope.$on('$locationChangeSuccess', function (e, newUrl, oldUrl) {
      dispatchEvent(eventName, { oldUrl: oldUrl, newUrl: newUrl });
    });
  }]);
};

var defaultSelector = 'linearGradient, radialGradient, pattern';

/**
 * @param {Element} svg
 * @param {string} [selector]
 * @return {Element}
 */
var moveGradientsOutsideSymbol = function (svg, selector) {
  if ( selector === void 0 ) selector = defaultSelector;

  arrayFrom(svg.querySelectorAll('symbol')).forEach(function (symbol) {
    arrayFrom(symbol.querySelectorAll(selector)).forEach(function (node) {
      symbol.parentNode.insertBefore(node, symbol);
    });
  });
  return svg;
};

/**
 * @param {NodeList} nodes
 * @param {Function} [matcher]
 * @return {Attr[]}
 */
function selectAttributes(nodes, matcher) {
  var attrs = arrayFrom(nodes).reduce(function (acc, node) {
    if (!node.attributes) {
      return acc;
    }

    var arrayfied = arrayFrom(node.attributes);
    var matched = matcher ? arrayfied.filter(matcher) : arrayfied;
    return acc.concat(matched);
  }, []);

  return attrs;
}

/**
 * @param {NodeList|Node} nodes
 * @param {boolean} [clone=true]
 * @return {string}
 */

var xLinkNS = namespaces_1.xlink.uri;
var xLinkAttrName = 'xlink:href';

// eslint-disable-next-line no-useless-escape
var specialUrlCharsPattern = /[{}|\\\^\[\]`"<>]/g;

function encoder(url) {
  return url.replace(specialUrlCharsPattern, function (match) {
    return ("%" + (match[0].charCodeAt(0).toString(16).toUpperCase()));
  });
}

/**
 * @param {NodeList} nodes
 * @param {string} startsWith
 * @param {string} replaceWith
 * @return {NodeList}
 */
function updateReferences(nodes, startsWith, replaceWith) {
  arrayFrom(nodes).forEach(function (node) {
    var href = node.getAttribute(xLinkAttrName);
    if (href && href.indexOf(startsWith) === 0) {
      var newUrl = href.replace(startsWith, replaceWith);
      node.setAttributeNS(xLinkNS, xLinkAttrName, newUrl);
    }
  });

  return nodes;
}

/**
 * List of SVG attributes to update url() target in them
 */
var attList = [
  'clipPath',
  'colorProfile',
  'src',
  'cursor',
  'fill',
  'filter',
  'marker',
  'markerStart',
  'markerMid',
  'markerEnd',
  'mask',
  'stroke',
  'style'
];

var attSelector = attList.map(function (attr) { return ("[" + attr + "]"); }).join(',');

/**
 * Update URLs in svg image (like `fill="url(...)"`) and update referencing elements
 * @param {Element} svg
 * @param {NodeList} references
 * @param {string|RegExp} startsWith
 * @param {string} replaceWith
 * @return {void}
 *
 * @example
 * const sprite = document.querySelector('svg.sprite');
 * const usages = document.querySelectorAll('use');
 * updateUrls(sprite, usages, '#', 'prefix#');
 */
var updateUrls = function (svg, references, startsWith, replaceWith) {
  var startsWithEncoded = encoder(startsWith);
  var replaceWithEncoded = encoder(replaceWith);

  var nodes = svg.querySelectorAll(attSelector);
  var attrs = selectAttributes(nodes, function (ref) {
    var localName = ref.localName;
    var value = ref.value;

    return attList.indexOf(localName) !== -1 && value.indexOf(("url(" + startsWithEncoded)) !== -1;
  });

  attrs.forEach(function (attr) { return attr.value = attr.value.replace(startsWithEncoded, replaceWithEncoded); });
  updateReferences(references, startsWithEncoded, replaceWithEncoded);
};

/**
 * Internal emitter events
 * @enum
 * @private
 */
var Events = {
  MOUNT: 'mount',
  SYMBOL_MOUNT: 'symbol_mount'
};

var BrowserSprite = (function (Sprite$$1) {
  function BrowserSprite(cfg) {
    var this$1 = this;
    if ( cfg === void 0 ) cfg = {};

    Sprite$$1.call(this, index(defaultConfig$1, cfg));

    var emitter = mitt();
    this._emitter = emitter;
    this.node = null;

    var ref = this;
    var config = ref.config;

    if (config.autoConfigure) {
      this._autoConfigure(cfg);
    }

    if (config.syncUrlsWithBaseTag) {
      var baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
      emitter.on(Events.MOUNT, function () { return this$1.updateUrls('#', baseUrl); });
    }

    var handleLocationChange = this._handleLocationChange.bind(this);
    this._handleLocationChange = handleLocationChange;

    // Provide way to update sprite urls externally via dispatching custom window event
    if (config.listenLocationChangeEvent) {
      window.addEventListener(config.locationChangeEvent, handleLocationChange);
    }

    // Emit location change event in Angular automatically
    if (config.locationChangeAngularEmitter) {
      locationChangeAngularEmitter(config.locationChangeEvent);
    }

    // After sprite mounted
    emitter.on(Events.MOUNT, function (spriteNode) {
      if (config.moveGradientsOutsideSymbol) {
        moveGradientsOutsideSymbol(spriteNode);
      }
    });

    // After symbol mounted into sprite
    emitter.on(Events.SYMBOL_MOUNT, function (symbolNode) {
      if (config.moveGradientsOutsideSymbol) {
        moveGradientsOutsideSymbol(symbolNode.parentNode);
      }

      if (browser.isIE || browser.isEdge) {
        evalStylesIEWorkaround(symbolNode);
      }
    });
  }

  if ( Sprite$$1 ) BrowserSprite.__proto__ = Sprite$$1;
  BrowserSprite.prototype = Object.create( Sprite$$1 && Sprite$$1.prototype );
  BrowserSprite.prototype.constructor = BrowserSprite;

  var prototypeAccessors = { isMounted: {} };

  /**
   * @return {boolean}
   */
  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * Automatically configure following options
   * - `syncUrlsWithBaseTag`
   * - `locationChangeAngularEmitter`
   * - `moveGradientsOutsideSymbol`
   * @param {Object} cfg
   * @private
   */
  BrowserSprite.prototype._autoConfigure = function _autoConfigure (cfg) {
    var ref = this;
    var config = ref.config;

    if (typeof cfg.syncUrlsWithBaseTag === 'undefined') {
      config.syncUrlsWithBaseTag = typeof document.getElementsByTagName('base')[0] !== 'undefined';
    }

    if (typeof cfg.locationChangeAngularEmitter === 'undefined') {
      config.locationChangeAngularEmitter = 'angular' in window;
    }

    if (typeof cfg.moveGradientsOutsideSymbol === 'undefined') {
      config.moveGradientsOutsideSymbol = browser.isFirefox;
    }
  };

  /**
   * @param {Event} event
   * @param {Object} event.detail
   * @param {string} event.detail.oldUrl
   * @param {string} event.detail.newUrl
   * @private
   */
  BrowserSprite.prototype._handleLocationChange = function _handleLocationChange (event) {
    var ref = event.detail;
    var oldUrl = ref.oldUrl;
    var newUrl = ref.newUrl;
    this.updateUrls(oldUrl, newUrl);
  };

  /**
   * Add new symbol. If symbol with the same id exists it will be replaced.
   * If sprite already mounted - `symbol.mount(sprite.node)` will be called.
   * @fires Events#SYMBOL_MOUNT
   * @param {BrowserSpriteSymbol} symbol
   * @return {boolean} `true` - symbol was added, `false` - replaced
   */
  BrowserSprite.prototype.add = function add (symbol) {
    var sprite = this;
    var isNewSymbol = Sprite$$1.prototype.add.call(this, symbol);

    if (this.isMounted && isNewSymbol) {
      symbol.mount(sprite.node);
      this._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
    }

    return isNewSymbol;
  };

  /**
   * Attach to existing DOM node
   * @param {string|Element} target
   * @return {Element|null} attached DOM Element. null if node to attach not found.
   */
  BrowserSprite.prototype.attach = function attach (target) {
    var this$1 = this;

    var sprite = this;

    if (sprite.isMounted) {
      return sprite.node;
    }

    /** @type Element */
    var node = typeof target === 'string' ? document.querySelector(target) : target;
    sprite.node = node;

    // Already added symbols needs to be mounted
    this.symbols.forEach(function (symbol) {
      symbol.mount(sprite.node);
      this$1._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
    });

    // Create symbols from existing DOM nodes, add and mount them
    arrayFrom(node.querySelectorAll('symbol'))
      .forEach(function (symbolNode) {
        var symbol = BrowserSpriteSymbol.createFromExistingNode(symbolNode);
        symbol.node = symbolNode; // hack to prevent symbol mounting to sprite when adding
        sprite.add(symbol);
      });

    this._emitter.emit(Events.MOUNT, node);

    return node;
  };

  BrowserSprite.prototype.destroy = function destroy () {
    var ref = this;
    var config = ref.config;
    var symbols = ref.symbols;
    var _emitter = ref._emitter;

    symbols.forEach(function (s) { return s.destroy(); });

    _emitter.off('*');
    window.removeEventListener(config.locationChangeEvent, this._handleLocationChange);

    if (this.isMounted) {
      this.unmount();
    }
  };

  /**
   * @fires Events#MOUNT
   * @param {string|Element} [target]
   * @param {boolean} [prepend=false]
   * @return {Element|null} rendered sprite node. null if mount node not found.
   */
  BrowserSprite.prototype.mount = function mount (target, prepend) {
    if ( target === void 0 ) target = this.config.mountTo;
    if ( prepend === void 0 ) prepend = false;

    var sprite = this;

    if (sprite.isMounted) {
      return sprite.node;
    }

    var mountNode = typeof target === 'string' ? document.querySelector(target) : target;
    var node = sprite.render();
    this.node = node;

    if (prepend && mountNode.childNodes[0]) {
      mountNode.insertBefore(node, mountNode.childNodes[0]);
    } else {
      mountNode.appendChild(node);
    }

    this._emitter.emit(Events.MOUNT, node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSprite.prototype.render = function render () {
    return parse(this.stringify());
  };

  /**
   * Detach sprite from the DOM
   */
  BrowserSprite.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  /**
   * Update URLs in sprite and usage elements
   * @param {string} oldUrl
   * @param {string} newUrl
   * @return {boolean} `true` - URLs was updated, `false` - sprite is not mounted
   */
  BrowserSprite.prototype.updateUrls = function updateUrls$1 (oldUrl, newUrl) {
    if (!this.isMounted) {
      return false;
    }

    var usages = document.querySelectorAll(this.config.usagesToUpdate);

    updateUrls(
      this.node,
      usages,
      ((getUrlWithoutFragment(oldUrl)) + "#"),
      ((getUrlWithoutFragment(newUrl)) + "#")
    );

    return true;
  };

  Object.defineProperties( BrowserSprite.prototype, prototypeAccessors );

  return BrowserSprite;
}(Sprite));

var ready$1 = createCommonjsModule(function (module) {
/*!
  * domready (c) Dustin Diaz 2014 - License MIT
  */
!function (name, definition) {

  { module.exports = definition(); }

}('domready', function () {

  var fns = [], listener
    , doc = document
    , hack = doc.documentElement.doScroll
    , domContentLoaded = 'DOMContentLoaded'
    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);


  if (!loaded)
  { doc.addEventListener(domContentLoaded, listener = function () {
    doc.removeEventListener(domContentLoaded, listener);
    loaded = 1;
    while (listener = fns.shift()) { listener(); }
  }); }

  return function (fn) {
    loaded ? setTimeout(fn, 0) : fns.push(fn);
  }

});
});

var spriteNodeId = '__SVG_SPRITE_NODE__';
var spriteGlobalVarName = '__SVG_SPRITE__';
var isSpriteExists = !!window[spriteGlobalVarName];

// eslint-disable-next-line import/no-mutable-exports
var sprite;

if (isSpriteExists) {
  sprite = window[spriteGlobalVarName];
} else {
  sprite = new BrowserSprite({ attrs: { id: spriteNodeId } });
  window[spriteGlobalVarName] = sprite;
}

var loadSprite = function () {
  /**
   * Check for page already contains sprite node
   * If found - attach to and reuse it's content
   * If not - render and mount the new sprite
   */
  var existing = document.getElementById(spriteNodeId);

  if (existing) {
    sprite.attach(existing);
  } else {
    sprite.mount(document.body, true);
  }
};

if (document.body) {
  loadSprite();
} else {
  ready$1(loadSprite);
}

var sprite$1 = sprite;

return sprite$1;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _modernizr = __webpack_require__(27);

var _modernizr2 = _interopRequireDefault(_modernizr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resized = false,
    resizeTimer = null,
    timeoutTime = 150,
    App = {};

function initResize() {
    setGlobalVars();
    (0, _jquery2.default)(window).on('resize', resizeProcessing);
    (0, _jquery2.default)(window).on('orientationchange', resizeProcessing);

    App.resize = resizeAfterProcessing.bind(this, true);
}

function setGlobalVars() {
    App.isTouch = _modernizr2.default.touchevents;
    App.isWinPhone = !!('ontouchstart' in window || navigator.msMaxTouchPoints) && navigator.userAgent.match(/Windows Phone/i);
    App.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    resizeAfterProcessing(true);
}

function resizeProcessing() {
    if (resizeTimer !== null) {
        clearTimeout(resizeTimer);
    }
    resized = true;
    resizeAfterProcessing();
}

function resizeAfterProcessing(notTrigger) {
    if (resized === true) {
        resized = false;
        resizeTimer = setTimeout(resizeAfterProcessing, timeoutTime);
        return;
    }

    var $window = (0, _jquery2.default)(window),
        width = $window.outerWidth(),
        height = $window.outerHeight();
    if (width == App.width && height == App.height) {
        return;
    }

    _extends(App, {
        width: width,
        height: height,
        orientation: typeof window.orientation === "undefined" || Math.abs(window.orientation) === 90 ? "landscape" : "portrait",
        isWidest: _modernizr2.default.mq('only screen and (min-width:1500px)'),
        isDesktop: _modernizr2.default.mq('only screen and (min-width:1025px)'),
        isTablet: _modernizr2.default.mq('only screen and (min-width:769px)'),
        isPhoneLandscape: _modernizr2.default.mq('only screen and (min-width:641px)')
    });

    if (typeof notTrigger != 'undefined' && notTrigger === true) {
        return;
    }

    $window.trigger('resize:finished');
}

initResize();

exports.default = App;

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ('data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');
//# sourceMappingURL=gif.js.map

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_platform__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_platform__);

// sugar for https://github.com/bestiejs/platform.js
// make sure to ALWAYS reference the layout engine,
// even if it is not necessary for the condition,
// as this makes grepping for this stuff simpler



// deep clone of original platform
var platform = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0_platform___default.a));

// operating system
var os = platform.os.family || '';
var ANDROID = os === 'Android';
var WINDOWS = os.slice(0, 7) === 'Windows';
var OSX = os === 'OS X';
var IOS = os === 'iOS';

// layout
var BLINK = platform.layout === 'Blink';
var GECKO = platform.layout === 'Gecko';
var TRIDENT = platform.layout === 'Trident';
var EDGE = platform.layout === 'EdgeHTML';
var WEBKIT = platform.layout === 'WebKit';

// browser version (not layout engine version!)
var version = parseFloat(platform.version);
var majorVersion = Math.floor(version);
platform.majorVersion = majorVersion;

platform.is = {
  // operating system
  ANDROID: ANDROID,
  WINDOWS: WINDOWS,
  OSX: OSX,
  IOS: IOS,
  // layout
  BLINK: BLINK, // "Chrome", "Chrome Mobile", "Opera"
  GECKO: GECKO, // "Firefox"
  TRIDENT: TRIDENT, // "Internet Explorer"
  EDGE: EDGE, // "Microsoft Edge"
  WEBKIT: WEBKIT, // "Safari"
  // INTERNET EXPLORERS
  IE9: TRIDENT && majorVersion === 9,
  IE10: TRIDENT && majorVersion === 10,
  IE11: TRIDENT && majorVersion === 11
};

/* harmony default export */ __webpack_exports__["a"] = (platform);
//# sourceMappingURL=platform.js.map

/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__element_focus_svg_foreign_object_hack__ = __webpack_require__(167);
/* harmony export (immutable) */ __webpack_exports__["a"] = generate;
/* unused harmony export focus */
/* harmony export (immutable) */ __webpack_exports__["b"] = validate;



function generate(element) {
  return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' + element + '</svg>';
}

function focus(element) {
  if (element.focus) {
    return;
  }

  try {
    HTMLElement.prototype.focus.call(element);
  } catch (e) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__element_focus_svg_foreign_object_hack__["a" /* default */])(element);
  }
}

function validate(element, focusTarget, _document) {
  focus(focusTarget);
  return _document.activeElement === focusTarget;
}
//# sourceMappingURL=svg.js.map

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports) {

;(function(window){
var hadGlobal = 'Modernizr' in window;
var oldGlobal = window.Modernizr;
/*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-appearance-csstransforms3d-customevent-flexbox-flexboxlegacy-smil-touchevents-mq-prefixed-setclasses-shiv !*/
!function(e,t,n){function r(e,t){return typeof e===t}function o(){var e,t,n,o,i,a,s;for(var l in S)if(S.hasOwnProperty(l)){if(e=[],t=S[l],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(o=r(t.fn,"function")?t.fn():t.fn,i=0;i<e.length;i++)a=e[i],s=a.split("."),1===s.length?Modernizr[s[0]]=o:(!Modernizr[s[0]]||Modernizr[s[0]]instanceof Boolean||(Modernizr[s[0]]=new Boolean(Modernizr[s[0]])),Modernizr[s[0]][s[1]]=o),x.push((o?"":"no-")+s.join("-"))}}function i(e){var t=b.className,n=Modernizr._config.classPrefix||"";if(E&&(t=t.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(r,"$1"+n+"js$2")}Modernizr._config.enableClasses&&(t+=" "+n+e.join(" "+n),E?b.className.baseVal=t:b.className=t)}function a(e,t){return!!~(""+e).indexOf(t)}function s(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):E?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function l(){var e=t.body;return e||(e=s(E?"svg":"body"),e.fake=!0),e}function u(e,n,r,o){var i,a,u,c,f="modernizr",d=s("div"),p=l();if(parseInt(r,10))for(;r--;)u=s("div"),u.id=o?o[r]:f+(r+1),d.appendChild(u);return i=s("style"),i.type="text/css",i.id="s"+f,(p.fake?p:d).appendChild(i),p.appendChild(d),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(t.createTextNode(e)),d.id=f,p.fake&&(p.style.background="",p.style.overflow="hidden",c=b.style.overflow,b.style.overflow="hidden",b.appendChild(p)),a=n(d,e),p.fake?(p.parentNode.removeChild(p),b.style.overflow=c,b.offsetHeight):d.parentNode.removeChild(d),!!a}function c(e){return e.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase()}).replace(/^ms-/,"-ms-")}function f(t,n,r){var o;if("getComputedStyle"in e){o=getComputedStyle.call(e,t,n);var i=e.console;if(null!==o)r&&(o=o.getPropertyValue(r));else if(i){var a=i.error?"error":"log";i[a].call(i,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else o=!n&&t.currentStyle&&t.currentStyle[r];return o}function d(t,r){var o=t.length;if("CSS"in e&&"supports"in e.CSS){for(;o--;)if(e.CSS.supports(c(t[o]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var i=[];o--;)i.push("("+c(t[o])+":"+r+")");return i=i.join(" or "),u("@supports ("+i+") { #modernizr { position: absolute; } }",function(e){return"absolute"==f(e,null,"position")})}return n}function p(e){return e.replace(/([a-z])-([a-z])/g,function(e,t,n){return t+n.toUpperCase()}).replace(/^-/,"")}function m(e,t,o,i){function l(){c&&(delete z.style,delete z.modElem)}if(i=r(i,"undefined")?!1:i,!r(o,"undefined")){var u=d(e,o);if(!r(u,"undefined"))return u}for(var c,f,m,h,v,g=["modernizr","tspan","samp"];!z.style&&g.length;)c=!0,z.modElem=s(g.shift()),z.style=z.modElem.style;for(m=e.length,f=0;m>f;f++)if(h=e[f],v=z.style[h],a(h,"-")&&(h=p(h)),z.style[h]!==n){if(i||r(o,"undefined"))return l(),"pfx"==t?h:!0;try{z.style[h]=o}catch(y){}if(z.style[h]!=v)return l(),"pfx"==t?h:!0}return l(),!1}function h(e,t){return function(){return e.apply(t,arguments)}}function v(e,t,n){var o;for(var i in e)if(e[i]in t)return n===!1?e[i]:(o=t[e[i]],r(o,"function")?h(o,n||t):o);return!1}function g(e,t,n,o,i){var a=e.charAt(0).toUpperCase()+e.slice(1),s=(e+" "+_.join(a+" ")+a).split(" ");return r(t,"string")||r(t,"undefined")?m(s,t,o,i):(s=(e+" "+N.join(a+" ")+a).split(" "),v(s,t,n))}function y(e,t,r){return g(e,n,n,t,r)}var S=[],C={_version:"3.5.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){S.push({name:e,fn:t,options:n})},addAsyncTest:function(e){S.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=C,Modernizr=new Modernizr;var x=[],b=t.documentElement,E="svg"===b.nodeName.toLowerCase();E||!function(e,t){function n(e,t){var n=e.createElement("p"),r=e.getElementsByTagName("head")[0]||e.documentElement;return n.innerHTML="x<style>"+t+"</style>",r.insertBefore(n.lastChild,r.firstChild)}function r(){var e=S.elements;return"string"==typeof e?e.split(" "):e}function o(e,t){var n=S.elements;"string"!=typeof n&&(n=n.join(" ")),"string"!=typeof e&&(e=e.join(" ")),S.elements=n+" "+e,u(t)}function i(e){var t=y[e[v]];return t||(t={},g++,e[v]=g,y[g]=t),t}function a(e,n,r){if(n||(n=t),f)return n.createElement(e);r||(r=i(n));var o;return o=r.cache[e]?r.cache[e].cloneNode():h.test(e)?(r.cache[e]=r.createElem(e)).cloneNode():r.createElem(e),!o.canHaveChildren||m.test(e)||o.tagUrn?o:r.frag.appendChild(o)}function s(e,n){if(e||(e=t),f)return e.createDocumentFragment();n=n||i(e);for(var o=n.frag.cloneNode(),a=0,s=r(),l=s.length;l>a;a++)o.createElement(s[a]);return o}function l(e,t){t.cache||(t.cache={},t.createElem=e.createElement,t.createFrag=e.createDocumentFragment,t.frag=t.createFrag()),e.createElement=function(n){return S.shivMethods?a(n,e,t):t.createElem(n)},e.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+r().join().replace(/[\w\-:]+/g,function(e){return t.createElem(e),t.frag.createElement(e),'c("'+e+'")'})+");return n}")(S,t.frag)}function u(e){e||(e=t);var r=i(e);return!S.shivCSS||c||r.hasCSS||(r.hasCSS=!!n(e,"article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),f||l(e,r),e}var c,f,d="3.7.3",p=e.html5||{},m=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,h=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,v="_html5shiv",g=0,y={};!function(){try{var e=t.createElement("a");e.innerHTML="<xyz></xyz>",c="hidden"in e,f=1==e.childNodes.length||function(){t.createElement("a");var e=t.createDocumentFragment();return"undefined"==typeof e.cloneNode||"undefined"==typeof e.createDocumentFragment||"undefined"==typeof e.createElement}()}catch(n){c=!0,f=!0}}();var S={elements:p.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",version:d,shivCSS:p.shivCSS!==!1,supportsUnknownElements:f,shivMethods:p.shivMethods!==!1,type:"default",shivDocument:u,createElement:a,createDocumentFragment:s,addElements:o};e.html5=S,u(t),"object"==typeof module&&module.exports&&(module.exports=S)}("undefined"!=typeof e?e:this,t);var w="Moz O ms Webkit",_=C._config.usePrefixes?w.split(" "):[];C._cssomPrefixes=_;var T={elem:s("modernizr")};Modernizr._q.push(function(){delete T.elem});var z={style:T.elem.style};Modernizr._q.unshift(function(){delete z.style});var N=C._config.usePrefixes?w.toLowerCase().split(" "):[];C._domPrefixes=N,C.testAllProps=g;var j=function(t){var r,o=D.length,i=e.CSSRule;if("undefined"==typeof i)return n;if(!t)return!1;if(t=t.replace(/^@/,""),r=t.replace(/-/g,"_").toUpperCase()+"_RULE",r in i)return"@"+t;for(var a=0;o>a;a++){var s=D[a],l=s.toUpperCase()+"_"+r;if(l in i)return"@-"+s.toLowerCase()+"-"+t}return!1};C.atRule=j;var k=(C.prefixed=function(e,t,n){return 0===e.indexOf("@")?j(e):(-1!=e.indexOf("-")&&(e=p(e)),t?g(e,t,n):g(e,"pfx"))},function(){var t=e.matchMedia||e.msMatchMedia;return t?function(e){var n=t(e);return n&&n.matches||!1}:function(t){var n=!1;return u("@media "+t+" { #modernizr { position: absolute; } }",function(t){n="absolute"==(e.getComputedStyle?e.getComputedStyle(t,null):t.currentStyle).position}),n}}());C.mq=k,C.testAllProps=y;var P=C.testStyles=u,F="CSS"in e&&"supports"in e.CSS,M="supportsCSS"in e;Modernizr.addTest("supports",F||M),Modernizr.addTest("csstransforms3d",function(){var e=!!y("perspective","1px",!0),t=Modernizr._config.usePrefixes;if(e&&(!t||"webkitPerspective"in b.style)){var n,r="#modernizr{width:0;height:0}";Modernizr.supports?n="@supports (perspective: 1px)":(n="@media (transform-3d)",t&&(n+=",(-webkit-transform-3d)")),n+="{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}",P(r+n,function(t){e=7===t.offsetWidth&&18===t.offsetHeight})}return e}),Modernizr.addTest("flexboxlegacy",y("boxDirection","reverse",!0)),Modernizr.addTest("flexbox",y("flexBasis","1px",!0));var D=C._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];C._prefixes=D,Modernizr.addTest("touchevents",function(){var n;if("ontouchstart"in e||e.DocumentTouch&&t instanceof DocumentTouch)n=!0;else{var r=["@media (",D.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");P(r,function(e){n=9===e.offsetTop})}return n}),Modernizr.addTest("appearance",y("appearance"));var L={}.toString;Modernizr.addTest("smil",function(){return!!t.createElementNS&&/SVGAnimate/.test(L.call(t.createElementNS("http://www.w3.org/2000/svg","animate")))}),Modernizr.addTest("customevent","CustomEvent"in e&&"function"==typeof e.CustomEvent),o(),i(x),delete C.addTest,delete C.addAsyncTest;for(var q=0;q<Modernizr._q.length;q++)Modernizr._q[q]();e.Modernizr=Modernizr}(window,document);
module.exports = window.Modernizr;
if (hadGlobal) { window.Modernizr = oldGlobal; }
else { delete window.Modernizr; }
})(window);

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.BackToTop = function (_Snappy$BaseComponent) {
	_inherits(BackToTop, _Snappy$BaseComponent);

	_createClass(BackToTop, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-back-to-top';
		}
	}]);

	function BackToTop(element) {
		_classCallCheck(this, BackToTop);

		return _possibleConstructorReturn(this, (BackToTop.__proto__ || Object.getPrototypeOf(BackToTop)).call(this, element));
	}

	_createClass(BackToTop, [{
		key: 'setVars',
		value: function setVars() {
			this.$backToTopButton = this.$element.find('.fa-back-to-top__button');
		}
	}, {
		key: 'addEventListeners',
		value: function addEventListeners() {
			this.$backToTopButton.on('click', this.onBackToTopButtonClick.bind(this));
		}
	}, {
		key: 'render',
		value: function render() {
			this.setVars();
			this.addEventListeners();
		}
	}, {
		key: 'onBackToTopButtonClick',
		value: function onBackToTopButtonClick() {
			(0, _jquery2.default)('body, html').animate({ scrollTop: 0 }, 800);
		}
	}]);

	return BackToTop;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(49);

var _resize = __webpack_require__(12);

var _resize2 = _interopRequireDefault(_resize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Carousel = function (_Snappy$BaseComponent) {
    _inherits(Carousel, _Snappy$BaseComponent);

    _createClass(Carousel, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-carousel';
        }
    }]);

    function Carousel(element) {
        _classCallCheck(this, Carousel);

        return _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, element));
    }

    _createClass(Carousel, [{
        key: 'setVars',
        value: function setVars() {
            this.isOn = true;
            this.$carousel = this.$element.find('.carousel');

            this.options = {
                arrows: this.$element.data('carouselArrows'),
                autoplay: this.$element.data('carouselAutoplay'),
                autoplaySpeed: this.$element.data('carouselAutoplaySpeed'),
                pauseOnHover: this.$element.data('carouselPauseOnHover'),
                dots: this.$element.data('carouselDots'),
                slidesToShow: this.$element.data('carouselSlidesToShow') || 1,
                slidesToScroll: this.$element.data('carouselSlidesToScroll') || 1,
                speed: this.$element.data('carouselSpeed'),
                fade: this.$element.data('carouselFade'),
                appendDots: this.$element.find(this.$element.data('carouselDotsContainer')),
                mobileFirst: this.$element.data('carouselMobileFirst'),
                adaptiveHeight: this.$element.data('carouselAdaptiveHeight'),
                accessibility: this.$element.data('carouselAccessibility') || false,
                touchThreshold: 10,
                variableWidth: this.$element.data('carouselVariableWidth'),
                centerMode: this.$element.data('carouselCenterMode'),
                infinite: this.$element.data('carouselInfinite'),
                draggable: this.$element.data('carouselDraggable'),

                //here are not slick options
                arrowsTheme: this.$element.data('carouselArrowsTheme'),
                dynamicArrowsColor: this.$element.data('carouselDynamicArrowsColor'),
                mobileOn: this.$element.data('mobileOn') !== undefined ? this.$element.data('mobileOn') : true,
                tabletOn: this.$element.data('tabletOn') !== undefined ? this.$element.data('tabletOn') : true,
                desktopOn: this.$element.data('desktopOn') !== undefined ? this.$element.data('desktopOn') : true
            };

            if (this.$element.data('carouselResponsive')) {
                if (this.$element.data('carouselResponsiveUnslick') !== undefined) {
                    this.options.responsive = [{
                        breakpoint: parseInt(this.$element.data('carouselResponsiveBreakpoint'), 10),
                        settings: 'unslick'
                    }];
                } else {
                    this.options.responsive = this.getResponsiveBreakpointConfig(this.$element.data('carouselResponsiveBreakpoint'), this.$element.data('carouselResponsiveSlidesToShow'), this.$element.data('carouselResponsiveSlidesToScroll'));
                }
            }
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            (0, _jquery2.default)(window).on('resize:finished', this.onResize.bind(this));

            if (this.options.dynamicArrowsColor) {
                this.$carousel.on('afterChange', this.setArrowsColor.bind(this));
            }

            this.$carousel.on('swipe', this.swipeHandler.bind(this));
        }
    }, {
        key: 'getResponsiveBreakpointConfig',
        value: function getResponsiveBreakpointConfig(breakpoints, slidesToShow, slidesToScroll) {
            var responsiveBreakpoints = [];

            breakpoints = breakpoints.toString().split(',');

            slidesToShow = slidesToShow ? slidesToShow = slidesToShow.toString().split(',') : [];
            slidesToScroll = slidesToScroll ? slidesToScroll.toString().split(',') : [];

            _jquery2.default.each(breakpoints, function (i, breakpoint) {
                responsiveBreakpoints.push({
                    breakpoint: parseInt(breakpoint, 10),
                    settings: {
                        slidesToShow: parseFloat(slidesToShow[i], 10) || 1,
                        slidesToScroll: parseFloat(slidesToScroll[i], 10) || 1
                    }
                });
            });

            return responsiveBreakpoints;
        }
    }, {
        key: 'initCarousel',
        value: function initCarousel() {
            this.setArrowsTheme();

            if (this.$element.data('carouselDeferInit')) {
                return false;
            }

            if (this.$carousel.hasClass('slick-initialized') && !this.isOn) {
                this.$carousel.slick('unslick');
            }

            if (!this.$carousel.hasClass('slick-initialized') && this.isOn) {
                this.$carousel.slick(this.options);
            }

            this.setArrowsColor();
        }
    }, {
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.onResize();
        }
    }, {
        key: 'setArrowsTheme',
        value: function setArrowsTheme() {
            if (!this.options.arrowsTheme) {
                return;
            }
            switch (this.options.arrowsTheme) {
                case 'cfa':
                    this.options.prevArrow = '<button\n                class="slick-prev"\n                type="button"\n                title="Previous Slide"\n                aria-label="Previous Slide"\n                data-gtm-on = "click"\n                data-gtm-category="' + Carousel.currentSection + '"\n                data-gtm-action="Carousel Arrow"\n                data-gtm-label = "Previous Slide">\n                        <svg role="img" aria-label="Description of your SVG image"  class="icon icon-arrow" width="12" height="20" aria-hidden="true" focusable="false">\n                            <use xlink:href="#icon-chevron-left"></use>\n                        </svg>\n                    </button>';
                    this.options.nextArrow = '<button\n                class="slick-next"\n                type="button"\n                title="Next Slide"\n                aria-label="Next Slide"\n                data-gtm-on = "click"\n                data-gtm-category="' + Carousel.currentSection + '"\n                data-gtm-action="Carousel Arrow"\n                data-gtm-label = "Next Slide">\n                        <svg role="img" aria-label="Description of your SVG image"  class="icon icon-arrow" width="12" height="20" aria-hidden="true" focusable="false">\n                            <use xlink:href="#icon-chevron-right"></use>\n                        </svg>\n                    </button>';
                    break;

                case 'edu':
                    this.options.prevArrow = '<button\n                class="slick-prev js-arrow-left"\n                title="Previous Slide test"\n                aria-label="Previous Slide "\n                data-gtm-on = "click"\n                data-gtm-event-category="' + Carousel.currentSection + '"\n                data-gtm-event-action="Carousel Arrow"\n                data-gtm-event-label = "Previous Slide"\n                tabindex="-1">\n                        <svg role="img" aria-label="Description of your SVG image"  class="icon icon-arrow" width="16" height="28" aria-hidden="true" focusable="false">\n                            <use xlink:href="#icon-chevron-left-thin"></use>\n                        </svg>\n                    </button>';
                    this.options.nextArrow = '<button\n                class="slick-next js-arrow-right"\n                title="Next Slide test"\n                aria-label="Next Slide"\n                data-gtm-on = "click"\n                data-gtm-event-category="' + Carousel.currentSection + '"\n                data-gtm-event-action="Carousel Arrow"\n                data-gtm-event-label = "Next Slide"\n                tabindex="-1">\n                        <svg role="img" aria-label="Description of your SVG image"  class="icon icon-arrow" width="16" height="28" aria-hidden="true" focusable="false">\n                            <use xlink:href="#icon-chevron-right-thin"></use>\n                        </svg>\n                    </button>';
                    break;
            }
        }
    }, {
        key: 'setArrowsColor',
        value: function setArrowsColor() {
            if (!this.options.dynamicArrowsColor) {
                return;
            }

            var $activeSlide = this.$carousel.find('.slick-active');
            var activeArrowColor = $activeSlide.data('arrowColor');
            this.$element.removeClass('white-arrows blue-arrows');

            switch (activeArrowColor) {
                case 'white':
                case 'opposite-blue':
                    this.$element.addClass('white-arrows');
                    break;
                case 'blue':
                case 'opposite-white':
                    this.$element.addClass('blue-arrows');
                    break;
            }
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            var isMobileOn = !_resize2.default.isTablet && this.options.mobileOn,
                isTabletOn = _resize2.default.isTablet && !_resize2.default.isDesktop && this.options.tabletOn,
                isDesktopOn = _resize2.default.isDesktop && this.options.desktopOn;
            this.isOn = isMobileOn || isTabletOn || isDesktopOn;

            this.initCarousel();
        }
    }, {
        key: 'swipeHandler',
        value: function swipeHandler(e, slick, direction) {
            (0, _jquery2.default)(window).trigger('gtm:send', [Carousel.currentSection, 'Carousel', 'Swipe ' + direction]);
        }
    }], [{
        key: 'currentSection',
        get: function get() {
            var mainNode = document.querySelector('#main-content');
            if (mainNode) {
                return mainNode.hasAttribute('data-current-section') ? mainNode.getAttribute('data-current-section') : '';
            }
            return '';
        }
    }]);

    return Carousel;
}(_snappy2.default.BaseComponent);

(0, _jquery2.default)(function () {
    (0, _jquery2.default)(window).resize(function () {
        (0, _jquery2.default)('div.strip-carousel .carousel').slick('resize');
    });

    // remove aria-live from slick-list
    setTimeout(function () {
        var slickList = [].concat(_toConsumableArray(document.querySelectorAll('.slick-list')));
        slickList.forEach(function (x) {
            x.removeAttribute('aria-live');
        });
    }, 500);
});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Cookie = function (_Snappy$BaseComponent) {
    _inherits(Cookie, _Snappy$BaseComponent);

    _createClass(Cookie, [{
        key: 'setVars',
        value: function setVars() {
            this.$button = this.$element.find('.accept-cta');
            this.cookieVisibilityKey = 'fa-cookie-visible';
            this.isCookieMessageVisible = this.getCookieMessageVisibility();
            this.activeClass = 'active';
            this.surveyVisibilityKey = 'fa-survey-visible';
            var surveyUniqueID = (0, _jquery2.default)('.SurveyUniqueID');
            if (surveyUniqueID.length) {
                this.SurveyUniqueID = surveyUniqueID.text();
            }
            this.surveyAlreadyActionedByUserKey = 'fa-survey-actioned' + this.SurveyUniqueID;
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$button.on('click', this.acceptCookies.bind(this));
        }
    }, {
        key: 'getCookieMessageVisibility',
        value: function getCookieMessageVisibility() {
            var visible = JSON.parse(localStorage.getItem(this.cookieVisibilityKey));

            if (visible === null) {
                // no preference stored, so message should be shown
                visible = true;
            }

            return visible;
        }
    }, {
        key: 'setCookieMessageVisibility',
        value: function setCookieMessageVisibility(visible) {
            localStorage.setItem(this.cookieVisibilityKey, visible);
        }
    }, {
        key: 'hideCookieMessage',
        value: function hideCookieMessage() {
            this.$element.removeClass(this.activeClass);
        }
    }], [{
        key: 'tagName',
        get: function get() {
            return 'fa-cookie';
        }
    }]);

    function Cookie(element) {
        _classCallCheck(this, Cookie);

        return _possibleConstructorReturn(this, (Cookie.__proto__ || Object.getPrototypeOf(Cookie)).call(this, element));
    }

    _createClass(Cookie, [{
        key: 'render',
        value: function render() {

            this.setVars();
            this.setEventListeners();
            this.showCookieMessage();
        }
    }, {
        key: 'showCookieMessage',
        value: function showCookieMessage() {

            if (this.isCookieMessageVisible) {
                this.$element.addClass(this.activeClass);
            } else {
                //alert("show survey");
                this.displaySurvey();
            }
        }
    }, {
        key: 'acceptCookies',
        value: function acceptCookies() {

            this.hideCookieMessage();
            this.setCookieMessageVisibility(false);
            this.displaySurvey();
        }
    }, {
        key: 'displaySurvey',
        value: function displaySurvey() {
            if (this.getSurveyAlreadyActionedByUser()) return; //User has already seen and accepted/declined the survey        

            var surveyVisible = localStorage.getItem(this.surveyVisibilityKey);
            if (surveyVisible != null && surveyVisible == 'True') {
                //alert("survey triggered in past");
                //user has already accepted the cookie in past and survey has been triggered
                this.incrementCurrentUserNumberAjax();
                this.getDisplaySurveyAfterTimeInSecondsAndDisplay();
            } else {
                //Triggered when user accepts the cookie
                //OR            
                //if cookie message has been accepted in another session and survey has not been shown yet
                //alert("accept cookie");
                var cookieAccepted = localStorage.getItem(this.cookieVisibilityKey);
                if (cookieAccepted != null && cookieAccepted != "True") //cookie has been accepted
                    {
                        var surveyEnabled = (0, _jquery2.default)('.survey-Enabled'); //Is survey enabled
                        if (surveyEnabled.length && surveyEnabled.text().toLowerCase() == "true") {
                            var displayToCurrentVisitor = (0, _jquery2.default)('.survey-DisplayToCurrentVisitor'); //Should survey be shown to current visitor
                            if (displayToCurrentVisitor.length && displayToCurrentVisitor.text().toLowerCase() == "true") {
                                localStorage.setItem(this.surveyVisibilityKey, "True"); //set survey localstorage to visible                
                                this.incrementCurrentUserNumberAjax();
                                this.getDisplaySurveyAfterTimeInSecondsAndDisplay();
                            }
                        }
                    }
            }
        }

        //Ajax call to get information from server

    }, {
        key: 'getDisplaySurveyAfterTimeInSecondsAndDisplay',
        value: function getDisplaySurveyAfterTimeInSecondsAndDisplay() {
            var serviceURL = (0, _jquery2.default)(".DisplaySurveyAfterInSecondsUrl").text();
            var displayAfterTimeInSurveyItemInSeconds = (0, _jquery2.default)('.survey-DisplayAfterTime').text();
            _jquery2.default.ajax({
                type: "GET",
                url: serviceURL,
                dataType: "json",
                data: { displayAfterTimeInSurveyItemInSeconds: displayAfterTimeInSurveyItemInSeconds },
                success: successFunc,
                error: errorFunc
            });
            function successFunc(returnedData) {
                var displayAfterTime = parseInt(returnedData);
                //alert('successCookie' + displayAfterTime);
                var survey = (0, _jquery2.default)('.fa-survey');
                setTimeout(function () {
                    survey.addClass('active');
                }, displayAfterTime);
            }

            function errorFunc(error, status) {
                //alert('error' + JSON.stringify(error));
                var survey = (0, _jquery2.default)('.fa-survey');
                survey.addClass('active'); //survey will be displayed immediately
            }
        }

        //Ajax call to increment user number

    }, {
        key: 'incrementCurrentUserNumberAjax',
        value: function incrementCurrentUserNumberAjax() {
            if (this.getCookie("sessionNew") != "false") {
                var successFunc = function successFunc(data, status) {
                    //alert('success' + data);
                };

                var errorFunc = function errorFunc(error, status) {
                    //alert('error' + JSON.stringify(status + "     " + error));
                };

                var serviceURL = (0, _jquery2.default)(".incrementCurrentUserNumberUrl").text();
                var websiteName = (0, _jquery2.default)('.SurveyWebsiteName').text();
                //alert(websiteName);
                _jquery2.default.ajax({
                    type: "GET",
                    url: serviceURL,
                    dataType: "json",
                    data: { websiteName: websiteName },
                    contentType: "application/json; charset=utf-8",
                    success: successFunc,
                    error: errorFunc
                });
            }
        }

        //This is browser document.cookie and not fa website cookie(which is based on concept of localstorage)

    }, {
        key: 'getCookie',
        value: function getCookie(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
    }, {
        key: 'getSurveyAlreadyActionedByUser',
        value: function getSurveyAlreadyActionedByUser() {

            var actioned = localStorage.getItem(this.surveyAlreadyActionedByUserKey);
            if (actioned != null && actioned == "True") {
                return true;
            }
            return false;
        }
    }]);

    return Cookie;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _handlebars = __webpack_require__(10);

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(48);

_snappy2.default.Component.Footer = function (_Snappy$BaseComponent) {
	_inherits(Footer, _Snappy$BaseComponent);

	_createClass(Footer, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-footer';
		}
	}]);

	function Footer(element) {
		_classCallCheck(this, Footer);

		return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, element));
	}

	_createClass(Footer, [{
		key: 'setVars',
		value: function setVars() {
			this.$newsletterForm = this.$element.find('.fa-footer__newsletter__form');
			this.$socialSelect = this.$element.find('.fa-dropdown__select');
			this.$newsletterResponseTemplate = (0, _jquery2.default)('#newsletter-response-template');
			this.activeClass = 'active';
			this.inactiveClass = 'inactive';
			this.submittedClass = 'submitted';
			this.errorClass = 'fa-input-field--error';
			this.messageClass = 'fa-input-field__error-message';
		}
	}, {
		key: 'setEventListeners',
		value: function setEventListeners() {
			this.$socialSelect.on('change', this.onSocialSelectChange.bind(this));
			this.$newsletterForm.on('submit', this.validateNewsletterForm.bind(this));

			if (this.$newsletterForm.length) {
				this.$window.on('modal:modalHasOpened', this.setNewsletterEventListeners.bind(this));
			}
		}
	}, {
		key: 'setNewsletterEventListeners',
		value: function setNewsletterEventListeners(event, modal) {
			modal.$element.find('.fa-footer__modal-form').on('submit', this.submitNewsletterSignup.bind(this, modal));
		}
	}, {
		key: 'validateNewsletterForm',
		value: function validateNewsletterForm(event) {
			var $emailField = this.$newsletterForm.find('input[type=email]');
			this.$newsletterForm.validate({
				rules: {
					'Email': {
						required: true,
						email: true
					}
				}
			});

			if ($emailField.valid()) {
				this.openNewsletterModal();
			} else {
				$emailField.focus();
			}

			event.preventDefault();
		}
	}, {
		key: 'handleValidationResponse',
		value: function handleValidationResponse(response) {
			if (response.success) {
				this.removeValidationError(response);
				this.openNewsletterModal();
			} else {
				this.showValidationError(response);
			}
		}
	}, {
		key: 'showValidationError',
		value: function showValidationError(response) {
			var $element = (0, _jquery2.default)('#' + response.element);

			$element.addClass(this.errorClass).parent().addClass(this.errorClass).find('.' + this.messageClass).text(response.message);
		}
	}, {
		key: 'removeValidationError',
		value: function removeValidationError(response) {
			var $element = (0, _jquery2.default)('#' + response.element);

			$element.removeClass(this.errorClass).parent('[data-fa-input-field]').removeClass(this.errorClass).find('.' + this.messageClass).text('');
		}
	}, {
		key: 'submitNewsletterSignup',
		value: function submitNewsletterSignup(modal, event) {
			var url = modal.$element.find('.fa-footer__modal-form').attr('action');
			var emailAddress = this.$newsletterForm.find('input[type=email]').val();
			var categories = modal.$element.find('input:checked').map(function (i, el) {
				return el.value;
			}).get().join();
			event.preventDefault();
			_jquery2.default.ajax({
				"url": url,
				"type": "post",
				"data": {
					"emailAddress": emailAddress,
					"categories": categories
				}
			}).always(this.handleNewsletterResponse.bind(this, modal));
		}
	}, {
		key: 'handleNewsletterResponse',
		value: function handleNewsletterResponse(modal, response) {
			var template = this.getNewsletterResponseTemplate();
			var responseHtml = template(response);
			var $error = (0, _jquery2.default)('.fa-footer__newsletter__modal-content').children('.' + this.messageClass);

			if (response.success) {
				this.closeNewsletterModal(modal);
				this.$newsletterForm.addClass(this.submittedClass).after(responseHtml);
			} else {
				$error.text(response.message).addClass(this.activeClass);
				$error[0].focus();
			}
		}
	}, {
		key: 'getNewsletterResponseTemplate',
		value: function getNewsletterResponseTemplate() {
			var template = void 0;

			if (this.$newsletterResponseTemplate) {
				template = _handlebars2.default.compile(this.$newsletterResponseTemplate.html());
			}

			return template;
		}
	}, {
		key: 'openNewsletterModal',
		value: function openNewsletterModal() {
			var $button = this.$newsletterForm.find('button');
			this.$window.trigger('modal:openModal', {
				$view: (0, _jquery2.default)($button.data('modal-template')),
				title: $button.data('modal-title'),
				$prevElement: $button
			});
		}
	}, {
		key: 'closeNewsletterModal',
		value: function closeNewsletterModal(modal) {
			modal.closeModal();
		}
	}, {
		key: 'hideSocialChannels',
		value: function hideSocialChannels() {
			this.$element.find('.fa-footer__social-channels__channel').addClass(this.inactiveClass);
		}
	}, {
		key: 'onSocialSelectChange',
		value: function onSocialSelectChange(event) {
			var section = event && event.currentTarget && event.currentTarget.value;
			if (section) {
				this.hideSocialChannels();
				this.$element.find('[data-social-section="' + section + '"]').removeClass(this.inactiveClass);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			this.setVars();
			this.setEventListeners();
			this.onSocialSelectChange({
				currentTarget: {
					value: this.$socialSelect.val()
				}
			});
		}
	}]);

	return Footer;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Modal = function (_Snappy$BaseComponent) {
    _inherits(Modal, _Snappy$BaseComponent);

    _createClass(Modal, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-modal';
        }
    }]);

    function Modal(element) {
        _classCallCheck(this, Modal);

        var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, element));

        _this.modalIsOpen = false;
        _this.modalOpenClass = 'fa-modal--modal-open';
        return _this;
    }

    _createClass(Modal, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.initModalService();

            (0, _jquery2.default)(function () {
                for (var child in document.body.children) {
                    if (!document.body.children.hasOwnProperty(child)) continue;

                    if (document.body.children[child].nodeName === 'svg') {
                        document.body.children[child].setAttribute('focusable', 'false');
                    }
                }
            });
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.focusableElements = [];
            this.$modalContents = this.$element.find('.js-modal-contents');
            this.$modalCloseButton = this.$element.find('.js-modal-close');
            this.$modalTitle = this.$element.find('.js-modal-title');
            this.$modalVideoDuration = this.$element.find('.js-modal-video-duration');
            this.$modalBase = this.$element.find('.js-modal-base');
            this.fullscreenClass = 'fullscreen';
        }
    }, {
        key: 'initModalService',
        value: function initModalService() {
            this.$window.on('modal:openModal', this.onOpenModalEvent.bind(this));
            this.$window.on('keyup', this.onKeyupEvent.bind(this));
            this.$modalCloseButton.on('click', this.onCloseModalButtonClick.bind(this));
            this.$modalBase.on('click', this.onModalBaseClick.bind(this));
        }
    }, {
        key: 'onOpenModalEvent',
        value: function onOpenModalEvent(event, options) {
            this.modalIsOpen = true;
            this.$previousFocusedElement = options.$prevElement;
            this.openModal(options);
        }
    }, {
        key: 'onKeyupEvent',
        value: function onKeyupEvent(event) {
            if (event && event.keyCode === 27 && this.modalIsOpen) {
                this.closeModal();
            }
        }
    }, {
        key: 'onCloseModalButtonClick',
        value: function onCloseModalButtonClick() {
            this.closeModal();
        }
    }, {
        key: 'openModal',
        value: function openModal(options) {
            var $template = options && options.$view;
            var title = options && options.title;
            var isFullscreen = options && options.fullscreen;
            var videoDuration = options && options.videoDuration;
            this.isUnclosable = options && options.unclosable;
            this.unclosableBase = options && options.unclosableBase;

            this.$body.addClass(this.modalOpenClass);
            this.$body.trigger('body:block');
            this.toggleFocusable(false);
            if ($template) {
                this.$modalContents.append($template.html());
                this.$modalTitle.text(title);
                this.$element.attr('tabindex', '0').focus();
                this.$window.trigger('modal:modalHasOpened', [this]);

                if (isFullscreen) {
                    this.$element.addClass(this.fullscreenClass);
                }
                if (this.$modalVideoDuration.length && videoDuration) {
                    this.$modalVideoDuration.text(videoDuration);
                }
            }

            (0, _jquery2.default)(window).trigger('content:updated');
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            if (this.isUnclosable) {
                this.redirect();
                return;
            }
            this.toggleFocusable(true);
            this.modalIsOpen = false;
            this.$body.removeClass(this.modalOpenClass);
            this.$body.trigger('body:unblock');
            this.$modalContents.empty();
            this.$modalVideoDuration.empty();
            this.$previousFocusedElement.focus();
            this.$element.removeClass(this.fullscreenClass);
        }
    }, {
        key: 'onModalBaseClick',
        value: function onModalBaseClick() {
            this.closeModal();
        }
    }, {
        key: 'toggleFocusable',
        value: function toggleFocusable(shouldFocus) {
            var focusableSelectors = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]'].join(',');

            if (!shouldFocus) {
                this.focusableElements = (0, _jquery2.default)('body').children(':not([data-fa-modal])').find(focusableSelectors).toArray();
            }

            this.focusableElements.forEach(function (element) {
                element.setAttribute('tabindex', shouldFocus ? '0' : '-1');
            });
        }
    }, {
        key: 'redirect',
        value: function redirect() {
            this.$modalCloseButton.attr('disabled', '');
            var redirectUrl = void 0;
            var matches = document.referrer.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
            var domain = matches && matches[1];
            if (domain && domain.indexOf('thefa.com') > -1) {
                redirectUrl = document.referrer;
            } else {
                redirectUrl = window.location.protocol + '//' + window.location.hostname + this.unclosableBase;
            }

            window.location.href = redirectUrl;
        }
    }]);

    return Modal;
}(_snappy2.default.BaseComponent);

_snappy2.default.Component.ModalTrigger = function (_Snappy$BaseComponent2) {
    _inherits(ModalTrigger, _Snappy$BaseComponent2);

    _createClass(ModalTrigger, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-modal-trigger';
        }
    }]);

    function ModalTrigger(element) {
        _classCallCheck(this, ModalTrigger);

        return _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, element));
    }

    _createClass(ModalTrigger, [{
        key: 'render',
        value: function render() {
            this.addEventListeners();
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            this.$element.on('click', this.onModalTriggerClick.bind(this));
        }
    }, {
        key: 'onModalTriggerClick',
        value: function onModalTriggerClick(event) {
            var $view = this.$body.find(this.$element.data('modal-template'));
            var modalTitle = this.$element.data('modal-title');
            var $prevElement = event && (0, _jquery2.default)(event.currentTarget);
            this.$window.trigger('modal:openModal', {
                $view: $view,
                title: modalTitle,
                $prevElement: $prevElement
            });
        }
    }]);

    return ModalTrigger;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.RowStrip = function (_Snappy$BaseComponent) {
	_inherits(RowStrip, _Snappy$BaseComponent);

	_createClass(RowStrip, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-row-strip';
		}
	}]);

	function RowStrip(element) {
		_classCallCheck(this, RowStrip);

		var _this = _possibleConstructorReturn(this, (RowStrip.__proto__ || Object.getPrototypeOf(RowStrip)).call(this, element));

		_this.backgroundImage = new Image();
		return _this;
	}

	_createClass(RowStrip, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.setStripDisplayRules();
			this.setEventListeners();
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.options = {
				images: {
					small: this.$element.data('smallImage'),
					large: this.$element.data('largeImage')
				},
				backgroundColor: this.$element.data('backgroundColor')
			};
		}
	}, {
		key: 'setEventListeners',
		value: function setEventListeners() {
			window.addEventListener('fa.viewportResize', this.setRelevantBackground.bind(this));
		}
	}, {
		key: 'setStripDisplayRules',
		value: function setStripDisplayRules() {
			if (this.options.images.small && this.options.images.large) {
				this.setRelevantBackground();
			} else {
				this.setStripColor();
			}
		}
	}, {
		key: 'setRelevantBackground',
		value: function setRelevantBackground() {

			/**
   * This functionality has a bug which results in the '--loaded' class not being added to elements with class '.fa-row-strip'.
   * This bug causes many components tobe left hidden on mobile
   *
   * The CSS transition for the 'fa-row-strip' class has been temporarily disabled until a fix can be found
   */

			this.imageToRequest = window.globalConfigs.viewportIsBelowLarge ? this.options.images.small : this.options.images.large;

			if (this.imageToRequest !== this.cachedImagePath) {
				this.backgroundImage.src = this.imageToRequest;
				this.backgroundImage.onload = this.onImageLoadedSuccess.bind(this);
				this.backgroundImage.onerror = this.fallbackToDefault.bind(this);

				this.cachedImagePath = this.imageToRequest;
			}
		}
	}, {
		key: 'onImageLoadedSuccess',
		value: function onImageLoadedSuccess() {
			this.$element.css({
				backgroundImage: 'url(' + this.imageToRequest + ')'
			});

			this.setStripReady();
		}
	}, {
		key: 'fallbackToDefault',
		value: function fallbackToDefault() {
			this.setStripReady();
		}
	}, {
		key: 'setStripReady',
		value: function setStripReady() {
			this.$element.addClass('fa-row-strip--loaded');
		}
	}, {
		key: 'setStripColor',
		value: function setStripColor() {
			var backgroundColor = this.options.backgroundColor;

			if (backgroundColor) {
				this.$element.css({
					backgroundColor: backgroundColor
				});
			}

			this.setStripReady();
		}
	}]);

	return RowStrip;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_node_array__ = __webpack_require__(215);



/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var context = _ref.context,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? 'context-to-element' : _ref$label,
      resolveDocument = _ref.resolveDocument,
      defaultToDocument = _ref.defaultToDocument;

  var element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_node_array__["a" /* default */])(context)[0];

  if (resolveDocument && element && element.nodeType === Node.DOCUMENT_NODE) {
    element = element.documentElement;
  }

  if (!element && defaultToDocument) {
    return document.documentElement;
  }

  if (!element) {
    throw new TypeError(label + ' requires valid options.context');
  }

  if (element.nodeType !== Node.ELEMENT_NODE && element.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
    throw new TypeError(label + ' requires options.context to be an Element');
  }

  return element;
});
//# sourceMappingURL=context-to-element.js.map

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(107);
var objectAssign = __webpack_require__(104);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Breadcrumbs = function (_Snappy$BaseComponent) {
	_inherits(Breadcrumbs, _Snappy$BaseComponent);

	_createClass(Breadcrumbs, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-breadcrumbs';
		}
	}]);

	function Breadcrumbs(element) {
		_classCallCheck(this, Breadcrumbs);

		return _possibleConstructorReturn(this, (Breadcrumbs.__proto__ || Object.getPrototypeOf(Breadcrumbs)).call(this, element));
	}

	_createClass(Breadcrumbs, [{
		key: 'render',
		value: function render() {}
	}]);

	return Breadcrumbs;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.InputField = function (_Snappy$BaseComponent) {
	_inherits(InputField, _Snappy$BaseComponent);

	_createClass(InputField, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-input-field';
		}
	}]);

	function InputField(element) {
		_classCallCheck(this, InputField);

		return _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).call(this, element));
	}

	_createClass(InputField, [{
		key: 'render',
		value: function render() {}
	}]);

	return InputField;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Navigation = function (_Snappy$BaseComponent) {
	_inherits(Navigation, _Snappy$BaseComponent);

	_createClass(Navigation, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-navigation';
		}
	}]);

	function Navigation(element) {
		_classCallCheck(this, Navigation);

		var _this = _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call(this, element));

		_this.menuIsActive = false;
		return _this;
	}

	_createClass(Navigation, [{
		key: 'setVars',
		value: function setVars() {
			this.$hamburgerButton = this.$element.find('.menu-icon');
			this.$listItems = this.$element.find('.more-available');
			this.$topbarListItems = this.$element.find('.more-content:not(.extramenu__social-dropdown)');
			this.$moreFaSitesButton = this.$element.find('.topbar__link.more-content');
			this.$returnButtons = this.$element.find('.global-navigation__return-button');
			this.$returnTopbarButtons = this.$element.find('.topbar__return-button');
			this.$toggleSearchButton = this.$element.find('.global-navigation__toggle-search');
			this.$searchInput = this.$element.find('.site-search__input');
			this.$faLogo = this.$element.find('.logo-container');
			this.$userLink = this.$element.find('.user-button');
			this.hiddenClass = 'hidden';
			this.activeItemClass = 'active-item';
			this.$userDetailsContainer = this.$element.find('.signin-menu');
			this.$userButton = this.$userDetailsContainer.find('.user-button');
			this.$navigationContainer = this.$element.find('.navigation-container');
			this.$siteSearchButton = this.$element.find('.site-search__button');
			this.$siteSearchInput = this.$element.find('.site-search__input');
			this.$siteSearchPositioner = this.$element.find('.navigation-container__searchbar');
			this.$siteSearchClose = this.$element.find('.site-search__close');
			this.$stickyListItem = this.$element.find('.global-navigation__primary-list-item.list-item--sticky a.global-navigation__primary-link').clone();
			this.stickyClonedItem = this.$element.find('.sticky-cloned-item');
		}
	}, {
		key: 'setEventListeners',
		value: function setEventListeners() {
			var onResizeEvent = (0, _underscore.throttle)(this.onViewportResize.bind(this), 200);
			var onScrollEvent = (0, _underscore.throttle)(this.onDocumentScroll.bind(this), 50);

			window.addEventListener('resize', onResizeEvent);
			window.addEventListener('scroll', onScrollEvent);
			window.addEventListener('keyup', this.onKeyupEvent.bind(this));
			this.$hamburgerButton.on('click', this.onHamburgerButtonClick.bind(this));
			this.$userLink.on('click', this.onUserLinkClick.bind(this));

			this.addListenersToMenuItems();
			this.$returnButtons.on('click', this.onReturnButtonClick.bind(this));
			this.$returnTopbarButtons.on('click', this.onReturnTopbarButtonClick.bind(this));
			this.$toggleSearchButton.on('click', this.onToggleSearchButtonClick.bind(this));
			this.$siteSearchClose.on('click', this.closeSearchBar.bind(this));
		}
	}, {
		key: 'addEventListenersToListItemsAboveLargeViewport',
		value: function addEventListenersToListItemsAboveLargeViewport() {
			this.$primaryListItems = this.$listItems.filter('.global-navigation__primary-link');
			this.$subMenuListItems = this.$listItems.filter('.global-navigation__submenu-link');
			this.$topbarSubMenuListItems = this.$topbarListItems.filter('.topbar__submenu-link');
			this.$siteSearchClose.on('keydown', this.onTabbingOffSearch.bind(this));

			if (!this.isViewportBelowLarge) {
				this.$primaryListItems.on('mouseover focus click', this.onListItemHoverFocus.bind(this));
				this.$subMenuListItems.on('mouseover focus', this.onSubmenuListItemHoverFocus.bind(this));
				this.$moreFaSitesButton.on('mouseover focus', (0, _underscore.debounce)(this.onTopbarListItemHoverFocus.bind(this), 200));
				this.$topbarSubMenuListItems.on('mouseover focus', this.onTopbarSubMenuListItemHoverFocus.bind(this));
			} else {
				this.$primaryListItems.off('mouseover focus');
				this.$subMenuListItems.off('mouseover focus');
				this.$topbarSubMenuListItems.off('mouseover focus');
			}
		}
	}, {
		key: 'addListenersToMenuItems',
		value: function addListenersToMenuItems() {
			this.$listItems.on('click', this.onListItemClick.bind(this));
			this.$topbarListItems.on('click', this.onTopbarListItemClick.bind(this));
		}
	}, {
		key: 'removeListenersFromMenuItems',
		value: function removeListenersFromMenuItems() {
			this.$listItems.off('click');
			this.$topbarListItems.off('click');
		}
	}, {
		key: 'addEventListenerOutsideComponent',
		value: function addEventListenerOutsideComponent() {
			this.$globalNavSubmenus = this.$element.find('.global-navigation__primary-list-item');
			this.$topnavSubmenus = this.$element.find('.topbar__menu-item');
			(0, _jquery2.default)(document).on('click touchstart', this.handleClicksOnDocument.bind(this));
		}
	}, {
		key: 'onTabbingOffSearch',
		value: function onTabbingOffSearch(event) {
			if (event.key !== undefined && event.key === 9) {
				this.handleTabOffSearch();
			} else if (event.keyIdentifier !== undefined && event.keyIdentifier === 9) {
				this.handleTabOffSearch();
			} else if (event.keyCode !== undefined && event.keyCode === 9) {
				this.handleTabOffSearch();
			}
		}
	}, {
		key: 'handleTabOffSearch',
		value: function handleTabOffSearch() {
			var _this2 = this;

			window.setTimeout(function () {
				_this2.focusToSiteSearch();
			}, 50);
		}
	}, {
		key: 'render',
		value: function render() {
			this.setSection();
			this.setVars();
			this.setEventListeners();
			this.setViewportWidth();
			this.addEventListenersToListItemsAboveLargeViewport();
			this.addEventListenerOutsideComponent();
			this.queryUserStatus();
			this.stickyClonedItem.html(this.$stickyListItem);
		}
	}, {
		key: 'setViewportWidth',
		value: function setViewportWidth() {
			this.isViewportBelowLarge = this.$body.hasClass('eduhub-layout') ? window.matchMedia('(max-width: 1024px)').matches : window.matchMedia('(max-width: 991px)').matches;
		}
	}, {
		key: 'onViewportResize',
		value: function onViewportResize() {
			this.setViewportWidth();
			this.removeListenersFromMenuItems();
			this.addListenersToMenuItems();
			this.addEventListenersToListItemsAboveLargeViewport();

			this.menuIsActive = false;
			this.searchIsActive = false;
			this.userMenuIsActive = false;
			this.toggleSearchBar();
			this.toggleUserMenu();
		}
	}, {
		key: 'onHamburgerButtonClick',
		value: function onHamburgerButtonClick() {
			this.menuIsActive = !this.menuIsActive;
			this.toggleGlobalNavigation();
		}
	}, {
		key: 'toggleGlobalNavigation',
		value: function toggleGlobalNavigation() {
			this.$element.toggleClass('fa-navigation--active', this.menuIsActive);
		}
	}, {
		key: 'handleClicksOnDocument',
		value: function handleClicksOnDocument(event) {
			// Taps on '.more-available' link on iPad Pro on Safari have null values for event.toElement and event.relatedTarget, so include event.target also
			// Without event.target, the first conditional statememnt below was missing clicks on links and closing the menu as a result
			var toElement = event.toElement || event.relatedTarget || event.target;

			if (this.$activeMenuBlock && !_jquery2.default.contains(this.$activeMenuBlock[0], toElement)) {
				this.$globalNavSubmenus.removeClass(this.activeItemClass);
			}

			if (this.$activeTopbarBlock && !_jquery2.default.contains(this.$activeTopbarBlock[0], toElement)) {
				this.$topnavSubmenus.removeClass(this.activeItemClass);
				this.$activeTopbarBlock.removeClass(this.activeItemClass);
				this.$faLogo.removeClass(this.hiddenClass);
				this.$activeTopbarBlock.off('focusout');
				this.$activeTopbarBlock = null;
				this.isMoreSitesMenuOpen = false;
			}
		}
	}, {
		key: 'onListItemClick',
		value: function onListItemClick(event) {
			var item = event && event.currentTarget;
			var $submenu = (0, _jquery2.default)(item).siblings('.global-navigation__submenu');

			if (this.isViewportBelowLarge) {
				if ($submenu.length) {
					event.preventDefault();
					$submenu.addClass('global-navigation__submenu--active');
					this.scrollToTopOfNavContainer();
				}
			}
		}
	}, {
		key: 'onTopbarListItemClick',
		value: function onTopbarListItemClick(event) {
			var item = event && event.currentTarget;
			var $submenu = (0, _jquery2.default)(item).siblings('.topbar__submenu');

			if (this.isViewportBelowLarge) {
				if ($submenu.length) {
					event.preventDefault();
					$submenu.addClass('topbar__submenu--active');
					this.scrollToTopOfNavContainer();
				}
			}
		}
	}, {
		key: 'scrollToTopOfNavContainer',
		value: function scrollToTopOfNavContainer() {
			this.$navigationContainer.animate({ scrollTop: 0 }, 0);
		}
	}, {
		key: 'showSubnavContainer',
		value: function showSubnavContainer($activeMenuBlock) {
			if ($activeMenuBlock) {
				$activeMenuBlock.addClass(this.activeItemClass);
			}
		}
	}, {
		key: 'onListItemHoverFocus',
		value: function onListItemHoverFocus(event) {
			var _this3 = this;

			var item = event && event.currentTarget;
			this.$activeMenuBlock = (0, _jquery2.default)(item).closest('.global-navigation__primary-list-item');

			if (event.type === 'click' && this.$activeMenuBlock.hasClass(this.activeItemClass)) {
				var target = event.currentTarget.getAttribute('href');
				window.location.href = target;
				return;
			}

			if (event.type === 'mouseover') {
				this.subnavTimeout = setTimeout(function () {
					_this3.showSubnavContainer(_this3.$activeMenuBlock);
				}, 150);
			} else {
				this.showSubnavContainer(this.$activeMenuBlock);
				event.preventDefault();
			}

			this.$activeMenuBlock.on('mouseout focusout', this.onListItemBlur.bind(this));
		}
	}, {
		key: 'onListItemBlur',
		value: function onListItemBlur(event) {
			var toElement = event.toElement || event.relatedTarget;
			clearTimeout(this.subnavTimeout);

			if (this.$activeMenuBlock) {
				var toElementIsInContainingElementChildren = _jquery2.default.contains(this.$activeMenuBlock[0], toElement);

				if (!toElementIsInContainingElementChildren) {
					this.$activeMenuBlock.removeClass(this.activeItemClass);
					this.$activeMenuBlock.off('mouseout focusout');
					this.$activeMenuBlock = null;
				}
			}
		}
	}, {
		key: 'onSubmenuListItemHoverFocus',
		value: function onSubmenuListItemHoverFocus(event) {
			var item = event && event.currentTarget;

			this.$activeSubMenuBlock = (0, _jquery2.default)(item).closest('.global-navigation__submenu-list-item');
			this.$activeSubMenuBlock.addClass(this.activeItemClass);

			if (!this.isViewportBelowLarge) {
				this.updateSubnavHeight((0, _jquery2.default)(item));
			}

			this.$activeSubMenuBlock.on('mouseout focusout', this.onSubMenuListItemBlur.bind(this));
		}
	}, {
		key: 'onSubMenuListItemBlur',
		value: function onSubMenuListItemBlur(event) {
			var toElement = event.toElement || event.relatedTarget;

			if (this.$activeSubMenuBlock) {
				var toElementIsInContainingElementChildren = _jquery2.default.contains(this.$activeSubMenuBlock[0], toElement);

				if (!toElementIsInContainingElementChildren) {
					this.$activeSubMenuBlock.removeClass(this.activeItemClass);
					this.$activeSubMenuBlock.off('mouseout focusout');
					this.$activeSubMenuBlock = null;
				}
			}
		}
	}, {
		key: 'onTopbarListItemHoverFocus',
		value: function onTopbarListItemHoverFocus(event) {
			var item = event && event.currentTarget;

			if ((0, _jquery2.default)(item).hasClass('more-content')) {
				this.$activeTopbarBlock = (0, _jquery2.default)(item).closest('.topbar__menu-item');
				this.isMoreSitesMenuOpen = !this.isMoreSitesMenuOpen;
				this.$activeTopbarBlock.toggleClass(this.activeItemClass, this.isMoreSitesMenuOpen);
				this.$faLogo.toggleClass(this.hiddenClass, this.isMoreSitesMenuOpen);
				event.preventDefault();

				this.$activeTopbarBlock.on('mouseout focusout', this.onTopListItemBlur.bind(this));
			}
		}
	}, {
		key: 'onTopListItemBlur',
		value: function onTopListItemBlur(event) {
			var toElement = event.toElement || event.relatedTarget;

			if (this.$activeTopbarBlock) {
				var toElementIsInContainingElementChildren = _jquery2.default.contains(this.$activeTopbarBlock[0], toElement);

				if (!toElementIsInContainingElementChildren) {
					this.isMoreSitesMenuOpen = false;
					this.$activeTopbarBlock.removeClass(this.activeItemClass);
					this.$faLogo.removeClass(this.hiddenClass);
					this.$activeTopbarBlock.off('mouseout focusout');
					this.$activeTopbarBlock = null;
				}
			}
		}
	}, {
		key: 'onTopbarSubMenuListItemHoverFocus',
		value: function onTopbarSubMenuListItemHoverFocus(event) {
			var item = event && event.currentTarget;

			this.$activeTopbarSubmenuBlock = (0, _jquery2.default)(item).closest('.topbar__submenu-list-item');
			this.$activeTopbarSubmenuBlock.addClass(this.activeItemClass);

			this.$activeTopbarSubmenuBlock.on('mouseout focusout', this.onTopbarSubMenuListItemBlur.bind(this));
		}
	}, {
		key: 'onTopbarSubMenuListItemBlur',
		value: function onTopbarSubMenuListItemBlur(event) {
			var toElement = event.toElement || event.relatedTarget;

			if (this.$activeTopbarSubmenuBlock) {
				var toElementIsInContainingElementChildren = _jquery2.default.contains(this.$activeTopbarSubmenuBlock[0], toElement);

				if (!toElementIsInContainingElementChildren) {
					this.$activeTopbarSubmenuBlock.removeClass(this.activeItemClass);
					this.$activeTopbarSubmenuBlock.off('mouseout focusout');
					this.$activeTopbarSubmenuBlock = null;
				}
			}
		}
	}, {
		key: 'onReturnButtonClick',
		value: function onReturnButtonClick(event) {
			var item = event && event.currentTarget;
			var $submenu = (0, _jquery2.default)(item).closest('.global-navigation__submenu');

			if ($submenu.length) {
				$submenu.removeClass('global-navigation__submenu--active');
			}
		}
	}, {
		key: 'onReturnTopbarButtonClick',
		value: function onReturnTopbarButtonClick(event) {
			//move this function into on above
			var item = event && event.currentTarget;
			var $submenu = (0, _jquery2.default)(item).closest('.topbar__submenu');

			if ($submenu.length) {
				$submenu.removeClass('topbar__submenu--active');
			}
		}
	}, {
		key: 'onToggleSearchButtonClick',
		value: function onToggleSearchButtonClick() {
			var _this4 = this;

			this.searchIsActive = !this.searchIsActive;
			this.toggleSearchBar();

			if (this.searchIsActive) {
				window.setTimeout(function () {
					_this4.focusToSiteSearch();
				}, 300);
			} else {
				this.$siteSearchButton.attr('tabindex', '-1');
				this.$siteSearchInput.attr('tabindex', '-1');
			}
		}
	}, {
		key: 'focusToSiteSearch',
		value: function focusToSiteSearch() {
			this.$searchInput.focus();
			this.$siteSearchButton.attr('tabindex', '');
			this.$siteSearchInput.attr('tabindex', '');
			this.$siteSearchPositioner.addClass('active');
		}
	}, {
		key: 'updateSubnavHeight',
		value: function updateSubnavHeight($item) {
			var $tertiaryList = $item.siblings('.global-navigation__submenu-list-items-secondary');
			var $tertiaryItems = $tertiaryList && $tertiaryList.find('li');
			var $subNavContainer = $tertiaryList.parents('.global-navigation__submenu-primary');
			var totalHeight = 0;

			$tertiaryItems.each(function (i, el) {
				totalHeight += (0, _jquery2.default)(el).outerHeight();
			});

			if (totalHeight >= $subNavContainer.outerHeight()) {
				$subNavContainer.css('height', totalHeight);
			} else {
				$subNavContainer.css('height', 'auto');
			}
		}
	}, {
		key: 'toggleSearchBar',
		value: function toggleSearchBar() {
			this.$element.toggleClass('fa-navigation--searchbar-active', this.searchIsActive);

			if (!this.searchIsActive) {
				this.$siteSearchPositioner.removeClass('active');
			}
		}
	}, {
		key: 'closeSearchBar',
		value: function closeSearchBar() {
			this.searchIsActive = false;

			this.toggleSearchBar();
			this.$toggleSearchButton.focus();
		}
	}, {
		key: 'onDocumentScroll',
		value: function onDocumentScroll() {
			this.stickyNavIsActive = this.$window.scrollTop() >= 30;

			this.toggleStickyNav();
		}
	}, {
		key: 'toggleStickyNav',
		value: function toggleStickyNav() {
			this.$body.toggleClass('sticky-nav--active', this.stickyNavIsActive);
		}
	}, {
		key: 'onUserLinkClick',
		value: function onUserLinkClick() {
			this.userMenuIsActive = !this.userMenuIsActive;

			this.toggleUserMenu();
		}
	}, {
		key: 'toggleUserMenu',
		value: function toggleUserMenu() {
			this.$body.toggleClass('user-menu-active', this.userMenuIsActive);
		}
	}, {
		key: 'queryUserStatus',
		value: function queryUserStatus() {
			var signInUrl = this.$userButton.data('signInUrl');

			if (signInUrl) {
				_jquery2.default.ajax({
					method: 'GET',
					cache: false,
					url: signInUrl
				}).then(this.onUserStatusResponse.bind(this), this.onUserStatusError.bind(this));
			}
		}
	}, {
		key: 'onUserStatusResponse',
		value: function onUserStatusResponse(response) {
			if (response && response.IsValid) {
				this.$userButton.text(response.Html);
				this.$userDetailsContainer.addClass('user-signed-in');
			}
		}
	}, {
		key: 'onUserStatusError',
		value: function onUserStatusError() {}
	}, {
		key: 'onKeyupEvent',
		value: function onKeyupEvent(event) {
			if (event && event.keyCode === 27 && this.searchIsActive) {
				this.onToggleSearchButtonClick();
			}
		}
	}, {
		key: 'setSection',
		value: function setSection() {
			var currentItemPath = (0, _jquery2.default)(".currentItemPath").val();

			(0, _jquery2.default)(".global-navigation__primary-list-item").each(function () {
				var sectionPath = (0, _jquery2.default)(this).attr("data-sectionPath");

				if (currentItemPath != null && currentItemPath.indexOf(sectionPath) == 0) {
					(0, _jquery2.default)(this).addClass("current-section");
				}
			});
		}
	}]);

	return Navigation;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.SubNavigation = function (_Snappy$BaseComponent) {
	_inherits(SubNavigation, _Snappy$BaseComponent);

	_createClass(SubNavigation, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-sub-navigation';
		}
	}]);

	function SubNavigation(element) {
		_classCallCheck(this, SubNavigation);

		var _this = _possibleConstructorReturn(this, (SubNavigation.__proto__ || Object.getPrototypeOf(SubNavigation)).call(this, element));

		_this.adjustmentCount = 0;
		return _this;
	}

	_createClass(SubNavigation, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.addListeners();

			if (window.matchMedia('(min-width: 992px)').matches) {
				this.calculateMenuItemsPosition();
			}
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.$mainMenu = this.$element.find('.fa-sub-navigation__section-links');
			this.$mainMenuItems = this.$mainMenu.find('.section-links__list');
			this.$innerContent = this.$element.find('.fa-sub-navigation__inner-content');
			this.$moreMenu = this.$element.find('.section-links__more-dropdown');
			this.$moreBtn = this.$element.find('.section-links__more-text');
			this.$moreBtnParent = this.$element.find('.section-links__more-list-item');
		}
	}, {
		key: 'addListeners',
		value: function addListeners() {
			var throttledViewportResizeHandler = (0, _underscore.throttle)(this.onViewportResize.bind(this), 100);
			var throttledOnScrollHandler = (0, _underscore.throttle)(this.onDocumentScroll.bind(this), 50);

			this.$window.on('resize', throttledViewportResizeHandler);
			this.$window.on('scroll', throttledOnScrollHandler);
			this.$moreBtn.on('mouseover focus', this.onMoreBtnHover.bind(this));
			this.$moreBtn.on('mouseout focusout', this.onMoreBtnBlur.bind(this));
			this.$moreMenu.on('mouseout focusout', this.onMoreBtnBlur.bind(this));
		}
	}, {
		key: 'onViewportResize',
		value: function onViewportResize() {
			if (window.matchMedia('(min-width: 992px)').matches) {
				this.calculateMenuItemsPosition();
			}
		}
	}, {
		key: 'onDocumentScroll',
		value: function onDocumentScroll() {
			this.stickySubNavIsActive = this.$window.scrollTop() > 40;

			this.toggleStickySubNav();
		}
	}, {
		key: 'onMoreBtnHover',
		value: function onMoreBtnHover() {
			this.$moreBtnParent.addClass('active');
		}
	}, {
		key: 'onMoreBtnBlur',
		value: function onMoreBtnBlur(event) {
			var toElement = event.toElement || event.relatedTarget;
			var toElementIsInContainingElementChildren = _jquery2.default.contains(this.$moreMenu[0], toElement);

			if (!toElementIsInContainingElementChildren) {
				this.$moreBtnParent.removeClass('active');
			}
		}
	}, {
		key: 'calculateMenuItemsPosition',
		value: function calculateMenuItemsPosition() {
			// need to show/hide ul if has content/empty
			this.mainMenuWidth = this.$mainMenu.width();
			this.availableSpace = this.$innerContent.width() - 160;
			this.viewportIsTooNarrow = this.mainMenuWidth > this.availableSpace;

			this.toggleMoreButtonVisibility();

			if (this.viewportIsTooNarrow) {
				this.moveListItemToMoreDropdown();
			} else {
				if (this.cachedMainMenu < this.availableSpace) {
					var $listItem = this.$moreMenu.find('.section-links__list-item').last();

					$listItem.insertBefore(this.$mainMenuItems.find('.section-links__more-list-item'));
					this.calculateMenuItemsPosition();
				}
			}
		}
	}, {
		key: 'toggleMoreButtonVisibility',
		value: function toggleMoreButtonVisibility() {
			this.$element.toggleClass('fa-sub-navigation--viewport-narrow', this.viewportIsTooNarrow || this.adjustmentCount > 0);
		}
	}, {
		key: 'moveListItemToMoreDropdown',
		value: function moveListItemToMoreDropdown() {
			var $listItem = this.$mainMenu.find('.section-links__list > .section-links__list-item:not(.section-links__more-list-item)').last();
			var $clonedListItem = $listItem.clone();

			this.$moreMenu.append($clonedListItem[0]);
			$listItem.remove();
			this.adjustmentCount += 1;
			this.cachedMainMenu = this.mainMenuWidth;

			this.calculateMenuItemsPosition();
		}
	}, {
		key: 'toggleStickySubNav',
		value: function toggleStickySubNav() {
			this.$body.toggleClass('sticky-subnav--active', this.stickySubNavIsActive);
		}
	}]);

	return SubNavigation;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Textarea = function (_Snappy$BaseComponent) {
	_inherits(Textarea, _Snappy$BaseComponent);

	_createClass(Textarea, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-textarea';
		}
	}]);

	function Textarea(element) {
		_classCallCheck(this, Textarea);

		return _possibleConstructorReturn(this, (Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call(this, element));
	}

	_createClass(Textarea, [{
		key: 'render',
		value: function render() {}
	}]);

	return Textarea;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ServerValidation = function (_Snappy$BaseComponent) {
  _inherits(ServerValidation, _Snappy$BaseComponent);

  _createClass(ServerValidation, null, [{
    key: 'tagName',
    get: function get() {
      return 'fa-form-validation';
    }
  }]);

  function ServerValidation(element) {
    _classCallCheck(this, ServerValidation);

    return _possibleConstructorReturn(this, (ServerValidation.__proto__ || Object.getPrototypeOf(ServerValidation)).call(this, element));
  }

  _createClass(ServerValidation, [{
    key: 'setVars',
    value: function setVars() {
      this.errorClass = 'fa-input-field--error';
      this.messageClass = 'fa-input-field__error-message';
    }
  }, {
    key: 'setEventListeners',
    value: function setEventListeners() {
      this.$element.on('submit', this.validateForm.bind(this));
    }
  }, {
    key: 'validateForm',
    value: function validateForm(event) {
      event.preventDefault();

      /* TEMP - expected JSON format from server
      {
          "success": false,
          "fields": [
            {
              "success": false,
              "element": "email-field",
              "message": "Please enter an email address"
            },
            {
              "success": true,
              "element": "text-field"
            },
            {
              "success": false,
              "element": "dropdown-field",
              "message": "Please choose an option"
            }
          ]
      }
      */
      _jquery2.default.ajax({
        "url": this.$element.attr('action'),
        "method": this.$element.attr('method'),
        "data": this.$element.serialize()
      }).always(this.handleValidationResponse.bind(this));
    }
  }, {
    key: 'handleValidationResponse',
    value: function handleValidationResponse(response) {
      var _this2 = this;

      if (!response.success) {
        _jquery2.default.each(response.fields, function (i, field) {
          if (!field.success) {
            _this2.showValidationError(field);
          } else {
            _this2.removeValidationError(field);
          }
        });
      } else {
        this.$element.off().submit();
      }
    }
  }, {
    key: 'showValidationError',
    value: function showValidationError(field) {
      var $element = this.$element.find('[name=' + field.element + ']');

      $element.addClass(this.errorClass).parent().addClass(this.errorClass).find('.' + this.messageClass).text(field.message);
    }
  }, {
    key: 'removeValidationError',
    value: function removeValidationError(field) {
      var $element = this.$element.find('[name=' + field.element + ']');

      $element.removeClass(this.errorClass).parent().removeClass(this.errorClass).find('.' + this.messageClass).text('');
    }
  }, {
    key: 'render',
    value: function render() {
      this.setVars();
      this.setEventListeners();
    }
  }]);

  return ServerValidation;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var jQuery = __webpack_require__(1);
window.$ = window.jQuery = jQuery;

__webpack_require__(92);
__webpack_require__(91);

jQuery.noConflict(true);

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _underscore = __webpack_require__(16);

window.globalConfigs = {};

window.addEventListener('resize', (0, _underscore.throttle)(onViewportResize, 100));

window.opta_settings = {
  subscription_id: '996cf5a7e7d89eba508208bbb2604497',
  language: 'en_GB',
  timezone: 'Europe/London'
};

function CustomEvent(event, params) {
  var evt = document.createEvent('CustomEvent');

  params = params || { bubbles: false, cancelable: false, detail: undefined };
  evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);

  return evt;
}

CustomEvent.prototype = window.Event.prototype;
window.CustomEvent = CustomEvent;

var resizeEvent = new CustomEvent('fa.viewportResize');

function onViewportResize() {
  globalConfigs.viewportIsBelowLarge = window.matchMedia('(max-width: 991px)').matches;

  broadcastWindowResizeEvent();
}

function broadcastWindowResizeEvent() {
  window.dispatchEvent(resizeEvent);
}

onViewportResize();

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = matches;
var proto = window.Element.prototype;
var nativeMatches = proto.matches || proto.matchesSelector || proto.webkitMatchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector;

/**
 * Tests if a DOM elements matches any of the test DOM elements or selectors.
 * @param {Element} element The DOM element to test.
 * @param {Element|string|Array<Element|string>} test A DOM element, a CSS
 *     selector, or an array of DOM elements or CSS selectors to match against.
 * @return {boolean} True of any part of the test matches.
 */
function matches(element, test) {
  // Validate input.
  if (element && element.nodeType == 1 && test) {
    // if test is a string or DOM element test it.
    if (typeof test == 'string' || test.nodeType == 1) {
      return element == test || matchesSelector(element, /** @type {string} */test);
    } else if ('length' in test) {
      // if it has a length property iterate over the items
      // and return true if any match.
      for (var i = 0, item; item = test[i]; i++) {
        if (element == item || matchesSelector(element, item)) return true;
      }
    }
  }
  // Still here? Return false
  return false;
}

/**
 * Tests whether a DOM element matches a selector. This polyfills the native
 * Element.prototype.matches method across browsers.
 * @param {!Element} element The DOM element to test.
 * @param {string} selector The CSS selector to test element against.
 * @return {boolean} True if the selector matches.
 */
function matchesSelector(element, selector) {
  if (typeof selector != 'string') return false;
  if (nativeMatches) return nativeMatches.call(element, selector);
  var nodes = element.parentNode.querySelectorAll(selector);
  for (var i = 0, node; node = nodes[i]; i++) {
    if (node == element) return true;
  }
  return false;
}

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports) {

(function(window, factory) {
	var lazySizes = factory(window, window.document);
	window.lazySizes = lazySizes;
	if(typeof module == 'object' && module.exports){
		module.exports = lazySizes;
	}
}(window, function l(window, document) {
	'use strict';
	/*jshint eqnull:true */
	if(!document.getElementsByClassName){return;}

	var lazysizes, lazySizesConfig;

	var docElem = document.documentElement;

	var Date = window.Date;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	var addEventListener = window[_addEventListener];

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('CustomEvent');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initCustomEvent(name, !noBubbles, !noCancelable, detail);

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesConfig.pf) ) ){
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesConfig.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = 125;
		var RIC_DEFAULT_TIMEOUT = 666;
		var rICTimeout = RIC_DEFAULT_TIMEOUT;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});
				if(rICTimeout !== RIC_DEFAULT_TIMEOUT){
					rICTimeout = RIC_DEFAULT_TIMEOUT;
				}
			}:
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;
			if((isPriority = isPriority === true)){
				rICTimeout = 44;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || (delay < 9 && requestIdleCallback)){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};


	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom;

		var defaultExpand, preloadExpand, hFac;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/glebot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(e && e.target){
				addRemoveLoadEvents(e.target, resetPreloading);
			}

			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = getCSS(document.body, 'visibility') == 'hidden' || getCSS(elem, 'visibility') != 'hidden';

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal;

			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesConfig.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				if(preloadExpand == null){
					if(!('expand' in lazySizesConfig)){
						lazySizesConfig.expand = docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370;
					}

					defaultExpand = lazySizesConfig.expand;
					preloadExpand = defaultExpand * lazySizesConfig.expFactor;
				}

				if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
					currentExpand = preloadExpand;
					lowRuns = 0;
				} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
					currentExpand = defaultExpand;
				} else {
					currentExpand = shrinkExpand;
				}

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesConfig.loadHidden || getCSS(lazyloadElems[i], 'visibility') != 'hidden') &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesConfig.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesConfig.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			addClass(e.target, lazySizesConfig.loadedClass);
			removeClass(e.target, lazySizesConfig.loadingClass);
			addRemoveLoadEvents(e.target, rafSwitchLoadingClass);
			triggerEvent(e.target, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			try {
				elem.contentWindow.location.replace(src);
			} catch(e){
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesConfig.srcsetAttr);

			if( (customMedia = lazySizesConfig.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesConfig.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesConfig.srcsetAttr);
				src = elem[_getAttribute](lazySizesConfig.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				if(firesLoad){
					addRemoveLoadEvents(elem, resetPreloading, true);
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);

					addClass(elem, lazySizesConfig.loadingClass);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesConfig.lazyClass);

			rAF(function(){
				if( !firesLoad || (elem.complete && elem.naturalWidth > 1)){
					if(firesLoad){
						resetPreloading(event);
					} else {
						isLoading--;
					}
					switchLoadingClass(event);
				}
			}, true);
		});

		var unveilElement = function (elem){
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesConfig.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesConfig.errorClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}
			var afterScroll = debounce(function(){
				lazySizesConfig.loadMode = 3;
				throttledCheckElements();
			});

			isCompleted = true;

			lazySizesConfig.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', function(){
				if(lazySizesConfig.loadMode == 3){
					lazySizesConfig.loadMode = 2;
				}
				afterScroll();
			}, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesConfig.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesConfig.lazyClass + ' ' + lazySizesConfig.preloadClass);
				hFac = lazySizesConfig.hFac;

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesConfig.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
		};

		lazySizesConfig = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesConfig)){
				lazySizesConfig[prop] = lazySizesDefaults[prop];
			}
		}

		window.lazySizesConfig = lazySizesConfig;

		setTimeout(function(){
			if(lazySizesConfig.init){
				init();
			}
		});
	})();

	lazysizes = {
		cfg: lazySizesConfig,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VideoHelpers = function () {
    function VideoHelpers() {
        _classCallCheck(this, VideoHelpers);
    }

    _createClass(VideoHelpers, null, [{
        key: "getFomattedDuration",
        value: function getFomattedDuration(durationSeconds) {
            var minutes = Math.floor(durationSeconds / 60);
            var seconds = durationSeconds - minutes * 60;

            return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
        }
    }, {
        key: "parseYoutubeId",
        value: function parseYoutubeId(url) {
            var ID = '';
            url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
            if (url[2] !== undefined) {
                ID = url[2].split(/[^0-9a-z_\-]/i);
                ID = ID[0];
            }

            return ID;
        }
    }, {
        key: "parseVimeoId",
        value: function parseVimeoId(url) {
            var id = url.match(/\/\/[^\/]+\/([^\.]+)/)[1];
            if (typeof id === 'string') {
                id = id.split('/')[0];
            }
            return id;
        }
    }]);

    return VideoHelpers;
}();

exports.default = VideoHelpers;

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _sister = __webpack_require__(106);

var _sister2 = _interopRequireDefault(_sister);

var _loadYouTubeIframeApi = __webpack_require__(114);

var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);

var _YouTubePlayer = __webpack_require__(110);

var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */

/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */
var youtubeIframeAPI = void 0;

/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param elementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */

exports.default = function (maybeElementId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var emitter = (0, _sister2.default)();

  if (!youtubeIframeAPI) {
    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)();
  }

  if (options.events) {
    throw new Error('Event handlers cannot be overwritten.');
  }

  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
    throw new Error('Element "' + maybeElementId + '" does not exist.');
  }

  options.events = _YouTubePlayer2.default.proxyEvents(emitter);

  var playerAPIReady = new Promise(function (resolve) {
    if (typeof maybeElementId === 'string' || maybeElementId instanceof HTMLElement) {
      // eslint-disable-next-line promise/catch-or-return
      youtubeIframeAPI.then(function (YT) {
        var player = new YT.Player(maybeElementId, options);

        emitter.on('ready', function () {
          resolve(player);
        });

        return null;
      });
    } else if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
      var player = maybeElementId;

      resolve(player);
    } else {
      throw new TypeError('Unexpected state.');
    }
  });

  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);

  playerApi.on = emitter.on;
  playerApi.off = emitter.off;

  return playerApi;
};

module.exports = exports['default'];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Accordion = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(53);

var _resize = __webpack_require__(12);

var _resize2 = _interopRequireDefault(_resize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Accordion = exports.Accordion = function (_Snappy$BaseComponent) {
    _inherits(Accordion, _Snappy$BaseComponent);

    _createClass(Accordion, null, [{
        key: 'tagName',
        get: function get() {
            return 'cfa-accordion';
        }
    }]);

    function Accordion(element) {
        _classCallCheck(this, Accordion);

        return _possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call(this, element));
    }

    _createClass(Accordion, [{
        key: 'render',
        value: function render() {
            this.setVars();

            this.onResize();

            this.$window.on('resize:finished', this.bindedResize = this.onResize.bind(this));

            if (this.isOpened) {
                this.$accordionLink.attr('aria-expanded', true);
            }
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            if (this.isOn && !this.isListenersAdded) {
                this.setEventListeners();
            } else if (!this.isOn && this.isListenersAdded) {
                this.removeEventListeners();
            }
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            var _this2 = this;

            this.settings = _extends({}, _snappy2.default.Component.Accordion._settings, this.$element.data(), typeof settings == 'undefined' ? {} : settings);

            this.$accordionLink = this.$element.find('.js-accordion-link').filter(function (index, el) {
                return (0, _jquery2.default)(el).parents('[data-cfa-accordion]').first().is(_this2.$element) ? true : false;
            });
            this.$accordionContent = this.$element.find('.js-accordion-content').filter(function (index, el) {
                return (0, _jquery2.default)(el).parents('[data-cfa-accordion]').first().is(_this2.$element) ? true : false;
            });
            this.$lazyContent = this.$accordionContent.find('.js-accordion-lazy-content');
            this.preloader = this.$element.find('.js-cfa-preloader');
            this.isOpened = this.$element.hasClass('is-opened');
            this.isAnimating = false;
            this.type = this.$element.data('type');
            this.url = this.$element.data('url');
            this.hasContent = !(this.type === 'lazy');
            this.isLoading = false;
            this.isExperienceEditor = (0, _jquery2.default)('body').hasClass('is-experience-editor');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {

            if (!this.isOpened) {
                this.$accordionContent.css({
                    'max-height': 0,
                    'overflow': 'hidden',
                    'display': 'none'
                });
            }

            this.$accordionLink.on('click', this.clickListener = this.clickProcess.bind(this));
            this.$accordionLink.on('keydown', this.keydownListener = this.keydownProcess.bind(this));
            this.isListenersAdded = true;
        }
    }, {
        key: 'removeEventListeners',
        value: function removeEventListeners() {
            this.$accordionContent.css({
                'max-height': '',
                'overflow': '',
                'display': ''
            });
            this.$accordionLink.off('click', this.clickListener);
            this.$accordionLink.off('keydown', this.keydownListener);
            this.isListenersAdded = false;
        }
    }, {
        key: 'clickProcess',
        value: function clickProcess(e) {
            if (typeof e !== 'undefined' && typeof e.preventDefault === "function") {
                e.preventDefault();
            }
            if (this.isAnimating) {
                return;
            }

            if (this.type === 'lazy' && !this.hasContent && !this.isOpened) {
                this.downloadContent();
                return;
            }

            this[this.isOpened ? "close" : "open"]();
            this.isAnimating = true;
        }
    }, {
        key: 'keydownProcess',
        value: function keydownProcess(event) {
            var keyCode = event.which;

            switch (keyCode) {
                case 13:
                case 32:
                    if (!this.isExperienceEditor) {
                        this.clickProcess(event);
                    }
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'open',
        value: function open() {
            if (this.isOpened) {
                this.animationComplete();
                return;
            }

            var $accordionChildren = this.$accordionContent.children();
            if (!$accordionChildren.length) return;

            this.$accordionContent.css({
                'display': 'block'
            });

            this.isOpened = true;
            this.$accordionLink.attr('aria-expanded', true);
            this.tween = new _gsap.TimelineLite({ onComplete: this.animationComplete.bind(this) });
            this.tween.fromTo(this.$accordionContent, this.settings.time, {
                maxHeight: this.$accordionContent.css('max-height')
            }, {
                maxHeight: $accordionChildren.first().outerHeight()
            });
            this.tween.play();
        }
    }, {
        key: 'close',
        value: function close() {
            if (!this.isOpened) {
                this.animationComplete();
                return;
            }
            this.isOpened = false;
            this.$accordionLink.attr('aria-expanded', false);

            this.$accordionContent.css({
                'max-height': this.$accordionContent.children().first().outerHeight(),
                'overflow': 'hidden'
            });
            this.$element.removeClass('is-opened');
            this.tween = new _gsap.TimelineLite({ onComplete: this.animationComplete.bind(this) });
            this.tween.to(this.$accordionContent, this.settings.time, { maxHeight: 0 });
            this.tween.play();
        }
    }, {
        key: 'animationComplete',
        value: function animationComplete() {
            if (this.settings.erase) {
                this.$accordionContent.css({
                    'max-height': '',
                    'overflow': ''
                });
            } else {
                this.$accordionContent.css('max-height', this.isOpened ? 'none' : '0');
                this.$accordionContent.css('overflow', this.isOpened ? 'visible' : 'hidden');
                this.$accordionContent.css('display', this.isOpened ? 'block' : 'none');
            }

            if (this.isOpened) {
                this.$element.addClass('is-opened');
            }
            this.isAnimating = false;
        }
    }, {
        key: 'downloadContent',
        value: function downloadContent() {
            var _this3 = this;

            this.$lazyContent.html('');
            this.isLoading = true;
            this.toggleLoading();
            this.preloader.css({
                'height': '100px',
                'max-height': '100px'
            });

            _jquery2.default.ajax({
                url: this.url,
                type: "GET",
                dataType: "html"
            }).done(function (data) {
                _this3.$lazyContent.html(data);
                _this3.hasContent = true;
            }).fail(function () {
                _this3.$lazyContent.html('<div class="no-data">Error getting data from Server. Please contact site administrator or try to reopen accordion again later.</div>');
            }).always(function () {
                _this3.preloader.css({
                    'height': 'auto'
                });

                _this3.isLoading = false;
                _this3.toggleLoading();
                _this3.open();
            });
        }
    }, {
        key: 'toggleLoading',
        value: function toggleLoading() {
            this.preloader.toggleClass('cfa-preloader--active', this.isLoading);
        }
    }, {
        key: 'isOn',
        get: function get() {
            var isOnMobile = !_resize2.default.isTablet && this.settings.mobile.toString() != 'false',
                isOnTablet = _resize2.default.isTablet && !_resize2.default.isDesktop && this.settings.tablet.toString() != 'false',
                isOnDesktop = _resize2.default.isDesktop && this.settings.desktop.toString() != 'false',
                isOn = isOnMobile || isOnTablet || isOnDesktop;

            return isOn;
        }
    }]);

    return Accordion;
}(_snappy2.default.BaseComponent);

;

_snappy2.default.Component.Accordion = Accordion;

_snappy2.default.Component.Accordion._settings = {
    erase: false,
    time: 0.5,
    mobile: true,
    tablet: true,
    desktop: true
};

exports.default = _snappy2.default.Component.Accordion;

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_shadowed__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shadow_host_parents__ = __webpack_require__(170);

// [0] always is the actual active element (even within web-components)
// [0+n] is the hierarchy of shadow-doms with [length -1] being the top most shadow-host




function walkToShadowedElement() {
  var list = [document.activeElement];

  while (list[0] && list[0].shadowRoot) {
    list.unshift(list[0].shadowRoot.activeElement);
  }

  return list;
}

function walkFromShadowedElement() {
  var hosts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shadow_host_parents__["a" /* default */])({ context: document.activeElement });
  return [document.activeElement].concat(hosts);
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  if (document.activeElement === null) {
    // IE10 does not redirect focus to <body> when the activeElement is removed
    document.body.focus();
  }

  // Firefox currently leaks the shadowed element
  // @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1117535
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is_shadowed__["a" /* default */])(document.activeElement)) {
    return walkFromShadowedElement();
  }

  return walkToShadowedElement();
});
//# sourceMappingURL=active-elements.js.map

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_context_to_element__ = __webpack_require__(50);



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_context_to_element__["a" /* default */])({
    label: 'get/shadow-host',
    context: context
  });

  // walk up to the root
  var container = null;

  while (element) {
    container = element;
    element = element.parentNode;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/Node.nodeType
  // NOTE: Firefox 34 does not expose ShadowRoot.host (but 37 does)
  if (container.nodeType === container.DOCUMENT_FRAGMENT_NODE && container.host) {
    // the root is attached to a fragment node that has a host
    return container.host;
  }

  return null;
});
//# sourceMappingURL=shadow-host.js.map

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var combinator = void 0;

  // see https://dev.w3.org/csswg/css-scoping-1/#deep-combinator
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1117572
  // https://code.google.com/p/chromium/issues/detail?id=446051
  try {
    document.querySelector('html >>> :first-child');
    combinator = '>>>';
  } catch (noArrowArrowArrow) {
    try {
      // old syntax supported at least up to Chrome 41
      // https://code.google.com/p/chromium/issues/detail?id=446051
      document.querySelector('html /deep/ :first-child');
      combinator = '/deep/';
    } catch (noDeep) {
      combinator = '';
    }
  }

  return combinator;
});
//# sourceMappingURL=css-shadow-piercing-deep-combinator.js.map

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtb' + 'G5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBpZD0ic3ZnIj48dGV4dCB4PSIxMCIgeT0iMjAiIGlkPSJ' + 'zdmctbGluay10ZXh0Ij50ZXh0PC90ZXh0Pjwvc3ZnPg==');
//# sourceMappingURL=svg.js.map

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/*
  The Singleton Decorator is intended to allow modules to initialize a ("singleton") component as if
  it was the only one using it. Every module gets to initialize and destruct the component by itself.
  Via simple reference counting the component keeps track of how many modules have initialized it,
  so it destructs only when the last module is gone. This decorator hides the component's singleton
  nature from the application in order to offer a homogenous API.

  engage() can return an object (result) with methods to expose to the consumer,
  upon initialization result.disengage is added and returned to the consumer.
*/

function destruct() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      force = _ref.force;

  if (force) {
    this.instances = 0;
  } else {
    this.instances--;
  }

  if (!this.instances) {
    this.disengage();
    this._result = null;
  }
}

function initialize() {
  if (this.instances) {
    this.instances++;
    return this._result;
  }

  this.instances++;
  this._result = this.engage() || {};
  this._result.disengage = destruct.bind(this);

  return this._result;
}

function noop() {}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      engage = _ref2.engage,
      disengage = _ref2.disengage;

  var data = {
    engage: engage || noop,
    disengage: disengage || noop,
    instances: 0,
    _result: null
  };

  return initialize.bind(data);
});
//# sourceMappingURL=decorate-service.js.map

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* ========================================================================
 * Bootstrap: collapse.js v3.3.7
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function Collapse(element, options) {
    this.$element = $(element);
    this.options = $.extend({}, Collapse.DEFAULTS, options);
    this.$trigger = $('[data-toggle="collapse"][href="#' + element.id + '"],' + '[data-toggle="collapse"][data-target="#' + element.id + '"]');
    this.transitioning = null;

    if (this.options.parent) {
      this.$parent = this.getParent();
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger);
    }

    if (this.options.toggle) this.toggle();
  };

  Collapse.VERSION = '3.3.7';

  Collapse.TRANSITION_DURATION = 350;

  Collapse.DEFAULTS = {
    toggle: true
  };

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width');
    return hasWidth ? 'width' : 'height';
  };

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return;

    var activesData;
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing');

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse');
      if (activesData && activesData.transitioning) return;
    }

    var startEvent = $.Event('show.bs.collapse');
    this.$element.trigger(startEvent);
    if (startEvent.isDefaultPrevented()) return;

    if (actives && actives.length) {
      Plugin.call(actives, 'hide');
      activesData || actives.data('bs.collapse', null);
    }

    var dimension = this.dimension();

    this.$element.removeClass('collapse').addClass('collapsing')[dimension](0).attr('aria-expanded', true);

    this.$trigger.removeClass('collapsed').attr('aria-expanded', true);

    this.transitioning = 1;

    var complete = function complete() {
      this.$element.removeClass('collapsing').addClass('collapse in')[dimension]('');
      this.transitioning = 0;
      this.$element.trigger('shown.bs.collapse');
    };

    if (!$.support.transition) return complete.call(this);

    var scrollSize = $.camelCase(['scroll', dimension].join('-'));

    this.$element.one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize]);
  };

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return;

    var startEvent = $.Event('hide.bs.collapse');
    this.$element.trigger(startEvent);
    if (startEvent.isDefaultPrevented()) return;

    var dimension = this.dimension();

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight;

    this.$element.addClass('collapsing').removeClass('collapse in').attr('aria-expanded', false);

    this.$trigger.addClass('collapsed').attr('aria-expanded', false);

    this.transitioning = 1;

    var complete = function complete() {
      this.transitioning = 0;
      this.$element.removeClass('collapsing').addClass('collapse').trigger('hidden.bs.collapse');
    };

    if (!$.support.transition) return complete.call(this);

    this.$element[dimension](0).one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION);
  };

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']();
  };

  Collapse.prototype.getParent = function () {
    return $(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each($.proxy(function (i, element) {
      var $element = $(element);
      this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element);
    }, this)).end();
  };

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in');

    $element.attr('aria-expanded', isOpen);
    $trigger.toggleClass('collapsed', !isOpen).attr('aria-expanded', isOpen);
  };

  function getTargetFromTrigger($trigger) {
    var href;
    var target = $trigger.attr('data-target') || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, ''); // strip for ie7

    return $(target);
  }

  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.collapse');
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false;
      if (!data) $this.data('bs.collapse', data = new Collapse(this, options));
      if (typeof option == 'string') data[option]();
    });
  }

  var old = $.fn.collapse;

  $.fn.collapse = Plugin;
  $.fn.collapse.Constructor = Collapse;

  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old;
    return this;
  };

  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this = $(this);

    if (!$this.attr('data-target')) e.preventDefault();

    var $target = getTargetFromTrigger($this);
    var data = $target.data('bs.collapse');
    var option = data ? 'toggle' : $this.data();

    Plugin.call($target, option);
  });
}(jQuery);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* ========================================================================
 * Bootstrap: transition.js v3.3.7
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap');

    var transEndEventNames = {
      WebkitTransition: 'webkitTransitionEnd',
      MozTransition: 'transitionend',
      OTransition: 'oTransitionEnd otransitionend',
      transition: 'transitionend'
    };

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] };
      }
    }

    return false; // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false;
    var $el = this;
    $(this).one('bsTransitionEnd', function () {
      called = true;
    });
    var callback = function callback() {
      if (!called) $($el).trigger($.support.transition.end);
    };
    setTimeout(callback, duration);
    return this;
  };

  $(function () {
    $.support.transition = transitionEnd();

    if (!$.support.transition) return;

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function handle(e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
      }
    };
  });
}(jQuery);

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = closest;

var _matches = __webpack_require__(66);

var _matches2 = _interopRequireDefault(_matches);

var _parents = __webpack_require__(94);

var _parents2 = _interopRequireDefault(_parents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the closest parent element that matches the passed selector.
 * @param {Element} element The element whose parents to check.
 * @param {string} selector The CSS selector to match against.
 * @param {boolean=} shouldCheckSelf True if the selector should test against
 *     the passed element itself.
 * @return {Element|undefined} The matching element or undefined.
 */
function closest(element, selector) {
  var shouldCheckSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!(element && element.nodeType == 1 && selector)) return;
  var parentElements = (shouldCheckSelf ? [element] : []).concat((0, _parents2.default)(element));

  for (var i = 0, parent; parent = parentElements[i]; i++) {
    if ((0, _matches2.default)(parent, selector)) return parent;
  }
}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parents;
/**
 * Returns an array of a DOM element's parent elements.
 * @param {!Element} element The DOM element whose parents to get.
 * @return {!Array} An array of all parent elemets, or an empty array if no
 *     parent elements are found.
 */
function parents(element) {
  var list = [];
  while (element && element.parentNode && element.parentNode.nodeType == 1) {
    element = /** @type {!Element} */element.parentNode;
    list.push(element);
  }
  return list;
}

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(101);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = __webpack_require__.i({"NODE_ENV":"production"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)))

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(103);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 102 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 103 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), __webpack_require__(47)))

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Sister;

/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/
Sister = function () {
    var sister = {},
        events = {};

    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */

    /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */
    sister.on = function (name, handler) {
        var listener = {name: name, handler: handler};
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };

    /**
     * @param {listener}
     */
    sister.off = function (listener) {
        var index = events[listener.name].indexOf(listener);

        if (index !== -1) {
            events[listener.name].splice(index, 1);
        }
    };

    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */
    sister.trigger = function (name, data) {
        var listeners = events[name],
            i;

        if (listeners) {
            i = listeners.length;
            while (i--) {
                listeners[i].handler(data);
            }
        }
    };

    return sister;
};

module.exports = Sister;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(105);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PlayerStates = __webpack_require__(111);

var _PlayerStates2 = _interopRequireDefault(_PlayerStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  pauseVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
    stateChangeRequired: false
  },
  playVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
    stateChangeRequired: false
  },
  seekTo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
    stateChangeRequired: true,

    // TRICKY: `seekTo` may not cause a state change if no buffering is
    // required.
    timeout: 3000
  }
};
module.exports = exports['default'];

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debug = __webpack_require__(100);

var _debug2 = _interopRequireDefault(_debug);

var _functionNames = __webpack_require__(113);

var _functionNames2 = _interopRequireDefault(_functionNames);

var _eventNames = __webpack_require__(112);

var _eventNames2 = _interopRequireDefault(_eventNames);

var _FunctionStateMap = __webpack_require__(109);

var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = (0, _debug2.default)('youtube-player');

var YouTubePlayer = {};

/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
YouTubePlayer.proxyEvents = function (emitter) {
  var events = {};

  var _loop = function _loop(eventName) {
    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);

    events[onEventName] = function (event) {
      debug('event "%s"', onEventName, event);

      emitter.trigger(eventName, event);
    };
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return events;
};

/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */
YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var functions = {};

  var _loop2 = function _loop2(functionName) {
    if (strictState && _FunctionStateMap2.default[functionName]) {
      functions[functionName] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return playerAPIReady.then(function (player) {
          var stateInfo = _FunctionStateMap2.default[functionName];
          var playerState = player.getPlayerState();

          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          var value = player[functionName].apply(player, args);

          // TRICKY: For functions like `seekTo`, a change in state must be
          // triggered given that the resulting state could match the initial
          // state.
          if (stateInfo.stateChangeRequired ||

          // eslint-disable-next-line no-extra-parens
          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
            return new Promise(function (resolve) {
              var onPlayerStateChange = function onPlayerStateChange() {
                var playerStateAfterChange = player.getPlayerState();

                var timeout = void 0;

                if (typeof stateInfo.timeout === 'number') {
                  timeout = setTimeout(function () {
                    player.removeEventListener('onStateChange', onPlayerStateChange);

                    resolve();
                  }, stateInfo.timeout);
                }

                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                  player.removeEventListener('onStateChange', onPlayerStateChange);

                  clearTimeout(timeout);

                  resolve();
                }
              };

              player.addEventListener('onStateChange', onPlayerStateChange);
            }).then(function () {
              return value;
            });
          }

          return value;
        });
      };
    } else {
      functions[functionName] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return playerAPIReady.then(function (player) {
          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          return player[functionName].apply(player, args);
        });
      };
    }
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var functionName = _step2.value;

      _loop2(functionName);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return functions;
};

exports.default = YouTubePlayer;
module.exports = exports['default'];

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange'];
module.exports = exports['default'];

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */
exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
module.exports = exports['default'];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loadScript = __webpack_require__(102);

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */
  var iframeAPIReady = new Promise(function (resolve) {
    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
      resolve(window.YT);

      return;
    }

    var previous = window.onYouTubeIframeAPIReady;

    // The API will call this function when page has finished downloading
    // the JavaScript for the player API.
    window.onYouTubeIframeAPIReady = function () {
      if (previous) {
        previous();
      }

      resolve(window.YT);
    };
  });

  var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';

  (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api');

  return iframeAPIReady;
};

module.exports = exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _resize = __webpack_require__(12);

var _resize2 = _interopRequireDefault(_resize);

var _menuAim = __webpack_require__(219);

var _gsap = __webpack_require__(53);

var _focusWithin = __webpack_require__(172);

var _focusWithin2 = _interopRequireDefault(_focusWithin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.CFANav = function (_Snappy$BaseComponent) {
    _inherits(CFANav, _Snappy$BaseComponent);

    _createClass(CFANav, null, [{
        key: 'tagName',
        get: function get() {
            return 'cfa-nav';
        }
    }]);

    function CFANav(element) {
        _classCallCheck(this, CFANav);

        return _possibleConstructorReturn(this, (CFANav.__proto__ || Object.getPrototypeOf(CFANav)).call(this, element));
    }

    _createClass(CFANav, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();

            if (_resize2.default.isDesktop) {
                this.initSticky();
                this.initMenuAim();
                this.initSearch();
                this.initKeyboardNavigation();
                this.switchTabOrder();
            } else {
                this.initMobile();
            }

            var handle = (0, _focusWithin2.default)();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.stickyElement = this.$element.find('.js-sticky-nav');
            this.stickyContainer = this.$element.find('.js-sticky-nav-container');

            this.navContainer = this.$element.find('.js-cfa-nav-container');
            this.mobileNavOpener = this.$element.find('.js-mobile-nav-opener');

            this.mainNav = this.$element.find('.js-cfa-main-nav');
            this.subNav = this.$element.find('.js-cfa-sub-nav');

            this.secondLevelMenu = this.$element.find('.js-cfa-second-level-menu');
            this.menuContent = this.$element.find('.js-cfa-menu-content');

            this.thirdLevelMenu = this.$element.find('.js-cfa-nav-third-level-menu');
            this.menuItem = this.$element.find('.js-menu-item');

            this.menuItemForward = this.$element.find('.js-menu-item-forward');
            this.menuItemBackward = this.$element.find('.js-menu-item-backward');

            this.firstLevelButtons = this.$element.find('.js-cfa-nav-first-level-button');
            this.secondLevelButtons = this.$element.find('.js-cfa-nav-second-level-button');
            this.activeFirstLevelItem = null;
            this.activeSecondLevelItem = null;

            this.isSearchOpened = false;
            this.search = this.$element.find('.js-cfa-search');
            this.openSearch = this.$element.find('.js-cfa-search-open');
            this.closeSearch = this.$element.find('.js-cfa-search-close');
            this.searchForm = this.$element.find('.js-cfa-search-form');
            this.searchInput = this.$element.find('.js-cfa-search-input');
            this.searchUrl = this.search.data('url');
            this.isGoogleSearch = this.search.is('[data-google-search]');

            this.isMobile = !_resize2.default.isDesktop;
            this.isRunning = false;
            this.isDesktopMenuOpened = false;
            this.isMobileMenuOpened = false;
            this.isMenuFocused = false;
            this.isSticky = false;
            this.translateValue = 0;
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$window.on('resize:finished', this.bindedResize = this.onResize.bind(this));
            this.$body.on('body:block', this.onBodyBlock.bind(this));
            this.$body.on('body:unblock', this.onBodyUnblock.bind(this));

            this.navContainer.on('transitionend', this.onNavTransitionEnd.bind(this));
            this.openSearch.on('click', this.onSearchOpen.bind(this));
            this.searchInput.on('keyup', this.onSearchKeyup.bind(this));

            (0, _jquery2.default)(document).on('show.bs.modal', '#IrSignInModal', this.onModalShow.bind(this));
            (0, _jquery2.default)(document).on('hidden.bs.modal', '#IrSignInModal', this.onModalHide.bind(this));
        }
    }, {
        key: 'initKeyboardNavigation',
        value: function initKeyboardNavigation() {
            this.firstLevelButtons.on('click', this.onClickFirstLevelButton.bind(this));
            this.secondLevelButtons.on('click', this.onClickSecondLevelButton.bind(this));
        }
    }, {
        key: 'onModalShow',
        value: function onModalShow() {
            if (this.clientHeight <= window.innerHeight) {
                return;
            }
            var scrollbarWidth = this.getScrollBarWidth();
            if (scrollbarWidth) {
                this.stickyElement.filter(function (index, el) {
                    return (0, _jquery2.default)(el).parents('.js-sticky-nav-container').hasClass('is-fixed');
                }).css('padding-right', scrollbarWidth);
            }
        }
    }, {
        key: 'onModalHide',
        value: function onModalHide() {
            this.stickyElement.filter(function (index, el) {
                return (0, _jquery2.default)(el).parents('.js-sticky-nav-container').hasClass('is-fixed');
            }).css('padding-right', 0);
        }
    }, {
        key: 'getScrollBarWidth',
        value: function getScrollBarWidth() {
            var inner = document.createElement('p');
            inner.style.width = '100%';
            inner.style.height = '200px';

            var outer = document.createElement('div');
            outer.style.position = 'absolute';
            outer.style.top = '0px';
            outer.style.left = '0px';
            outer.style.visibility = 'hidden';
            outer.style.width = '200px';
            outer.style.height = '150px';
            outer.style.overflow = 'hidden';
            outer.appendChild(inner);

            document.body.appendChild(outer);
            var w1 = inner.offsetWidth;
            outer.style.overflow = 'scroll';
            var w2 = inner.offsetWidth;
            if (w1 == w2) w2 = outer.clientWidth;

            document.body.removeChild(outer);

            return w1 - w2;
        }
    }, {
        key: 'onClickFirstLevelButton',
        value: function onClickFirstLevelButton(event) {
            var activeFirstLevelItem = (0, _jquery2.default)(event.target).parents('.js-cfa-nav-first-level-item');

            event.preventDefault();
            event.stopPropagation();

            if (this.activeFirstLevelItem) {
                if (this.activeSecondLevelItem) {
                    this.deactivateThirdLevelMenu(this.activeSecondLevelItem);
                    this.closeThirdLevelMenu(this.activeSecondLevelItem);
                    this.activeSecondLevelItem = null;
                }

                this.deactivateSecondLevelMenu();
                this.closeSecondLevelMenu();

                if (activeFirstLevelItem[0] === this.activeFirstLevelItem[0]) {
                    this.activeFirstLevelItem = null;
                    return;
                }
            }

            this.activeFirstLevelItem = activeFirstLevelItem;
            this.activateSecondLevelMenu(event.target);
        }
    }, {
        key: 'onClickSecondLevelButton',
        value: function onClickSecondLevelButton(event) {
            var activeSecondLevelItem = (0, _jquery2.default)(event.target).parents('.js-cfa-nav-second-level-item');

            event.preventDefault();
            event.stopPropagation();

            if (this.activeSecondLevelItem) {
                this.deactivateThirdLevelMenu();
                this.closeThirdLevelMenu();

                if (activeSecondLevelItem[0] === this.activeSecondLevelItem[0]) {
                    this.activeSecondLevelItem = null;
                    return;
                }
            }

            this.activeSecondLevelItem = activeSecondLevelItem;
            this.activateThirdLevelMenu(event.target);
        }
    }, {
        key: 'initSearch',
        value: function initSearch() {
            this.search.on('transitionend', this.onSearchTransitionEnd.bind(this));
            this.closeSearch.on('click', this.onSearchClose.bind(this));
        }
    }, {
        key: 'onSearchKeyup',
        value: function onSearchKeyup(e) {
            if (e && e.keyCode === 13) {
                this.onSearchSubmit();
            }
        }
    }, {
        key: 'onSearchSubmit',
        value: function onSearchSubmit() {
            var keyword = this.searchInput.val();

            if (keyword === '') {
                return;
            }

            if (this.isGoogleSearch) {
                var query = this.searchForm.serialize();
                window.location.href = this.searchForm.attr('action') + '?' + query;
            } else {
                window.location.href = this.searchUrl + '?keyword=' + keyword + '&page=1';
            }

            var currentSection = this.searchForm.data('currentSection');
            if (currentSection && !this.isSubmitTracked) {
                (0, _jquery2.default)(window).trigger('gtm:send', [currentSection, 'Search', keyword]);
                this.isSubmitTracked = true;
            }
        }
    }, {
        key: 'onSearchOpen',
        value: function onSearchOpen(e) {
            if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
                e.preventDefault();
            }

            var inputValue = this.searchInput.val();

            if (this.isMobile) {
                if (inputValue !== '') {
                    this.onSearchSubmit();
                }

                return;
            }

            if (this.isSearchOpened && inputValue !== '') {
                this.onSearchSubmit();
            } else {
                this.isSearchOpened = true;
                this.search.addClass('cfa-search--opened');
                this.search.addClass('cfa-search--visible');
            }
        }
    }, {
        key: 'onSearchClose',
        value: function onSearchClose(e) {
            if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
                e.preventDefault();
            }

            this.isSearchOpened = false;
            this.search.removeClass('cfa-search--opened');
            this.openSearch.focus();
        }
    }, {
        key: 'onSearchTransitionEnd',
        value: function onSearchTransitionEnd(e) {
            if (e.target !== this.search[0]) {
                return;
            }

            if (this.isSearchOpened) {
                this.searchInput.focus();
            } else {
                this.search.removeClass('cfa-search--visible');
            }
        }
    }, {
        key: 'initMenuAim',
        value: function initMenuAim() {
            this.mainNav.menuAim({
                rowSelector: '> ul > li',
                submenuDirection: 'below',
                tolerance: 0,
                activate: function (el) {
                    this.activateSecondLevelMenu(el);
                }.bind(this),
                deactivate: function (el) {
                    this.deactivateSecondLevelMenu(el);
                }.bind(this),
                exitMenu: this.closeSecondLevelMenu.bind(this)
            });

            this.subNav.menuAim({
                activate: function (el) {
                    this.activateThirdLevelMenu(el);
                }.bind(this),
                deactivate: function (el) {
                    this.deactivateThirdLevelMenu(el);
                }.bind(this),
                exitMenu: this.closeThirdLevelMenu.bind(this)
            });
        }
    }, {
        key: 'activateSecondLevelMenu',
        value: function activateSecondLevelMenu(triggerElem) {
            if (this.isSearchOpened) {
                return;
            }

            this.activeFirstLevelItem = (0, _jquery2.default)(triggerElem).hasClass('js-cfa-nav-first-level-item') ? (0, _jquery2.default)(triggerElem) : (0, _jquery2.default)(triggerElem).parents('.js-cfa-nav-first-level-item');
            this.activeFirstLevelItem.addClass('cfa-nav__item--active');

            var newMenu = this.activeFirstLevelItem.find('.js-cfa-nav-second-level-menu').get(0);

            if (newMenu && !this.isDesktopMenuOpened) {
                var newContent = newMenu.querySelector('.js-cfa-menu-content');

                this.tweenPromote(this.tween);
                this.tween = new _gsap.TimelineLite();
                this.tween.set(newMenu, { display: 'block' });
                this.tween.set(newContent, { autoAlpha: 1 });
                this.tween.to(newMenu, 0.2, {
                    autoAlpha: 1,
                    ease: Power0.easeNone
                });
                this.tween.play();

                newMenu.style.pointerEvents = 'auto';

                this.isDesktopMenuOpened = true;
                this.currentDesktopMenu = newMenu;
            } else if (newMenu && this.isDesktopMenuOpened) {
                var oldMenu = this.currentDesktopMenu,
                    oldContent = oldMenu.querySelector('.js-cfa-menu-content'),
                    _newContent = newMenu.querySelector('.js-cfa-menu-content');

                this.tweenPromote(this.tween);
                this.tween = new _gsap.TimelineLite();
                this.tween.to(oldContent, 0.2, { autoAlpha: 0, ease: Power0.easeNone }).set(newMenu, { display: 'block', autoAlpha: 1 }).set(oldMenu, { display: 'none', autoAlpha: 0 }).to(_newContent, 0.2, { autoAlpha: 1, ease: Power0.easeNone });
                this.tween.play();

                oldMenu.style.pointerEvents = 'none';
                newMenu.style.pointerEvents = 'auto';

                this.currentDesktopMenu = newMenu;
            } else {
                this.closeSecondLevelMenu();
            }
        }
    }, {
        key: 'closeSecondLevelMenu',
        value: function closeSecondLevelMenu() {
            if (this.isDesktopMenuOpened) {
                this.tweenPromote(this.tween);
                this.tween = new _gsap.TimelineLite();
                this.tween.to(this.currentDesktopMenu, 0.2, {
                    autoAlpha: 0,
                    ease: Power0.easeNone
                }).set(this.currentDesktopMenu, { display: 'none' }).set(this.currentDesktopMenu.querySelector('.js-cfa-menu-content'), {
                    autoAlpha: 1
                });
                this.tween.play();

                this.currentDesktopMenu.style.pointerEvents = 'none';

                this.currentDesktopMenu = null;
                this.isDesktopMenuOpened = false;
            }

            return true;
        }
    }, {
        key: 'deactivateSecondLevelMenu',
        value: function deactivateSecondLevelMenu() {
            if (this.isSearchOpened) {
                return;
            }

            this.activeFirstLevelItem.removeClass('cfa-nav__item--active');
        }
    }, {
        key: 'activateThirdLevelMenu',
        value: function activateThirdLevelMenu(triggerElem) {
            this.activeSecondLevelItem = (0, _jquery2.default)(triggerElem).hasClass('js-cfa-nav-second-level-item') ? (0, _jquery2.default)(triggerElem) : (0, _jquery2.default)(triggerElem).parents('.js-cfa-nav-second-level-item');
            this.activeSecondLevelItem.addClass('cfa-menu__item--active');

            var newSubMenu = this.activeSecondLevelItem.find('.js-cfa-nav-third-level-menu')[0];

            if (newSubMenu && !this.isDesktopSubMenuOpened) {
                this.tweenPromote(this.tween);
                this.tween = new _gsap.TimelineLite();
                this.tween.set(newSubMenu, { display: 'block' }).set(this.currentDesktopMenu, {
                    height: newSubMenu.scrollHeight + 40 > this.currentDesktopMenu.scrollHeight ? newSubMenu.scrollHeight + 40 : 'auto'
                }).to(newSubMenu, 0.2, { autoAlpha: 1, ease: Power0.easeNone });
                this.tween.play();

                newSubMenu.style.pointerEvents = 'auto';

                this.isDesktopSubMenuOpened = true;
                this.currentDesktopSubMenu = newSubMenu;
            } else if (newSubMenu && this.isDesktopSubMenuOpened) {
                var oldSubMenu = this.currentDesktopSubMenu;

                this.tweenPromote(this.tween);
                this.tween = new _gsap.TimelineLite();
                this.tween.set(newSubMenu, { display: 'block' }).set(this.currentDesktopMenu, {
                    height: newSubMenu.scrollHeight + 40 > this.currentDesktopMenu.scrollHeight ? newSubMenu.scrollHeight + 40 : 'auto'
                }).to(oldSubMenu, 0.2, { autoAlpha: 0, ease: Power0.easeNone }).set(oldSubMenu, { display: 'none' }).to(newSubMenu, 0.2, { autoAlpha: 1, ease: Power0.easeNone });
                this.tween.play();
                oldSubMenu.style.pointerEvents = 'none';
                newSubMenu.style.pointerEvents = 'auto';

                this.currentDesktopSubMenu = newSubMenu;
            } else {
                this.closeThirdLevelMenu();
            }
        }
    }, {
        key: 'deactivateThirdLevelMenu',
        value: function deactivateThirdLevelMenu(el) {
            if (!this.activeSecondLevelItem) return;

            this.activeSecondLevelItem.removeClass('cfa-menu__item--active');
        }
    }, {
        key: 'closeThirdLevelMenu',
        value: function closeThirdLevelMenu() {
            if (this.isDesktopSubMenuOpened) {
                this.tweenPromote(this.tween);
                this.tween = new _gsap.TimelineLite();
                this.tween.to(this.currentDesktopSubMenu, 0.2, {
                    autoAlpha: 0,
                    ease: Power0.easeNone
                }).set(this.currentDesktopSubMenu, { display: 'none' }).set(this.currentDesktopMenu, { height: 'auto' });
                this.tween.play();

                this.currentDesktopSubMenu.style.pointerEvents = 'none';

                this.currentDesktopSubMenu = null;
                this.isDesktopSubMenuOpened = false;
            }

            return true;
        }
    }, {
        key: 'tweenPromote',
        value: function tweenPromote(tween) {
            if (typeof tween === 'undefined' || tween == null) return;

            if (typeof tween.progress === 'function' && tween.progress() < 1) {
                tween.pause();
                tween.progress(1);
            }

            if (typeof tween.destroy === 'function') {
                tween.destroy();
            }
        }
    }, {
        key: 'destroyMenuAim',
        value: function destroyMenuAim() {
            this.mainNav.menuAim('destroy');
            this.subNav.menuAim('destroy');
            this.secondLevelMenu.removeAttr('style');
            this.menuContent.removeAttr('style');
            this.thirdLevelMenu.removeAttr('style');
        }
    }, {
        key: 'initSticky',
        value: function initSticky() {
            if (this.$body.hasClass('is-experience-editor') || !this.stickyContainer.length) {
                return;
            }

            this.getStickyData();
            this.onScroll();
            (0, _jquery2.default)(window).on('scroll', this.bindedScroll = this.onScroll.bind(this));
        }
    }, {
        key: 'destroySticky',
        value: function destroySticky() {
            this.deactivateSticky();
            (0, _jquery2.default)(window).off('scroll', this.bindedScroll);
        }
    }, {
        key: 'getStickyData',
        value: function getStickyData() {
            this.stickyOffset = this.stickyContainer.height();
            this.offset = this.stickyElement.offset().top;
        }
    }, {
        key: 'activateSticky',
        value: function activateSticky() {
            this.stickyContainer.addClass('is-fixed');
            this.stickyContainer.css('height', this.stickyOffset);
        }
    }, {
        key: 'deactivateSticky',
        value: function deactivateSticky() {
            this.stickyContainer.removeClass('is-fixed');
            this.stickyContainer.css('height', 'auto');
            this.isSticky = false;
        }
    }, {
        key: 'initMobile',
        value: function initMobile() {
            this.mobileNavOpener.on('click', this.bindedHamburgerClick = this.onHamburgerClick.bind(this));
            this.menuItemForward.on('click', this.bindedForwardClick = this.onForwardClick.bind(this));
            this.menuItemBackward.on('click', this.bindedBackwardClick = this.onBackwardClick.bind(this));
        }
    }, {
        key: 'onBodyBlock',
        value: function onBodyBlock() {
            this.pageOffset = this.$body.scrollTop();
            this.$body.addClass('is-blocked');
            this.$body.css('top', -this.pageOffset);
        }
    }, {
        key: 'onBodyUnblock',
        value: function onBodyUnblock() {
            this.$body.css('top', 'initial');
            this.$body.removeClass('is-blocked');
            window.scrollTo(0, this.pageOffset);
        }
    }, {
        key: 'destroyMobile',
        value: function destroyMobile() {
            this.resetMenu();
            this.mobileNavOpener.off('click', this.bindedHamburgerClick);
            this.menuItemForward.off('click', this.bindedForwardClick);
            this.menuItemBackward.off('click', this.bindedBackwardClick);
        }
    }, {
        key: 'resetMenu',
        value: function resetMenu() {
            this.translateValue = 0;
            this.navContainer.css('transform', '');
            this.menuItem.removeClass('is-active');
        }
    }, {
        key: 'onHamburgerClick',
        value: function onHamburgerClick() {
            this.isMobileMenuOpened = !this.isMobileMenuOpened;
            this.resetMenu();
            this.toggleHamburger();
            this.toggleMenu();
            this.toggleBodyBlock();
        }
    }, {
        key: 'onNavTransitionEnd',
        value: function onNavTransitionEnd(e) {
            if (e.target !== this.navContainer[0]) {
                return;
            }

            this.isRunning = false;
            if (this.translateValue === -100) {
                this.subNav.find('li.is-active').removeClass('is-active');
            } else if (this.translateValue === 0) {
                this.mainNav.find('li.is-active').removeClass('is-active');
            }
        }
    }, {
        key: 'onForwardClick',
        value: function onForwardClick(e) {
            if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
                e.preventDefault();
            }

            if (this.isRunning) {
                return;
            } else {
                this.isRunning = true;
            }

            var forwardLink = (0, _jquery2.default)(e.currentTarget);
            forwardLink.closest('.js-menu-item').addClass('is-active');

            this.translateValue -= 100;
            this.navContainer.css('transform', 'translateX(' + this.translateValue + '%)');
        }
    }, {
        key: 'onBackwardClick',
        value: function onBackwardClick(e) {
            if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
                e.preventDefault();
            }

            if (this.isRunning) {
                return;
            } else {
                this.isRunning = true;
            }

            //const backwardLink = $(e.currentTarget);

            this.translateValue += 100;
            this.navContainer.css('transform', 'translateX(' + this.translateValue + '%)');
        }
    }, {
        key: 'toggleHamburger',
        value: function toggleHamburger() {
            this.mobileNavOpener.toggleClass('is-active', this.isMobileMenuOpened);
        }
    }, {
        key: 'toggleMenu',
        value: function toggleMenu() {
            this.$element.toggleClass('is-mobile-active', this.isMobileMenuOpened);
        }
    }, {
        key: 'toggleBodyBlock',
        value: function toggleBodyBlock() {
            if (this.isMobileMenuOpened) {
                this.$body.trigger('body:block');
            } else {
                this.$body.trigger('body:unblock');
            }
        }
    }, {
        key: 'onScroll',
        value: function onScroll() {
            if (this.isSticky !== this.offset < window.pageYOffset) {
                this.isSticky = !this.isSticky;

                if (this.isSticky) {
                    this.activateSticky();
                } else {
                    this.deactivateSticky();
                }
            }
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            var screenSize = void 0;

            if (_resize2.default.isDesktop) {
                screenSize = 'desktop';
            } else {
                screenSize = 'mobile';
            }

            this.onBreakpointChange(screenSize);
        }
    }, {
        key: 'onBreakpointChange',
        value: function onBreakpointChange(screenSize) {
            var wasMobile = this.isMobile;
            var isMobile = screenSize === 'mobile';

            if (isMobile && !wasMobile) {
                if (this.isSearchOpened) {
                    this.onSearchClose();
                }

                this.destroySticky();
                //this.destroyKeyboardNavigation();
                this.destroyMenuAim();
                this.initMobile();
            } else if (!isMobile && wasMobile) {
                if (this.isMobileMenuOpened) {
                    this.isMobileMenuOpened = false;
                    this.toggleMenu();
                    this.toggleHamburger();
                    this.toggleBodyBlock();
                }

                this.destroyMobile();
                this.initSticky();
                this.initMenuAim();
                this.initSearch();
                //this.initKeyboardNavigation();
            }

            this.isMobile = isMobile;
            this.switchTabOrder();
        }
    }, {
        key: 'switchTabOrder',
        value: function switchTabOrder() {
            if (this.isMobile) {
                this.mainNav.insertAfter(this.search);
            } else {
                this.search.insertAfter(this.mainNav);
            }
        }
    }]);

    return CFANav;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _handlebars = __webpack_require__(10);

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ContactForm = function (_Snappy$BaseComponent) {
    _inherits(ContactForm, _Snappy$BaseComponent);

    _createClass(ContactForm, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-contact-form';
        }
    }]);

    function ContactForm(element) {
        _classCallCheck(this, ContactForm);

        return _possibleConstructorReturn(this, (ContactForm.__proto__ || Object.getPrototypeOf(ContactForm)).call(this, element));
    }

    _createClass(ContactForm, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.addEventListeners();
            localStorage.removeItem(this.$unsavedDataStorageNamespace);
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$form = this.$element.find('.fa-contact-form__form');
            this.$messageContainer = this.$element.find('.message-container');
            this.errorClass = 'fa-input-field--error';
            this.messageClass = 'fa-input-field__error-message';
            this.$addFieldButton = this.$element.find('.js-add-field-button');
            this.$formItself = this.$element.find('[data-form-itself]');
            this.$thankYouMessage = this.$element.find('[data-thank-you-message]');
            this.$fileinputs = this.$element.find('.js-inputfile');
            this.$conditionalSelect = this.$element.find('[data-conditional-select]');
            this.$conditionalOptions = this.$element.find('[data-conditional-option]');
            this.$removeSectionButton = this.$element.find('[data-remove-section-button]');
            this.$addSectionButton = this.$element.find('[data-add-section-button]');
            this.$newSectionsPlaceholder = this.$element.find('[data-new-sections-placeholder]');
            this.$submitButton = this.$element.find(':submit');
            this.isProfile = this.$element[0].hasAttribute('data-profile-form');
            this.isHandleUnsavedData = this.$element.is('[data-unsaved-storage-namespace]');
            this.$unsavedDataStorageNamespace = this.$element.attr('data-unsaved-storage-namespace');
            this.$initialState = this.$form.serialize();
            this.$preloader = this.$element.find('.js-cfa-preloader');
            this.$avatar = this.$element.find('.js-avatar');

            if (window.FileReader) {
                this.fileReader = new FileReader();
            }
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            this.$form.on('submit', this.onFormSubmission.bind(this));
            this.$addFieldButton.on('click', this.addField.bind(this));
            if (this.$fileinputs.length) {
                this.$fileinputs.on('change', this.onInputFileChange.bind(this));
            }
            if (this.$conditionalSelect.length) {
                this.$element.on('change', this.$conditionalSelect, this.onConditionalSelectChange.bind(this));
            }
            if (this.$addSectionButton.length) {
                this.$addSectionButton.on('click', this.onAddSectionButtonClick.bind(this));
            }
            if (this.$removeSectionButton.length) {
                this.$element.on('click', this.$removeSectionButton, this.onRemoveSectionButtonClick.bind(this));
            }

            this.$form.on('change', this.onFormChange.bind(this));

            if (this.isProfile) {
                this.fileReader.addEventListener('loadend', this.onFileReaderLoadFile.bind(this));
            }
        }
    }, {
        key: 'onAddSectionButtonClick',
        value: function onAddSectionButtonClick(e) {
            e.preventDefault();

            var $target = (0, _jquery2.default)(e.target);

            var $lastSectionIndex = this.getLastSectionIndex();

            var $templateType = $target.attr('data-add-section-template-type');

            var $templateSource = (0, _jquery2.default)('#' + $templateType + '-section-template').html();

            var $newSectionHtml = this.getNewSectionHtml($templateSource, $lastSectionIndex + 1);

            this.$newSectionsPlaceholder.append($newSectionHtml);

            this.$conditionalOptions = this.$element.find('[data-conditional-option]');
        }
    }, {
        key: 'onFormChange',
        value: function onFormChange(e) {
            if (this.isHandleUnsavedData) {
                this.handleUnsavedData();
            }

            this.removeValidationError({ element: e.target.name });
        }
    }, {
        key: 'isDirty',
        value: function isDirty() {
            return this.$form.serialize() !== this.$initialState;
        }
    }, {
        key: 'getLastSectionIndex',
        value: function getLastSectionIndex() {
            var $availableSections = this.$element.find('[data-section]');

            var sectionsIndexes = [];
            var maxIndex = null;

            $availableSections.each(function (index, el) {
                sectionsIndexes.push(parseInt((0, _jquery2.default)(el).attr('data-section-index')));
            });

            maxIndex = sectionsIndexes.reduce(function (a, b) {
                return Math.max(a, b);
            }, 0);

            return maxIndex;
        }
    }, {
        key: 'getNewSectionHtml',
        value: function getNewSectionHtml(template, index) {
            var sectionTemplateFn = _handlebars2.default.compile(template);
            return sectionTemplateFn({ sectionIndex: index });
        }
    }, {
        key: 'onRemoveSectionButtonClick',
        value: function onRemoveSectionButtonClick(e) {
            var $target = (0, _jquery2.default)(e.target);

            if (!$target[0].hasAttribute('data-remove-section-button')) return;

            var $sectionIndexToRemove = $target.attr('data-remove-section-button-index');

            this.$element.find('[data-section-index="' + $sectionIndexToRemove + '"]').remove();
        }
    }, {
        key: 'onConditionalSelectChange',
        value: function onConditionalSelectChange(e) {
            var $target = (0, _jquery2.default)(e.target);

            if (!$target[0].hasAttribute('data-conditional-select')) return;

            var $choosenOption = this.getInputValue($target);
            var $conditionalSelectGroup = $target.attr('data-conditional-group');

            $target.closest('.cfa-field').removeClass('fa-input-field--error').find('.cfa-field__error').text('');

            $target.removeClass('fa-input-field--error');

            this.$conditionalOptions.filter('[data-conditional-group="' + $conditionalSelectGroup + '"]').hide().find('[data-conditional-input]').val('');
            this.$element.find('[data-' + $choosenOption + ']').filter('[data-conditional-group="' + $conditionalSelectGroup + '"]').show();
        }
    }, {
        key: 'getInputValue',
        value: function getInputValue($input) {
            var type = $input.attr('type');

            if (type === 'radio') {
                return (0, _jquery2.default)('input[name=' + $input.attr("name") + ']:checked').val();
            }

            if (type === 'checkbox') return $input.is(':checked');

            return $input.val();
        }
    }, {
        key: 'toggleLoading',
        value: function toggleLoading() {
            if (this.$preloader.length) {
                this.$preloader.toggleClass('cfa-preloader--active', this.isLoading);
            }
        }
    }, {
        key: 'onFormSubmission',
        value: function onFormSubmission(event) {
            event.preventDefault();
            this.toggleLoading();
            if (this.$preloader.length) {
                this.$preloader.attr('aria-busy', true);
            }

            _jquery2.default.ajax({
                url: this.formAction = this.$form.attr('action'),
                method: this.formMethod = this.$form.attr('method'),
                data: new FormData(event.target),
                contentType: false,
                cache: false,
                processData: false
            }).fail(this.handleFailedResponse.bind(this)).always(this.handleValidationResponse.bind(this));
        }
    }, {
        key: 'handleFailedResponse',
        value: function handleFailedResponse(response) {
            var pathname = window.location.pathname;

            if (response.status === 403) {
                window.location = response.responseJSON.logOnUrl + '?ReturnUrl=' + pathname;
            }
        }
    }, {
        key: 'handleValidationResponse',
        value: function handleValidationResponse(response) {
            var _this2 = this;

            this.toggleLoading();
            if (this.$preloader.length) {
                this.$preloader.attr('aria-busy', false);
            }

            if (!response.success) {
                _jquery2.default.each(response.fields, function (i, field) {
                    if (!field.success) {
                        _this2.showValidationError(field);
                    } else {
                        _this2.removeValidationError(field);
                    }
                });
                this.scrollToError(this.$form.find('.fa-input-field--error:first'));
            } else {
                this.handleSuccess(response);
            }
        }
    }, {
        key: 'getEscapedSelector',
        value: function getEscapedSelector(field) {

            return field.element ? field.element.replace(/(:|\.|\[|\])/g, '\\$1') : null;
        }
    }, {
        key: 'showValidationError',
        value: function showValidationError(field) {

            var escapedSelector = this.getEscapedSelector(field);

            var $element = this.$form.find('[name=' + escapedSelector + ']');

            $element.addClass(this.errorClass)[$element.is(':checkbox') ? 'parents' : 'closest']('.cfa-field').addClass(this.errorClass).find('.' + this.messageClass).text(field.message);
        }
    }, {
        key: 'onInputFileChange',
        value: function onInputFileChange(e) {
            var label = e.target.nextElementSibling;
            var labelVal = label.innerHTML;
            var fileName = '';

            fileName = e.target.value.split('\\').pop();

            var filelabel = label.querySelector('.js-inputfile-label');

            if (this.isProfile) {
                filelabel.innerHTML = 'Change Photo';
                var file = e.target.files[0];
                this.showAvatar(file);
            } else {
                if (fileName && filelabel) {
                    filelabel.innerHTML = fileName;
                } else {
                    label.innerHTML = labelVal;
                }
            }
        }
    }, {
        key: 'showAvatar',
        value: function showAvatar(file) {
            if (window.File && window.FileReader && window.FileList && window.Blob) {
                if (file) {
                    this.fileReader.readAsDataURL(file);
                }
            }
        }
    }, {
        key: 'onFileReaderLoadFile',
        value: function onFileReaderLoadFile() {
            this.updateAvatar(this.fileReader.result);
        }
    }, {
        key: 'removeValidationError',
        value: function removeValidationError(field) {
            var escapedSelector = this.getEscapedSelector(field);

            var $element = this.$form.find('[name=' + escapedSelector + ']');

            $element.removeClass(this.errorClass)[$element.is(':checkbox') ? 'parents' : 'closest']('.cfa-field').removeClass(this.errorClass).find('.' + this.messageClass).text('');
        }
    }, {
        key: 'getNextIndex',
        value: function getNextIndex() {}
    }, {
        key: 'addNewSection',
        value: function addNewSection(template) {}
    }, {
        key: 'handleUnsavedData',
        value: function handleUnsavedData() {
            this.$form[this.isDirty() ? 'addClass' : 'removeClass']('is-dirty');

            var formName = this.$form.closest('.js-tab').attr('data-target');

            var unsavedData = {};

            unsavedData[formName] = this.isDirty();

            (0, _jquery2.default)(window).trigger('unsaved:changed', [this.$unsavedDataStorageNamespace, unsavedData]);

            if (this.isDirty()) {
                this.$submitButton.text('Save');
            }
        }
    }, {
        key: 'handleSuccess',
        value: function handleSuccess(response) {
            var _this3 = this;

            var activeClass = 'active';

            if (this.isHandleUnsavedData) {
                this.$initialState = this.$form.serialize();
                this.handleUnsavedData();
            }

            this.removeErrors();

            if (!this.isProfile) {
                this.resetForm();
            }

            this.$messageContainer.addClass(activeClass);

            if (this.$thankYouMessage.length && this.$formItself.length) {
                this.$form.css('height', this.$form.outerHeight());
                this.$formItself.fadeOut(function () {
                    _this3.$thankYouMessage.fadeIn(function () {
                        _this3.$form.wrapInner('<div/>');
                        var newHeight = _this3.$form.find('div:first').height();
                        _this3.$form.css('height', newHeight);
                    });
                });
            }

            // commented code below didn't work so now it's commented and is to be removed
            // $.each(response.fields, (i, field) => {
            //     this.removeValidationError(field);
            // });

            window.setTimeout(function () {
                this.$messageContainer.removeClass(activeClass);
            }.bind(this), 10000);

            if (this.isProfile) {
                this.$submitButton.text('Saved');
                this.updateAvatar(response.photo);
            }

            if (this.$body.hasClass('cfa-generic')) {
                (0, _jquery2.default)(window).trigger('gtm:send', ['Contact Us', 'Submit', 'Submit an enquiry']);
            }

            this.trackSubmission();
        }
    }, {
        key: 'updateAvatar',
        value: function updateAvatar(photoUrl) {
            this.$avatar.attr('src', photoUrl);
        }
    }, {
        key: 'trackSubmission',
        value: function trackSubmission() {
            var category = this.$element.attr('data-gtm-category');
            var action = this.$element.attr('data-gtm-action');
            var label = this.$element.attr('data-gtm-label') || '';

            if (category && action) {
                (0, _jquery2.default)(window).trigger('gtm:send', [category, action, label]);
            }
        }
    }, {
        key: 'removeErrors',
        value: function removeErrors() {
            var _this4 = this;

            this.$form.find('input, select, textarea').each(function (i, element) {
                (0, _jquery2.default)(element).removeClass(_this4.errorClass)[(0, _jquery2.default)(element).is(':checkbox') ? 'parents' : 'closest']('.cfa-field').removeClass(_this4.errorClass).find('.' + _this4.messageClass).text('');
            });
        }
    }, {
        key: 'addField',
        value: function addField(e) {
            e.preventDefault();

            var $clonedField = (0, _jquery2.default)(e.target).closest('[data-clonable]').find('[data-to-clone]').not('[data-cloned]').clone().val('').attr('data-cloned', '');

            (0, _jquery2.default)(e.target).closest('[data-clonable]').find('.js-added-fields-container').append($clonedField);
        }
    }, {
        key: 'resetForm',
        value: function resetForm() {
            this.$form.find('input, select, textarea').each(function (i, element) {
                element.value = '';
            });
        }
    }, {
        key: 'scrollToError',
        value: function scrollToError(el) {
            if (el.length) {
                (0, _jquery2.default)('html, body').animate({ scrollTop: el.offset().top - 100 }, 300);
            }
        }
    }]);

    return ContactForm;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _queryString = __webpack_require__(57);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ContentLoader = function (_Snappy$BaseComponent) {
    _inherits(ContentLoader, _Snappy$BaseComponent);

    _createClass(ContentLoader, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-content-loader';
        }
    }]);

    function ContentLoader(element) {
        _classCallCheck(this, ContentLoader);

        return _possibleConstructorReturn(this, (ContentLoader.__proto__ || Object.getPrototypeOf(ContentLoader)).call(this, element));
    }

    _createClass(ContentLoader, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.addEventListeners();
            this.selectFilterOption();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$contentContainer = this.$element.find('.js-content-container');
            this.$contentFilter = this.$element.find('.js-content-filter');
            this.$contentFilterBtn = this.$element.find('.js-content-filter-btn');
            this.$preloader = this.$element.find('.js-cfa-preloader');
            this.$handler = this.$element.data('url');
            this.$queryParameter = this.$element.data('query-parameter');
            this.$pages = this.$element.find('.js-content-page');
            this.$prevNextPage = this.$element.find('.js-content-page-prev-next');
            this.paramsObj = {};
            this.selectedValue = '';
            this.isLoading = false;
            this.browserAddressWay = this.$element.data('browser-address');
            this.currentPage = 1;
            if (this.$contentFilter.length) {
                this.selectedOption = (0, _jquery2.default)(this.$contentFilter[0].options[this.$contentFilter[0].selectedIndex]);
            }

            this.shouldFocused = false;
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            if (this.$contentFilter.length) {
                this.$contentFilter.on('change', this.onFilterChange.bind(this));
            }
            this.bindPageListeners();

            if (this.$contentFilterBtn) {
                this.$contentFilterBtn.on('click', this.onFilterChange.bind(this));
            }

            this.$window.on('contentLoader:loadByQueryString', this.loadByQueryString.bind(this));
            this.$window.on('contentLoader:setQueryString', this.setQueryString.bind(this));
            this.$window.on('popstate', this.onPopstate.bind(this));
        }
    }, {
        key: 'bindPageListeners',
        value: function bindPageListeners() {
            this.unbindPageListeners();
            this.$pages.on('click', this.bindedPageListeners = this.changePage.bind(this));
            this.$prevNextPage.on('click', this.bindedPrevNextPageListeners = this.onPrevNextClick.bind(this));
        }
    }, {
        key: 'unbindPageListeners',
        value: function unbindPageListeners() {
            this.$pages.off('click', this.bindedPageListeners);
            this.$prevNextPage.off('click', this.bindedPrevNextPageListeners);
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange() {
            this.$preloader.attr('aria-busy', true);
            this.sendChosenFilter();
        }
    }, {
        key: 'changePage',
        value: function changePage(e) {
            e.preventDefault();
            var page = (0, _jquery2.default)(e.target).data('page-number');

            this.shouldFocused = true;
            this.onPageChange(page);
        }
    }, {
        key: 'onPrevNextClick',
        value: function onPrevNextClick(e) {
            e.preventDefault();

            var link = (0, _jquery2.default)(e.currentTarget),
                linkType = void 0,
                page = void 0;

            linkType = link.data('page-type');

            this.currentPage = this.$pages.filter('.is-active').data('page-number');

            page = linkType === 'prev' ? --this.currentPage : ++this.currentPage;

            this.shouldFocused = true;
            this.onPageChange(page);
        }
    }, {
        key: 'updatePageInParamsObj',
        value: function updatePageInParamsObj(page) {
            if (page !== '' && page !== 1) {
                this.paramsObj.page = page;
            }

            if (page === 1) {
                delete this.paramsObj.page;
            }
        }
    }, {
        key: 'onPageChange',
        value: function onPageChange(page) {

            this.updatePageInParamsObj(page);

            this.isPageChanged = true;
            this.updateBrowserAddress();
            this.fetchData();
        }
    }, {
        key: 'sendChosenFilter',
        value: function sendChosenFilter() {
            this.paramsObj = {};
            this.currentPage = 1;

            this.selectedOption = (0, _jquery2.default)(this.$contentFilter[0].options[this.$contentFilter[0].selectedIndex]);
            this.selectedValue = this.selectedOption.val();

            if (this.selectedValue !== 'null' && this.selectedValue !== '') {
                this.paramsObj[this.$queryParameter] = this.selectedValue;
            }
            this.updateBrowserAddress();

            this.fetchData();
        }
    }, {
        key: 'setParamsObj',
        value: function setParamsObj(obj) {
            this.paramsObj = obj;
        }
    }, {
        key: 'fetchData',
        value: function fetchData() {
            var paramsStr = _queryString2.default.stringify(this.paramsObj);
            var url = this.$handler + (this.$handler.indexOf('?') === -1 ? '?' : '&') + paramsStr;

            this.isLoading = true;
            this.toggleLoading();

            _jquery2.default.ajax({
                url: url,
                type: 'GET',
                dataType: 'html',
                success: this.handleSuccess.bind(this),
                error: this.handleError.bind(this)
            });
        }
    }, {
        key: 'loadByQueryString',
        value: function loadByQueryString(e, qs) {
            var parsedQs = _queryString2.default.parse(qs);
            this.setParamsObj(parsedQs);
            this.fetchData();
            this.updateBrowserAddress();
        }
    }, {
        key: 'setQueryString',
        value: function setQueryString(e, qs) {
            var parsedQs = _queryString2.default.parse(qs);
            this.setParamsObj(parsedQs);
        }
    }, {
        key: 'handleSuccess',
        value: function handleSuccess(response) {
            this.isLoading = false;
            this.toggleLoading();
            this.$contentContainer.empty().html(response);
            this.$window.trigger('content:updated');
            this.$pages = this.$contentContainer.find('.js-content-page');
            this.$prevNextPage = this.$contentContainer.find('.js-content-page-prev-next');
            this.bindPageListeners();

            if (this.shouldFocused) {
                this.shouldFocused = false;

                var $card = this.$contentContainer.find('a').first();

                if ($card.length) {
                    $card.focus();
                }
            }

            this.$preloader.attr('aria-busy', false);
        }
    }, {
        key: 'handleError',
        value: function handleError(response) {
            console.log(response);
        }
    }, {
        key: 'toggleLoading',
        value: function toggleLoading() {
            this.$preloader.toggleClass('cfa-preloader--active', this.isLoading);
        }
    }, {
        key: 'selectFilterOption',
        value: function selectFilterOption() {
            if (!this.selectedOption) return;

            var optionType = this.selectedOption.data('type');

            if (optionType) {
                if ('scrollRestoration' in history) {
                    history.scrollRestoration = 'manual';
                }

                window.scroll(0, this.$element.offset().top - 70);
            }
        }
    }, {
        key: 'updateURLHash',
        value: function updateURLHash() {
            var parsedSearchString = _queryString2.default.parse(location.search);

            if (this.$contentFilter.length) {
                var optionType = this.selectedOption.data('type');

                if (optionType) {
                    parsedSearchString[this.$queryParameter] = optionType;
                } else {
                    delete parsedSearchString[this.$queryParameter];
                }
            }

            if (this.paramsObj.page) {
                parsedSearchString.page = this.paramsObj.page;
            } else {
                delete parsedSearchString.page;
            }

            var URL = location.pathname,
                convertedQuiery = _queryString2.default.stringify(parsedSearchString);

            if (convertedQuiery) {
                URL += '?' + convertedQuiery;
            }

            URL += location.hash;

            this.changeHistory(document.title, URL);
        }
    }, {
        key: 'updateBrowserAddress',
        value: function updateBrowserAddress() {
            if (this.browserAddressWay === 'transmit') {
                this.transmitQsObjectToBA();
            } else {
                this.updateURLHash();
            }
        }

        // use query parameters from this.paramsObj (it is used for ajax call) to generate query string in browser address

    }, {
        key: 'transmitQsObjectToBA',
        value: function transmitQsObjectToBA() {
            var qs = _queryString2.default.stringify(this.paramsObj);
            var browserQs = qs ? '?' + qs : '';
            var url = '' + window.location.pathname + browserQs;
            this.changeHistory(document.title, url);
        }
    }, {
        key: 'changeHistory',
        value: function changeHistory(title, url) {
            if (this.isPageChanged) {
                window.history.pushState({}, title, url);
            } else {
                window.history.replaceState({}, title, url);
            }

            this.isPageChanged = false;
        }
    }, {
        key: 'onPopstate',
        value: function onPopstate() {
            if (window.location.hash) {
                return;
            }
            var qs = document.location.search;
            var parsedQs = _queryString2.default.parse(qs);

            var page = parsedQs.page || 1;
            this.updatePageInParamsObj(page);
            this.fetchData();
        }
    }]);

    return ContentLoader;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ContentPromo = function (_Snappy$BaseComponent) {
	_inherits(ContentPromo, _Snappy$BaseComponent);

	_createClass(ContentPromo, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-content-promo';
		}
	}]);

	function ContentPromo(element) {
		_classCallCheck(this, ContentPromo);

		return _possibleConstructorReturn(this, (ContentPromo.__proto__ || Object.getPrototypeOf(ContentPromo)).call(this, element));
	}

	_createClass(ContentPromo, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.setEventListeners();
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.$anchorableElement = this.$element.find('.fa-content-promo__block-link');
			this.elementHasFocusClass = 'fa-content-promo--has-focus';
		}
	}, {
		key: 'setEventListeners',
		value: function setEventListeners() {
			this.$anchorableElement.on('mouseover focus', this.onElementFocusState.bind(this));
			this.$anchorableElement.on('mouseout focusout', this.onElementBlur.bind(this));
		}
	}, {
		key: 'onElementFocusState',
		value: function onElementFocusState() {
			this.$element.addClass(this.elementHasFocusClass);
		}
	}, {
		key: 'onElementBlur',
		value: function onElementBlur(event) {
			var toElement = event.toElement || event.relatedTarget;
			var toElementIsRelated = _jquery2.default.contains(this.$element[0], toElement);

			if (!toElementIsRelated) {
				this.$element.removeClass(this.elementHasFocusClass);
			}
		}
	}]);

	return ContentPromo;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _queryString = __webpack_require__(57);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.CourseTable = function (_Snappy$BaseComponent) {
    _inherits(CourseTable, _Snappy$BaseComponent);

    _createClass(CourseTable, null, [{
        key: 'tagName',
        get: function get() {
            return 'cfa-course-table';
        }
    }]);

    function CourseTable(element) {
        _classCallCheck(this, CourseTable);

        return _possibleConstructorReturn(this, (CourseTable.__proto__ || Object.getPrototypeOf(CourseTable)).call(this, element));
    }

    _createClass(CourseTable, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.onPopState();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$filterDropdown = this.$element.find('.js-cfa-course-table-filter');
            this.$resetButton = this.$element.find('.js-cfa-course-table-reset');
            this.$courseBlocks = this.$element.find('[data-block]');
            this.selectedValue = '';
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.bindEventListeners();
            this.$window.on('popstate', this.onPopState.bind(this));
        }
    }, {
        key: 'bindEventListeners',
        value: function bindEventListeners() {
            this.unbindEventListeners();
            this.$filterDropdown.on('change', this.bindedFilterDropdownListeners = this.onChange.bind(this));
            this.$resetButton.on('click', this.bindedResetButtonListeners = this.onReset.bind(this));
        }
    }, {
        key: 'unbindEventListeners',
        value: function unbindEventListeners() {
            this.$filterDropdown.off('change', this.bindedFilterDropdownListeners);
            this.$resetButton.off('click', this.bindedResetButtonListeners);
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            var _this2 = this;

            this.selectedValue = (0, _jquery2.default)(e.target).val();
            var filteredBlocks = this.$courseBlocks.removeClass('is-hidden').filter(function (index, el) {
                return _this2.selectedValue && (0, _jquery2.default)(el).data('block') !== _this2.selectedValue;
            }).addClass('is-hidden');

            this.updateURLHash(this.selectedValue);
        }
    }, {
        key: 'onReset',
        value: function onReset(e) {
            e.preventDefault();
            this.$filterDropdown.val('').trigger('change');
        }
    }, {
        key: 'updateURLHash',
        value: function updateURLHash(value) {
            var parsedSearchString = _queryString2.default.parse(location.search);
            parsedSearchString['block'] = value;

            var convertedQuery = _queryString2.default.stringify(parsedSearchString),
                URL = value !== '' ? location.pathname + '?' + convertedQuery + location.hash : location.pathname + location.hash;

            if ('pushState' in history) {
                history.pushState({}, document.title, URL);
            }
        }
    }, {
        key: 'onPopState',
        value: function onPopState() {
            var parsedSearchString = _queryString2.default.parse(location.search);

            this.selectedValue = parsedSearchString['block'];

            if (this.selectedValue !== '') {
                this.$filterDropdown.val(this.selectedValue).trigger('change');
            }
        }
    }]);

    return CourseTable;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(48);

_snappy2.default.Component.CWFooter = function (_Snappy$BaseComponent) {
	_inherits(CWFooter, _Snappy$BaseComponent);

	_createClass(CWFooter, null, [{
		key: 'tagName',
		get: function get() {
			return 'cw-footer';
		}
	}]);

	function CWFooter(element) {
		_classCallCheck(this, CWFooter);

		var _this = _possibleConstructorReturn(this, (CWFooter.__proto__ || Object.getPrototypeOf(CWFooter)).call(this, element));

		(0, _jquery2.default)('.fa-footer__newsletter__form').submit(_this.openModalForm);
		return _this;
	}

	_createClass(CWFooter, [{
		key: 'setVars',
		value: function setVars() {
			this.$newsletterForm = this.$element.find('.cw-footer__newsletter__form');
		}
	}, {
		key: 'setEventListeners',
		value: function setEventListeners() {
			this.$newsletterForm.on('submit', this.validateNewsletterForm.bind(this));
		}
	}, {
		key: 'validateNewsletterForm',
		value: function validateNewsletterForm(event) {
			var $emailField = this.$newsletterForm.find('input[type=email]');
			this.$newsletterForm.validate({
				rules: {
					'Email': {
						required: true,
						email: true
					}
				}
			});

			if ($emailField.valid()) {
				this.openNewsletterModal();
			} else {
				$emailField.focus();
			}

			event.preventDefault();
		}
	}, {
		key: 'openNewsletterModal',
		value: function openNewsletterModal() {
			var $button = this.$newsletterForm.find('button');

			this.$window.trigger('modal:openModal', {
				$view: (0, _jquery2.default)($button.data('modal-template')),
				title: $button.data('modal-title'),
				$prevElement: $button
			});
		}
	}, {
		key: 'openModalForm',
		value: function openModalForm(event) {
			var emailAddress = (0, _jquery2.default)(this).find('input[type=email]').val();
			window.setTimeout(function () {
				new _snappy2.default.Component.NewsletterForm('div.cw-newsletter-form').render();
				(0, _jquery2.default)('.cw-newsletter-form__form').find('input[type=email]').val(emailAddress);
			}.bind(this), 1);
			event.preventDefault();
		}
	}, {
		key: 'closeNewsletterModal',
		value: function closeNewsletterModal(modal) {
			modal.closeModal();
		}
	}, {
		key: 'render',
		value: function render() {
			this.setVars();
			this.setEventListeners();
		}
	}]);

	return CWFooter;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Dropdown = function (_Snappy$BaseComponent) {
	_inherits(Dropdown, _Snappy$BaseComponent);

	_createClass(Dropdown, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-dropdown';
		}
	}]);

	function Dropdown(element) {
		_classCallCheck(this, Dropdown);

		return _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, element));
	}

	_createClass(Dropdown, [{
		key: 'render',
		value: function render() {}
	}]);

	return Dropdown;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _customValidation = __webpack_require__(147);

var _customValidation2 = _interopRequireDefault(_customValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.FindCourse = function (_Snappy$BaseComponent) {
	_inherits(FindCourse, _Snappy$BaseComponent);

	_createClass(FindCourse, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-find-course';
		}
	}]);

	function FindCourse(element) {
		_classCallCheck(this, FindCourse);

		return _possibleConstructorReturn(this, (FindCourse.__proto__ || Object.getPrototypeOf(FindCourse)).call(this, element));
	}

	_createClass(FindCourse, [{
		key: 'setVars',
		value: function setVars() {
			this.findCourseForm = document.getElementById('findCourseForm');
		}
	}, {
		key: 'render',
		value: function render() {
			this.setVars();
			this.attachValidationToForm();
		}
	}, {
		key: 'attachValidationToForm',
		value: function attachValidationToForm() {
			this.formInstance = new _customValidation2.default(this.findCourseForm);
			this.formInstance.init();
		}
	}]);

	return FindCourse;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Gallery = function (_Snappy$BaseComponent) {
	_inherits(Gallery, _Snappy$BaseComponent);

	_createClass(Gallery, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-gallery';
		}
	}]);

	function Gallery(element) {
		_classCallCheck(this, Gallery);

		return _possibleConstructorReturn(this, (Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call(this, element));
	}

	_createClass(Gallery, [{
		key: 'setVars',
		value: function setVars() {
			this.$mediaFrame = this.$element.find('.media-frame');
			this.$thumbnailBtns = this.$element.find('.media-carousel__thumbnail-button');
			this.activeSlide = null;
			this.$allAssets = this.$element.find('.media-carousel__asset');
			this.activeThumbnailClass = 'active';
		}
	}, {
		key: 'addEventListeners',
		value: function addEventListeners() {
			this.$thumbnailBtns.on('click', this.handleThumbnailBtnClick.bind(this));
		}
	}, {
		key: 'render',
		value: function render() {
			this.setVars();
			this.addEventListeners();
			this.initiateSnappyTracker();
			this.initiateGallery();
		}
	}, {
		key: 'initiateSnappyTracker',
		value: function initiateSnappyTracker() {
			this.SnappyComponents = [];
		}
	}, {
		key: 'handleThumbnailBtnClick',
		value: function handleThumbnailBtnClick(event) {
			var $thumbnail = (0, _jquery2.default)(event.currentTarget);
			this.setActiveSlide($thumbnail);
		}
	}, {
		key: 'initiateGallery',
		value: function initiateGallery() {
			var $firstThumnail = this.$element.find('.carousel__slide[data-slick-index="0"] .media-carousel__thumbnail-button[data-asset="0"]');
			this.setActiveSlide($firstThumnail);
		}
	}, {
		key: 'setActiveSlide',
		value: function setActiveSlide($thumbnail) {
			var $asset = $thumbnail.siblings('.media-carousel__asset');
			var slickIndex = $thumbnail.parents('.slick-slide').data('slick-index');

			if (slickIndex !== this.slickIndex) {
				this.emptyFrame();
				this.setActiveClasses($thumbnail);
				this.injectViewIntoFrame($asset);
				this.activeSlide = slickIndex;
			}
		}
	}, {
		key: 'setActiveClasses',
		value: function setActiveClasses($thumbnail) {
			this.$thumbnailBtns.removeClass(this.activeThumbnailClass);
			$thumbnail.addClass(this.activeThumbnailClass);
		}
	}, {
		key: 'injectViewIntoFrame',
		value: function injectViewIntoFrame($asset) {
			var $clone = $asset.clone();
			var $pageMedia = $clone.find('.fa-page-media');
			this.$mediaFrame.append($clone);
			this.activeFrame = new _snappy2.default.Component.PageMedia($pageMedia[0]);
			this.activeFrame.render();
			this.SnappyComponents.push(this.activeFrame);
		}
	}, {
		key: 'emptyFrame',
		value: function emptyFrame() {
			this.SnappyComponents = [];
			this.$mediaFrame.empty();
		}
	}]);

	return Gallery;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(256);

__webpack_require__(257);

__webpack_require__(78);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LazyImages = function LazyImages() {
    _classCallCheck(this, LazyImages);
};

exports.default = LazyImages;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import App from 'resizement/scripts/resize';

_snappy2.default.Component.MediaGallery = function (_Snappy$BaseComponent) {
    _inherits(MediaGallery, _Snappy$BaseComponent);

    _createClass(MediaGallery, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-media-gallery';
        }
    }]);

    function MediaGallery(element) {
        _classCallCheck(this, MediaGallery);

        return _possibleConstructorReturn(this, (MediaGallery.__proto__ || Object.getPrototypeOf(MediaGallery)).call(this, element));
    }

    _createClass(MediaGallery, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();

            this.init();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.mainCarouselNode = this.$element.find('.js-mg-main-carousel');
            this.navCarouselNode = this.$element.find('.js-mg-nav-carousel');
            this.navArrowsNode = this.$element.find('.js-mg-nav-arrows');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {}
    }, {
        key: 'init',
        value: function init() {
            //debugger;
            this.mainCarouselNode.slick({
                asNavFor: this.navCarouselNode,
                touchThreshold: 10,
                arrows: false
            });
            this.navCarouselNode.slick({
                asNavFor: this.mainCarouselNode,
                slidesToShow: 4,
                slidesToScroll: 1,
                focusOnSelect: true,
                touchThreshold: 10,
                appendArrows: this.navArrowsNode,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                }],
                prevArrow: '<button type="button" class="slick-prev" title="Previous Slide" aria-label="Previous Slide">\n                            <svg class="icon icon-arrow" width="12" height="20" aria-hidden="true" focusable="false">\n                                <use  xlink:href="#icon-chevron-left"></use>\n                            </svg>\n                        </button>',
                nextArrow: '<button type="button" class="slick-next" title="Next Slide" aria-label="Next Slide">\n                            <svg class="icon icon-arrow" width="12" height="20" aria-hidden="true" focusable="false">\n                                <use  xlink:href="#icon-chevron-right"></use>\n                            </svg>\n                        </button>'

            });

            this.navCarouselNode.on('beforeChange', function () {
                (0, _jquery2.default)(document).trigger('responsiveVideo:stopVideo');
            });
        }
    }]);

    return MediaGallery;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Poll = function (_Snappy$BaseComponent) {
	_inherits(Poll, _Snappy$BaseComponent);

	_createClass(Poll, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-poll';
		}
	}]);

	function Poll(element) {
		_classCallCheck(this, Poll);

		var _this = _possibleConstructorReturn(this, (Poll.__proto__ || Object.getPrototypeOf(Poll)).call(this, element));

		_this.submitPoll = _this.submitPoll.bind(_this);
		return _this;
	}

	_createClass(Poll, [{
		key: 'setVars',
		value: function setVars() {
			this.$answers = this.$element.find('.fa-poll__answers');
			if (this.$answers.hasClass('results')) {
				//this.displayPollResults();
				this.disablePollSubmission();
			}
		}
	}, {
		key: 'addEventListeners',
		value: function addEventListeners() {
			if (!this.$element[0].classList.contains('results')) {
				this.$element.find(':radio').on('keypress', this.submitPoll);
				this.$element.find('label').on('click', this.submitPoll);
			}
		}
	}, {
		key: 'submitPoll',
		value: function submitPoll(event) {
			var $parent = (0, _jquery2.default)(event.currentTarget).parent('li');
			$parent.find(':radio').prop('checked', true);

			var $form = (0, _jquery2.default)(event.currentTarget).parents('form');
			_jquery2.default.ajax({
				"url": $form.attr('action'),
				"method": $form.attr('method'),
				"data": $form.serialize()
			}).done(this.displayPollResults.bind(this));
		}
	}, {
		key: 'displayPollResults',
		value: function displayPollResults(response) {
			var _this2 = this;

			//If you are finding errors in this section, it's most likely the answer value

			if (!this.$answers.hasClass('private')) {
				_jquery2.default.each(response.answers, function (i, answer) {
					_this2.$answers.addClass('results').find('input[value=' + answer.value + ']').siblings('.fa-poll__result-bar').css('width', answer.total + '%').next('.fa-poll__result-text').text(answer.total + '%');
					(0, _jquery2.default)(answer).attr('disabled', 'disabled');
				});
			} else {
				this.$answers.hide();
				this.$element.find('.thankyou-box').removeClass('thankyou-box--hidden');
			}
			this.disablePollSubmission();
		}
	}, {
		key: 'disablePollSubmission',
		value: function disablePollSubmission() {
			this.$element.find('label').off('click', this.submitPoll);
			this.$element.find(':radio').off('keypress', this.submitPoll);
		}
	}, {
		key: 'render',
		value: function render() {
			this.setVars();
			this.addEventListeners();
		}
	}]);

	return Poll;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import {TimelineLite} from 'gsap';

_snappy2.default.Component.RelatedDocuments = function (_Snappy$BaseComponent) {
    _inherits(RelatedDocuments, _Snappy$BaseComponent);

    _createClass(RelatedDocuments, null, [{
        key: 'tagName',
        get: function get() {
            return 'cfa-related-documents';
        }
    }]);

    function RelatedDocuments(element) {
        _classCallCheck(this, RelatedDocuments);

        return _possibleConstructorReturn(this, (RelatedDocuments.__proto__ || Object.getPrototypeOf(RelatedDocuments)).call(this, element));
    }

    _createClass(RelatedDocuments, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.init();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.numberToShow = 9;
            this.$items = this.$element.find('.js-item');
            this.$remainingCount = this.$element.find('.js-count');
            this.$additionalContainer = this.$element.find('.js-additional');
            this.$accordion = this.$element.find('.js-accordion');
        }
    }, {
        key: 'init',
        value: function init() {
            var documentCount = this.$items.length;
            if (documentCount <= this.numberToShow) {
                this.$accordion.addClass('is-hidden');
            } else {
                this.$remainingCount.text(documentCount - this.numberToShow);
                this.createAccordion();
            }

            this.$element.removeClass('is-before-init');
        }
    }, {
        key: 'createAccordion',
        value: function createAccordion() {
            var $additionalItems = this.$items.slice(this.numberToShow);
            this.$additionalContainer.append($additionalItems);
        }
    }]);

    return RelatedDocuments;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _videoHelpers = __webpack_require__(79);

var _videoHelpers2 = _interopRequireDefault(_videoHelpers);

var _playerBridge = __webpack_require__(220);

var _playerBridge2 = _interopRequireDefault(_playerBridge);

var _youtubeWrapper = __webpack_require__(222);

var _youtubeWrapper2 = _interopRequireDefault(_youtubeWrapper);

var _vimeoWrapper = __webpack_require__(221);

var _vimeoWrapper2 = _interopRequireDefault(_vimeoWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ResponsiveVideo = function (_Snappy$BaseComponent) {
    _inherits(ResponsiveVideo, _Snappy$BaseComponent);

    _createClass(ResponsiveVideo, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-responsive-video';
        }
    }]);

    function ResponsiveVideo(element) {
        _classCallCheck(this, ResponsiveVideo);

        return _possibleConstructorReturn(this, (ResponsiveVideo.__proto__ || Object.getPrototypeOf(ResponsiveVideo)).call(this, element));
    }

    _createClass(ResponsiveVideo, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.init();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.player = null;
            this.$thumbnailNode = this.$element.find('.js-rv-thumbnail');
            this.$videoNode = this.$element.find('.js-rv-video');
            this.$durationNode = this.$element.find('.js-rv-duration');
            this.caption = this.$element.data('videoCaption');
            this.videoUrl = this.$element.data('videoUrl');
            this.currentSection = this.$element.data('currentSection');
            this.isTracked = false;
            this.videoHost = this.detectVideoHost();
            this.videoId = this.getVideoId();
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            (0, _jquery2.default)(document).on('responsiveVideo:stopVideo', this.onEventStopVideo.bind(this));
            this.$thumbnailNode.on('click', this.onClickThumbnailHandler.bind(this));
        }
    }, {
        key: 'init',
        value: function init() {

            this.playerBridge = new _playerBridge2.default();

            var options = {
                videoNode: this.$videoNode[0],
                videoId: this.videoId,
                videoUrl: this.videoUrl,
                onReadyCallback: this.onPlayerReadyCallback.bind(this),
                onPlayCallback: this.onPlayCallback.bind(this)
            };

            var playerWrapper = void 0;

            if (this.videoHost === 'youtube') {
                playerWrapper = new _youtubeWrapper2.default();
            } else if (this.videoHost === 'vimeo') {
                playerWrapper = new _vimeoWrapper2.default();
            }

            this.playerBridge.setImplementation(playerWrapper);
            this.playerBridge.initPlayer(options);

            if (this.$durationNode.length) {
                this.updateMetaData();
            }
        }
    }, {
        key: 'onPlayerReadyCallback',
        value: function onPlayerReadyCallback() {
            this.setEventListeners();
        }
    }, {
        key: 'onPlayCallback',
        value: function onPlayCallback() {
            this.$thumbnailNode.fadeOut(200);

            if (!this.isTracked) {
                this.trackPlay();
            }
        }
    }, {
        key: 'detectVideoHost',
        value: function detectVideoHost() {
            if (this.$element.hasClass('is-vimeo')) {
                return 'vimeo';
            }
            if (this.$element.hasClass('is-youtube')) {
                return 'youtube';
            }

            if (this.videoUrl) {
                return this.videoUrl.indexOf("youtu") > -1 ? 'youtube' : 'vimeo';
            }

            return 'youtube';
        }
    }, {
        key: 'getVideoId',
        value: function getVideoId() {
            if (this.$element.data('videoId')) {
                return this.$element.data('videoId');
            }

            if (this.videoHost === 'youtube' && this.videoUrl) {
                return _videoHelpers2.default.parseYoutubeId(this.videoUrl);
            }

            if (this.videoHost === 'vimeo' && this.videoUrl) {
                return _videoHelpers2.default.parseVimeoId(this.videoUrl);
            }
        }
    }, {
        key: 'updateMetaData',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var duration, formattedDuration;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.playerBridge.getDuration();

                            case 2:
                                duration = _context.sent;
                                formattedDuration = _videoHelpers2.default.getFomattedDuration(duration);

                                this.$durationNode.text(formattedDuration);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function updateMetaData() {
                return _ref.apply(this, arguments);
            }

            return updateMetaData;
        }()
    }, {
        key: 'onEventStopVideo',
        value: function onEventStopVideo() {
            this.playerBridge.stop();
        }
    }, {
        key: 'trackPlay',
        value: function trackPlay() {
            this.isTracked = true;
            if (this.$body.hasClass('eduhub-layout')) {
                this.$window.trigger('gtm:send', [this.currentSection, 'View Video', window.location.href + ' > ' + this.caption]);
            } else {
                this.$window.trigger('gtm:send', ['Video', 'Play', this.caption]);
            }
        }

        //IE FIX; Doesn't support pointer-events property

    }, {
        key: 'onClickThumbnailHandler',
        value: function onClickThumbnailHandler() {
            this.$thumbnailNode.fadeOut(200);
            this.playerBridge.play();
        }
    }]);

    return ResponsiveVideo;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.RowHeading = function (_Snappy$BaseComponent) {
	_inherits(RowHeading, _Snappy$BaseComponent);

	_createClass(RowHeading, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-row-heading';
		}
	}]);

	function RowHeading(element) {
		_classCallCheck(this, RowHeading);

		return _possibleConstructorReturn(this, (RowHeading.__proto__ || Object.getPrototypeOf(RowHeading)).call(this, element));
	}

	_createClass(RowHeading, [{
		key: 'render',
		value: function render() {}
	}]);

	return RowHeading;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _resize = __webpack_require__(12);

var _resize2 = _interopRequireDefault(_resize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Scrollto = function (_Snappy$BaseComponent) {
    _inherits(Scrollto, _Snappy$BaseComponent);

    _createClass(Scrollto, null, [{
        key: 'tagName',
        get: function get() {
            return 'cfa-scrollto';
        }
    }]);

    function Scrollto(element) {
        _classCallCheck(this, Scrollto);

        return _possibleConstructorReturn(this, (Scrollto.__proto__ || Object.getPrototypeOf(Scrollto)).call(this, element));
    }

    _createClass(Scrollto, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.onResize();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            var name = this.$element.attr('data-name');
            this.$links = (0, _jquery2.default)(document).find('.js-scroll-link[data-target="' + name + '"]');
            this.$desktopNav = (0, _jquery2.default)(document).find('.js-sticky-nav-container');
            this.$mobilenav = (0, _jquery2.default)(document).find('.cfa-nav-mobile');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            (0, _jquery2.default)(window).on('resize:finished', this.bindedResize = this.onResize.bind(this));
            this.$links.on('click', this.scrollToTarget.bind(this));
        }
    }, {
        key: 'scrollToTarget',
        value: function scrollToTarget(e) {
            if (e.target.hasAttribute('data-push-state') && 'replaceState' in history) {
                history.replaceState({}, document.title, e.target.getAttribute('data-push-state') + location.hash);
                var evt = document.createEvent('UIEvents');
                evt.initUIEvent('popstate', true, false, window, 0);
                window.dispatchEvent(evt);
            }
            var topOffset = this.$element[0].getBoundingClientRect().top;
            var scrollVal = topOffset + (0, _jquery2.default)(window).scrollTop() - this.menuHeight;
            (0, _jquery2.default)("html, body").animate({ scrollTop: scrollVal }, 300);
        }
    }, {
        key: 'onResize',
        value: function onResize(e) {
            if (!this.$desktopNav.length || !this.$mobilenav.length) {
                this.menuHeight = 0;
                return;
            }

            if (_resize2.default.isDesktop) {
                this.menuHeight = this.$desktopNav.height();
            } else {
                this.menuHeight = this.$mobilenav.height();
            };
        }
    }]);

    return Scrollto;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.SignpostContentPromo = function (_Snappy$BaseComponent) {
	_inherits(SignpostContentPromo, _Snappy$BaseComponent);

	_createClass(SignpostContentPromo, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-content-promo-signpost';
		}
	}]);

	function SignpostContentPromo(element) {
		_classCallCheck(this, SignpostContentPromo);

		return _possibleConstructorReturn(this, (SignpostContentPromo.__proto__ || Object.getPrototypeOf(SignpostContentPromo)).call(this, element));
	}

	_createClass(SignpostContentPromo, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.setEventListeners();
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.$anchorableElement = this.$element.find('.fa-content-promo__block-link');
			this.elementHasFocusClass = 'fa-content-promo--has-focus';
		}
	}, {
		key: 'setEventListeners',
		value: function setEventListeners() {
			this.$anchorableElement.on('mouseover focus', this.onElementFocusState.bind(this));
			this.$anchorableElement.on('mouseout focusout', this.onElementBlur.bind(this));
		}
	}, {
		key: 'onElementFocusState',
		value: function onElementFocusState() {
			this.$element.addClass(this.elementHasFocusClass);
		}
	}, {
		key: 'onElementBlur',
		value: function onElementBlur(event) {
			var toElement = event.toElement || event.relatedTarget;
			var toElementIsRelated = _jquery2.default.contains(this.$element[0], toElement);

			if (!toElementIsRelated) {
				this.$element.removeClass(this.elementHasFocusClass);
			}
		}
	}]);

	return SignpostContentPromo;
}(_snappy2.default.BaseComponent);

(0, _jquery2.default)(function () {
	new _snappy2.default.Component.SignpostContentPromo();

	//Image Gallery
	(0, _jquery2.default)('.prev, .next').css('cursor', 'pointer');

	//Hide all images except the first one
	(0, _jquery2.default)(".slide-content").each(function () {
		(0, _jquery2.default)(this).find('.slide-content__items picture:gt(0)').hide();
	});

	(0, _jquery2.default)('.prev').click(function () {
		(0, _jquery2.default)(this).parent().find('.slide-content__items picture:first-child').hide();
		(0, _jquery2.default)(this).parent().find('.slide-content__items picture:last-child').prependTo((0, _jquery2.default)(this).parent().find('.slide-content__items')).hide();
		(0, _jquery2.default)(this).parent().find('.slide-content__items picture:first-child').show();
	});

	(0, _jquery2.default)('.next').click(function () {
		(0, _jquery2.default)(this).parent().find('.slide-content__items picture:first-child').hide().next().show().end().appendTo((0, _jquery2.default)(this).parent().find('.slide-content__items'));
	});
});

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _handlebars = __webpack_require__(10);

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Tabs = function (_Snappy$BaseComponent) {
    _inherits(Tabs, _Snappy$BaseComponent);

    _createClass(Tabs, null, [{
        key: 'tagName',
        get: function get() {
            return 'cfa-tabs';
        }
    }]);

    function Tabs(element) {
        _classCallCheck(this, Tabs);

        return _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, element));
    }

    _createClass(Tabs, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.setDefaultState();
            if (this.hasDropdown) {
                this.renderDropdown();
            }
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$links = this.$element.find('.js-tab-link');
            this.$tabs = this.$element.find('.js-tab');
            this.checkForUnsavedData = this.$element.is('[data-check-for-unsaved-data]');
            this.unsavedLocalStorage = this.$element.attr('data-check-for-unsaved-data');
            this.hasDropdown = this.$element.is('[data-has-dropdown]');
            this.$dropdownContainer = this.$element.find('[data-dropdown-container]');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$links.on('click', this.clickProcess.bind(this));
        }
    }, {
        key: 'setDefaultState',
        value: function setDefaultState() {
            var $activeLink = this.$links.filter('.is-active').length ? this.$links.filter('.is-active') : this.$links.eq(0);
            var target = $activeLink.attr('href').substr(1);

            $activeLink.addClass('is-active');
            $activeLink.attr('aria-selected', 'true');

            this.selectTab(target);
        }
    }, {
        key: 'renderDropdown',
        value: function renderDropdown() {
            var dropdownOptions = [];
            var dropdownTemplate = (0, _jquery2.default)('#dropdown-template').html();
            var dropdownTemplateFn = _handlebars2.default.compile(dropdownTemplate);

            this.$links.each(function (index, link) {
                dropdownOptions.push({
                    selected: false,
                    value: link.getAttribute('href').substr(1),
                    text: link.textContent
                });
            });

            var dropdownHtml = dropdownTemplateFn(dropdownOptions);

            this.$dropdownContainer.html(dropdownHtml);

            this.$dropdown = this.$element.find('[data-dropdown]');
            this.$dropdown.on('click', this.onDropdownClick.bind(this));
            this.$dropdown.on('change', this.changeProcess.bind(this));
        }
    }, {
        key: 'onDropdownClick',
        value: function onDropdownClick(e) {
            this.dropdownPreviousSelection = (0, _jquery2.default)(e.target).find('option:selected');
            this.dropdownPreviousValue = (0, _jquery2.default)(e.target).val();
        }
    }, {
        key: 'preventClick',
        value: function preventClick(target) {
            var targets = JSON.parse(localStorage.getItem(this.unsavedLocalStorage));

            if (targets && typeof targets[target] !== 'undefined') {
                if (targets[target]) {
                    if (confirm(targets['unsavedDataWarnMessage'])) {
                        return false;
                    } else {
                        return true;
                    }
                }
            } else {
                return false;
            }
        }
    }, {
        key: 'clickProcess',
        value: function clickProcess(e) {
            e.preventDefault();

            var $previousActive = this.$links.filter('.is-active');

            var $previousActiveTarget = $previousActive.attr('href').substr(1);

            var $activeLink = (0, _jquery2.default)(e.target);

            if ($activeLink === $previousActive) return;

            var target = $activeLink.attr('href').substr(1);

            if (this.checkForUnsavedData && this.preventClick($previousActiveTarget)) {
                $activeLink.blur();
                return;
            }

            if (this.hasDropdown) {
                this.$dropdown.find('option').filter('[value=\'' + target + '\']').prop('selected', true);
            }

            this.changeActiveLink($activeLink);

            this.selectTab(target);
        }
    }, {
        key: 'changeProcess',
        value: function changeProcess(e) {
            var target = e.target.value;

            if (this.checkForUnsavedData && this.preventClick(this.dropdownPreviousValue)) {
                this.dropdownPreviousSelection.prop('selected', true);
                return false;
            }

            var $activeLink = this.$links.filter('[href=\'#' + target + '\']');

            this.changeActiveLink($activeLink);

            this.selectTab(target);
        }
    }, {
        key: 'changeActiveLink',
        value: function changeActiveLink($activeLink) {
            this.$links.removeClass('is-active');
            this.$links.attr('aria-selected', 'false');

            $activeLink.addClass('is-active');
            $activeLink.attr('aria-selected', 'true');
        }
    }, {
        key: 'selectTab',
        value: function selectTab(name) {
            var $activeTab = this.$tabs.filter('[data-target=\'' + name + '\']');
            this.$tabs.removeClass('is-active');
            this.$tabs.attr('aria-hidden', 'true');

            $activeTab.addClass('is-active');
            $activeTab.attr('aria-hidden', 'false');
        }
    }]);

    return Tabs;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Topbar = function (_Snappy$BaseComponent) {
	_inherits(Topbar, _Snappy$BaseComponent);

	_createClass(Topbar, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-topbar';
		}
	}]);

	function Topbar(element) {
		_classCallCheck(this, Topbar);

		return _possibleConstructorReturn(this, (Topbar.__proto__ || Object.getPrototypeOf(Topbar)).call(this, element));
	}

	_createClass(Topbar, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.setEventListeners();
			this.setEventListenersOnLargeViewport();
			this.queryUserStatus();
		}
	}, {
		key: 'setEventListeners',
		value: function setEventListeners() {
			window.addEventListener('fa.viewportResize', this.onViewportResize.bind(this));
			this.$menuToggle.on('click', this.onMenuToggleClick.bind(this));
			this.$expandableLinks.on('click', this.onLinkItemClick.bind(this));
			this.$returnButtons.on('click', this.onReturnButtonClick.bind(this));
			this.$moreSitesButton.on('mouseover focus', this.onMoreSitesBtnHover.bind(this));
			this.$faSitesPrimaryLink.on('mouseover focus', this.onPrimaryLinkMoreAvailableHover.bind(this));
			this.$userButton.on('click', this.onUserButtonClick.bind(this));
		}
	}, {
		key: 'setEventListenersOnLargeViewport',
		value: function setEventListenersOnLargeViewport() {
			if (!globalConfigs.viewportIsBelowLarge) {
				this.$moreSitesButton.on('mouseout focusout', this.onMenuBlur.bind(this, this.$moreFaSitesParent));
				this.$parentLinksContainer.on('mouseout focusout', this.onMenuBlur.bind(this, this.$moreFaSitesParent));
			}
		}
	}, {
		key: 'onLinkItemClick',
		value: function onLinkItemClick(event) {
			if (globalConfigs.viewportIsBelowLarge) {
				var $link = (0, _jquery2.default)(event.currentTarget);

				$link.closest(this.moreClass).addClass(this.expandedClass);
				event.preventDefault();
			}
		}
	}, {
		key: 'onViewportResize',
		value: function onViewportResize() {
			this.setEventListenersOnLargeViewport();
			this.menuIsActive = false;
			this.toggleMenu();
		}
	}, {
		key: 'onReturnButtonClick',
		value: function onReturnButtonClick(event) {
			var $returnCta = (0, _jquery2.default)(event.currentTarget);

			$returnCta.closest(this.moreClass).removeClass(this.expandedClass);
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.menuIsActive = false;
			this.$menuToggle = this.$element.find('.controls__menu-toggle');
			this.$expandableLinks = this.$element.find('.more-available');
			this.$returnButtons = this.$element.find('.more-fa-sites__link--go-back');
			this.$moreSitesButton = this.$element.find('.more-fa-item__button');
			this.$moreFaSitesParent = this.$element.find('.topbar__primary-item.more-fa-item');
			this.$faSitesPrimaryLink = this.$element.find('.more-fa-sites__link.more-available');
			this.$parentLinksContainer = this.$element.find('.parent-links');
			this.menuActiveClass = 'menu-active';
			this.expandedClass = 'expanded';
			this.moreClass = '.more-fa-item';
			this.$userDetailsContainer = this.$element.find('.controls');
			this.$userButton = this.$userDetailsContainer.find('.controls__sign-in');
		}
	}, {
		key: 'onMenuToggleClick',
		value: function onMenuToggleClick() {
			this.menuIsActive = !this.menuIsActive;
			this.toggleMenu();
		}
	}, {
		key: 'toggleMenu',
		value: function toggleMenu() {
			this.$element.toggleClass(this.menuActiveClass, this.menuIsActive);
		}
	}, {
		key: 'onMoreSitesBtnHover',
		value: function onMoreSitesBtnHover() {
			this.$moreFaSitesParent.addClass(this.menuActiveClass);
		}
	}, {
		key: 'onPrimaryLinkMoreAvailableHover',
		value: function onPrimaryLinkMoreAvailableHover(event) {
			var target = event && event.currentTarget;
			this.$activePrimaryLink = (0, _jquery2.default)(target).parent('.more-fa-sites__list-item');

			this.$activePrimaryLink.addClass(this.menuActiveClass);
			this.$activePrimaryLink.children().on('mouseout focusout', this.onMenuBlur.bind(this, this.$activePrimaryLink));
		}
	}, {
		key: 'onMenuBlur',
		value: function onMenuBlur($parent, event) {
			var toElement = event.toElement || event.relatedTarget;
			var toElementIsInContainingParent = _jquery2.default.contains($parent[0], toElement);

			if (!toElementIsInContainingParent) {
				$parent.removeClass(this.menuActiveClass);
			}
		}
	}, {
		key: 'queryUserStatus',
		value: function queryUserStatus() {
			var signInUrl = this.$userButton.data('isSignedInUrl');

			var currentHost = window.location.hostname;

			if (currentHost == "www.thefa.com" || currentHost == "beta.thefa.dev" || currentHost == "beta.thefa.test") {

				_jquery2.default.ajax({
					method: 'GET',
					cache: false,
					url: signInUrl
				}).then(this.onUserStatusResponse.bind(this), this.onUserStatusError.bind(this));
			}
		}
	}, {
		key: 'onUserStatusResponse',
		value: function onUserStatusResponse(response) {
			if (response && response.isLoggedIn) {
				this.$userButton.text(response.Html);
				this.$userDetailsContainer.addClass('user-signed-in');
			}
		}
	}, {
		key: 'onUserStatusError',
		value: function onUserStatusError() {}
	}, {
		key: 'onUserButtonClick',
		value: function onUserButtonClick() {
			this.userMenuIsActive = !this.userMenuIsActive;

			this.toggleUserMenu();
		}
	}, {
		key: 'toggleUserMenu',
		value: function toggleUserMenu() {
			this.$userDetailsContainer.toggleClass('account-menu-active', this.userMenuIsActive);
		}
	}]);

	return Topbar;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _domUtils = __webpack_require__(223);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tracking = function () {
    function Tracking() {
        _classCallCheck(this, Tracking);

        this.opts = {
            events: ['click', 'change', 'keyup'],
            attributePrefix: 'data-gtm-',
            eventName: 'eventTrack'
        };

        this.init();
    }

    _createClass(Tracking, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.handleEvents = this.handleEvents.bind(this);
            this.send = this.send.bind(this);

            var selector = '[' + this.opts.attributePrefix + 'on]';

            var $mailLinks = (0, _jquery2.default)('a[href^="mailto"]');
            var $externalLinks = (0, _jquery2.default)('a').filter(function () {
                return this.hostname && !this.href.match(/^mailto\:/) && this.hostname !== location.hostname && !this.hasAttribute('data-gtm-on');
            });

            this.delegates = {};

            this.opts.events.forEach(function (event) {
                _this.delegates[event] = (0, _domUtils.delegate)(document, event, selector, _this.handleEvents, {
                    composed: true,
                    useCapture: true
                });
            });

            // <button
            // data-gtm-on="click"
            // data-gtm-event-category="category"
            // data-gtm-event-action="action"
            // data-gtm-event-label="label">
            //btn </button>


            (0, _jquery2.default)(window).on('gtm:send', this.send); // $(window).trigger('gtm:send', [ 'category', 'action', 'label']);
            $mailLinks.on('click', this.onClickMailto.bind(this));
            $externalLinks.on('click', this.onExternalLinkClick.bind(this));
        }
    }, {
        key: 'getAttributeFields',
        value: function getAttributeFields(element, prefix) {
            var _this2 = this;

            var attributes = (0, _domUtils.getAttributes)(element);
            var attributeFields = {};

            Object.keys(attributes).forEach(function (attribute) {
                if (attribute.indexOf(prefix) === 0 && attribute !== prefix + 'on') {
                    var value = attributes[attribute];
                    if (value === 'true') value = true;
                    if (value === 'false') value = false;
                    var field = _this2.constructor.camelCase(attribute.slice(prefix.length));
                    attributeFields[field] = value;
                }
            });

            return attributeFields;
        }
    }, {
        key: 'handleEvents',
        value: function handleEvents(event, element) {

            if (typeof dataLayer === 'undefined') return;

            var prefix = this.opts.attributePrefix;
            var events = element.getAttribute(prefix + 'on').split(/\s*,\s*/);

            if (events.indexOf(event.type) < 0) return;

            var attributeFields = this.getAttributeFields(element, prefix);

            attributeFields.event = this.opts.eventName;

            dataLayer.push(attributeFields);
        }
    }, {
        key: 'send',
        value: function send() {

            if (typeof dataLayer === 'undefined') return;

            var _ref = [].concat(Array.prototype.slice.call(arguments)),
                e = _ref[0],
                category = _ref[1],
                action = _ref[2],
                label = _ref[3];

            dataLayer.push(_extends({}, { 'event': this.opts.eventName }, category && { 'eventCategory': category }, action && { 'eventAction': action }, label && { 'eventLabel': label }));
        }
    }, {
        key: 'onClickMailto',
        value: function onClickMailto(e) {
            var $link = (0, _jquery2.default)(e.target).closest('a');
            var email = $link.attr('href').substr(7);
            (0, _jquery2.default)(window).trigger('gtm:send', ['Email', 'Click', email]);
        }
    }, {
        key: 'onExternalLinkClick',
        value: function onExternalLinkClick(e) {
            var linkDestination = (0, _jquery2.default)(e.target).closest('a').attr('href');
            (0, _jquery2.default)(window).trigger('gtm:send', ['Link', 'Click', window.location.href + ' > ' + linkDestination]);
        }
    }], [{
        key: 'camelCase',
        value: function camelCase(str) {
            return str.replace(/[\-\_]+(\w?)/g, function (match, p1) {
                return p1.toUpperCase();
            });
        }
    }]);

    return Tracking;
}();

var tracking = new Tracking();

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _handlebars = __webpack_require__(10);

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Video = function (_Snappy$BaseComponent) {
	_inherits(Video, _Snappy$BaseComponent);

	_createClass(Video, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-video';
		}
	}]);

	function Video(element) {
		_classCallCheck(this, Video);

		return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, element));
	}

	_createClass(Video, [{
		key: 'render',
		value: function render() {
			this.setVideoTemplate();
		}
	}, {
		key: 'setVideoTemplate',
		value: function setVideoTemplate() {
			var source = (0, _jquery2.default)('#video-template').html();

			window.videoTemplate = _handlebars2.default.compile(source);
		}
	}]);

	return Video;
}(_snappy2.default.BaseComponent);

_snappy2.default.Component.VideoPromo = function (_Snappy$BaseComponent2) {
	_inherits(VideoPromo, _Snappy$BaseComponent2);

	_createClass(VideoPromo, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-video-promo';
		}
	}]);

	function VideoPromo(element) {
		_classCallCheck(this, VideoPromo);

		return _possibleConstructorReturn(this, (VideoPromo.__proto__ || Object.getPrototypeOf(VideoPromo)).call(this, element));
	}

	_createClass(VideoPromo, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.setVideoData();
			this.addVideoEventListeners();
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.$videoPlayIcon = this.$element.find('.featured-media__expand--video');
			this.$videoThumbnailLink = this.$element.find('.responsive-image');
			this.$videoThumbnailBlock = this.$element.find('.fa-content-promo__block-link');
			this.$videoLinkBlock = this.$element.find('.video-link__block-link');
		}
	}, {
		key: 'addVideoEventListeners',
		value: function addVideoEventListeners() {
			this.$videoThumbnailLink.on('click', this.onVideoThumbnailClick.bind(this));
			this.$videoThumbnailBlock.on('click', this.onVideoThumbnailClick.bind(this));
			this.$videoLinkBlock.on('click', this.onVideoThumbnailClick.bind(this));
			if (this.$videoPlayIcon) {
				this.$videoPlayIcon.on('click', this.onVideoThumbnailClick.bind(this));
			}
		}
	}, {
		key: 'onVideoThumbnailClick',
		value: function onVideoThumbnailClick(event) {
			this.$window.trigger('modal:openModal', {
				title: this.videoTitle,
				$view: this.$videoTemplate,
				$prevElement: this.$element
			});

			if (this.$body.hasClass('cfa-generic')) {
				this.$window.trigger('gtm:send', ['Video', 'Play', this.videoTitle]);
			}

			event.preventDefault();
		}
	}, {
		key: 'formatYoutubeUrl',
		value: function formatYoutubeUrl(url) {
			return url += '?autoplay=1';
		}
	}, {
		key: 'setVideoData',
		value: function setVideoData() {
			var videoUrl = this.formatYoutubeUrl(this.$element.data('videoUrl'));
			var videoRel = this.$element.data('videoRel');

			if (videoRel !== "") {
				videoUrl += '&rel=' + videoRel;
			}

			this.videoTitle = this.$element.data('videoTitle');
			this.$videoTemplate = (0, _jquery2.default)(window.videoTemplate({
				videoUrl: videoUrl
			}));
		}
	}]);

	return VideoPromo;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _picturefill = __webpack_require__(165);

var _picturefill2 = _interopRequireDefault(_picturefill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _picturefill2.default)();

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Production steps of ECMA-262, Edition 6, 22.1.2.1
if (!Array.from) {
  Array.from = function () {
    var toStr = Object.prototype.toString;
    var isCallable = function isCallable(fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function toInteger(value) {
      var number = Number(value);
      if (isNaN(number)) {
        return 0;
      }
      if (number === 0 || !isFinite(number)) {
        return number;
      }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function toLength(value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike /*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }();
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _handlebars = __webpack_require__(10);

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_handlebars2.default.registerHelper('ifCond', function (v1, operator, v2, options) {

    switch (operator) {
        case '==':
            return v1 == v2 ? options.fn(this) : options.inverse(this);
        case '===':
            return v1 === v2 ? options.fn(this) : options.inverse(this);
        case '&&':
            return v1 && v2 ? options.fn(this) : options.inverse(this);
        case '||':
            return v1 || v2 ? options.fn(this) : options.inverse(this);
        default:
            return options.inverse(this);
    }
});

/***/ }),
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! npm.im/object-fit-images 3.2.0 */


var OFI = 'bfred-it:object-fit-images';
var propRegex = /(object-fit|object-position)\s*:\s*([-\w\s%]+)/g;
var testImg = typeof Image === 'undefined' ? {style: {'object-position': 1}} : new Image();
var supportsObjectFit = 'object-fit' in testImg.style;
var supportsObjectPosition = 'object-position' in testImg.style;
var supportsOFI = 'background-size' in testImg.style;
var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
var nativeGetAttribute = testImg.getAttribute;
var nativeSetAttribute = testImg.setAttribute;
var autoModeEnabled = false;

function createPlaceholder(w, h) {
	return ("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E");
}

function polyfillCurrentSrc(el) {
	if (el.srcset && !supportsCurrentSrc && window.picturefill) {
		var pf = window.picturefill._;
		// parse srcset with picturefill where currentSrc isn't available
		if (!el[pf.ns] || !el[pf.ns].evaled) {
			// force synchronous srcset parsing
			pf.fillImg(el, {reselect: true});
		}

		if (!el[pf.ns].curSrc) {
			// force picturefill to parse srcset
			el[pf.ns].supported = false;
			pf.fillImg(el, {reselect: true});
		}

		// retrieve parsed currentSrc, if any
		el.currentSrc = el[pf.ns].curSrc || el.src;
	}
}

function getStyle(el) {
	var style = getComputedStyle(el).fontFamily;
	var parsed;
	var props = {};
	while ((parsed = propRegex.exec(style)) !== null) {
		props[parsed[1]] = parsed[2];
	}
	return props;
}

function setPlaceholder(img, width, height) {
	// Default: fill width, no height
	var placeholder = createPlaceholder(width || 1, height || 0);

	// Only set placeholder if it's different
	if (nativeGetAttribute.call(img, 'src') !== placeholder) {
		nativeSetAttribute.call(img, 'src', placeholder);
	}
}

function onImageReady(img, callback) {
	// naturalWidth is only available when the image headers are loaded,
	// this loop will poll it every 100ms.
	if (img.naturalWidth) {
		callback(img);
	} else {
		setTimeout(onImageReady, 100, img, callback);
	}
}

function fixOne(el) {
	var style = getStyle(el);
	var ofi = el[OFI];
	style['object-fit'] = style['object-fit'] || 'fill'; // default value

	// Avoid running where unnecessary, unless OFI had already done its deed
	if (!ofi.img) {
		// fill is the default behavior so no action is necessary
		if (style['object-fit'] === 'fill') {
			return;
		}

		// Where object-fit is supported and object-position isn't (Safari < 10)
		if (
			!ofi.skipTest && // unless user wants to apply regardless of browser support
			supportsObjectFit && // if browser already supports object-fit
			!style['object-position'] // unless object-position is used
		) {
			return;
		}
	}

	// keep a clone in memory while resetting the original to a blank
	if (!ofi.img) {
		ofi.img = new Image(el.width, el.height);
		ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
		ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

		// preserve for any future cloneNode calls
		// https://github.com/bfred-it/object-fit-images/issues/53
		nativeSetAttribute.call(el, "data-ofi-src", el.src);
		if (el.srcset) {
			nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
		}

		setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

		// remove srcset because it overrides src
		if (el.srcset) {
			el.srcset = '';
		}
		try {
			keepSrcUsable(el);
		} catch (err) {
			if (window.console) {
				console.log('http://bit.ly/ofi-old-browser');
			}
		}
	}

	polyfillCurrentSrc(ofi.img);

	el.style.backgroundImage = "url(\"" + ((ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"')) + "\")";
	el.style.backgroundPosition = style['object-position'] || 'center';
	el.style.backgroundRepeat = 'no-repeat';

	if (/scale-down/.test(style['object-fit'])) {
		onImageReady(ofi.img, function () {
			if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
				el.style.backgroundSize = 'contain';
			} else {
				el.style.backgroundSize = 'auto';
			}
		});
	} else {
		el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
	}

	onImageReady(ofi.img, function (img) {
		setPlaceholder(el, img.naturalWidth, img.naturalHeight);
	});
}

function keepSrcUsable(el) {
	var descriptors = {
		get: function get(prop) {
			return el[OFI].img[prop ? prop : 'src'];
		},
		set: function set(value, prop) {
			el[OFI].img[prop ? prop : 'src'] = value;
			nativeSetAttribute.call(el, ("data-ofi-" + prop), value); // preserve for any future cloneNode
			fixOne(el);
			return value;
		}
	};
	Object.defineProperty(el, 'src', descriptors);
	Object.defineProperty(el, 'currentSrc', {
		get: function () { return descriptors.get('currentSrc'); }
	});
	Object.defineProperty(el, 'srcset', {
		get: function () { return descriptors.get('srcset'); },
		set: function (ss) { return descriptors.set(ss, 'srcset'); }
	});
}

function hijackAttributes() {
	function getOfiImageMaybe(el, name) {
		return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
	}
	if (!supportsObjectPosition) {
		HTMLImageElement.prototype.getAttribute = function (name) {
			return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
		};

		HTMLImageElement.prototype.setAttribute = function (name, value) {
			return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
		};
	}
}

function fix(imgs, opts) {
	var startAutoMode = !autoModeEnabled && !imgs;
	opts = opts || {};
	imgs = imgs || 'img';

	if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
		return false;
	}

	// use imgs as a selector or just select all images
	if (typeof imgs === 'string') {
		imgs = document.querySelectorAll(imgs);
	} else if (!('length' in imgs)) {
		imgs = [imgs];
	}

	// apply fix to all
	for (var i = 0; i < imgs.length; i++) {
		imgs[i][OFI] = imgs[i][OFI] || {
			skipTest: opts.skipTest
		};
		fixOne(imgs[i]);
	}

	if (startAutoMode) {
		document.body.addEventListener('load', function (e) {
			if (e.target.tagName === 'IMG') {
				fix(e.target, {
					skipTest: opts.skipTest
				});
			}
		}, true);
		autoModeEnabled = true;
		imgs = 'img'; // reset to a generic selector for watchMQ
	}

	// if requested, watch media queries for object-fit change
	if (opts.watchMQ) {
		window.addEventListener('resize', fix.bind(null, imgs, {
			skipTest: opts.skipTest
		}));
	}
}

fix.supportsObjectFit = supportsObjectFit;
fix.supportsObjectPosition = supportsObjectPosition;

hijackAttributes();

module.exports = fix;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(48);

_jquery2.default.validator.addMethod('postcodeCheck', function (value) {
    var regexp = /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/i;

    return regexp.test(value);
}, 'Please enter a valid UK postcode');

var defaultOptions = {
    submitHandler: function submitHandler(form) {
        form.submit();
    },

    errorClass: 'fa-input-field--error',

    errorPlacement: function errorPlacement() {},

    highlight: function highlight(element, errorClass, validClass) {
        var $element = (0, _jquery2.default)(element);

        $element.addClass(errorClass).removeClass(validClass);

        $element.parents('[data-fa-input-field]').addClass(errorClass);
    },

    unhighlight: function unhighlight(element, errorClass, validClass) {
        var $element = (0, _jquery2.default)(element);

        $element.removeClass(errorClass).addClass(validClass);

        $element.parents('[data-fa-input-field]').removeClass(errorClass);
    },

    rules: {
        postcode: { postcodeCheck: true }
    }
};

var Form = function () {
    function Form(formElement) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;

        _classCallCheck(this, Form);

        this.$form = (0, _jquery2.default)(formElement);
        this.options = options;
    }

    _createClass(Form, [{
        key: 'init',
        value: function init() {
            this.$form.validate(this.options);
        }
    }]);

    return Form;
}();

exports.default = Form;

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/*! @vimeo/player v2.11.0 | (c) 2020 Vimeo | MIT License | https://github.com/vimeo/player.js */
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/**
 * @module lib/functions
 */

/**
 * Check to see this is a node environment.
 * @type {Boolean}
 */

/* global global */
var isNode = typeof global !== 'undefined' && {}.toString.call(global) === '[object global]';
/**
 * Get the name of the method for a given getter or setter.
 *
 * @param {string} prop The name of the property.
 * @param {string} type Either “get” or “set”.
 * @return {string}
 */

function getMethodName(prop, type) {
  if (prop.indexOf(type.toLowerCase()) === 0) {
    return prop;
  }

  return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
}
/**
 * Check to see if the object is a DOM Element.
 *
 * @param {*} element The object to check.
 * @return {boolean}
 */

function isDomElement(element) {
  return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
}
/**
 * Check to see whether the value is a number.
 *
 * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
 * @param {*} value The value to check.
 * @param {boolean} integer Check if the value is an integer.
 * @return {boolean}
 */

function isInteger(value) {
  // eslint-disable-next-line eqeqeq
  return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
}
/**
 * Check to see if the URL is a Vimeo url.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */

function isVimeoUrl(url) {
  return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
}
/**
 * Get the Vimeo URL from an element.
 * The element must have either a data-vimeo-id or data-vimeo-url attribute.
 *
 * @param {object} oEmbedParameters The oEmbed parameters.
 * @return {string}
 */

function getVimeoUrl() {
  var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = oEmbedParameters.id;
  var url = oEmbedParameters.url;
  var idOrUrl = id || url;

  if (!idOrUrl) {
    throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
  }

  if (isInteger(idOrUrl)) {
    return "https://vimeo.com/".concat(idOrUrl);
  }

  if (isVimeoUrl(idOrUrl)) {
    return idOrUrl.replace('http:', 'https:');
  }

  if (id) {
    throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
  }

  throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
}

var arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
var postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';

if (!isNode && (!arrayIndexOfSupport || !postMessageSupport)) {
  throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/*!
 * weakmap-polyfill v2.0.1 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2020 Polygon Planet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */
(function (self) {

  if (self.WeakMap) {
    return;
  }

  var hasOwnProperty = Object.prototype.hasOwnProperty;

  var defineProperty = function (object, name, value) {
    if (Object.defineProperty) {
      Object.defineProperty(object, name, {
        configurable: true,
        writable: true,
        value: value
      });
    } else {
      object[name] = value;
    }
  };

  self.WeakMap = function () {
    // ECMA-262 23.3 WeakMap Objects
    function WeakMap() {
      if (this === void 0) {
        throw new TypeError("Constructor WeakMap requires 'new'");
      }

      defineProperty(this, '_id', genId('_WeakMap')); // ECMA-262 23.3.1.1 WeakMap([iterable])

      if (arguments.length > 0) {
        // Currently, WeakMap `iterable` argument is not supported
        throw new TypeError('WeakMap iterable is not supported');
      }
    } // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)


    defineProperty(WeakMap.prototype, 'delete', function (key) {
      checkInstance(this, 'delete');

      if (!isObject(key)) {
        return false;
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        delete key[this._id];
        return true;
      }

      return false;
    }); // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)

    defineProperty(WeakMap.prototype, 'get', function (key) {
      checkInstance(this, 'get');

      if (!isObject(key)) {
        return void 0;
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        return entry[1];
      }

      return void 0;
    }); // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)

    defineProperty(WeakMap.prototype, 'has', function (key) {
      checkInstance(this, 'has');

      if (!isObject(key)) {
        return false;
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        return true;
      }

      return false;
    }); // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)

    defineProperty(WeakMap.prototype, 'set', function (key, value) {
      checkInstance(this, 'set');

      if (!isObject(key)) {
        throw new TypeError('Invalid value used as weak map key');
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        entry[1] = value;
        return this;
      }

      defineProperty(key, this._id, [key, value]);
      return this;
    });

    function checkInstance(x, methodName) {
      if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
        throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
      }
    }

    function genId(prefix) {
      return prefix + '_' + rand() + '.' + rand();
    }

    function rand() {
      return Math.random().toString().substring(2);
    }

    defineProperty(WeakMap, '_polyfill', true);
    return WeakMap;
  }();

  function isObject(x) {
    return Object(x) === x;
  }
})(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal);

var npo_src = createCommonjsModule(function (module) {
/*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/
(function UMD(name, context, definition) {
  // special form of UMD for polyfilling across evironments
  context[name] = context[name] || definition();

  if ( module.exports) {
    module.exports = context[name];
  }
})("Promise", typeof commonjsGlobal != "undefined" ? commonjsGlobal : commonjsGlobal, function DEF() {

  var builtInProp,
      cycle,
      scheduling_queue,
      ToString = Object.prototype.toString,
      timer = typeof setImmediate != "undefined" ? function timer(fn) {
    return setImmediate(fn);
  } : setTimeout; // dammit, IE8.

  try {
    Object.defineProperty({}, "x", {});

    builtInProp = function builtInProp(obj, name, val, config) {
      return Object.defineProperty(obj, name, {
        value: val,
        writable: true,
        configurable: config !== false
      });
    };
  } catch (err) {
    builtInProp = function builtInProp(obj, name, val) {
      obj[name] = val;
      return obj;
    };
  } // Note: using a queue instead of array for efficiency


  scheduling_queue = function Queue() {
    var first, last, item;

    function Item(fn, self) {
      this.fn = fn;
      this.self = self;
      this.next = void 0;
    }

    return {
      add: function add(fn, self) {
        item = new Item(fn, self);

        if (last) {
          last.next = item;
        } else {
          first = item;
        }

        last = item;
        item = void 0;
      },
      drain: function drain() {
        var f = first;
        first = last = cycle = void 0;

        while (f) {
          f.fn.call(f.self);
          f = f.next;
        }
      }
    };
  }();

  function schedule(fn, self) {
    scheduling_queue.add(fn, self);

    if (!cycle) {
      cycle = timer(scheduling_queue.drain);
    }
  } // promise duck typing


  function isThenable(o) {
    var _then,
        o_type = typeof o;

    if (o != null && (o_type == "object" || o_type == "function")) {
      _then = o.then;
    }

    return typeof _then == "function" ? _then : false;
  }

  function notify() {
    for (var i = 0; i < this.chain.length; i++) {
      notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
    }

    this.chain.length = 0;
  } // NOTE: This is a separate function to isolate
  // the `try..catch` so that other code can be
  // optimized better


  function notifyIsolated(self, cb, chain) {
    var ret, _then;

    try {
      if (cb === false) {
        chain.reject(self.msg);
      } else {
        if (cb === true) {
          ret = self.msg;
        } else {
          ret = cb.call(void 0, self.msg);
        }

        if (ret === chain.promise) {
          chain.reject(TypeError("Promise-chain cycle"));
        } else if (_then = isThenable(ret)) {
          _then.call(ret, chain.resolve, chain.reject);
        } else {
          chain.resolve(ret);
        }
      }
    } catch (err) {
      chain.reject(err);
    }
  }

  function resolve(msg) {
    var _then,
        self = this; // already triggered?


    if (self.triggered) {
      return;
    }

    self.triggered = true; // unwrap

    if (self.def) {
      self = self.def;
    }

    try {
      if (_then = isThenable(msg)) {
        schedule(function () {
          var def_wrapper = new MakeDefWrapper(self);

          try {
            _then.call(msg, function $resolve$() {
              resolve.apply(def_wrapper, arguments);
            }, function $reject$() {
              reject.apply(def_wrapper, arguments);
            });
          } catch (err) {
            reject.call(def_wrapper, err);
          }
        });
      } else {
        self.msg = msg;
        self.state = 1;

        if (self.chain.length > 0) {
          schedule(notify, self);
        }
      }
    } catch (err) {
      reject.call(new MakeDefWrapper(self), err);
    }
  }

  function reject(msg) {
    var self = this; // already triggered?

    if (self.triggered) {
      return;
    }

    self.triggered = true; // unwrap

    if (self.def) {
      self = self.def;
    }

    self.msg = msg;
    self.state = 2;

    if (self.chain.length > 0) {
      schedule(notify, self);
    }
  }

  function iteratePromises(Constructor, arr, resolver, rejecter) {
    for (var idx = 0; idx < arr.length; idx++) {
      (function IIFE(idx) {
        Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
          resolver(idx, msg);
        }, rejecter);
      })(idx);
    }
  }

  function MakeDefWrapper(self) {
    this.def = self;
    this.triggered = false;
  }

  function MakeDef(self) {
    this.promise = self;
    this.state = 0;
    this.triggered = false;
    this.chain = [];
    this.msg = void 0;
  }

  function Promise(executor) {
    if (typeof executor != "function") {
      throw TypeError("Not a function");
    }

    if (this.__NPO__ !== 0) {
      throw TypeError("Not a promise");
    } // instance shadowing the inherited "brand"
    // to signal an already "initialized" promise


    this.__NPO__ = 1;
    var def = new MakeDef(this);

    this["then"] = function then(success, failure) {
      var o = {
        success: typeof success == "function" ? success : true,
        failure: typeof failure == "function" ? failure : false
      }; // Note: `then(..)` itself can be borrowed to be used against
      // a different promise constructor for making the chained promise,
      // by substituting a different `this` binding.

      o.promise = new this.constructor(function extractChain(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        o.resolve = resolve;
        o.reject = reject;
      });
      def.chain.push(o);

      if (def.state !== 0) {
        schedule(notify, def);
      }

      return o.promise;
    };

    this["catch"] = function $catch$(failure) {
      return this.then(void 0, failure);
    };

    try {
      executor.call(void 0, function publicResolve(msg) {
        resolve.call(def, msg);
      }, function publicReject(msg) {
        reject.call(def, msg);
      });
    } catch (err) {
      reject.call(def, err);
    }
  }

  var PromisePrototype = builtInProp({}, "constructor", Promise,
  /*configurable=*/
  false); // Note: Android 4 cannot use `Object.defineProperty(..)` here

  Promise.prototype = PromisePrototype; // built-in "brand" to signal an "uninitialized" promise

  builtInProp(PromisePrototype, "__NPO__", 0,
  /*configurable=*/
  false);
  builtInProp(Promise, "resolve", function Promise$resolve(msg) {
    var Constructor = this; // spec mandated checks
    // note: best "isPromise" check that's practical for now

    if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
      return msg;
    }

    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      resolve(msg);
    });
  });
  builtInProp(Promise, "reject", function Promise$reject(msg) {
    return new this(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      reject(msg);
    });
  });
  builtInProp(Promise, "all", function Promise$all(arr) {
    var Constructor = this; // spec mandated checks

    if (ToString.call(arr) != "[object Array]") {
      return Constructor.reject(TypeError("Not an array"));
    }

    if (arr.length === 0) {
      return Constructor.resolve([]);
    }

    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      var len = arr.length,
          msgs = Array(len),
          count = 0;
      iteratePromises(Constructor, arr, function resolver(idx, msg) {
        msgs[idx] = msg;

        if (++count === len) {
          resolve(msgs);
        }
      }, reject);
    });
  });
  builtInProp(Promise, "race", function Promise$race(arr) {
    var Constructor = this; // spec mandated checks

    if (ToString.call(arr) != "[object Array]") {
      return Constructor.reject(TypeError("Not an array"));
    }

    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      iteratePromises(Constructor, arr, function resolver(idx, msg) {
        resolve(msg);
      }, reject);
    });
  });
  return Promise;
});
});

/**
 * @module lib/callbacks
 */
var callbackMap = new WeakMap();
/**
 * Store a callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
 *        The callback to call or an object with resolve and reject functions for a promise.
 * @return {void}
 */

function storeCallback(player, name, callback) {
  var playerCallbacks = callbackMap.get(player.element) || {};

  if (!(name in playerCallbacks)) {
    playerCallbacks[name] = [];
  }

  playerCallbacks[name].push(callback);
  callbackMap.set(player.element, playerCallbacks);
}
/**
 * Get the callbacks for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @return {function[]}
 */

function getCallbacks(player, name) {
  var playerCallbacks = callbackMap.get(player.element) || {};
  return playerCallbacks[name] || [];
}
/**
 * Remove a stored callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @param {function} [callback] The specific callback to remove.
 * @return {boolean} Was this the last callback?
 */

function removeCallback(player, name, callback) {
  var playerCallbacks = callbackMap.get(player.element) || {};

  if (!playerCallbacks[name]) {
    return true;
  } // If no callback is passed, remove all callbacks for the event


  if (!callback) {
    playerCallbacks[name] = [];
    callbackMap.set(player.element, playerCallbacks);
    return true;
  }

  var index = playerCallbacks[name].indexOf(callback);

  if (index !== -1) {
    playerCallbacks[name].splice(index, 1);
  }

  callbackMap.set(player.element, playerCallbacks);
  return playerCallbacks[name] && playerCallbacks[name].length === 0;
}
/**
 * Return the first stored callback for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @return {function} The callback, or false if there were none
 */

function shiftCallbacks(player, name) {
  var playerCallbacks = getCallbacks(player, name);

  if (playerCallbacks.length < 1) {
    return false;
  }

  var callback = playerCallbacks.shift();
  removeCallback(player, name, callback);
  return callback;
}
/**
 * Move callbacks associated with an element to another element.
 *
 * @param {HTMLElement} oldElement The old element.
 * @param {HTMLElement} newElement The new element.
 * @return {void}
 */

function swapCallbacks(oldElement, newElement) {
  var playerCallbacks = callbackMap.get(oldElement);
  callbackMap.set(newElement, playerCallbacks);
  callbackMap.delete(oldElement);
}

/**
 * @module lib/embed
 */
var oEmbedParameters = ['autopause', 'autoplay', 'background', 'byline', 'color', 'controls', 'dnt', 'height', 'id', 'loop', 'maxheight', 'maxwidth', 'muted', 'playsinline', 'portrait', 'responsive', 'speed', 'texttrack', 'title', 'transparent', 'url', 'width'];
/**
 * Get the 'data-vimeo'-prefixed attributes from an element as an object.
 *
 * @param {HTMLElement} element The element.
 * @param {Object} [defaults={}] The default values to use.
 * @return {Object<string, string>}
 */

function getOEmbedParameters(element) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return oEmbedParameters.reduce(function (params, param) {
    var value = element.getAttribute("data-vimeo-".concat(param));

    if (value || value === '') {
      params[param] = value === '' ? 1 : value;
    }

    return params;
  }, defaults);
}
/**
 * Create an embed from oEmbed data inside an element.
 *
 * @param {object} data The oEmbed data.
 * @param {HTMLElement} element The element to put the iframe in.
 * @return {HTMLIFrameElement} The iframe embed.
 */

function createEmbed(_ref, element) {
  var html = _ref.html;

  if (!element) {
    throw new TypeError('An element must be provided');
  }

  if (element.getAttribute('data-vimeo-initialized') !== null) {
    return element.querySelector('iframe');
  }

  var div = document.createElement('div');
  div.innerHTML = html;
  element.appendChild(div.firstChild);
  element.setAttribute('data-vimeo-initialized', 'true');
  return element.querySelector('iframe');
}
/**
 * Make an oEmbed call for the specified URL.
 *
 * @param {string} videoUrl The vimeo.com url for the video.
 * @param {Object} [params] Parameters to pass to oEmbed.
 * @param {HTMLElement} element The element.
 * @return {Promise}
 */

function getOEmbedData(videoUrl) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var element = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    if (!isVimeoUrl(videoUrl)) {
      throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
    }

    var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl));

    for (var param in params) {
      if (params.hasOwnProperty(param)) {
        url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
      }
    }

    var xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
    xhr.open('GET', url, true);

    xhr.onload = function () {
      if (xhr.status === 404) {
        reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
        return;
      }

      if (xhr.status === 403) {
        reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
        return;
      }

      try {
        var json = JSON.parse(xhr.responseText); // Check api response for 403 on oembed

        if (json.domain_status_code === 403) {
          // We still want to create the embed to give users visual feedback
          createEmbed(json, element);
          reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
          return;
        }

        resolve(json);
      } catch (error) {
        reject(error);
      }
    };

    xhr.onerror = function () {
      var status = xhr.status ? " (".concat(xhr.status, ")") : '';
      reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
    };

    xhr.send();
  });
}
/**
 * Initialize all embeds within a specific element
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */

function initializeEmbeds() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));

  var handleError = function handleError(error) {
    if ('console' in window && console.error) {
      console.error("There was an error creating an embed: ".concat(error));
    }
  };

  elements.forEach(function (element) {
    try {
      // Skip any that have data-vimeo-defer
      if (element.getAttribute('data-vimeo-defer') !== null) {
        return;
      }

      var params = getOEmbedParameters(element);
      var url = getVimeoUrl(params);
      getOEmbedData(url, params, element).then(function (data) {
        return createEmbed(data, element);
      }).catch(handleError);
    } catch (error) {
      handleError(error);
    }
  });
}
/**
 * Resize embeds when messaged by the player.
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */

function resizeEmbeds() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  // Prevent execution if users include the player.js script multiple times.
  if (window.VimeoPlayerResizeEmbeds_) {
    return;
  }

  window.VimeoPlayerResizeEmbeds_ = true;

  var onMessage = function onMessage(event) {
    if (!isVimeoUrl(event.origin)) {
      return;
    } // 'spacechange' is fired only on embeds with cards


    if (!event.data || event.data.event !== 'spacechange') {
      return;
    }

    var iframes = parent.querySelectorAll('iframe');

    for (var i = 0; i < iframes.length; i++) {
      if (iframes[i].contentWindow !== event.source) {
        continue;
      } // Change padding-bottom of the enclosing div to accommodate
      // card carousel without distorting aspect ratio


      var space = iframes[i].parentElement;
      space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
      break;
    }
  };

  window.addEventListener('message', onMessage);
}

/**
 * @module lib/postmessage
 */
/**
 * Parse a message received from postMessage.
 *
 * @param {*} data The data received from postMessage.
 * @return {object}
 */

function parseMessageData(data) {
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (error) {
      // If the message cannot be parsed, throw the error as a warning
      console.warn(error);
      return {};
    }
  }

  return data;
}
/**
 * Post a message to the specified target.
 *
 * @param {Player} player The player object to use.
 * @param {string} method The API method to call.
 * @param {object} params The parameters to send to the player.
 * @return {void}
 */

function postMessage(player, method, params) {
  if (!player.element.contentWindow || !player.element.contentWindow.postMessage) {
    return;
  }

  var message = {
    method: method
  };

  if (params !== undefined) {
    message.value = params;
  } // IE 8 and 9 do not support passing messages, so stringify them


  var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));

  if (ieVersion >= 8 && ieVersion < 10) {
    message = JSON.stringify(message);
  }

  player.element.contentWindow.postMessage(message, player.origin);
}
/**
 * Parse the data received from a message event.
 *
 * @param {Player} player The player that received the message.
 * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
 * @return {void}
 */

function processData(player, data) {
  data = parseMessageData(data);
  var callbacks = [];
  var param;

  if (data.event) {
    if (data.event === 'error') {
      var promises = getCallbacks(player, data.data.method);
      promises.forEach(function (promise) {
        var error = new Error(data.data.message);
        error.name = data.data.name;
        promise.reject(error);
        removeCallback(player, data.data.method, promise);
      });
    }

    callbacks = getCallbacks(player, "event:".concat(data.event));
    param = data.data;
  } else if (data.method) {
    var callback = shiftCallbacks(player, data.method);

    if (callback) {
      callbacks.push(callback);
      param = data.value;
    }
  }

  callbacks.forEach(function (callback) {
    try {
      if (typeof callback === 'function') {
        callback.call(player, param);
        return;
      }

      callback.resolve(param);
    } catch (e) {// empty
    }
  });
}

var playerMap = new WeakMap();
var readyMap = new WeakMap();

var Player =
/*#__PURE__*/
function () {
  /**
   * Create a Player.
   *
   * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
   *        player iframe, and id, or a jQuery object.
   * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
   * @return {Player}
   */
  function Player(element) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Player);

    /* global jQuery */
    if (window.jQuery && element instanceof jQuery) {
      if (element.length > 1 && window.console && console.warn) {
        console.warn('A jQuery object with multiple elements was passed, using the first element.');
      }

      element = element[0];
    } // Find an element by ID


    if (typeof document !== 'undefined' && typeof element === 'string') {
      element = document.getElementById(element);
    } // Not an element!


    if (!isDomElement(element)) {
      throw new TypeError('You must pass either a valid element or a valid id.');
    } // Already initialized an embed in this div, so grab the iframe


    if (element.nodeName !== 'IFRAME') {
      var iframe = element.querySelector('iframe');

      if (iframe) {
        element = iframe;
      }
    } // iframe url is not a Vimeo url


    if (element.nodeName === 'IFRAME' && !isVimeoUrl(element.getAttribute('src') || '')) {
      throw new Error('The player element passed isn’t a Vimeo embed.');
    } // If there is already a player object in the map, return that


    if (playerMap.has(element)) {
      return playerMap.get(element);
    }

    this._window = element.ownerDocument.defaultView;
    this.element = element;
    this.origin = '*';
    var readyPromise = new npo_src(function (resolve, reject) {
      _this._onMessage = function (event) {
        if (!isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) {
          return;
        }

        if (_this.origin === '*') {
          _this.origin = event.origin;
        }

        var data = parseMessageData(event.data);
        var isError = data && data.event === 'error';
        var isReadyError = isError && data.data && data.data.method === 'ready';

        if (isReadyError) {
          var error = new Error(data.data.message);
          error.name = data.data.name;
          reject(error);
          return;
        }

        var isReadyEvent = data && data.event === 'ready';
        var isPingResponse = data && data.method === 'ping';

        if (isReadyEvent || isPingResponse) {
          _this.element.setAttribute('data-ready', 'true');

          resolve();
          return;
        }

        processData(_this, data);
      };

      _this._window.addEventListener('message', _this._onMessage);

      if (_this.element.nodeName !== 'IFRAME') {
        var params = getOEmbedParameters(element, options);
        var url = getVimeoUrl(params);
        getOEmbedData(url, params, element).then(function (data) {
          var iframe = createEmbed(data, element); // Overwrite element with the new iframe,
          // but store reference to the original element

          _this.element = iframe;
          _this._originalElement = element;
          swapCallbacks(element, iframe);
          playerMap.set(_this.element, _this);
          return data;
        }).catch(reject);
      }
    }); // Store a copy of this Player in the map

    readyMap.set(this, readyPromise);
    playerMap.set(this.element, this); // Send a ping to the iframe so the ready promise will be resolved if
    // the player is already ready.

    if (this.element.nodeName === 'IFRAME') {
      postMessage(this, 'ping');
    }

    return this;
  }
  /**
   * Get a promise for a method.
   *
   * @param {string} name The API method to call.
   * @param {Object} [args={}] Arguments to send via postMessage.
   * @return {Promise}
   */


  _createClass(Player, [{
    key: "callMethod",
    value: function callMethod(name) {
      var _this2 = this;

      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new npo_src(function (resolve, reject) {
        // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return
        return _this2.ready().then(function () {
          storeCallback(_this2, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this2, name, args);
        }).catch(reject);
      });
    }
    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */

  }, {
    key: "get",
    value: function get(name) {
      var _this3 = this;

      return new npo_src(function (resolve, reject) {
        name = getMethodName(name, 'get'); // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return

        return _this3.ready().then(function () {
          storeCallback(_this3, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this3, name);
        }).catch(reject);
      });
    }
    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */

  }, {
    key: "set",
    value: function set(name, value) {
      var _this4 = this;

      return new npo_src(function (resolve, reject) {
        name = getMethodName(name, 'set');

        if (value === undefined || value === null) {
          throw new TypeError('There must be a value to set.');
        } // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return


        return _this4.ready().then(function () {
          storeCallback(_this4, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this4, name, value);
        }).catch(reject);
      });
    }
    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */

  }, {
    key: "on",
    value: function on(eventName, callback) {
      if (!eventName) {
        throw new TypeError('You must pass an event name.');
      }

      if (!callback) {
        throw new TypeError('You must pass a callback function.');
      }

      if (typeof callback !== 'function') {
        throw new TypeError('The callback must be a function.');
      }

      var callbacks = getCallbacks(this, "event:".concat(eventName));

      if (callbacks.length === 0) {
        this.callMethod('addEventListener', eventName).catch(function () {// Ignore the error. There will be an error event fired that
          // will trigger the error callback if they are listening.
        });
      }

      storeCallback(this, "event:".concat(eventName), callback);
    }
    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */

  }, {
    key: "off",
    value: function off(eventName, callback) {
      if (!eventName) {
        throw new TypeError('You must pass an event name.');
      }

      if (callback && typeof callback !== 'function') {
        throw new TypeError('The callback must be a function.');
      }

      var lastCallback = removeCallback(this, "event:".concat(eventName), callback); // If there are no callbacks left, remove the listener

      if (lastCallback) {
        this.callMethod('removeEventListener', eventName).catch(function (e) {// Ignore the error. There will be an error event fired that
          // will trigger the error callback if they are listening.
        });
      }
    }
    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id successfully loaded.
     * @reject {TypeError} The id was not a number.
     */

    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|object} options The id of the video or an object with embed options.
     * @return {LoadVideoPromise}
     */

  }, {
    key: "loadVideo",
    value: function loadVideo(options) {
      return this.callMethod('loadVideo', options);
    }
    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */

    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */

  }, {
    key: "ready",
    value: function ready() {
      var readyPromise = readyMap.get(this) || new npo_src(function (resolve, reject) {
        reject(new Error('Unknown player. Probably unloaded.'));
      });
      return npo_src.resolve(readyPromise);
    }
    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */

    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */

  }, {
    key: "addCuePoint",
    value: function addCuePoint(time) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.callMethod('addCuePoint', {
        time: time,
        data: data
      });
    }
    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */

    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */

  }, {
    key: "removeCuePoint",
    value: function removeCuePoint(id) {
      return this.callMethod('removeCuePoint', id);
    }
    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */

    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */

    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */

  }, {
    key: "enableTextTrack",
    value: function enableTextTrack(language, kind) {
      if (!language) {
        throw new TypeError('You must pass a language.');
      }

      return this.callMethod('enableTextTrack', {
        language: language,
        kind: kind
      });
    }
    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */

    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */

  }, {
    key: "disableTextTrack",
    value: function disableTextTrack() {
      return this.callMethod('disableTextTrack');
    }
    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */

    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */

  }, {
    key: "pause",
    value: function pause() {
      return this.callMethod('pause');
    }
    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */

    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */

  }, {
    key: "play",
    value: function play() {
      return this.callMethod('play');
    }
    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */

    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */

  }, {
    key: "unload",
    value: function unload() {
      return this.callMethod('unload');
    }
    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var _this5 = this;

      return new npo_src(function (resolve) {
        readyMap.delete(_this5);
        playerMap.delete(_this5.element);

        if (_this5._originalElement) {
          playerMap.delete(_this5._originalElement);

          _this5._originalElement.removeAttribute('data-vimeo-initialized');
        }

        if (_this5.element && _this5.element.nodeName === 'IFRAME' && _this5.element.parentNode) {
          _this5.element.parentNode.removeChild(_this5.element);
        }

        _this5._window.removeEventListener('message', _this5._onMessage);

        resolve();
      });
    }
    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */

    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */

  }, {
    key: "getAutopause",
    value: function getAutopause() {
      return this.get('autopause');
    }
    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */

    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */

  }, {
    key: "setAutopause",
    value: function setAutopause(autopause) {
      return this.set('autopause', autopause);
    }
    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */

    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */

  }, {
    key: "getBuffered",
    value: function getBuffered() {
      return this.get('buffered');
    }
    /**
     * A representation of a chapter.
     *
     * @typedef {Object} VimeoChapter
     * @property {number} startTime The start time of the chapter.
     * @property {object} title The title of the chapter.
     * @property {number} index The place in the order of Chapters. Starts at 1.
     */

    /**
     * A promise to get chapters for the video.
     *
     * @promise GetChaptersPromise
     * @fulfill {VimeoChapter[]} The chapters for the video.
     */

    /**
     * Get an array of all the chapters for the video.
     *
     * @return {GetChaptersPromise}
     */

  }, {
    key: "getChapters",
    value: function getChapters() {
      return this.get('chapters');
    }
    /**
     * A promise to get the currently active chapter.
     *
     * @promise GetCurrentChaptersPromise
     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
     */

    /**
     * Get the currently active chapter for the video.
     *
     * @return {GetCurrentChaptersPromise}
     */

  }, {
    key: "getCurrentChapter",
    value: function getCurrentChapter() {
      return this.get('currentChapter');
    }
    /**
     * A promise to get the color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */

    /**
     * Get the color for this player.
     *
     * @return {GetColorPromise}
     */

  }, {
    key: "getColor",
    value: function getColor() {
      return this.get('color');
    }
    /**
     * A promise to set the color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */

    /**
     * Set the color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */

  }, {
    key: "setColor",
    value: function setColor(color) {
      return this.set('color', color);
    }
    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */

    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */

    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */

  }, {
    key: "getCuePoints",
    value: function getCuePoints() {
      return this.get('cuePoints');
    }
    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */

    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */

  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.get('currentTime');
    }
    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */

    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */

  }, {
    key: "setCurrentTime",
    value: function setCurrentTime(currentTime) {
      return this.set('currentTime', currentTime);
    }
    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */

    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */

  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.get('duration');
    }
    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */

    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */

  }, {
    key: "getEnded",
    value: function getEnded() {
      return this.get('ended');
    }
    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */

    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */

  }, {
    key: "getLoop",
    value: function getLoop() {
      return this.get('loop');
    }
    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */

    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */

  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      return this.set('loop', loop);
    }
    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */

    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */

  }, {
    key: "setMuted",
    value: function setMuted(muted) {
      return this.set('muted', muted);
    }
    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */

    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */

  }, {
    key: "getMuted",
    value: function getMuted() {
      return this.get('muted');
    }
    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */

    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */

  }, {
    key: "getPaused",
    value: function getPaused() {
      return this.get('paused');
    }
    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0.5 to 2.
     */

    /**
     * Get the playback rate of the player on a scale from `0.5` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */

  }, {
    key: "getPlaybackRate",
    value: function getPlaybackRate() {
      return this.get('playbackRate');
    }
    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0.5 or greater than 2.
     */

    /**
     * Set the playback rate of the player on a scale from `0.5` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */

  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(playbackRate) {
      return this.set('playbackRate', playbackRate);
    }
    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */

    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */

  }, {
    key: "getPlayed",
    value: function getPlayed() {
      return this.get('played');
    }
    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */

    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */

  }, {
    key: "getSeekable",
    value: function getSeekable() {
      return this.get('seekable');
    }
    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */

    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */

  }, {
    key: "getSeeking",
    value: function getSeeking() {
      return this.get('seeking');
    }
    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */

    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */

  }, {
    key: "getTextTracks",
    value: function getTextTracks() {
      return this.get('textTracks');
    }
    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */

    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */

  }, {
    key: "getVideoEmbedCode",
    value: function getVideoEmbedCode() {
      return this.get('videoEmbedCode');
    }
    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */

    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */

  }, {
    key: "getVideoId",
    value: function getVideoId() {
      return this.get('videoId');
    }
    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */

    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */

  }, {
    key: "getVideoTitle",
    value: function getVideoTitle() {
      return this.get('videoTitle');
    }
    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */

    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */

  }, {
    key: "getVideoWidth",
    value: function getVideoWidth() {
      return this.get('videoWidth');
    }
    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */

    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */

  }, {
    key: "getVideoHeight",
    value: function getVideoHeight() {
      return this.get('videoHeight');
    }
    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */

    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */

  }, {
    key: "getVideoUrl",
    value: function getVideoUrl() {
      return this.get('videoUrl');
    }
    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */

    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */

  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.get('volume');
    }
    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */

    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */

  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      return this.set('volume', volume);
    }
  }]);

  return Player;
}(); // Setup embed only if this is not a node environment


if (!isNode) {
  initializeEmbeds();
  resizeEmbeds();
}

/* harmony default export */ __webpack_exports__["default"] = (Player);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19), __webpack_require__(108).setImmediate))

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

function makeFocusableForeignObject() {
  var fragment = document.createElement('div');
  fragment.innerHTML = '<svg><foreignObject width="30" height="30">\n      <input type="text"/>\n  </foreignObject></svg>';

  return fragment.firstChild.firstChild;
}

/* harmony default export */ __webpack_exports__["a"] = (function (element) {
  // Edge13, Edge14: foreignObject focus hack
  // https://jsbin.com/kunehinugi/edit?html,js,output
  // https://jsbin.com/fajagi/3/edit?html,js,output
  var isSvgElement = element.ownerSVGElement || element.nodeName.toLowerCase() === 'svg';
  if (!isSvgElement) {
    return false;
  }

  // inject and focus an <input> element into the SVG element to receive focus
  var foreignObject = makeFocusableForeignObject();
  element.appendChild(foreignObject);
  var input = foreignObject.querySelector('input');
  input.focus();

  // upon disabling the activeElement, IE and Edge
  // will not shift focus to <body> like all the other
  // browsers, but instead find the first focusable
  // ancestor and shift focus to that
  input.disabled = true;

  // clean up
  element.removeChild(foreignObject);
  return true;
});
//# sourceMappingURL=focus.svg-foreign-object-hack.js.map

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_active_elements__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_decorate_service__ = __webpack_require__(90);

/*
  Utility to observe focus changes within ShadowDOMs.

  USAGE:
    engage();
    document.body.addEventListener('shadow-focus', function(event) {
      // event.detail.elements: complete focus ancestry (array of nodes)
      // event.detail.active: the actually focused element within the ShadowDOM
      // event.detail.hosts: the shadow host ancestry of the active element
    }, false);

  Alternate implementation: https://github.com/cdata/focus-observer
*/




var engage = void 0;
var disengage = void 0;

if (typeof document === 'undefined' || !document.documentElement.createShadowRoot) {
  // no need to initialize any of this if we don't have ShadowDOM available
  engage = disengage = function disengage() {};
} else {
  (function () {
    var blurTimer = void 0;
    var blurElement = void 0;

    var handleElementBlurEvent = function handleElementBlurEvent() {
      stopHandleElementBlurEvent();
      // abort any handlers that come from document blur handler
      (window.clearImmediate || window.clearTimeout)(blurTimer);
      blurTimer = (window.setImmediate || window.setTimeout)(function () {
        handleFocusChange();
      });
    };

    var observeElementBlurEvent = function observeElementBlurEvent(element) {
      // call us when we're leaving the element
      element.addEventListener('blur', handleElementBlurEvent, true);
      blurElement = element;
    };

    var stopHandleElementBlurEvent = function stopHandleElementBlurEvent() {
      // once() - sometimes I miss jQuery's simplicity…
      blurElement && blurElement.removeEventListener('blur', handleElementBlurEvent, true);
      blurElement = null;
    };

    var handleFocusChange = function handleFocusChange() {
      var _active = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__get_active_elements__["a" /* default */])();
      if (_active.length === 1) {
        stopHandleElementBlurEvent();
        return;
      }

      // listen for blur so we know when to re-validate
      observeElementBlurEvent(_active[0]);
      var shadowFocusEvent = new CustomEvent('shadow-focus', {
        bubbles: false,
        cancelable: false,
        detail: {
          // complete focus ancestry
          elements: _active,
          // the actually focused element
          active: _active[0],
          // shadow host ancestry
          hosts: _active.slice(1)
        }
      });

      document.dispatchEvent(shadowFocusEvent);
    };

    var handleDocumentFocusEvent = function handleDocumentFocusEvent() {
      (window.clearImmediate || window.clearTimeout)(blurTimer);
      handleFocusChange();
    };

    engage = function engage() {
      document.addEventListener('focus', handleDocumentFocusEvent, true);
    };

    disengage = function disengage() {
      (window.clearImmediate || window.clearTimeout)(blurTimer);
      blurElement && blurElement.removeEventListener('blur', handleElementBlurEvent, true);
      document.removeEventListener('focus', handleDocumentFocusEvent, true);
    };
  })();
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_decorate_service__["a" /* default */])({ engage: engage, disengage: disengage }));
//# sourceMappingURL=shadow-focus.js.map

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_context_to_element__ = __webpack_require__(50);



// [elem, elem.parent, elem.parent.parent, …, html]
// will not contain the shadowRoot (DOCUMENT_FRAGMENT_NODE) and shadowHost
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var list = [];
  var element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_context_to_element__["a" /* default */])({
    label: 'get/parents',
    context: context
  });

  while (element) {
    list.push(element);
    // IE does know support parentElement on SVGElement
    element = element.parentNode;
    if (element && element.nodeType !== Node.ELEMENT_NODE) {
      element = null;
    }
  }

  return list;
});
//# sourceMappingURL=parents.js.map

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shadow_host__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_context_to_element__ = __webpack_require__(50);




/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var list = [];
  var element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_context_to_element__["a" /* default */])({
    label: 'get/shadow-host-parents',
    context: context
  });

  while (element) {
    element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shadow_host__["a" /* default */])({ context: element });
    if (!element) {
      break;
    }

    list.push(element);
  }

  return list;
});
//# sourceMappingURL=shadow-host-parents.js.map

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_context_to_element__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_shadow_host__ = __webpack_require__(87);

// determine if an element is the child of a ShadowRoot




/* harmony default export */ __webpack_exports__["a"] = (function (context) {
  var element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_context_to_element__["a" /* default */])({
    label: 'is/shadowed',
    resolveDocument: true,
    context: context
  });

  return Boolean(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_shadow_host__["a" /* default */])({ context: element }));
});
//# sourceMappingURL=shadowed.js.map

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_toggle_class__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_shadow_focus__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_active_elements__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__get_parents__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_decorate_service__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_select_in_shadows__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__supports_supports__ = __webpack_require__(213);

/*
  add .ally-focus-within class to parents of document.activeElement,
  to provide the functionality of :focus-within where it's not available
  see https://dev.w3.org/csswg/selectors-4/#the-focus-within-pseudo

  USAGE:
    style/focus-within()
*/









var supports = void 0;

// preferring focusin/out because they are synchronous in IE10+11
var supportsFocusIn = typeof document !== 'undefined' && 'onfocusin' in document;
var focusEventName = supportsFocusIn ? 'focusin' : 'focus';
var blurEventName = supportsFocusIn ? 'focusout' : 'blur';

var className = 'ally-focus-within';
// defined in engage();
var selector = void 0;
var blurTimer = void 0;
var shadowHandle = void 0;

function applyFocusWithinClass(active) {
  var _active = active || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_active_elements__["a" /* default */])();
  if (!supports.cssShadowPiercingDeepCombinator) {
    // no shadow-piercing descendant selector, no joy
    _active = _active.slice(-1);
  }

  // identify the elements that currently have :focus-within
  var _current = [].slice.call(document.querySelectorAll(selector), 0);
  // get the path (ancestry) of each ShadowRoot and merge them into a flat list
  var elements = _active.map(function (context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__get_parents__["a" /* default */])({ context: context });
  }).reduce(function (previous, current) {
    return current.concat(previous);
  }, []);

  // remove the class only from elements that would not receive it again (minimize dom action)
  _current.forEach(function (element) {
    if (elements.indexOf(element) !== -1) {
      return;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_toggle_class__["a" /* removeClass */])(element, className);
  });

  // apply the class only to elements that do not yet have it (minimize dom action)
  elements.forEach(function (element) {
    if (_current.indexOf(element) !== -1) {
      return;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_toggle_class__["b" /* addClass */])(element, className);
  });
}

function handleDocumentBlurEvent() {
  // we won't get a focus for <body>, but a delayed blur handler will achieve
  // the same thing listening for focus would've done, unless we get a focus, of course
  blurTimer = (window.setImmediate || window.setTimeout)(function () {
    applyFocusWithinClass();
  });
}

function handleDocumentFocusEvent() {
  // abort any handlers that come from document or element blur handlers
  (window.clearImmediate || window.clearTimeout)(blurTimer);
  // NOTE: we could overcome Firefox 34 issue of not supporting ShadowRoot.host by
  // passing event.target (which references the first-level ShadowHost), but that
  // would require applyFocusWithinClass() to distinguish between the argument and
  // getActiveElements().
  applyFocusWithinClass();
}

function handleShadowFocusEvent(event) {
  applyFocusWithinClass(event.detail.elements);
}

function disengage() {
  shadowHandle && shadowHandle.disengage();
  (window.clearImmediate || window.clearTimeout)(blurTimer);
  document.removeEventListener(blurEventName, handleDocumentBlurEvent, true);
  document.removeEventListener(focusEventName, handleDocumentFocusEvent, true);
  document.removeEventListener('shadow-focus', handleShadowFocusEvent, true);

  // remove any remaining ally-within-focus occurrences
  [].forEach.call(document.querySelectorAll(selector), function (element) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_toggle_class__["a" /* removeClass */])(element, className);
  });
}

function engage() {
  if (!supports) {
    supports = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__supports_supports__["a" /* default */])();
    selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_select_in_shadows__["a" /* default */])('.' + className);
  }

  shadowHandle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__event_shadow_focus__["a" /* default */])();
  document.addEventListener(blurEventName, handleDocumentBlurEvent, true);
  document.addEventListener(focusEventName, handleDocumentFocusEvent, true);
  document.addEventListener('shadow-focus', handleShadowFocusEvent, true);
  applyFocusWithinClass();
}

/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_decorate_service__["a" /* default */])({ engage: engage, disengage: disengage }));
//# sourceMappingURL=focus-within.js.map

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_platform__ = __webpack_require__(21);



function before() {
  var data = {
    // remember what had focus to restore after test
    activeElement: document.activeElement,
    // remember scroll positions to restore after test
    windowScrollTop: window.scrollTop,
    windowScrollLeft: window.scrollLeft,
    bodyScrollTop: document.body.scrollTop,
    bodyScrollLeft: document.body.scrollLeft
  };

  // wrap tests in an element hidden from screen readers to prevent them
  // from announcing focus, which can be quite irritating to the user
  var iframe = document.createElement('iframe');
  iframe.setAttribute('style', 'position:absolute; position:fixed; top:0; left:-2px; width:1px; height:1px; overflow:hidden;');
  iframe.setAttribute('aria-live', 'off');
  iframe.setAttribute('aria-busy', 'true');
  iframe.setAttribute('aria-hidden', 'true');
  document.body.appendChild(iframe);

  var _window = iframe.contentWindow;
  var _document = _window.document;

  _document.open();
  _document.close();
  var wrapper = _document.createElement('div');
  _document.body.appendChild(wrapper);

  data.iframe = iframe;
  data.wrapper = wrapper;
  data.window = _window;
  data.document = _document;

  return data;
}

// options.element:
//  {string} element name
//  {function} callback(wrapper, document) to generate an element
// options.mutate: (optional)
//  {function} callback(element, wrapper, document) to manipulate element prior to focus-test.
//             Can return DOMElement to define focus target (default: element)
// options.validate: (optional)
//  {function} callback(element, focusTarget, document) to manipulate test-result
function test(data, options) {
  // make sure we operate on a clean slate
  data.wrapper.innerHTML = '';
  // create dummy element to test focusability of
  var element = typeof options.element === 'string' ? data.document.createElement(options.element) : options.element(data.wrapper, data.document);
  // allow callback to further specify dummy element
  // and optionally define element to focus
  var focus = options.mutate && options.mutate(element, data.wrapper, data.document);
  if (!focus && focus !== false) {
    focus = element;
  }
  // element needs to be part of the DOM to be focusable
  !element.parentNode && data.wrapper.appendChild(element);
  // test if the element with invalid tabindex can be focused
  focus && focus.focus && focus.focus();
  // validate test's result
  return options.validate ? options.validate(element, focus, data.document) : data.document.activeElement === focus;
}

function after(data) {
  // restore focus to what it was before test and cleanup
  if (data.activeElement === document.body) {
    document.activeElement && document.activeElement.blur && document.activeElement.blur();
    if (__WEBPACK_IMPORTED_MODULE_0__util_platform__["a" /* default */].is.IE10) {
      // IE10 does not redirect focus to <body> when the activeElement is removed
      document.body.focus();
    }
  } else {
    data.activeElement && data.activeElement.focus && data.activeElement.focus();
  }

  document.body.removeChild(data.iframe);

  // restore scroll position
  window.scrollTop = data.windowScrollTop;
  window.scrollLeft = data.windowScrollLeft;
  document.body.scrollTop = data.bodyScrollTop;
  document.body.scrollLeft = data.bodyScrollLeft;
}

/* harmony default export */ __webpack_exports__["a"] = (function (tests) {
  var data = before();

  var results = {};
  Object.keys(tests).map(function (key) {
    results[key] = test(data, tests[key]);
  });

  after(data);
  return results;
});
//# sourceMappingURL=detect-focus.js.map

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_gif__ = __webpack_require__(20);



// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-tabindex-test">' + '<area shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-tabindex-test" tabindex="-1" alt="" src="' + __WEBPACK_IMPORTED_MODULE_0__media_gif__["a" /* default */] + '">';

    return element.querySelector('area');
  }
});
//# sourceMappingURL=focus-area-img-tabindex.js.map

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_gif__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_platform__ = __webpack_require__(21);




// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-tabindex-test">' + '<area href="#void" tabindex="-1" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-tabindex-test" alt="" src="' + __WEBPACK_IMPORTED_MODULE_0__media_gif__["a" /* default */] + '">';

    return false;
  },
  validate: function validate(element, focusTarget, _document) {
    if (__WEBPACK_IMPORTED_MODULE_1__util_platform__["a" /* default */].is.GECKO) {
      // fixes https://github.com/medialize/ally.js/issues/35
      // Firefox loads the DataURI asynchronously, causing a false-negative
      return true;
    }

    var focus = element.querySelector('area');
    focus.focus();
    return _document.activeElement === focus;
  }
});
//# sourceMappingURL=focus-area-tabindex.js.map

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_gif__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_platform__ = __webpack_require__(21);




// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-area-href-test">' + '<area shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-area-href-test" alt="" src="' + __WEBPACK_IMPORTED_MODULE_0__media_gif__["a" /* default */] + '">';

    return element.querySelector('area');
  },
  validate: function validate(element, focusTarget, _document) {
    if (__WEBPACK_IMPORTED_MODULE_1__util_platform__["a" /* default */].is.GECKO) {
      // fixes https://github.com/medialize/ally.js/issues/35
      // Firefox loads the DataURI asynchronously, causing a false-negative
      return true;
    }

    return _document.activeElement === focusTarget;
  }
});
//# sourceMappingURL=focus-area-without-href.js.map

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_mp3__ = __webpack_require__(210);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'can-focus-audio-without-controls',
  element: 'audio',
  mutate: function mutate(element) {
    try {
      // invalid media file can trigger warning in console, data-uri to prevent HTTP request
      element.setAttribute('src', __WEBPACK_IMPORTED_MODULE_0__media_mp3__["a" /* default */]);
    } catch (e) {
      // IE9 may throw "Error: Not implemented"
    }
  }
});
//# sourceMappingURL=focus-audio-without-controls.js.map

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_gif_invalid__ = __webpack_require__(209);



// NOTE: https://github.com/medialize/ally.js/issues/35
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="broken-image-map-test"><area href="#void" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#broken-image-map-test" alt="" src="' + __WEBPACK_IMPORTED_MODULE_0__media_gif_invalid__["a" /* default */] + '">';

    return element.querySelector('area');
  }
});
//# sourceMappingURL=focus-broken-image-map.js.map

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Children of focusable elements with display:flex are focusable in IE10-11
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', '-1');
    element.setAttribute('style', 'display: -webkit-flex; display: -ms-flexbox; display: flex;');
    element.innerHTML = '<span style="display: block;">hello</span>';
    return element.querySelector('span');
  }
});
//# sourceMappingURL=focus-children-of-focusable-flexbox.js.map

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// fieldset[tabindex=0][disabled] should not be focusable, but Blink and WebKit disagree
// @specification https://www.w3.org/TR/html5/disabled-elements.html#concept-element-disabled
// @browser-issue Chromium https://crbug.com/453847
// @browser-issue WebKit https://bugs.webkit.org/show_bug.cgi?id=141086
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'fieldset',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', 0);
    element.setAttribute('disabled', 'disabled');
  }
});
//# sourceMappingURL=focus-fieldset-disabled.js.map

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'fieldset',
  mutate: function mutate(element) {
    element.innerHTML = '<legend>legend</legend><p>content</p>';
  }
});
//# sourceMappingURL=focus-fieldset.js.map

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// elements with display:flex are focusable in IE10-11
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'span',
  mutate: function mutate(element) {
    element.setAttribute('style', 'display: -webkit-flex; display: -ms-flexbox; display: flex;');
    element.innerHTML = '<span style="display: block;">hello</span>';
  }
});
//# sourceMappingURL=focus-flexbox-container.js.map

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// form[tabindex=0][disabled] should be focusable as the
// specification doesn't know the disabled attribute on the form element
// @specification https://www.w3.org/TR/html5/forms.html#the-form-element
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'form',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', 0);
    element.setAttribute('disabled', 'disabled');
  }
});
//# sourceMappingURL=focus-form-disabled.js.map

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_gif__ = __webpack_require__(20);



// NOTE: https://github.com/medialize/ally.js/issues/35
// fixes https://github.com/medialize/ally.js/issues/20
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-ismap
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'a',
  mutate: function mutate(element) {
    element.href = '#void';
    element.innerHTML = '<img ismap src="' + __WEBPACK_IMPORTED_MODULE_0__media_gif__["a" /* default */] + '" alt="">';
    return element.querySelector('img');
  }
});
//# sourceMappingURL=focus-img-ismap.js.map

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_gif__ = __webpack_require__(20);



// NOTE: https://github.com/medialize/ally.js/issues/35
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-tabindex-test"><area href="#void" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-tabindex-test" tabindex="-1" alt="" ' + 'src="' + __WEBPACK_IMPORTED_MODULE_0__media_gif__["a" /* default */] + '">';

    return element.querySelector('img');
  }
});
//# sourceMappingURL=focus-img-usemap-tabindex.js.map

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  element: function element(wrapper, _document) {
    var iframe = _document.createElement('iframe');

    // iframe must be part of the DOM before accessing the contentWindow is possible
    wrapper.appendChild(iframe);

    // create the iframe's default document (<html><head></head><body></body></html>)
    var iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.close();
    return iframe;
  },
  mutate: function mutate(iframe) {
    iframe.style.visibility = 'hidden';

    var iframeDocument = iframe.contentWindow.document;
    var input = iframeDocument.createElement('input');
    iframeDocument.body.appendChild(input);
    return input;
  },
  validate: function validate(iframe) {
    var iframeDocument = iframe.contentWindow.document;
    var focus = iframeDocument.querySelector('input');
    return iframeDocument.activeElement === focus;
  }
});
//# sourceMappingURL=focus-in-hidden-iframe.js.map

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_platform__ = __webpack_require__(21);



var result = !__WEBPACK_IMPORTED_MODULE_0__util_platform__["a" /* default */].is.WEBKIT;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return result;
});
//# sourceMappingURL=focus-in-zero-dimension-object.js.map

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Firefox allows *any* value and treats invalid values like tabindex="-1"
// @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', 'invalid-value');
  }
});
//# sourceMappingURL=focus-invalid-tabindex.js.map

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'label',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', '-1');
  },
  validate: function validate(element, focusTarget, _document) {
    // force layout in Chrome 49, otherwise the element won't be focusable
    /* eslint-disable no-unused-vars */
    var variableToPreventDeadCodeElimination = element.offsetHeight;
    /* eslint-enable no-unused-vars */
    element.focus();
    return _document.activeElement === element;
  }
});
//# sourceMappingURL=focus-label-tabindex.js.map

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_svg__ = __webpack_require__(89);



// Note: IE10 on BrowserStack does not like this test

/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'object',
  mutate: function mutate(element) {
    element.setAttribute('type', 'image/svg+xml');
    element.setAttribute('data', __WEBPACK_IMPORTED_MODULE_0__media_svg__["a" /* default */]);
    element.setAttribute('width', '200');
    element.setAttribute('height', '50');
    element.style.visibility = 'hidden';
  }
});
//# sourceMappingURL=focus-object-svg-hidden.js.map

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_svg__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_platform__ = __webpack_require__(21);




// Note: IE10 on BrowserStack does not like this test

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'can-focus-object-svg',
  element: 'object',
  mutate: function mutate(element) {
    element.setAttribute('type', 'image/svg+xml');
    element.setAttribute('data', __WEBPACK_IMPORTED_MODULE_0__media_svg__["a" /* default */]);
    element.setAttribute('width', '200');
    element.setAttribute('height', '50');
  },
  validate: function validate(element, focusTarget, _document) {
    if (__WEBPACK_IMPORTED_MODULE_1__util_platform__["a" /* default */].is.GECKO) {
      // Firefox seems to be handling the object creation asynchronously and thereby produces a false negative test result.
      // Because we know Firefox is able to focus object elements referencing SVGs, we simply cheat by sniffing the user agent string
      return true;
    }

    return _document.activeElement === element;
  }
});
//# sourceMappingURL=focus-object-svg.js.map

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_platform__ = __webpack_require__(21);



// Every Environment except IE9 considers SWF objects focusable
var result = !__WEBPACK_IMPORTED_MODULE_0__util_platform__["a" /* default */].is.IE9;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return result;
});
//# sourceMappingURL=focus-object-swf.js.map

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_gif__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="focus-redirect-img-usemap"><area href="#void" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#focus-redirect-img-usemap" alt="" ' + 'src="' + __WEBPACK_IMPORTED_MODULE_0__media_gif__["a" /* default */] + '">';

    // focus the <img>, not the <div>
    return element.querySelector('img');
  },
  validate: function validate(element, focusTarget, _document) {
    var target = element.querySelector('area');
    return _document.activeElement === target;
  }
});
//# sourceMappingURL=focus-redirect-img-usemap.js.map

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// see https://jsbin.com/nenirisage/edit?html,js,console,output

/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'fieldset',
  mutate: function mutate(element) {
    element.innerHTML = '<legend>legend</legend><input tabindex="-1"><input tabindex="0">';
    // take care of focus in validate();
    return false;
  },
  validate: function validate(element, focusTarget, _document) {
    var focusable = element.querySelector('input[tabindex="-1"]');
    var tabbable = element.querySelector('input[tabindex="0"]');

    // Firefox requires this test to focus the <fieldset> first, while this is not necessary in
    // https://jsbin.com/nenirisage/edit?html,js,console,output
    element.focus();

    element.querySelector('legend').focus();
    return _document.activeElement === focusable && 'focusable' || _document.activeElement === tabbable && 'tabbable' || '';
  }
});
//# sourceMappingURL=focus-redirect-legend.js.map

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// https://github.com/medialize/ally.js/issues/21
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('style', 'width: 100px; height: 50px; overflow: auto;');
    element.innerHTML = '<div style="width: 500px; height: 40px;">scrollable content</div>';
    return element.querySelector('div');
  }
});
//# sourceMappingURL=focus-scroll-body.js.map

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// https://github.com/medialize/ally.js/issues/21
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('style', 'width: 100px; height: 50px;');
    element.innerHTML = '<div style="width: 500px; height: 40px;">scrollable content</div>';
  }
});
//# sourceMappingURL=focus-scroll-container-without-overflow.js.map

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// https://github.com/medialize/ally.js/issues/21
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('style', 'width: 100px; height: 50px; overflow: auto;');
    element.innerHTML = '<div style="width: 500px; height: 40px;">scrollable content</div>';
  }
});
//# sourceMappingURL=focus-scroll-container.js.map

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'details',
  mutate: function mutate(element) {
    element.innerHTML = '<summary>foo</summary><p>content</p>';
    return element.firstElementChild;
  }
});
//# sourceMappingURL=focus-summary.js.map

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_svg__ = __webpack_require__(23);



/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_svg__["a" /* generate */])('<text focusable="true">a</text>');
    return element.querySelector('text');
  },
  validate: __WEBPACK_IMPORTED_MODULE_0__helper_svg__["b" /* validate */]
});
//# sourceMappingURL=focus-svg-focusable-attribute.js.map

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_svg__ = __webpack_require__(23);



/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_svg__["a" /* generate */])('<foreignObject tabindex="-1"><input type="text" /></foreignObject>');
    // Safari 8's quersSelector() can't identify foreignObject, but getElementyByTagName() can
    return element.querySelector('foreignObject') || element.getElementsByTagName('foreignObject')[0];
  },
  validate: __WEBPACK_IMPORTED_MODULE_0__helper_svg__["b" /* validate */]

});
//# sourceMappingURL=focus-svg-foreignobject-tabindex.js.map

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_platform__ = __webpack_require__(21);



// Firefox seems to be handling the SVG-document-in-iframe creation asynchronously
// and thereby produces a false negative test result. Thus the test is pointless
// and we resort to UA sniffing once again.
// see http://jsbin.com/vunadohoko/1/edit?js,console,output

var result = Boolean(__WEBPACK_IMPORTED_MODULE_0__util_platform__["a" /* default */].is.GECKO && typeof SVGElement !== 'undefined' && SVGElement.prototype.focus);

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return result;
});
//# sourceMappingURL=focus-svg-in-iframe.js.map

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_svg__ = __webpack_require__(23);



/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_svg__["a" /* generate */])('<text tabindex="-1">a</text>');
    return element.querySelector('text');
  },
  validate: __WEBPACK_IMPORTED_MODULE_0__helper_svg__["b" /* validate */]
});
//# sourceMappingURL=focus-svg-negative-tabindex-attribute.js.map

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_svg__ = __webpack_require__(23);



/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_svg__["a" /* generate */])('<text tabindex="0">a</text>');
    return element.querySelector('text');
  },
  validate: __WEBPACK_IMPORTED_MODULE_0__helper_svg__["b" /* validate */]
});
//# sourceMappingURL=focus-svg-tabindex-attribute.js.map

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_svg__ = __webpack_require__(23);



/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_svg__["a" /* generate */])(['<g id="ally-test-target"><a xlink:href="#void"><text>link</text></a></g>', '<use xlink:href="#ally-test-target" x="0" y="0" tabindex="-1" />'].join(''));

    return element.querySelector('use');
  },
  validate: __WEBPACK_IMPORTED_MODULE_0__helper_svg__["b" /* validate */]
});
//# sourceMappingURL=focus-svg-use-tabindex.js.map

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_svg__ = __webpack_require__(23);



/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_svg__["a" /* generate */])('');
    return element.firstChild;
  },
  validate: __WEBPACK_IMPORTED_MODULE_0__helper_svg__["b" /* validate */]
});
//# sourceMappingURL=focus-svg.js.map

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Firefox allows *any* value and treats invalid values like tabindex="-1"
// @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', '3x');
  }
});
//# sourceMappingURL=focus-tabindex-trailing-characters.js.map

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'table',
  mutate: function mutate(element, wrapper, _document) {
    // IE9 has a problem replacing TBODY contents with innerHTML.
    // https://stackoverflow.com/a/8097055/515124
    // element.innerHTML = '<tr><td>cell</td></tr>';
    var fragment = _document.createDocumentFragment();
    fragment.innerHTML = '<tr><td>cell</td></tr>';
    element.appendChild(fragment);
  }
});
//# sourceMappingURL=focus-table.js.map

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_mp4__ = __webpack_require__(211);



/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'video',
  mutate: function mutate(element) {
    try {
      // invalid media file can trigger warning in console, data-uri to prevent HTTP request
      element.setAttribute('src', __WEBPACK_IMPORTED_MODULE_0__media_mp4__["a" /* default */]);
    } catch (e) {
      // IE9 may throw "Error: Not implemented"
    }
  }
});
//# sourceMappingURL=focus-video-without-controls.js.map

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ('data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZ');
//# sourceMappingURL=gif.invalid.js.map

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gif__ = __webpack_require__(20);

// export default 'data:audio/mp3;base64,audio-focus-test';

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__gif__["a" /* default */]);
//# sourceMappingURL=mp3.js.map

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gif__ = __webpack_require__(20);

// export default 'data:video/mp4;base64,video-focus-test';

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__gif__["a" /* default */]);
//# sourceMappingURL=mp4.js.map

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version__ = __webpack_require__(218);
/*
    Facility to cache test results in localStorage.

    USAGE:
      cache.get('key');
      cache.set('key', 'value');
 */



function readLocalStorage(key) {
  // allow reading from storage to retrieve previous support results
  // even while the document does not have focus
  var data = void 0;

  try {
    data = window.localStorage && window.localStorage.getItem(key);
    data = data ? JSON.parse(data) : {};
  } catch (e) {
    data = {};
  }

  return data;
}

function writeLocalStorage(key, value) {
  if (!document.hasFocus()) {
    // if the document does not have focus when tests are executed, focus() may
    // not be handled properly and events may not be dispatched immediately.
    // This can happen when a document is reloaded while Developer Tools have focus.
    try {
      window.localStorage && window.localStorage.removeItem(key);
    } catch (e) {
      // ignore
    }

    return;
  }

  try {
    window.localStorage && window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // ignore
  }
}

var userAgent = typeof window !== 'undefined' && window.navigator.userAgent || '';
var cacheKey = 'ally-supports-cache';
var cache = readLocalStorage(cacheKey);

// update the cache if ally or the user agent changed (newer version, etc)
if (cache.userAgent !== userAgent || cache.version !== __WEBPACK_IMPORTED_MODULE_0__version__["a" /* default */]) {
  cache = {};
}

cache.userAgent = userAgent;
cache.version = __WEBPACK_IMPORTED_MODULE_0__version__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    return cache;
  },
  set: function set(values) {
    Object.keys(values).forEach(function (key) {
      cache[key] = values[key];
    });

    cache.time = new Date().toISOString();
    writeLocalStorage(cacheKey, cache);
  }
});
//# sourceMappingURL=supports-cache.js.map

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__detect_focus__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__supports_cache__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_shadow_piercing_deep_combinator__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__focus_area_img_tabindex__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__focus_area_tabindex__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__focus_area_without_href__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__focus_audio_without_controls__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__focus_broken_image_map__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__focus_children_of_focusable_flexbox__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__focus_fieldset_disabled__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__focus_fieldset__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__focus_flexbox_container__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__focus_form_disabled__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__focus_img_ismap__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__focus_img_usemap_tabindex__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__focus_in_hidden_iframe__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__focus_in_zero_dimension_object__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__focus_invalid_tabindex__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__focus_label_tabindex__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__focus_object_svg_hidden__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__focus_object_svg__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__focus_object_swf__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__focus_redirect_img_usemap__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__focus_redirect_legend__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__focus_scroll_body__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__focus_scroll_container_without_overflow__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__focus_scroll_container__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__focus_summary__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__focus_svg_focusable_attribute__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__focus_svg_tabindex_attribute__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__focus_svg_negative_tabindex_attribute__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__focus_svg_use_tabindex__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__focus_svg_foreignobject_tabindex__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__focus_svg_in_iframe__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__focus_svg__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__focus_tabindex_trailing_characters__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__focus_table__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__focus_video_without_controls__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__tabsequence_area_at_img_position__ = __webpack_require__(214);










































var testCallbacks = {
  cssShadowPiercingDeepCombinator: __WEBPACK_IMPORTED_MODULE_2__css_shadow_piercing_deep_combinator__["a" /* default */],
  focusInZeroDimensionObject: __WEBPACK_IMPORTED_MODULE_16__focus_in_zero_dimension_object__["a" /* default */],
  focusObjectSwf: __WEBPACK_IMPORTED_MODULE_21__focus_object_swf__["a" /* default */],
  focusSvgInIframe: __WEBPACK_IMPORTED_MODULE_33__focus_svg_in_iframe__["a" /* default */],
  tabsequenceAreaAtImgPosition: __WEBPACK_IMPORTED_MODULE_38__tabsequence_area_at_img_position__["a" /* default */]
};

var testDescriptions = {
  focusAreaImgTabindex: __WEBPACK_IMPORTED_MODULE_3__focus_area_img_tabindex__["a" /* default */],
  focusAreaTabindex: __WEBPACK_IMPORTED_MODULE_4__focus_area_tabindex__["a" /* default */],
  focusAreaWithoutHref: __WEBPACK_IMPORTED_MODULE_5__focus_area_without_href__["a" /* default */],
  focusAudioWithoutControls: __WEBPACK_IMPORTED_MODULE_6__focus_audio_without_controls__["a" /* default */],
  focusBrokenImageMap: __WEBPACK_IMPORTED_MODULE_7__focus_broken_image_map__["a" /* default */],
  focusChildrenOfFocusableFlexbox: __WEBPACK_IMPORTED_MODULE_8__focus_children_of_focusable_flexbox__["a" /* default */],
  focusFieldsetDisabled: __WEBPACK_IMPORTED_MODULE_9__focus_fieldset_disabled__["a" /* default */],
  focusFieldset: __WEBPACK_IMPORTED_MODULE_10__focus_fieldset__["a" /* default */],
  focusFlexboxContainer: __WEBPACK_IMPORTED_MODULE_11__focus_flexbox_container__["a" /* default */],
  focusFormDisabled: __WEBPACK_IMPORTED_MODULE_12__focus_form_disabled__["a" /* default */],
  focusImgIsmap: __WEBPACK_IMPORTED_MODULE_13__focus_img_ismap__["a" /* default */],
  focusImgUsemapTabindex: __WEBPACK_IMPORTED_MODULE_14__focus_img_usemap_tabindex__["a" /* default */],
  focusInHiddenIframe: __WEBPACK_IMPORTED_MODULE_15__focus_in_hidden_iframe__["a" /* default */],
  focusInvalidTabindex: __WEBPACK_IMPORTED_MODULE_17__focus_invalid_tabindex__["a" /* default */],
  focusLabelTabindex: __WEBPACK_IMPORTED_MODULE_18__focus_label_tabindex__["a" /* default */],
  focusObjectSvg: __WEBPACK_IMPORTED_MODULE_20__focus_object_svg__["a" /* default */],
  focusObjectSvgHidden: __WEBPACK_IMPORTED_MODULE_19__focus_object_svg_hidden__["a" /* default */],
  focusRedirectImgUsemap: __WEBPACK_IMPORTED_MODULE_22__focus_redirect_img_usemap__["a" /* default */],
  focusRedirectLegend: __WEBPACK_IMPORTED_MODULE_23__focus_redirect_legend__["a" /* default */],
  focusScrollBody: __WEBPACK_IMPORTED_MODULE_24__focus_scroll_body__["a" /* default */],
  focusScrollContainerWithoutOverflow: __WEBPACK_IMPORTED_MODULE_25__focus_scroll_container_without_overflow__["a" /* default */],
  focusScrollContainer: __WEBPACK_IMPORTED_MODULE_26__focus_scroll_container__["a" /* default */],
  focusSummary: __WEBPACK_IMPORTED_MODULE_27__focus_summary__["a" /* default */],
  focusSvgFocusableAttribute: __WEBPACK_IMPORTED_MODULE_28__focus_svg_focusable_attribute__["a" /* default */],
  focusSvgTabindexAttribute: __WEBPACK_IMPORTED_MODULE_29__focus_svg_tabindex_attribute__["a" /* default */],
  focusSvgNegativeTabindexAttribute: __WEBPACK_IMPORTED_MODULE_30__focus_svg_negative_tabindex_attribute__["a" /* default */],
  focusSvgUseTabindex: __WEBPACK_IMPORTED_MODULE_31__focus_svg_use_tabindex__["a" /* default */],
  focusSvgForeignobjectTabindex: __WEBPACK_IMPORTED_MODULE_32__focus_svg_foreignobject_tabindex__["a" /* default */],
  focusSvg: __WEBPACK_IMPORTED_MODULE_34__focus_svg__["a" /* default */],
  focusTabindexTrailingCharacters: __WEBPACK_IMPORTED_MODULE_35__focus_tabindex_trailing_characters__["a" /* default */],
  focusTable: __WEBPACK_IMPORTED_MODULE_36__focus_table__["a" /* default */],
  focusVideoWithoutControls: __WEBPACK_IMPORTED_MODULE_37__focus_video_without_controls__["a" /* default */]
};

function executeTests() {
  var results = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__detect_focus__["a" /* default */])(testDescriptions);
  Object.keys(testCallbacks).forEach(function (key) {
    results[key] = testCallbacks[key]();
  });

  return results;
}

var supportsCache = null;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  if (supportsCache) {
    return supportsCache;
  }

  supportsCache = __WEBPACK_IMPORTED_MODULE_1__supports_cache__["a" /* default */].get();
  if (!supportsCache.time) {
    __WEBPACK_IMPORTED_MODULE_1__supports_cache__["a" /* default */].set(executeTests());
    supportsCache = __WEBPACK_IMPORTED_MODULE_1__supports_cache__["a" /* default */].get();
  }

  return supportsCache;
});
//# sourceMappingURL=supports.js.map

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_platform__ = __webpack_require__(21);



// https://jsbin.com/vafaba/3/edit?html,js,console,output
var result = __WEBPACK_IMPORTED_MODULE_0__util_platform__["a" /* default */].is.GECKO || __WEBPACK_IMPORTED_MODULE_0__util_platform__["a" /* default */].is.TRIDENT || __WEBPACK_IMPORTED_MODULE_0__util_platform__["a" /* default */].is.EDGE;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return result;
});
//# sourceMappingURL=tabsequence-area-at-img-position.js.map

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// input may be undefined, selector-tring, Node, NodeList, HTMLCollection, array of Nodes
// yes, to some extent this is a bad replica of jQuery's constructor function
/* harmony default export */ __webpack_exports__["a"] = (function (input) {
  if (!input) {
    return [];
  }

  if (Array.isArray(input)) {
    return input;
  }

  // instanceof Node - does not work with iframes
  if (input.nodeType !== undefined) {
    return [input];
  }

  if (typeof input === 'string') {
    input = document.querySelectorAll(input);
  }

  if (input.length !== undefined) {
    return [].slice.call(input, 0);
  }

  throw new TypeError('unexpected input ' + String(input));
});
//# sourceMappingURL=node-array.js.map

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__supports_css_shadow_piercing_deep_combinator__ = __webpack_require__(88);

// convert a CSS selector so that it also pierces ShadowDOM
// takes ".a, #b" and turns it into ".a, #b, html >>> .a, html >>> #b"



var shadowPrefix = void 0;

/* harmony default export */ __webpack_exports__["a"] = (function (selector) {
  if (typeof shadowPrefix !== 'string') {
    var operator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__supports_css_shadow_piercing_deep_combinator__["a" /* default */])();
    if (operator) {
      shadowPrefix = ', html ' + operator + ' ';
    }
  }

  if (!shadowPrefix) {
    return selector;
  }

  return selector + shadowPrefix + selector.replace(/\s*,\s*/g, ',').split(',').join(shadowPrefix);
});
//# sourceMappingURL=select-in-shadows.js.map

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toggleClass */
/* harmony export (immutable) */ __webpack_exports__["a"] = removeClass;
/* harmony export (immutable) */ __webpack_exports__["b"] = addClass;
//
// This util allows to easily add, remove or toggle classes.
//
// Using it is neccessary as IE 9 doesn't support element classList
// and IE 11 doesn't support classList for SVG elements
// see also https://developer.mozilla.org/en/docs/Web/API/Element/classList
//
// This file is a replacement for domtokenlist because of
// https://github.com/medialize/ally.js/issues/147
//
// Usage:
//
// toggleClass(div, 'demo'); // Toggles the class `demo`
// toggleClass(div, 'demo', true); // Adds the class `demo`
// toggleClass(div, 'demo', false); // removes the class `demo`
//
// removeClass(div, 'demo');
// addClass(div, 'demo');
//

/**
 * Extract an array of all classNames of the given DOM or SVG node
 */
function getClassNames(element) {
  var className = element.getAttribute && element.getAttribute('class') || '';
  return className === '' ? [] : className.split(' ');
}

function toggleClass(element, className, force) {
  var classNames = getClassNames(element);
  var idx = classNames.indexOf(className);
  var hasClass = idx !== -1;
  var shouldHaveClass = force !== undefined ? force : !hasClass;
  // Break if classes are already set/removed
  if (shouldHaveClass === hasClass) {
    return;
  }
  // Remove class
  if (!shouldHaveClass) {
    classNames.splice(idx, 1);
  }
  // Add class
  if (shouldHaveClass) {
    classNames.push(className);
  }
  element.setAttribute('class', classNames.join(' '));
}

function removeClass(element, className) {
  return toggleClass(element, className, false);
}

function addClass(element, className) {
  return toggleClass(element, className, true);
}
//# sourceMappingURL=toggle-class.js.map

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// this file is overwritten by `npm run build:pre`
var version = '1.4.1';
/* harmony default export */ __webpack_exports__["a"] = (version);
//# sourceMappingURL=version.js.map

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * THIS IS A FORK IN ORDER TO PROVIDE A NPM PACKAGE OF IT!
 *
 * ORIGINAL:
 * Copyright © 2016 Ben Kamens | MIT license | https://github.com/kamens/jQuery-menu-aim
 *
 * menu-aim is a jQuery plugin for dropdown menus that can differentiate
 * between a user trying hover over a dropdown item vs trying to navigate into
 * a submenu's contents.
 *
 * menu-aim assumes that you have are using a menu with submenus that expand
 * to the menu's right. It will fire events when the user's mouse enters a new
 * dropdown item *and* when that item is being intentionally hovered over.
 *
 * __________________________
 * | Monkeys  >|   Gorilla  |
 * | Gorillas >|   Content  |
 * | Chimps   >|   Here     |
 * |___________|____________|
 *
 * In the above example, "Gorillas" is selected and its submenu content is
 * being shown on the right. Imagine that the user's cursor is hovering over
 * "Gorillas." When they move their mouse into the "Gorilla Content" area, they
 * may briefly hover over "Chimps." This shouldn't close the "Gorilla Content"
 * area.
 *
 * This problem is normally solved using timeouts and delays. menu-aim tries to
 * solve this by detecting the direction of the user's mouse movement. This can
 * make for quicker transitions when navigating up and down the menu. The
 * experience is hopefully similar to amazon.com/'s "Shop by Department"
 * dropdown.
 *
 * Use like so:
 *
 *      $("#menu").menuAim({
 *          activate: $.noop,  // fired on row activation
 *          deactivate: $.noop  // fired on row deactivation
 *      });
 *
 *  ...to receive events when a menu's row has been purposefully (de)activated.
 *
 * The following options can be passed to menuAim. All functions execute with
 * the relevant row's HTML element as the execution context ('this'):
 *
 *      .menuAim({
 *          // Function to call when a row is purposefully activated. Use this
 *          // to show a submenu's content for the activated row.
 *          activate: function() {},
 *
 *          // Function to call when a row is deactivated.
 *          deactivate: function() {},
 *
 *          // Function to call when mouse enters a menu row. Entering a row
 *          // does not mean the row has been activated, as the user may be
 *          // mousing over to a submenu.
 *          enter: function() {},
 *
 *          // Function to call when mouse exits a menu row.
 *          exit: function() {},
 *
 *          // Selector for identifying which elements in the menu are rows
 *          // that can trigger the above events. Defaults to "> li".
 *          rowSelector: "> li",
 *
 *          // You may have some menu rows that aren't submenus and therefore
 *          // shouldn't ever need to "activate." If so, filter submenu rows w/
 *          // this selector. Defaults to "*" (all elements).
 *          submenuSelector: "*",
 *
 *          // Direction the submenu opens relative to the main menu. Can be
 *          // left, right, above, or below. Defaults to "right".
 *          submenuDirection: "right"
 *      });
 *
*/
(function (factory) {
    if (( false ? 'undefined' : _typeof(exports)) === 'object') {
        factory(__webpack_require__(1));
    } else if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
        factory(jQuery);
    }
})(function ($) {
    "use strict";

    var MenuAim = function MenuAim(element, options) {
        this.$menu = this.activeRow = this.mouseLocs = this.lastDelayLoc = this.timeoutId = this.options = null;

        this.init(element, options);
    };

    MenuAim.DEFAULTS = {
        rowSelector: "> li",
        submenuSelector: "*",
        submenuDirection: "right",
        tolerance: 75, // bigger = more forgivey when entering submenu
        enter: $.noop,
        exit: $.noop,
        activate: $.noop,
        deactivate: $.noop,
        exitMenu: $.noop
    };

    MenuAim.prototype.getDefaults = function () {
        return MenuAim.DEFAULTS;
    };

    /**
     * Keep track of the last few locations of the mouse.
     */
    MenuAim.prototype.mousemoveDocument = function (e) {
        this.mouseLocs.push({ x: e.pageX, y: e.pageY });

        if (this.mouseLocs.length > this.MOUSE_LOCS_TRACKED) {
            this.mouseLocs.shift();
        }
    };

    /**
     * Cancel possible row activations when leaving the menu entirely
     */
    MenuAim.prototype.mouseleaveMenu = function () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }

        // If exitMenu is supplied and returns true, deactivate the
        // currently active row on menu exit.
        if (this.options.exitMenu(this)) {
            if (this.activeRow) {
                this.options.deactivate(this.activeRow);
            }

            this.activeRow = null;
        }
    };

    /**
     * Trigger a possible row activation whenever entering a new row.
     */
    MenuAim.prototype.mouseenterRow = function (ev) {
        if (this.timeoutId) {
            // Cancel any previous activation delays
            clearTimeout(this.timeoutId);
        }

        this.options.enter(ev.currentTarget);
        this.possiblyActivate(ev.currentTarget);
    };

    MenuAim.prototype.mouseleaveRow = function (ev) {
        this.options.exit(ev.currentTarget);
    };

    /*
     * Immediately activate a row if the user clicks on it.
     */
    MenuAim.prototype.clickRow = function (ev) {
        this.activate(ev.currentTarget);
    };

    /**
     * Activate a menu row.
     */
    MenuAim.prototype.activate = function (row) {
        if (row == this.activeRow) {
            return;
        }

        if (this.activeRow) {
            this.options.deactivate(this.activeRow);
        }

        this.options.activate(row);
        this.activeRow = row;
    };

    /**
     * Possibly activate a menu row. If mouse movement indicates that we
     * shouldn't activate yet because user may be trying to enter
     * a submenu's content, then delay and check again later.
     */
    MenuAim.prototype.possiblyActivate = function (row) {
        var delay = this.activationDelay(),
            self = this;

        if (delay) {
            this.timeoutId = setTimeout(function () {
                self.possiblyActivate(row);
            }, delay);
        } else {
            this.activate(row);
        }
    };

    /**
     * Return the amount of time that should be used as a delay before the
     * currently hovered row is activated.
     *
     * Returns 0 if the activation should happen immediately. Otherwise,
     * returns the number of milliseconds that should be delayed before
     * checking again to see if the row should be activated.
     */
    MenuAim.prototype.activationDelay = function () {
        if (!this.activeRow || !$(this.activeRow).is(this.options.submenuSelector)) {
            // If there is no other submenu row already active, then
            // go ahead and activate immediately.
            return 0;
        }

        var offset = this.$menu.offset(),
            upperLeft = {
            x: offset.left,
            y: offset.top - this.options.tolerance
        },
            upperRight = {
            x: offset.left + this.$menu.outerWidth(),
            y: upperLeft.y
        },
            lowerLeft = {
            x: offset.left,
            y: offset.top + this.$menu.outerHeight() + this.options.tolerance
        },
            lowerRight = {
            x: offset.left + this.$menu.outerWidth(),
            y: lowerLeft.y
        },
            loc = this.mouseLocs[this.mouseLocs.length - 1],
            prevLoc = this.mouseLocs[0];

        if (!loc) {
            return 0;
        }

        if (!prevLoc) {
            prevLoc = loc;
        }

        if (prevLoc.x < offset.left || prevLoc.x > lowerRight.x || prevLoc.y < offset.top || prevLoc.y > lowerRight.y) {
            // If the previous mouse location was outside of the entire
            // menu's bounds, immediately activate.
            return 0;
        }

        if (this.lastDelayLoc && loc.x == this.lastDelayLoc.x && loc.y == this.lastDelayLoc.y) {
            // If the mouse hasn't moved since the last time we checked
            // for activation status, immediately activate.
            return 0;
        }

        // Detect if the user is moving towards the currently activated
        // submenu.
        //
        // If the mouse is heading relatively clearly towards
        // the submenu's content, we should wait and give the user more
        // time before activating a new row. If the mouse is heading
        // elsewhere, we can immediately activate a new row.
        //
        // We detect this by calculating the slope formed between the
        // current mouse location and the upper/lower right points of
        // the menu. We do the same for the previous mouse location.
        // If the current mouse location's slopes are
        // increasing/decreasing appropriately compared to the
        // previous's, we know the user is moving toward the submenu.
        //
        // Note that since the y-axis increases as the cursor moves
        // down the screen, we are looking for the slope between the
        // cursor and the upper right corner to decrease over time, not
        // increase (somewhat counterintuitively).
        function slope(a, b) {
            return (b.y - a.y) / (b.x - a.x);
        }

        var decreasingCorner = upperRight,
            increasingCorner = lowerRight;

        // Our expectations for decreasing or increasing slope values
        // depends on which direction the submenu opens relative to the
        // main menu. By default, if the menu opens on the right, we
        // expect the slope between the cursor and the upper right
        // corner to decrease over time, as explained above. If the
        // submenu opens in a different direction, we change our slope
        // expectations.
        if (this.options.submenuDirection == "left") {
            decreasingCorner = lowerLeft;
            increasingCorner = upperLeft;
        } else if (this.options.submenuDirection == "below") {
            decreasingCorner = lowerRight;
            increasingCorner = lowerLeft;
        } else if (this.options.submenuDirection == "above") {
            decreasingCorner = upperLeft;
            increasingCorner = upperRight;
        }

        var decreasingSlope = slope(loc, decreasingCorner),
            increasingSlope = slope(loc, increasingCorner),
            prevDecreasingSlope = slope(prevLoc, decreasingCorner),
            prevIncreasingSlope = slope(prevLoc, increasingCorner);

        if (decreasingSlope < prevDecreasingSlope && increasingSlope > prevIncreasingSlope) {
            // Mouse is moving from previous location towards the
            // currently activated submenu. Delay before activating a
            // new menu row, because user may be moving into submenu.
            this.lastDelayLoc = loc;
            return this.DELAY;
        }

        this.lastDelayLoc = null;
        return 0;
    };

    MenuAim.prototype.destroy = function () {
        this.$menu.removeData("jquery.menu-aim");

        this.$menu.off(".menu-aim").find(this.options.rowSelector).off(".menu-aim");

        $(document).off(".menu-aim");
    };

    MenuAim.prototype.reset = function (triggerDeactivate) {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }

        if (this.activeRow && triggerDeactivate) {
            this.options.deactivate(this.activeRow);
        }

        this.activeRow = null;
    };

    MenuAim.prototype.init = function (element, option) {
        this.$menu = $(element);
        this.activeRow = null;
        this.mouseLocs = [];
        this.lastDelayLoc = null;
        this.timeoutId = null;
        this.options = $.extend({}, this.getDefaults(), option);

        this.MOUSE_LOCS_TRACKED = 3; // number of past mouse locations to track
        this.DELAY = 300; // ms delay when user appears to be entering submenu

        /**
         * Hook up initial menu events
         */

        this.$menu.on("mouseleave.menu-aim", $.proxy(this.mouseleaveMenu, this)).find(this.options.rowSelector).on("mouseenter.menu-aim", $.proxy(this.mouseenterRow, this)).on("mouseleave.menu-aim", $.proxy(this.mouseleaveRow, this)).on("click.menu-aim", $.proxy(this.clickRow, this));

        $(document).on("mousemove.menu-aim", $.proxy(this.mousemoveDocument, this));
    };

    $.fn.menuAim = function (opts) {
        return this.each(function () {
            var $this = $(this),
                data = $this.data("jquery.menu-aim"),
                options = (typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) == "object" && opts;

            if (!data) {
                $this.data("jquery.menu-aim", data = new MenuAim(this, options));
            }

            if (typeof opts == "string") {
                data[opts]();
            }
        });
    };
});

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PlayerBridge = function () {
    function PlayerBridge() {
        _classCallCheck(this, PlayerBridge);
    }

    _createClass(PlayerBridge, [{
        key: "setImplementation",
        value: function setImplementation(implementation) {
            this._implementation = implementation;
        }
    }, {
        key: "initPlayer",
        value: function initPlayer(options) {
            this._implementation.initPlayer(options);
        }
    }, {
        key: "play",
        value: function play() {
            this._implementation.play();
        }
    }, {
        key: "stop",
        value: function stop() {
            this._implementation.stop();
        }
    }, {
        key: "getDuration",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._implementation.getDuration();

                            case 2:
                                return _context.abrupt("return", _context.sent);

                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getDuration() {
                return _ref.apply(this, arguments);
            }

            return getDuration;
        }()
    }]);

    return PlayerBridge;
}();

exports.default = PlayerBridge;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _player = __webpack_require__(166);

var _player2 = _interopRequireDefault(_player);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VimeoWrapper = function () {
    function VimeoWrapper() {
        _classCallCheck(this, VimeoWrapper);
    }

    _createClass(VimeoWrapper, [{
        key: "initPlayer",
        value: function initPlayer(options) {
            this.videoUrl = options.videoUrl.replace(/[\u200B-\u200D\uFEFF]/g, '');
            this.metaEndpoint = 'https://vimeo.com/api/oembed.json';
            this.player = new _player2.default(options.videoNode, { id: options.videoId });

            this.player.ready().then(function () {
                options.onReadyCallback();
            });

            this.player.on('play', function () {
                options.onPlayCallback();
            });
        }
    }, {
        key: "play",
        value: function play() {
            this.player.play();
        }
    }, {
        key: "stop",
        value: function stop() {
            this.player.pause();
        }
    }, {
        key: "getDuration",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var videoUrl, request, result;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                videoUrl = encodeURIComponent(this.videoUrl);
                                request = this.metaEndpoint + "?url=" + videoUrl;
                                _context.next = 4;
                                return _jquery2.default.get(request);

                            case 4:
                                result = _context.sent;
                                return _context.abrupt("return", result.duration);

                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getDuration() {
                return _ref.apply(this, arguments);
            }

            return getDuration;
        }()
    }]);

    return VimeoWrapper;
}();

exports.default = VimeoWrapper;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _youtubePlayer = __webpack_require__(84);

var _youtubePlayer2 = _interopRequireDefault(_youtubePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var YoutubeWrapper = function () {
    function YoutubeWrapper() {
        _classCallCheck(this, YoutubeWrapper);
    }

    _createClass(YoutubeWrapper, [{
        key: 'initPlayer',
        value: function initPlayer(options) {
            this.player = (0, _youtubePlayer2.default)(options.videoNode, {
                videoId: options.videoId,
                playerVars: { rel: 0 }
            });

            this.player.on('ready', options.onReadyCallback);

            this.player.on('stateChange', function (event) {
                if (event.data === YT.PlayerState.BUFFERING || event.data === YT.PlayerState.PLAYING) {
                    options.onPlayCallback();
                }
            });
        }
    }, {
        key: 'play',
        value: function play() {
            this.player.playVideo();
        }
    }, {
        key: 'stop',
        value: function stop() {
            this.player.stopVideo();
        }
    }, {
        key: 'getDuration',
        value: function getDuration() {
            // not needed for youtube
        }
    }]);

    return YoutubeWrapper;
}();

exports.default = YoutubeWrapper;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseUrl = exports.parents = exports.matches = exports.getAttributes = exports.dispatch = exports.delegate = exports.closest = undefined;

var _closest = __webpack_require__(93);

var _closest2 = _interopRequireDefault(_closest);

var _delegate = __webpack_require__(224);

var _delegate2 = _interopRequireDefault(_delegate);

var _dispatch = __webpack_require__(225);

var _dispatch2 = _interopRequireDefault(_dispatch);

var _getAttributes = __webpack_require__(226);

var _getAttributes2 = _interopRequireDefault(_getAttributes);

var _matches = __webpack_require__(66);

var _matches2 = _interopRequireDefault(_matches);

var _parents = __webpack_require__(94);

var _parents2 = _interopRequireDefault(_parents);

var _parseUrl = __webpack_require__(227);

var _parseUrl2 = _interopRequireDefault(_parseUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.closest = _closest2.default;
exports.delegate = _delegate2.default;
exports.dispatch = _dispatch2.default;
exports.getAttributes = _getAttributes2.default;
exports.matches = _matches2.default;
exports.parents = _parents2.default;
exports.parseUrl = _parseUrl2.default;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = delegate;

var _closest = __webpack_require__(93);

var _closest2 = _interopRequireDefault(_closest);

var _matches = __webpack_require__(66);

var _matches2 = _interopRequireDefault(_matches);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Delegates the handling of events for an element matching a selector to an
 * ancestor of the matching element.
 * @param {!Node} ancestor The ancestor element to add the listener to.
 * @param {string} eventType The event type to listen to.
 * @param {string} selector A CSS selector to match against child elements.
 * @param {!Function} callback A function to run any time the event happens.
 * @param {Object=} opts A configuration options object. The available options:
 *     - useCapture<boolean>: If true, bind to the event capture phase.
 *     - deep<boolean>: If true, delegate into shadow trees.
 * @return {Object} The delegate object. It contains a destroy method.
 */
function delegate(ancestor, eventType, selector, callback) {
  var opts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  // Defines the event listener.
  var listener = function listener(event) {
    var delegateTarget = void 0;

    // If opts.composed is true and the event originated from inside a Shadow
    // tree, check the composed path nodes.
    if (opts.composed && typeof event.composedPath == 'function') {
      var composedPath = event.composedPath();
      for (var i = 0, node; node = composedPath[i]; i++) {
        if (node.nodeType == 1 && (0, _matches2.default)(node, selector)) {
          delegateTarget = node;
        }
      }
    } else {
      // Otherwise check the parents.
      delegateTarget = (0, _closest2.default)(event.target, selector, true);
    }

    if (delegateTarget) {
      callback.call(delegateTarget, event, delegateTarget);
    }
  };

  ancestor.addEventListener(eventType, listener, opts.useCapture);

  return {
    destroy: function destroy() {
      ancestor.removeEventListener(eventType, listener, opts.useCapture);
    }
  };
}

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = dispatch;
/**
 * Dispatches an event on the passed element.
 * @param {!Element} element The DOM element to dispatch the event on.
 * @param {string} eventType The type of event to dispatch.
 * @param {Object|string=} eventName A string name of the event constructor
 *     to use. Defaults to 'Event' if nothing is passed or 'CustomEvent' if
 *     a value is set on `initDict.detail`. If eventName is given an object
 *     it is assumed to be initDict and thus reassigned.
 * @param {Object=} initDict The initialization attributes for the
 *     event. A `detail` property can be used here to pass custom data.
 * @return {boolean} The return value of `element.dispatchEvent`, which will
 *     be false if any of the event listeners called `preventDefault`.
 */
function dispatch(element, eventType) {
  var eventName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Event';
  var initDict = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var event = void 0;
  var isCustom = void 0;

  // eventName is optional
  if ((typeof eventName === 'undefined' ? 'undefined' : _typeof(eventName)) == 'object') {
    initDict = eventName;
    eventName = 'Event';
  }

  initDict.bubbles = initDict.bubbles || false;
  initDict.cancelable = initDict.cancelable || false;
  initDict.composed = initDict.composed || false;

  // If a detail property is passed, this is a custom event.
  if ('detail' in initDict) isCustom = true;
  eventName = isCustom ? 'CustomEvent' : eventName;

  // Tries to create the event using constructors, if that doesn't work,
  // fallback to `document.createEvent()`.
  try {
    event = new window[eventName](eventType, initDict);
  } catch (err) {
    event = document.createEvent(eventName);
    var initMethod = 'init' + (isCustom ? 'Custom' : '') + 'Event';
    event[initMethod](eventType, initDict.bubbles, initDict.cancelable, initDict.detail);
  }

  return element.dispatchEvent(event);
}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getAttributes;
/**
 * Gets all attributes of an element as a plain JavaScriot object.
 * @param {Element} element The element whose attributes to get.
 * @return {!Object} An object whose keys are the attribute keys and whose
 *     values are the attribute values. If no attributes exist, an empty
 *     object is returned.
 */
function getAttributes(element) {
  var attrs = {};

  // Validate input.
  if (!(element && element.nodeType == 1)) return attrs;

  // Return an empty object if there are no attributes.
  var map = element.attributes;
  if (map.length === 0) return {};

  for (var i = 0, attr; attr = map[i]; i++) {
    attrs[attr.name] = attr.value;
  }
  return attrs;
}

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseUrl;
var HTTP_PORT = '80';
var HTTPS_PORT = '443';
var DEFAULT_PORT = RegExp(':(' + HTTP_PORT + '|' + HTTPS_PORT + ')$');

var a = document.createElement('a');
var cache = {};

/**
 * Parses the given url and returns an object mimicing a `Location` object.
 * @param {string} url The url to parse.
 * @return {!Object} An object with the same properties as a `Location`.
 */
function parseUrl(url) {
  // All falsy values (as well as ".") should map to the current URL.
  url = !url || url == '.' ? location.href : url;

  if (cache[url]) return cache[url];

  a.href = url;

  // When parsing file relative paths (e.g. `../index.html`), IE will correctly
  // resolve the `href` property but will keep the `..` in the `path` property.
  // It will also not include the `host` or `hostname` properties. Furthermore,
  // IE will sometimes return no protocol or just a colon, especially for things
  // like relative protocol URLs (e.g. "//google.com").
  // To workaround all of these issues, we reparse with the full URL from the
  // `href` property.
  if (url.charAt(0) == '.' || url.charAt(0) == '/') return parseUrl(a.href);

  // Don't include default ports.
  var port = a.port == HTTP_PORT || a.port == HTTPS_PORT ? '' : a.port;

  // PhantomJS sets the port to "0" when using the file: protocol.
  port = port == '0' ? '' : port;

  // Sometimes IE incorrectly includes a port for default ports
  // (e.g. `:80` or `:443`) even when no port is specified in the URL.
  // http://bit.ly/1rQNoMg
  var host = a.host.replace(DEFAULT_PORT, '');

  // Not all browser support `origin` so we have to build it.
  var origin = a.origin ? a.origin : a.protocol + '//' + host;

  // Sometimes IE doesn't include the leading slash for pathname.
  // http://bit.ly/1rQNoMg
  var pathname = a.pathname.charAt(0) == '/' ? a.pathname : '/' + a.pathname;

  return cache[url] = {
    hash: a.hash,
    host: host,
    hostname: a.hostname,
    href: a.href,
    origin: origin,
    pathname: pathname,
    port: port,
    protocol: a.protocol,
    search: a.search
  };
}

/***/ }),
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

(function(window, factory) {
	var globalInstall = function(initialEvent){
		factory(window.lazySizes, initialEvent);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(__webpack_require__(78));
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(window, function(window, document, lazySizes, initialEvent) {
	'use strict';
	var style = document.createElement('a').style;
	var fitSupport = 'objectFit' in style;
	var positionSupport = fitSupport && 'objectPosition' in style;
	var regCssFit = /object-fit["']*\s*:\s*["']*(contain|cover)/;
	var regCssPosition = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/;
	var blankSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
	var regBgUrlEscape = /\(|\)|'/;
	var positionDefaults = {
		center: 'center',
		'50% 50%': 'center',
	};

	function getObject(element){
		var css = (getComputedStyle(element, null) || {});
		var content = css.fontFamily || '';
		var objectFit = content.match(regCssFit) || '';
		var objectPosition = objectFit && content.match(regCssPosition) || '';

		if(objectPosition){
			objectPosition = objectPosition[1];
		}

		return {
			fit: objectFit && objectFit[1] || '',
			position: positionDefaults[objectPosition] || objectPosition || 'center',
		};
	}

	function initFix(element, config){
		var switchClassesAdded;
		var lazysizesCfg = lazySizes.cfg;
		var styleElement = element.cloneNode(false);
		var styleElementStyle = styleElement.style;

		var onChange = function(){
			var src = element.currentSrc || element.src;

			if(src){
				styleElementStyle.backgroundImage = 'url(' + (regBgUrlEscape.test(src) ? JSON.stringify(src) : src ) + ')';

				if(!switchClassesAdded){
					switchClassesAdded = true;
					lazySizes.rC(styleElement, lazysizesCfg.loadingClass);
					lazySizes.aC(styleElement, lazysizesCfg.loadedClass);
				}
			}
		};

		element._lazysizesParentFit = config.fit;

		element.addEventListener('load', function(){
			lazySizes.rAF(onChange);
		}, true);

		styleElement.addEventListener('load', function(){
			var curSrc = styleElement.currentSrc || styleElement.src;

			if(curSrc && curSrc != blankSrc){
				styleElement.src = blankSrc;
				styleElement.srcset = '';
			}
		});

		lazySizes.rAF(function(){

			var hideElement = element;
			var container = element.parentNode;

			if(container.nodeName.toUpperCase() == 'PICTURE'){
				hideElement = container;
				container = container.parentNode;
			}

			lazySizes.rC(styleElement, lazysizesCfg.loadedClass);
			lazySizes.rC(styleElement, lazysizesCfg.lazyClass);
			lazySizes.aC(styleElement, lazysizesCfg.loadingClass);
			lazySizes.aC(styleElement, lazysizesCfg.objectFitClass || 'lazysizes-display-clone');

			if(styleElement.getAttribute(lazysizesCfg.srcsetAttr)){
				styleElement.setAttribute(lazysizesCfg.srcsetAttr, '');
			}

			if(styleElement.getAttribute(lazysizesCfg.srcAttr)){
				styleElement.setAttribute(lazysizesCfg.srcAttr, '');
			}

			styleElement.src = blankSrc;
			styleElement.srcset = '';

			styleElementStyle.backgroundRepeat = 'no-repeat';
			styleElementStyle.backgroundPosition = config.position;
			styleElementStyle.backgroundSize = config.fit;

			hideElement.style.display = 'none';

			element.setAttribute('data-parent-fit', config.fit);
			element.setAttribute('data-parent-container', 'prev');

			container.insertBefore(styleElement, hideElement);

			if(element._lazysizesParentFit){
				delete element._lazysizesParentFit;
			}

			if(element.complete){
				onChange();
			}
		});
	}

	if(!fitSupport || !positionSupport){
		var onRead = function(e){
			if(e.detail.instance != lazySizes){return;}

			var element = e.target;
			var obj = getObject(element);

			if(obj.fit && (!fitSupport || (obj.position != 'center'))){
				initFix(element, obj);
			}
		};

		window.addEventListener('lazyunveilread', onRead, true);

		if(initialEvent && initialEvent.detail){
			onRead(initialEvent);
		}
	}
}));


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

/*
This plugin extends lazySizes to lazyLoad:
background images, videos/posters and scripts

Background-Image:
For background images, use data-bg attribute:
<div class="lazyload" data-bg="bg-img.jpg"></div>

 Video:
 For video/audio use data-poster and preload="none":
 <video class="lazyload" data-poster="poster.jpg" preload="none">
 <!-- sources -->
 </video>

 Scripts:
 For scripts use data-script:
 <div class="lazyload" data-script="module-name.js"></div>


 Script modules using require:
 For modules using require use data-require:
 <div class="lazyload" data-require="module-name"></div>
*/

(function(window, factory) {
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(__webpack_require__(78));
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(window, function(window, document, lazySizes) {
	/*jshint eqnull:true */
	'use strict';
	var bgLoad, regBgUrlEscape;
	var uniqueUrls = {};

	if(document.addEventListener){
		regBgUrlEscape = /\(|\)|\s|'/;

		bgLoad = function (url, cb){
			var img = document.createElement('img');
			img.onload = function(){
				img.onload = null;
				img.onerror = null;
				img = null;
				cb();
			};
			img.onerror = img.onload;

			img.src = url;

			if(img && img.complete && img.onload){
				img.onload();
			}
		};

		addEventListener('lazybeforeunveil', function(e){
			if(e.detail.instance != lazySizes){return;}

			var tmp, load, bg, poster;
			if(!e.defaultPrevented) {

				if(e.target.preload == 'none'){
					e.target.preload = 'auto';
				}

				tmp = e.target.getAttribute('data-link');
				if(tmp){
					addStyleScript(tmp, true);
				}

				// handle data-script
				tmp = e.target.getAttribute('data-script');
				if(tmp){
					addStyleScript(tmp);
				}

				// handle data-require
				tmp = e.target.getAttribute('data-require');
				if(tmp){
					if(lazySizes.cfg.requireJs){
						lazySizes.cfg.requireJs([tmp]);
					} else {
						addStyleScript(tmp);
					}
				}

				// handle data-bg
				bg = e.target.getAttribute('data-bg');
				if (bg) {
					e.detail.firesLoad = true;
					load = function(){
						e.target.style.backgroundImage = 'url(' + (regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg ) + ')';
						e.detail.firesLoad = false;
						lazySizes.fire(e.target, '_lazyloaded', {}, true, true);
					};

					bgLoad(bg, load);
				}

				// handle data-poster
				poster = e.target.getAttribute('data-poster');
				if(poster){
					e.detail.firesLoad = true;
					load = function(){
						e.target.poster = poster;
						e.detail.firesLoad = false;
						lazySizes.fire(e.target, '_lazyloaded', {}, true, true);
					};

					bgLoad(poster, load);

				}
			}
		}, false);

	}

	function addStyleScript(src, style){
		if(uniqueUrls[src]){
			return;
		}
		var elem = document.createElement(style ? 'link' : 'script');
		var insertElem = document.getElementsByTagName('script')[0];

		if(style){
			elem.rel = 'stylesheet';
			elem.href = src;
		} else {
			elem.src = src;
		}
		uniqueUrls[src] = true;
		uniqueUrls[elem.src || elem.href] = true;
		insertElem.parentNode.insertBefore(elem, insertElem);
	}
}));


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Platform.js <https://mths.be/platform>
 * Copyright 2014-2016 Benjamin Tan <https://demoneaux.github.io/>
 * Copyright 2011-2013 John-David Dalton <http://allyoucanleet.com/>
 * Available under MIT license <https://mths.be/mit>
 */
;(function() {
  'use strict';

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used as a reference to the global object. */
  var root = (objectTypes[typeof window] && window) || this;

  /** Backup possible global object. */
  var oldRoot = root;

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;
  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
    root = freeGlobal;
  }

  /**
   * Used as the maximum length of an array-like object.
   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
   * for more details.
   */
  var maxSafeInteger = Math.pow(2, 53) - 1;

  /** Regular expression to detect Opera. */
  var reOpera = /\bOpera/;

  /** Possible global object. */
  var thisBinding = this;

  /** Used for native method references. */
  var objectProto = Object.prototype;

  /** Used to check for own properties of an object. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to resolve the internal `[[Class]]` of values. */
  var toString = objectProto.toString;

  /*--------------------------------------------------------------------------*/

  /**
   * Capitalizes a string value.
   *
   * @private
   * @param {string} string The string to capitalize.
   * @returns {string} The capitalized string.
   */
  function capitalize(string) {
    string = String(string);
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * A utility function to clean up the OS name.
   *
   * @private
   * @param {string} os The OS name to clean up.
   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
   * @param {string} [label] A label for the OS.
   */
  function cleanupOS(os, pattern, label) {
    // Platform tokens are defined at:
    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    var data = {
      '10.0': '10',
      '6.4':  '10 Technical Preview',
      '6.3':  '8.1',
      '6.2':  '8',
      '6.1':  'Server 2008 R2 / 7',
      '6.0':  'Server 2008 / Vista',
      '5.2':  'Server 2003 / XP 64-bit',
      '5.1':  'XP',
      '5.01': '2000 SP1',
      '5.0':  '2000',
      '4.0':  'NT',
      '4.90': 'ME'
    };
    // Detect Windows version from platform tokens.
    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) &&
        (data = data[/[\d.]+$/.exec(os)])) {
      os = 'Windows ' + data;
    }
    // Correct character case and cleanup string.
    os = String(os);

    if (pattern && label) {
      os = os.replace(RegExp(pattern, 'i'), label);
    }

    os = format(
      os.replace(/ ce$/i, ' CE')
        .replace(/\bhpw/i, 'web')
        .replace(/\bMacintosh\b/, 'Mac OS')
        .replace(/_PowerPC\b/i, ' OS')
        .replace(/\b(OS X) [^ \d]+/i, '$1')
        .replace(/\bMac (OS X)\b/, '$1')
        .replace(/\/(\d)/, ' $1')
        .replace(/_/g, '.')
        .replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '')
        .replace(/\bx86\.64\b/gi, 'x86_64')
        .replace(/\b(Windows Phone) OS\b/, '$1')
        .replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1')
        .split(' on ')[0]
    );

    return os;
  }

  /**
   * An iteration utility for arrays and objects.
   *
   * @private
   * @param {Array|Object} object The object to iterate over.
   * @param {Function} callback The function called per iteration.
   */
  function each(object, callback) {
    var index = -1,
        length = object ? object.length : 0;

    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
      while (++index < length) {
        callback(object[index], index, object);
      }
    } else {
      forOwn(object, callback);
    }
  }

  /**
   * Trim and conditionally capitalize string values.
   *
   * @private
   * @param {string} string The string to format.
   * @returns {string} The formatted string.
   */
  function format(string) {
    string = trim(string);
    return /^(?:webOS|i(?:OS|P))/.test(string)
      ? string
      : capitalize(string);
  }

  /**
   * Iterates over an object's own properties, executing the `callback` for each.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} callback The function executed per own property.
   */
  function forOwn(object, callback) {
    for (var key in object) {
      if (hasOwnProperty.call(object, key)) {
        callback(object[key], key, object);
      }
    }
  }

  /**
   * Gets the internal `[[Class]]` of a value.
   *
   * @private
   * @param {*} value The value.
   * @returns {string} The `[[Class]]`.
   */
  function getClassOf(value) {
    return value == null
      ? capitalize(value)
      : toString.call(value).slice(8, -1);
  }

  /**
   * Host objects can return type values that are different from their actual
   * data type. The objects we are concerned with usually return non-primitive
   * types of "object", "function", or "unknown".
   *
   * @private
   * @param {*} object The owner of the property.
   * @param {string} property The property to check.
   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
   */
  function isHostType(object, property) {
    var type = object != null ? typeof object[property] : 'number';
    return !/^(?:boolean|number|string|undefined)$/.test(type) &&
      (type == 'object' ? !!object[property] : true);
  }

  /**
   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
   *
   * @private
   * @param {string} string The string to qualify.
   * @returns {string} The qualified string.
   */
  function qualify(string) {
    return String(string).replace(/([ -])(?!$)/g, '$1?');
  }

  /**
   * A bare-bones `Array#reduce` like utility function.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function called per iteration.
   * @returns {*} The accumulated result.
   */
  function reduce(array, callback) {
    var accumulator = null;
    each(array, function(value, index) {
      accumulator = callback(accumulator, value, index, array);
    });
    return accumulator;
  }

  /**
   * Removes leading and trailing whitespace from a string.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} The trimmed string.
   */
  function trim(string) {
    return String(string).replace(/^ +| +$/g, '');
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a new platform object.
   *
   * @memberOf platform
   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
   *  context object.
   * @returns {Object} A platform object.
   */
  function parse(ua) {

    /** The environment context object. */
    var context = root;

    /** Used to flag when a custom context is provided. */
    var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';

    // Juggle arguments.
    if (isCustomContext) {
      context = ua;
      ua = null;
    }

    /** Browser navigator object. */
    var nav = context.navigator || {};

    /** Browser user agent string. */
    var userAgent = nav.userAgent || '';

    ua || (ua = userAgent);

    /** Used to flag when `thisBinding` is the [ModuleScope]. */
    var isModuleScope = isCustomContext || thisBinding == oldRoot;

    /** Used to detect if browser is like Chrome. */
    var likeChrome = isCustomContext
      ? !!nav.likeChrome
      : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());

    /** Internal `[[Class]]` value shortcuts. */
    var objectClass = 'Object',
        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
        enviroClass = isCustomContext ? objectClass : 'Environment',
        javaClass = (isCustomContext && context.java) ? 'JavaPackage' : getClassOf(context.java),
        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';

    /** Detect Java environments. */
    var java = /\bJava/.test(javaClass) && context.java;

    /** Detect Rhino. */
    var rhino = java && getClassOf(context.environment) == enviroClass;

    /** A character to represent alpha. */
    var alpha = java ? 'a' : '\u03b1';

    /** A character to represent beta. */
    var beta = java ? 'b' : '\u03b2';

    /** Browser document object. */
    var doc = context.document || {};

    /**
     * Detect Opera browser (Presto-based).
     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
     */
    var opera = context.operamini || context.opera;

    /** Opera `[[Class]]`. */
    var operaClass = reOpera.test(operaClass = (isCustomContext && opera) ? opera['[[Class]]'] : getClassOf(opera))
      ? operaClass
      : (opera = null);

    /*------------------------------------------------------------------------*/

    /** Temporary variable used over the script's lifetime. */
    var data;

    /** The CPU architecture. */
    var arch = ua;

    /** Platform description array. */
    var description = [];

    /** Platform alpha/beta indicator. */
    var prerelease = null;

    /** A flag to indicate that environment features should be used to resolve the platform. */
    var useFeatures = ua == userAgent;

    /** The browser/environment version. */
    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();

    /** A flag to indicate if the OS ends with "/ Version" */
    var isSpecialCasedOS;

    /* Detectable layout engines (order is important). */
    var layout = getLayout([
      { 'label': 'EdgeHTML', 'pattern': 'Edge' },
      'Trident',
      { 'label': 'WebKit', 'pattern': 'AppleWebKit' },
      'iCab',
      'Presto',
      'NetFront',
      'Tasman',
      'KHTML',
      'Gecko'
    ]);

    /* Detectable browser names (order is important). */
    var name = getName([
      'Adobe AIR',
      'Arora',
      'Avant Browser',
      'Breach',
      'Camino',
      'Epiphany',
      'Fennec',
      'Flock',
      'Galeon',
      'GreenBrowser',
      'iCab',
      'Iceweasel',
      'K-Meleon',
      'Konqueror',
      'Lunascape',
      'Maxthon',
      { 'label': 'Microsoft Edge', 'pattern': 'Edge' },
      'Midori',
      'Nook Browser',
      'PaleMoon',
      'PhantomJS',
      'Raven',
      'Rekonq',
      'RockMelt',
      'SeaMonkey',
      { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Sleipnir',
      'SlimBrowser',
      { 'label': 'SRWare Iron', 'pattern': 'Iron' },
      'Sunrise',
      'Swiftfox',
      'WebPositive',
      'Opera Mini',
      { 'label': 'Opera Mini', 'pattern': 'OPiOS' },
      'Opera',
      { 'label': 'Opera', 'pattern': 'OPR' },
      'Chrome',
      { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' },
      { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' },
      { 'label': 'Firefox for iOS', 'pattern': 'FxiOS' },
      { 'label': 'IE', 'pattern': 'IEMobile' },
      { 'label': 'IE', 'pattern': 'MSIE' },
      'Safari'
    ]);

    /* Detectable products (order is important). */
    var product = getProduct([
      { 'label': 'BlackBerry', 'pattern': 'BB10' },
      'BlackBerry',
      { 'label': 'Galaxy S', 'pattern': 'GT-I9000' },
      { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' },
      { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' },
      { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' },
      'Google TV',
      'Lumia',
      'iPad',
      'iPod',
      'iPhone',
      'Kindle',
      { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Nexus',
      'Nook',
      'PlayBook',
      'PlayStation 3',
      'PlayStation 4',
      'PlayStation Vita',
      'TouchPad',
      'Transformer',
      { 'label': 'Wii U', 'pattern': 'WiiU' },
      'Wii',
      'Xbox One',
      { 'label': 'Xbox 360', 'pattern': 'Xbox' },
      'Xoom'
    ]);

    /* Detectable manufacturers. */
    var manufacturer = getManufacturer({
      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
      'Archos': {},
      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
      'Asus': { 'Transformer': 1 },
      'Barnes & Noble': { 'Nook': 1 },
      'BlackBerry': { 'PlayBook': 1 },
      'Google': { 'Google TV': 1, 'Nexus': 1 },
      'HP': { 'TouchPad': 1 },
      'HTC': {},
      'LG': {},
      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
      'Motorola': { 'Xoom': 1 },
      'Nintendo': { 'Wii U': 1,  'Wii': 1 },
      'Nokia': { 'Lumia': 1 },
      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
      'Sony': { 'PlayStation 4': 1, 'PlayStation 3': 1, 'PlayStation Vita': 1 }
    });

    /* Detectable operating systems (order is important). */
    var os = getOS([
      'Windows Phone',
      'Android',
      'CentOS',
      { 'label': 'Chrome OS', 'pattern': 'CrOS' },
      'Debian',
      'Fedora',
      'FreeBSD',
      'Gentoo',
      'Haiku',
      'Kubuntu',
      'Linux Mint',
      'OpenBSD',
      'Red Hat',
      'SuSE',
      'Ubuntu',
      'Xubuntu',
      'Cygwin',
      'Symbian OS',
      'hpwOS',
      'webOS ',
      'webOS',
      'Tablet OS',
      'Linux',
      'Mac OS X',
      'Macintosh',
      'Mac',
      'Windows 98;',
      'Windows '
    ]);

    /*------------------------------------------------------------------------*/

    /**
     * Picks the layout engine from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected layout engine.
     */
    function getLayout(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the manufacturer from an array of guesses.
     *
     * @private
     * @param {Array} guesses An object of guesses.
     * @returns {null|string} The detected manufacturer.
     */
    function getManufacturer(guesses) {
      return reduce(guesses, function(result, value, key) {
        // Lookup the manufacturer by product or scan the UA for the manufacturer.
        return result || (
          value[product] ||
          value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] ||
          RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)
        ) && key;
      });
    }

    /**
     * Picks the browser name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected browser name.
     */
    function getName(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the OS name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected OS name.
     */
    function getOS(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua)
            )) {
          result = cleanupOS(result, pattern, guess.label || guess);
        }
        return result;
      });
    }

    /**
     * Picks the product name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected product name.
     */
    function getProduct(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) ||
              RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua)
            )) {
          // Split by forward slash and append product version if needed.
          if ((result = String((guess.label && !RegExp(pattern, 'i').test(guess.label)) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
            result[0] += ' ' + result[1];
          }
          // Correct character case and cleanup string.
          guess = guess.label || guess;
          result = format(result[0]
            .replace(RegExp(pattern, 'i'), guess)
            .replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ')
            .replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
        }
        return result;
      });
    }

    /**
     * Resolves the version using an array of UA patterns.
     *
     * @private
     * @param {Array} patterns An array of UA patterns.
     * @returns {null|string} The detected version.
     */
    function getVersion(patterns) {
      return reduce(patterns, function(result, pattern) {
        return result || (RegExp(pattern +
          '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
      });
    }

    /**
     * Returns `platform.description` when the platform object is coerced to a string.
     *
     * @name toString
     * @memberOf platform
     * @returns {string} Returns `platform.description` if available, else an empty string.
     */
    function toStringPlatform() {
      return this.description || '';
    }

    /*------------------------------------------------------------------------*/

    // Convert layout to an array so we can add extra details.
    layout && (layout = [layout]);

    // Detect product names that contain their manufacturer's name.
    if (manufacturer && !product) {
      product = getProduct([manufacturer]);
    }
    // Clean up Google TV.
    if ((data = /\bGoogle TV\b/.exec(product))) {
      product = data[0];
    }
    // Detect simulators.
    if (/\bSimulator\b/i.test(ua)) {
      product = (product ? product + ' ' : '') + 'Simulator';
    }
    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
      description.push('running in Turbo/Uncompressed mode');
    }
    // Detect IE Mobile 11.
    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
      data = parse(ua.replace(/like iPhone OS/, ''));
      manufacturer = data.manufacturer;
      product = data.product;
    }
    // Detect iOS.
    else if (/^iP/.test(product)) {
      name || (name = 'Safari');
      os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua))
        ? ' ' + data[1].replace(/_/g, '.')
        : '');
    }
    // Detect Kubuntu.
    else if (name == 'Konqueror' && !/buntu/i.test(os)) {
      os = 'Kubuntu';
    }
    // Detect Android browsers.
    else if ((manufacturer && manufacturer != 'Google' &&
        ((/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua)) || /\bVita\b/.test(product))) ||
        (/\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua))) {
      name = 'Android Browser';
      os = /\bAndroid\b/.test(os) ? os : 'Android';
    }
    // Detect Silk desktop/accelerated modes.
    else if (name == 'Silk') {
      if (!/\bMobi/i.test(ua)) {
        os = 'Android';
        description.unshift('desktop mode');
      }
      if (/Accelerated *= *true/i.test(ua)) {
        description.unshift('accelerated');
      }
    }
    // Detect PaleMoon identifying as Firefox.
    else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
      description.push('identifying as Firefox ' + data[1]);
    }
    // Detect Firefox OS and products running Firefox.
    else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
      os || (os = 'Firefox OS');
      product || (product = data[1]);
    }
    // Detect false positives for Firefox/Safari.
    else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
      // Escape the `/` for Firefox 1.
      if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
        // Clear name of false positives.
        name = null;
      }
      // Reassign a generic name.
      if ((data = product || manufacturer || os) &&
          (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
        name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
      }
    }
    // Detect non-Opera (Presto-based) versions (order is important).
    if (!version) {
      version = getVersion([
        '(?:Cloud9|CriOS|CrMo|Edge|FxiOS|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|Silk(?!/[\\d.]+$))',
        'Version',
        qualify(name),
        '(?:Firefox|Minefield|NetFront)'
      ]);
    }
    // Detect stubborn layout engines.
    if ((data =
          layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' ||
          /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') ||
          /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' ||
          !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') ||
          layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront'
        )) {
      layout = [data];
    }
    // Detect Windows Phone 7 desktop mode.
    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
      name += ' Mobile';
      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
      description.unshift('desktop mode');
    }
    // Detect Windows Phone 8.x desktop mode.
    else if (/\bWPDesktop\b/i.test(ua)) {
      name = 'IE Mobile';
      os = 'Windows Phone 8.x';
      description.unshift('desktop mode');
      version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
    }
    // Detect IE 11.
    else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
      if (name) {
        description.push('identifying as ' + name + (version ? ' ' + version : ''));
      }
      name = 'IE';
      version = data[1];
    }
    // Leverage environment features.
    if (useFeatures) {
      // Detect server-side environments.
      // Rhino has a global function while others have a global object.
      if (isHostType(context, 'global')) {
        if (java) {
          data = java.lang.System;
          arch = data.getProperty('os.arch');
          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
        }
        if (isModuleScope && isHostType(context, 'system') && (data = [context.system])[0]) {
          os || (os = data[0].os || null);
          try {
            data[1] = context.require('ringo/engine').version;
            version = data[1].join('.');
            name = 'RingoJS';
          } catch(e) {
            if (data[0].global.system == context.system) {
              name = 'Narwhal';
            }
          }
        }
        else if (
          typeof context.process == 'object' && !context.process.browser &&
          (data = context.process)
        ) {
          name = 'Node.js';
          arch = data.arch;
          os = data.platform;
          version = /[\d.]+/.exec(data.version)[0];
        }
        else if (rhino) {
          name = 'Rhino';
        }
      }
      // Detect Adobe AIR.
      else if (getClassOf((data = context.runtime)) == airRuntimeClass) {
        name = 'Adobe AIR';
        os = data.flash.system.Capabilities.os;
      }
      // Detect PhantomJS.
      else if (getClassOf((data = context.phantom)) == phantomClass) {
        name = 'PhantomJS';
        version = (data = data.version || null) && (data.major + '.' + data.minor + '.' + data.patch);
      }
      // Detect IE compatibility modes.
      else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
        // We're in compatibility mode when the Trident version + 4 doesn't
        // equal the document mode.
        version = [version, doc.documentMode];
        if ((data = +data[1] + 4) != version[1]) {
          description.push('IE ' + version[1] + ' mode');
          layout && (layout[1] = '');
          version[1] = data;
        }
        version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
      }
      os = os && format(os);
    }
    // Detect prerelease phases.
    if (version && (data =
          /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) ||
          /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) ||
          /\bMinefield\b/i.test(ua) && 'a'
        )) {
      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
      version = version.replace(RegExp(data + '\\+?$'), '') +
        (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
    }
    // Detect Firefox Mobile.
    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS)\b/.test(os)) {
      name = 'Firefox Mobile';
    }
    // Obscure Maxthon's unreliable version.
    else if (name == 'Maxthon' && version) {
      version = version.replace(/\.[\d.]+/, '.x');
    }
    // Detect Xbox 360 and Xbox One.
    else if (/\bXbox\b/i.test(product)) {
      os = null;
      if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
        description.unshift('mobile mode');
      }
    }
    // Add mobile postfix.
    else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) &&
        (os == 'Windows CE' || /Mobi/i.test(ua))) {
      name += ' Mobile';
    }
    // Detect IE platform preview.
    else if (name == 'IE' && useFeatures && context.external === null) {
      description.unshift('platform preview');
    }
    // Detect BlackBerry OS version.
    // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
    else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data =
          (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] ||
          version
        )) {
      data = [data, /BB10/.test(ua)];
      os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
      version = null;
    }
    // Detect Opera identifying/masking itself as another browser.
    // http://www.opera.com/support/kb/view/843/
    else if (this != forOwn && product != 'Wii' && (
          (useFeatures && opera) ||
          (/Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua)) ||
          (name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os)) ||
          (name == 'IE' && (
            (os && !/^Win/.test(os) && version > 5.5) ||
            /\bWindows XP\b/.test(os) && version > 8 ||
            version == 8 && !/\bTrident\b/.test(ua)
          ))
        ) && !reOpera.test((data = parse.call(forOwn, ua.replace(reOpera, '') + ';'))) && data.name) {
      // When "identifying", the UA contains both Opera and the other browser's name.
      data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
      if (reOpera.test(name)) {
        if (/\bIE\b/.test(data) && os == 'Mac OS') {
          os = null;
        }
        data = 'identify' + data;
      }
      // When "masking", the UA contains only the other browser's name.
      else {
        data = 'mask' + data;
        if (operaClass) {
          name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
        } else {
          name = 'Opera';
        }
        if (/\bIE\b/.test(data)) {
          os = null;
        }
        if (!useFeatures) {
          version = null;
        }
      }
      layout = ['Presto'];
      description.push(data);
    }
    // Detect WebKit Nightly and approximate Chrome/Safari versions.
    if ((data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
      // Correct build number for numeric comparison.
      // (e.g. "532.5" becomes "532.05")
      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
      // Nightly builds are postfixed with a "+".
      if (name == 'Safari' && data[1].slice(-1) == '+') {
        name = 'WebKit Nightly';
        prerelease = 'alpha';
        version = data[1].slice(0, -1);
      }
      // Clear incorrect browser versions.
      else if (version == data[1] ||
          version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
        version = null;
      }
      // Use the full Chrome version when available.
      data[1] = (/\bChrome\/([\d.]+)/i.exec(ua) || 0)[1];
      // Detect Blink layout engine.
      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
        layout = ['Blink'];
      }
      // Detect JavaScriptCore.
      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
      if (!useFeatures || (!likeChrome && !data[1])) {
        layout && (layout[1] = 'like Safari');
        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : '8');
      } else {
        layout && (layout[1] = 'like Chrome');
        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
      }
      // Add the postfix of ".x" or "+" for approximate versions.
      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
      // Obscure version for some Safari 1-2 releases.
      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
        version = data;
      }
    }
    // Detect Opera desktop modes.
    if (name == 'Opera' &&  (data = /\bzbov|zvav$/.exec(os))) {
      name += ' ';
      description.unshift('desktop mode');
      if (data == 'zvav') {
        name += 'Mini';
        version = null;
      } else {
        name += 'Mobile';
      }
      os = os.replace(RegExp(' *' + data + '$'), '');
    }
    // Detect Chrome desktop mode.
    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
      description.unshift('desktop mode');
      name = 'Chrome Mobile';
      version = null;

      if (/\bOS X\b/.test(os)) {
        manufacturer = 'Apple';
        os = 'iOS 4.3+';
      } else {
        os = null;
      }
    }
    // Strip incorrect OS versions.
    if (version && version.indexOf((data = /[\d.]+$/.exec(os))) == 0 &&
        ua.indexOf('/' + data + '-') > -1) {
      os = trim(os.replace(data, ''));
    }
    // Add layout engine.
    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (
        /Browser|Lunascape|Maxthon/.test(name) ||
        name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) ||
        /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Sleipnir|Web)/.test(name) && layout[1])) {
      // Don't add layout details to description if they are falsey.
      (data = layout[layout.length - 1]) && description.push(data);
    }
    // Combine contextual information.
    if (description.length) {
      description = ['(' + description.join('; ') + ')'];
    }
    // Append manufacturer to description.
    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
      description.push('on ' + manufacturer);
    }
    // Append product to description.
    if (product) {
      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
    }
    // Parse the OS into an object.
    if (os) {
      data = / ([\d.+]+)$/.exec(os);
      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
      os = {
        'architecture': 32,
        'family': (data && !isSpecialCasedOS) ? os.replace(data[0], '') : os,
        'version': data ? data[1] : null,
        'toString': function() {
          var version = this.version;
          return this.family + ((version && !isSpecialCasedOS) ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
        }
      };
    }
    // Add browser/OS architecture.
    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
      if (os) {
        os.architecture = 64;
        os.family = os.family.replace(RegExp(' *' + data), '');
      }
      if (
          name && (/\bWOW64\b/i.test(ua) ||
          (useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua)))
      ) {
        description.unshift('32-bit');
      }
    }
    // Chrome 39 and above on OS X is always 64-bit.
    else if (
        os && /^OS X/.test(os.family) &&
        name == 'Chrome' && parseFloat(version) >= 39
    ) {
      os.architecture = 64;
    }

    ua || (ua = null);

    /*------------------------------------------------------------------------*/

    /**
     * The platform object.
     *
     * @name platform
     * @type Object
     */
    var platform = {};

    /**
     * The platform description.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.description = ua;

    /**
     * The name of the browser's layout engine.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.layout = layout && layout[0];

    /**
     * The name of the product's manufacturer.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.manufacturer = manufacturer;

    /**
     * The name of the browser/environment.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.name = name;

    /**
     * The alpha/beta release indicator.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.prerelease = prerelease;

    /**
     * The name of the product hosting the browser.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.product = product;

    /**
     * The browser's user agent string.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.ua = ua;

    /**
     * The browser/environment version.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.version = name && version;

    /**
     * The name of the operating system.
     *
     * @memberOf platform
     * @type Object
     */
    platform.os = os || {

      /**
       * The CPU architecture the OS is built for.
       *
       * @memberOf platform.os
       * @type number|null
       */
      'architecture': null,

      /**
       * The family of the OS.
       *
       * Common values include:
       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
       * "Windows XP", "OS X", "Ubuntu", "Debian", "Fedora", "Red Hat", "SuSE",
       * "Android", "iOS" and "Windows Phone"
       *
       * @memberOf platform.os
       * @type string|null
       */
      'family': null,

      /**
       * The version of the OS.
       *
       * @memberOf platform.os
       * @type string|null
       */
      'version': null,

      /**
       * Returns the OS string.
       *
       * @memberOf platform.os
       * @returns {string} The OS string.
       */
      'toString': function() { return 'null'; }
    };

    platform.parse = parse;
    platform.toString = toStringPlatform;

    if (platform.version) {
      description.unshift(version);
    }
    if (platform.name) {
      description.unshift(name);
    }
    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
      description.push(product ? '(' + os + ')' : 'on ' + os);
    }
    if (description.length) {
      platform.description = description.join(' ');
    }
    return platform;
  }

  /*--------------------------------------------------------------------------*/

  // Export platform.
  var platform = parse();

  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
  if (true) {
    // Expose platform on the global object to prevent errors when platform is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    root.platform = platform;

    // Define as an anonymous module so platform can be aliased through path mapping.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return platform;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for CommonJS support.
    forOwn(platform, function(value, key) {
      freeExports[key] = value;
    });
  }
  else {
    // Export to the global object.
    root.platform = platform;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(320)(module), __webpack_require__(19)))

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-account",
  "use": "icon-account-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 10\" id=\"icon-account\">\r\n<path id=\"icon-account_Icon\" d=\"M6,6.8c-1.3,0-2.4-1-2.4-2.3S4.7,2.1,6,2.1s2.4,1,2.4,2.3S7.3,6.8,6,6.8 M0,5.8C0,7.5,0.7,8.9,1.9,10\r\n\tC2.6,8.5,4.2,7.5,6,7.5s3.4,1,4.1,2.5C11.3,8.9,12,7.5,12,5.8C12,2.6,9.3,0,6,0S0,2.6,0,5.8z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-apple",
  "use": "icon-apple-usage",
  "viewBox": "-10 0 720 880",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns:svg=\"http://www.w3.org/2000/svg\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-10 0 720 880\" id=\"icon-apple\">\r\n    <g transform=\"matrix(54.85,0,0,-54.85,-2485.383,4815.859)\" id=\"icon-apple_g186\">\r\n        <path d=\"m 56.105,79.364 c -0.018,2.008 1.64,2.972 1.715,3.019 -0.933,1.365 -2.385,1.552 -2.903,1.574 -1.235,0.125 -2.411,-0.727 -3.037,-0.727 -0.626,0 -1.594,0.709 -2.618,0.689 -1.348,-0.02 -2.589,-0.783 -3.283,-1.989 -1.399,-2.427 -0.357,-6.024 1.005,-7.994 0.667,-0.963 1.461,-2.048 2.505,-2.008 1.006,0.04 1.386,0.65 2.6,0.65 1.214,0 1.556,-0.65 2.619,-0.631 1.081,0.021 1.767,0.984 2.429,1.95 0.764,1.118 1.08,2.2 1.098,2.257 -0.024,0.01 -2.108,0.809 -2.13,3.21\" id=\"icon-apple_path188\" />\r\n    </g>\r\n    <path d=\"M 482.4387,139.3374 C 512.8252,102.533 533.3389,51.3572 527.6888,0.3487 483.9152,2.1058 430.9332,29.5295 399.5032,66.3339 c -28.1373,32.5275 -52.8196,84.6335 -46.131,134.6035 48.8183,3.7847 98.675,-24.8497 129.0665,-61.6\" id=\"icon-apple_path190\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-arrow-red",
  "use": "icon-arrow-red-usage",
  "viewBox": "0 0 100 90",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 90\" id=\"icon-arrow-red\">\r\n    <style>#icon-arrow-red .a{fill:#e11917;}</style>\r\n    <title>  Page 1</title>\r\n    <desc>Arrow</desc>\r\n    <g class=\"a\">\r\n        <path d=\"M50.5 56C53.3 53.2 56.2 50.4 59 47.6L57.7 46.3 51.4 52.5 51.4 35 49.6 35 49.6 52.5 43.3 46.3 42 47.6\" />\r\n    </g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-arrow-right-circle",
  "use": "icon-arrow-right-circle-usage",
  "viewBox": "0 0 35 35",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 35 35\" id=\"icon-arrow-right-circle\">\r\n<path d=\"M17.5,35C7.9,35,0,27.1,0,17.5S7.9,0,17.5,0S35,7.9,35,17.5S27.1,35,17.5,35z M17.5,5C10.6,5,5,10.6,5,17.5\r\n\tS10.6,30,17.5,30S30,24.4,30,17.5S24.4,5,17.5,5z M16.3,26.4l-3.6-3.5l5.4-5.4L12.6,12l3.5-3.5l9,9L16.3,26.4z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-arrow-right-solid",
  "use": "icon-arrow-right-solid-usage",
  "viewBox": "0 0 448 512",
  "content": "<symbol aria-hidden=\"true\" class=\"svg-inline--fa fa-arrow-right fa-w-14\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\" id=\"icon-arrow-right-solid\"><path fill=\"currentColor\" d=\"M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "0 0 100 90",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 90\" id=\"icon-arrow\">\r\n    <style>#icon-arrow .a{fill:#FFF;}</style>\r\n    <title>  Page 1</title>\r\n    <desc>Arrow</desc>\r\n    <g class=\"a\">\r\n        <path d=\"M50.5 56C53.3 53.2 56.2 50.4 59 47.6L57.7 46.3 51.4 52.5 51.4 35 49.6 35 49.6 52.5 43.3 46.3 42 47.6\" />\r\n    </g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-aya",
  "use": "icon-aya-usage",
  "viewBox": "0 0 68.34 65",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 68.34 65\" id=\"icon-aya\">\r\n  <defs>\r\n    <linearGradient id=\"icon-aya_linear-gradient\" x1=\"-266.32\" y1=\"422.78\" x2=\"-266.32\" y2=\"422.54\" gradientTransform=\"matrix(64.82, 0, 0, -61.65, 17295.63, 26085.06)\" gradientUnits=\"userSpaceOnUse\">\r\n      <stop offset=\"0\" stop-color=\"#ccd0d7\" stop-opacity=\"0.4\" />\r\n      <stop offset=\"1\" stop-color=\"#9da3ae\" stop-opacity=\"0.4\" />\r\n    </linearGradient>\r\n  </defs>\r\n  <title>aya</title>\r\n  <g>\r\n    <polygon points=\"16.65 29.77 20.95 29.77 18.78 23.93 16.65 29.77\" fill=\"none\" />\r\n    <polygon points=\"43.17 29.77 47.47 29.77 45.3 23.93 43.17 29.77\" fill=\"none\" />\r\n    <path d=\"M53.14,3H15.25L3.53,39.06,34.17,61.29,64.82,39.06ZM23.34,36,22,32.42H15.67L14.37,36H11l6.13-15.75H20.5L26.8,36Zm10.43-6.61V36H30.6V29.37l-5.77-9.12h3.73l3.71,6.23,3.63-6.23h3.66Zm14.72,3H42.2L40.9,36H37.52l6.13-15.75H47L53.32,36H49.87Z\" transform=\"translate(0)\" fill=\"none\" />\r\n    <path d=\"M55.32,0H13.07L0,40.21,34.17,65,68.34,40.21ZM3.53,39.06,15.25,3H53.14L64.82,39.06,34.17,61.29Z\" transform=\"translate(0)\" fill=\"url(#icon-aya_linear-gradient)\" />\r\n    <path d=\"M17.13,20.25,11,36h3.37l1.3-3.58H22L23.34,36H26.8L20.5,20.25Zm-.48,9.52,2.13-5.84,2.17,5.84Z\" transform=\"translate(0)\" fill=\"#9da3ae\" />\r\n    <polygon points=\"35.9 20.25 32.27 26.48 28.56 20.25 24.84 20.25 30.6 29.37 30.6 36 33.77 36 33.77 29.39 39.56 20.25 35.9 20.25\" fill=\"#9da3ae\" />\r\n    <path d=\"M47,20.25H43.66L37.52,36H40.9l1.3-3.58h6.29L49.87,36h3.46Zm-3.85,9.52,2.13-5.84,2.17,5.84Z\" transform=\"translate(0)\" fill=\"#9da3ae\" />\r\n  </g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-bootroom",
  "use": "icon-bootroom-usage",
  "viewBox": "0 0 332 29.4",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 332 29.4\" id=\"icon-bootroom\"><title>bootroom</title><g id=\"icon-bootroom_Group\"><path id=\"icon-bootroom_The\" d=\"M0,29V22l1.2.1v2.7H9v1.5H1.2V29ZM0,12.9V11.5H9v1.4H5v4.2H9v1.4H0V17.1H3.8V12.9ZM0,7V0L1.2.1V5.2H3.7V.7H4.9V5.2H7.7V.1H8.9V7Z\" /></g><path d=\"M234.3,5.3A9.7,9.7,0,1,0,244,15a9.71,9.71,0,0,0-9.7-9.7m0,24.1A14.4,14.4,0,1,1,248.7,15a14.4,14.4,0,0,1-14.4,14.4\" /><path d=\"M276.6,5.3a9.7,9.7,0,1,0,9.7,9.7,9.71,9.71,0,0,0-9.7-9.7m0,24.1A14.4,14.4,0,1,1,291,15a14.4,14.4,0,0,1-14.4,14.4\" /><path d=\"M193.2,14.7h2.1c3.9,0,5.7-.4,5.7-4.5v-.1c0-3.2-1.7-4.4-5.4-4.4h-2.4Zm2-13.4c6,0,11,1.4,11,8.6v.2c0,3.9-1.6,6.8-4.8,8l5.4,10.6h-5.1L197.2,19h-4v9.7h-4.9V1.3Z\" /><path d=\"M310.2,1.3c2.4,5.1,6,13.4,8.1,17.9,2.1-4.6,5.8-12.8,8.2-17.9h4c.6,8.5,1.3,19.5,1.5,27.4h-4.8c-.1-5-.3-11.1-.7-18-2,4.7-4.5,10.3-6.7,15.3h-3c-2.2-5-4.3-9.9-6.7-15.3-.4,6.9-.6,12.9-.7,18h-4.7c.3-7.8.9-18.9,1.5-27.4Z\" /><path d=\"M72,5.3A9.7,9.7,0,1,0,81.7,15,9.71,9.71,0,0,0,72,5.3m0,24.1A14.4,14.4,0,1,1,86.4,15,14.4,14.4,0,0,1,72,29.4\" /><path d=\"M114.4,5.3a9.7,9.7,0,1,0,9.7,9.7,9.71,9.71,0,0,0-9.7-9.7m0,24.1A14.4,14.4,0,1,1,128.8,15a14.4,14.4,0,0,1-14.4,14.4\" /><path d=\"M29.8,24.4h3.3c3.4,0,5.9-.2,5.9-3.9,0-3-2.2-3.8-5.2-3.8H29.7v7.7Zm0-12h3.1c3,0,4.4-.9,4.4-3.5,0-2.2-.9-3.2-4.3-3.2H29.8ZM32.1,1.3c5.9,0,10.1.8,10.1,6.9a5.62,5.62,0,0,1-3.8,5.7V14A6.39,6.39,0,0,1,44,20.7c0,7.2-5.4,8-10.9,8H24.8V1.3Z\" /><polygon points=\"161.6 1.3 161.2 5.7 154.2 5.7 154.2 28.7 149.4 28.7 149.4 5.7 142.2 5.7 142.2 1.3 161.6 1.3\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-bye_tag",
  "use": "icon-bye_tag-usage",
  "viewBox": "0 0 29 18",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 29 18\" id=\"icon-bye_tag\">\n<path d=\"M27,1c0.6,0,1,0.4,1,1v14c0,0.6-0.4,1-1,1H2c-0.6,0-1-0.4-1-1V2c0-0.6,0.4-1,1-1H27 M27,0H2C0.9,0,0,0.9,0,2v14\n\tc0,1.1,0.9,2,2,2h25c1.1,0,2-0.9,2-2V2C29,0.9,28.1,0,27,0L27,0z\" />\n<g>\n\t<path d=\"M6.4,4.3c2,0,3.5,0.3,3.5,2.4c0,0.9-0.4,1.7-1.3,2v0c1.2,0.2,1.9,1.1,1.9,2.3c0,2.5-1.8,2.8-3.8,2.8H3.9V4.3H6.4z M5.6,8.1\n\t\th1.1c1,0,1.5-0.3,1.5-1.2c0-0.7-0.3-1.1-1.5-1.1H5.6V8.1z M5.6,12.2h1.1c1.2,0,2-0.1,2-1.3c0-1-0.8-1.3-1.8-1.3H5.6V12.2z\" />\n\t<path d=\"M12.7,4.3c0.6,1.8,1.1,3.3,1.8,4.6h0.1c0.7-1.4,1.2-2.9,1.8-4.6H18c-0.7,2.2-1.7,4.4-2.7,6.3v3.1h-1.7v-3.1\n\t\tc-1-1.9-2-4.2-2.7-6.3H12.7z\" />\n\t<path d=\"M25.1,4.3L25,5.8H21v2.3h3.4v1.5H21v2.5H25v1.5h-5.6V4.3H25.1z\" />\n</g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-calendar",
  "use": "icon-calendar-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"icon-calendar\">\r\n<path d=\"M1,2v9h10V2H1z M0,1h12v11H0V1z M2,5h2v2H2V5z M2,8h2v2H2V8z M5,5h2v2H5V5z M5,8h2v2H5V8z M8,5h2v2H8V5z M1,2h10v2H1V2z\r\n\t M8,8h2v2H8V8z M2,0h2v1H2V0z M8,0h2v1H8V0z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-camera",
  "use": "icon-camera-usage",
  "viewBox": "0 0 49 40",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 49 40\" id=\"icon-camera\">\r\n  <title>camera</title>\r\n  <path d=\"M24.79,11.43A10.68,10.68,0,0,0,14,22a10.77,10.77,0,0,0,21.53,0A10.68,10.68,0,0,0,24.79,11.43Zm0,17.14A6.57,6.57,0,1,1,31.56,22,6.68,6.68,0,0,1,24.79,28.57ZM46.62,8.1a8.08,8.08,0,0,0-5.75-2.38H36L33.86,1.63A3,3,0,0,0,31.19,0h-14a3,3,0,0,0-2.67,1.63L12.46,5.71H7.84A7.85,7.85,0,0,0,0,13.56V30A10,10,0,0,0,10,40H39A10,10,0,0,0,49,30V13.85A8.08,8.08,0,0,0,46.62,8.1ZM45,30a6,6,0,0,1-6,6H10a6,6,0,0,1-6-6V13.56A3.85,3.85,0,0,1,7.84,9.71h5.23a3,3,0,0,0,2.67-1.63L17.83,4H30.58l2.09,4.08a3,3,0,0,0,2.67,1.63h5.53A4.14,4.14,0,0,1,45,13.85Z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\" id=\"icon-check\">\r\n  <title>check</title>\r\n  <g>\r\n    <path d=\"M25,43.75A18.75,18.75,0,1,0,6.25,25,18.75,18.75,0,0,0,25,43.75ZM25,50A25,25,0,1,1,50,25,25,25,0,0,1,25,50Z\" />\r\n    <path d=\"M22.35,28.38l10-15.88,5.12,3.71L24.05,37.5,12.5,29.38l3.39-5.54Z\" />\r\n  </g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-down-thin",
  "use": "icon-chevron-down-thin-usage",
  "viewBox": "0 0 28 15.8",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 15.8\" id=\"icon-chevron-down-thin\"><title>chevron-down-thin</title><polygon id=\"icon-chevron-down-thin_Page-1\" points=\"28 1.5 26.6 0 14 12.9 14 12.9 14 12.9 1.4 0 0 1.5 12.6 14.4 14 15.8 14 15.8 14.8 15 28 1.5\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-down",
  "use": "icon-chevron-down-usage",
  "viewBox": "0 0 13 7.82",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 7.82\" id=\"icon-chevron-down\"><title>chevron-down</title><path d=\"M6.5,7.82,0,1.74,1.73,0,6.5,4.35,11.27,0,13,1.74Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-left-thin",
  "use": "icon-chevron-left-thin-usage",
  "viewBox": "0 0 16 28",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 28\" id=\"icon-chevron-left-thin\">\r\n<polygon id=\"icon-chevron-left-thin_Page-1\" points=\"14.3,28 15.8,26.6 2.9,14 2.9,14 2.9,14 15.8,1.4 14.3,0 1.4,12.6 0,14 0,14 0.8,14.8 \" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-left",
  "use": "icon-chevron-left-usage",
  "viewBox": "0 0 7.82 13",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7.82 13\" id=\"icon-chevron-left\"><path d=\"M0,6.5,6.08,0,7.82,1.73,3.47,6.5l4.35,4.77L6.08,13Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-right-circle",
  "use": "icon-chevron-right-circle-usage",
  "viewBox": "0 0 63 63",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 63 63\" id=\"icon-chevron-right-circle\">\r\n<path d=\"M28.3,47.2l-5-4.9l10.8-10.8L23.2,20.5l5-5L44,31.4L28.3,47.2z M63,31.5C63,14.1,48.9,0,31.5,0S0,14.1,0,31.5\r\n\tS14.1,63,31.5,63S63,48.9,63,31.5z M56,31.5C56,45,45,56,31.5,56S7,45,7,31.5C7,18,18,7,31.5,7S56,18,56,31.5z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-right-thin",
  "use": "icon-chevron-right-thin-usage",
  "viewBox": "0 0 16 28",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 28\" id=\"icon-chevron-right-thin\">\r\n<polygon id=\"icon-chevron-right-thin_Page-1\" points=\"1.4,0 0,1.4 12.9,14 12.9,14 12.9,14 0,26.6 1.4,28 14.3,15.4 15.8,14 15.8,14 15,13.2 \" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 7.82 13",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7.82 13\" id=\"icon-chevron-right\"><path d=\"M7.82,6.5,1.74,13,0,11.27,4.35,6.5,0,1.73,1.74,0Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-close-thin",
  "use": "icon-close-thin-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" id=\"icon-close-thin\">\r\n<g>\r\n\t<polygon points=\"36,32.6 32.6,36 18,21.4 3.5,35.8 0.1,32.4 14.6,18 0,3.4 3.4,0 18,14.6 32.4,0.2 35.8,3.6 21.4,18 \t\" />\r\n</g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 10.2 10.2",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 10.2 10.2\" id=\"icon-close\">\r\n<path d=\"M0,1.3L1.3,0l8.8,8.8l-1.3,1.3L0,1.3z M1.3,10.2L0,8.8L8.8,0l1.3,1.3L1.3,10.2z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-doc",
  "use": "icon-doc-usage",
  "viewBox": "0 0 21 24",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 24\" id=\"icon-doc\"><path d=\"M19.67,8.58H19.1V5.8a.42.42,0,0,0,0-.05A.47.47,0,0,0,19,5.44L14.41.16h0L14.32.08l0,0L14.2,0H2.83A.94.94,0,0,0,1.9.94V8.58H1.33A1.34,1.34,0,0,0,0,9.93v7a1.34,1.34,0,0,0,1.33,1.35H1.9v4.79a.94.94,0,0,0,.93.94H18.17a.94.94,0,0,0,.93-.94V18.27h.57A1.34,1.34,0,0,0,21,16.93v-7a1.34,1.34,0,0,0-1.33-1.35ZM2.83.94H13.6V5.76a.47.47,0,0,0,.46.47h4.11V8.58H2.83ZM14,13c0,2.14-1.28,3.44-3.17,3.44a3,3,0,0,1-3-3.32,3.14,3.14,0,0,1,3.14-3.42A3,3,0,0,1,14,13ZM1.43,16.35V9.94a12.8,12.8,0,0,1,2-.14A4.1,4.1,0,0,1,6,10.5,2.9,2.9,0,0,1,7.13,13,3.33,3.33,0,0,1,6.06,15.6a4.6,4.6,0,0,1-3,.84A12.48,12.48,0,0,1,1.43,16.35Zm16.74,6.46H2.83V18.27H18.17Zm.07-7.55A3.61,3.61,0,0,0,19.46,15l.22,1.15a4.1,4.1,0,0,1-1.65.28,3.08,3.08,0,0,1-3.38-3.26,3.3,3.3,0,0,1,3.52-3.47,3.76,3.76,0,0,1,1.59.29l-.3,1.17A3.12,3.12,0,0,0,18.23,11a2,2,0,0,0-2.06,2.16,1.94,1.94,0,0,0,2.07,2.13ZM5.58,13a1.86,1.86,0,0,0-2-2.07,3,3,0,0,0-.66.06v4.27a2.62,2.62,0,0,0,.51,0A2,2,0,0,0,5.58,13Zm3.75.13c0,1.28.59,2.18,1.57,2.18s1.55-.95,1.55-2.22-.55-2.18-1.56-2.18S9.33,11.86,9.33,13.13Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\" id=\"icon-download\"><path d=\"M12.56,14.08H6.87C5,14,3,14,1.18,14a1,1,0,0,0-1,.7,1,1,0,0,0,.49,1.11A1,1,0,0,0,1,16H12.9A1,1,0,0,0,14,15.12,1,1,0,0,0,13.14,14a1,1,0,0,0-.53.09Zm.88-8.75a1.06,1.06,0,0,0-1.47.1C10.69,6.74,9.42,7.94,8.14,9.25c-.1,0-.1.1-.2.2h-.1V.94A1.2,1.2,0,0,0,7.72.5,1,1,0,0,0,6.38.14h0A.87.87,0,0,0,5.89,1V9.55c-.1-.1-.2-.1-.2-.2C4.51,8.29,3.44,7,2.26,6l-.59-.6a1,1,0,0,0-1.37.1l-.1.1a.87.87,0,0,0,.1,1.21h0L.59,7C2.45,9,4.32,10.76,6.28,12.47a1,1,0,0,0,1.47,0l.2-.2c1.47-1.51,2.94-2.92,4.41-4.43l1.18-1.21a1,1,0,0,0-.1-1.27Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 34 34\" id=\"icon-edit\">\r\n<path d=\"M15.9,24.7L7,28l3.3-8.9L15.9,24.7z M17.1,23.6l-5.6-5.6L24,5.5l5.6,5.6L17.1,23.6z M30.7,10l-5.6-5.6l2.8-2.8l5.6,5.6\r\n\tL30.7,10z M0,0h16v2H0V0z M0,0h2v34H0V0z M32,17h2v17h-2V17z M0,32h33v2H0V32z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-external",
  "use": "icon-external-usage",
  "viewBox": "0 0 14.01 10",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.01 10\" id=\"icon-external\"><path d=\"M1.9,5.7a.86.86,0,0,1-.6-.3.64.64,0,0,1,0-.6L2.5,1.7a.55.55,0,0,1,.6-.4H8.4a.55.55,0,0,1,.5.3.66.66,0,0,1,.1.6L7.8,5.3a.68.68,0,0,1-.6.4H6.5L6,7H7.2A2,2,0,0,0,9,5.8l1.2-3.1A1.91,1.91,0,0,0,10,.9,1.92,1.92,0,0,0,8.4,0H3.1A2,2,0,0,0,1.3,1.2L.1,4.3A2.25,2.25,0,0,0,.3,6.1,1.92,1.92,0,0,0,1.9,7H3.3l.5-1.3ZM13.7,3.9A2.2,2.2,0,0,0,12.1,3H10.7l-.5,1.3h1.9a.55.55,0,0,1,.5.3.66.66,0,0,1,.1.6L11.5,8.3a.55.55,0,0,1-.6.4H5.6a.55.55,0,0,1-.5-.3c-.2-.1-.2-.4-.1-.6L6.2,4.7a.68.68,0,0,1,.6-.4h.7L8,3H6.8A1.92,1.92,0,0,0,5,4.3l-1.2,3A2.54,2.54,0,0,0,4,9.2a2.09,2.09,0,0,0,1.6.8h5.3a2,2,0,0,0,1.8-1.2l1.2-3.1A2.25,2.25,0,0,0,13.7,3.9Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-facebook\"><path d=\"M30.23,0H1.77A1.77,1.77,0,0,0,0,1.77V30.23A1.77,1.77,0,0,0,1.77,32H17.09V19.61H12.92V14.78h4.17V11.22c0-4.13,2.52-6.38,6.21-6.38A34.22,34.22,0,0,1,27,5V9.34H24.47c-2,0-2.39,1-2.39,2.35v3.08h4.78l-.62,4.83H22.08V32h8.15A1.77,1.77,0,0,0,32,30.23V1.77A1.77,1.77,0,0,0,30.23,0\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-fail",
  "use": "icon-fail-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-fail\">\r\n  <title>fail</title>\r\n  <g>\r\n    <path d=\"M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM8,14a6,6,0,1,1,6-6A6,6,0,0,1,8,14Z\" />\r\n    <polygon points=\"10.12 4.46 8 6.59 5.88 4.46 4.46 5.88 6.59 8 4.46 10.12 5.88 11.54 8 9.41 10.12 11.54 11.54 10.12 9.41 8 11.54 5.88 10.12 4.46\" />\r\n  </g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-gif",
  "use": "icon-gif-usage",
  "viewBox": "0 0 21 24",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 24\" id=\"icon-gif\"><path d=\"M19.67,8.58H19.1V5.8a.41.41,0,0,0,0-.05A.46.46,0,0,0,19,5.45L14.41.16h0L14.32.08l0,0L14.2,0H2.83A.94.94,0,0,0,1.9.94V8.58H1.33A1.34,1.34,0,0,0,0,9.93H0v7a1.34,1.34,0,0,0,1.33,1.35H1.9v4.79a.94.94,0,0,0,.93.94H18.17a.94.94,0,0,0,.93-.94V18.27h.57A1.34,1.34,0,0,0,21,16.93v-7a1.34,1.34,0,0,0-1.33-1.35ZM18.17,22.8H2.83V18.27H18.17ZM7,15.82a2.16,2.16,0,0,0,.77-.1V14.24H6.69V13H9.28v3.7A7.69,7.69,0,0,1,7,17.1a3.84,3.84,0,0,1-2.82-.95,3.42,3.42,0,0,1-1-2.55c0-2.34,1.69-3.67,4-3.67a4.73,4.73,0,0,1,1.93.34l-.33,1.27a3.81,3.81,0,0,0-1.62-.3,2.11,2.11,0,0,0-2.3,2.27A2.1,2.1,0,0,0,7,15.82ZM10.5,17V10h1.58v7Zm7-4.12V14.2H15V17H13.44V10h4.24v1.3H15v1.61h2.5Zm.66-4.32H2.83V.94H13.6V5.76a.47.47,0,0,0,.46.47h4.11Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-google-calendar",
  "use": "icon-google-calendar-usage",
  "viewBox": "4 4 40 40",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"4 4 40 40\" id=\"icon-google-calendar\">\r\n\r\n<g id=\"icon-google-calendar_Layer_3\">\r\n\t<path style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#C7C7C7;\" d=\"M38,5c-6.302,0-21.698,0-28,0C8.895,5,8,5.895,8,7   c0,3.047,0,3,0,3h32c0,0,0,0.047,0-3C40,5.895,39.105,5,38,5z M14,8c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1   C15,7.552,14.552,8,14,8z M34,8c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1C35,7.552,34.552,8,34,8z\" />\r\n\t<path style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#1976D2;\" d=\"M44,11c0.103-0.582-1.409-2-2-2C34.889,9,13.111,9,6,9   c-1,0-2.103,1.418-2,2c0.823,4.664,3,15,3,15h34C41,26,43.177,15.664,44,11z\" />\r\n\t<path style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#1E88E5;\" d=\"M41,26H7c0,0-2.177,10.336-3,15c0,1.146,0.792,2,2,2   c7.111,0,28.889,0,36,0c0.591,0,2-0.5,2-2C43.177,36.336,41,26,41,26z\" />\r\n\t<path style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#FAFAFA;\" d=\"M20.534,26c0.984,0.325,1.687,0.85,2.105,1.557   c0.433,0.732,0.65,1.55,0.65,2.457c0,1.582-0.519,2.826-1.556,3.733c-1.037,0.906-2.363,1.36-3.977,1.36   c-1.582,0-2.892-0.427-3.93-1.282c-1.038-0.855-1.536-2.014-1.497-3.476l0.036-0.072h2.242c0,0.914,0.28,1.642,0.841,2.182   c0.56,0.541,1.33,0.811,2.308,0.811c0.994,0,1.773-0.27,2.337-0.811c0.564-0.541,0.847-1.34,0.847-2.397   c0-1.073-0.25-1.864-0.751-2.373c-0.501-0.509-1.292-0.763-2.373-0.763h-2.051V26H20.534z\" />\r\n\t<rect x=\"31.637\" y=\"26\" style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#FAFAFA;\" width=\"2.349\" height=\"8.856\" />\r\n\t<path style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#E0E0E0;\" d=\"M14.727,22.036h-2.254l-0.024-0.072   c-0.04-1.312,0.435-2.427,1.425-3.345c0.99-0.918,2.284-1.377,3.882-1.377c1.606,0,2.886,0.427,3.84,1.282   c0.954,0.855,1.431,2.073,1.431,3.655c0,0.716-0.217,1.429-0.65,2.141c-0.433,0.712-1.083,1.254-1.95,1.628L20.534,26h-4.77v-0.911   h2.051c1.042,0,1.779-0.26,2.212-0.781c0.433-0.521,0.65-1.246,0.65-2.176c0-0.994-0.246-1.749-0.739-2.266   c-0.493-0.517-1.22-0.775-2.182-0.775c-0.914,0-1.648,0.268-2.2,0.805C15.022,20.414,14.746,21.098,14.727,22.036z\" />\r\n\t<polygon style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#E0E0E0;\" points=\"33.986,26 31.637,26 31.637,19.782 28.083,19.83    28.083,18.136 33.986,17.492  \" />\r\n\t<path style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#1976D2;\" d=\"M6,9c-1.438,0-2.103,1.418-2,2c0.823,4.664,3,15,3,15\" />\r\n\t<path style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#1976D2;\" d=\"M41,26c0,0,2.177-10.336,3-15c0-1.625-1.409-2-2-2\" />\r\n</g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-google-plus",
  "use": "icon-google-plus-usage",
  "viewBox": "0 0 46.4 29.7",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 46.4 29.7\" id=\"icon-google-plus\">\r\n<path d=\"M46.4,16.5L46.4,16.5h-5.1v5.1h-3.4v-5.1h-5.1v-3.4h5.1V8h3.4v5.1h5.1V16.5L46.4,16.5z M14.9,12.7v5.1h8.4\r\n\tc-0.3,2.2-2.5,6.4-8.4,6.4c-5.1,0-9.2-4.2-9.2-9.4c0-5.2,4.1-9.4,9.2-9.4c2.9,0,4.8,1.2,5.9,2.3l4-3.9C22.2,1.5,18.9,0,14.9,0\r\n\tC6.6,0,0,6.6,0,14.9s6.6,14.9,14.9,14.9c8.6,0,14.3-6,14.3-14.5c0-1-0.1-1.7-0.2-2.5C28.9,12.7,14.9,12.7,14.9,12.7z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-hive-learning",
  "use": "icon-hive-learning-usage",
  "viewBox": "0 0 554 93",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 554 93\" id=\"icon-hive-learning\">\r\n  <title>hive-learning</title>\r\n  <path d=\"M279,16h4V67.11a5.26,5.26,0,0,0,1.3,3.75,4.66,4.66,0,0,0,3.58,1.39A12.81,12.81,0,0,0,290,72a10.79,10.79,0,0,0,2.24-.61L293,74.7a15.87,15.87,0,0,1-3.3.94,18.8,18.8,0,0,1-3.38.37A7,7,0,0,1,281,73.92a7.7,7.7,0,0,1-2-5.58V16m56.47,29.43a21.72,21.72,0,0,0-4.27-6.94,20.42,20.42,0,0,0-6.52-4.73,20,20,0,0,0-16.31,0,20.05,20.05,0,0,0-6.48,4.69,22.36,22.36,0,0,0-4.31,6.94A22.73,22.73,0,0,0,296,53.8a23.25,23.25,0,0,0,1.57,8.57,22.8,22.8,0,0,0,4.35,7.06,20.3,20.3,0,0,0,6.56,4.82A19.31,19.31,0,0,0,316.7,76h0a20.63,20.63,0,0,0,5.64-.78,20.4,20.4,0,0,0,5-2.16,17.72,17.72,0,0,0,4-3.31,13.56,13.56,0,0,0,2.62-4.2l-3.54-1a12.09,12.09,0,0,1-2.22,3.31A14.16,14.16,0,0,1,325,70.45a17.31,17.31,0,0,1-3.91,1.67,15.15,15.15,0,0,1-4.27.61,14.9,14.9,0,0,1-6.2-1.31,16.45,16.45,0,0,1-5.11-3.59,19.36,19.36,0,0,1-3.67-5.43,19.1,19.1,0,0,1-1.69-6.82h36.73a2.29,2.29,0,0,0,.08-.78v-1A23,23,0,0,0,335.47,45.43Zm-35.36,6.9a20.89,20.89,0,0,1,1.57-6.82,17,17,0,0,1,3.54-5.39,16.26,16.26,0,0,1,5.11-3.51,15.84,15.84,0,0,1,12.41,0,16.27,16.27,0,0,1,5.11,3.51,18.37,18.37,0,0,1,3.63,5.35,19.48,19.48,0,0,1,1.65,6.86Zm77.13,17.14V48.74q0-7.84-4.32-12.29T361.08,32q-7.2,0-15.2,5.55l1.52,2.78a32.68,32.68,0,0,1,6.92-3.76,18,18,0,0,1,6.44-1.31,12,12,0,0,1,9.12,3.55q3.36,3.55,3.36,9.59v4.16a32.84,32.84,0,0,0-6.12-1.67,38.1,38.1,0,0,0-6.76-.61,25,25,0,0,0-7,.94,17.56,17.56,0,0,0-5.48,2.61,12.44,12.44,0,0,0-3.56,4A10.19,10.19,0,0,0,343,62.86,12.92,12.92,0,0,0,344,68,12.26,12.26,0,0,0,347,72.2,14.24,14.24,0,0,0,351.32,75a14,14,0,0,0,5.36,1h0a23.1,23.1,0,0,0,9.68-2,18.77,18.77,0,0,0,7.36-5.88v3.51a4.66,4.66,0,0,0,1.12,2.65,3.23,3.23,0,0,0,2.56,1.1q.38,0,.76,0a8.19,8.19,0,0,0,.84-.12V71.51Q377.24,71.51,377.24,69.47Zm-4-6.53A5.53,5.53,0,0,1,372,66.2a14.6,14.6,0,0,1-6,4.73,20,20,0,0,1-8.52,1.8h0a11.29,11.29,0,0,1-4.2-.78,10.67,10.67,0,0,1-3.4-2.12,9.4,9.4,0,0,1-2.24-3.22,10.1,10.1,0,0,1-.8-4,7.69,7.69,0,0,1,1-3.88,8.81,8.81,0,0,1,2.84-3,15,15,0,0,1,4.4-1.92,21.76,21.76,0,0,1,5.68-.69,36,36,0,0,1,6.48.57,31.74,31.74,0,0,1,6,1.72ZM407,36.87a16.82,16.82,0,0,0-10,3.42,17.06,17.06,0,0,0-6,8.94V76H387V33.17h3.9V43.71a20.66,20.66,0,0,1,5.81-7.37,14.78,14.78,0,0,1,7.77-3.25q.73-.08,1.46-.08H407v3.87M449,75h-4V51.43q0-8.21-2.28-11.95t-7.24-3.74a14.78,14.78,0,0,0-5.23,1,17.64,17.64,0,0,0-4.84,2.76,20.07,20.07,0,0,0-3.92,4.19A17.26,17.26,0,0,0,419,48.83V75h-4V32.73h3.76V42.81a20,20,0,0,1,7.4-7.84,21.1,21.1,0,0,1,5-2.2A19.27,19.27,0,0,1,436.6,32q6.8,0,9.6,4.84T449,50.7V75m9,0h4V33h-4Zm0-51.57h4V16h-4ZM505,75h-4V51.43q0-8.21-2.28-11.95t-7.24-3.74a14.8,14.8,0,0,0-5.24,1,17.64,17.64,0,0,0-4.84,2.76,19.91,19.91,0,0,0-3.92,4.19A17.28,17.28,0,0,0,475,48.83V75h-4V32.73h3.76V42.81a20,20,0,0,1,7.4-7.84,21.1,21.1,0,0,1,5-2.2A19.27,19.27,0,0,1,492.6,32q6.8,0,9.6,4.84T505,50.7V75m45.26-42.27V41.9a27.59,27.59,0,0,0-7-7A16.34,16.34,0,0,0,533.67,32a17.84,17.84,0,0,0-8,1.78,19.37,19.37,0,0,0-6.22,4.83,22.33,22.33,0,0,0-4,7A24.42,24.42,0,0,0,514,53.9a22.05,22.05,0,0,0,1.51,8,23.18,23.18,0,0,0,4.15,6.94,20.13,20.13,0,0,0,6.3,4.87,17.75,17.75,0,0,0,8,1.83h0a17.86,17.86,0,0,0,9-2.47,19.5,19.5,0,0,0,6.91-6.61v9.25a13.76,13.76,0,0,1-1.26,6.08,12.59,12.59,0,0,1-3.41,4.34,14.92,14.92,0,0,1-5,2.64,20.65,20.65,0,0,1-6.14.89,21.67,21.67,0,0,1-9.19-2,15.15,15.15,0,0,1-6.83-6.29l-2.77,1.87a22.07,22.07,0,0,0,3.05,4,17,17,0,0,0,4,3.08,19.71,19.71,0,0,0,5.16,1.95,28.86,28.86,0,0,0,6.59.69,26.08,26.08,0,0,0,7.6-1.09A19,19,0,0,0,548,88.66a15.75,15.75,0,0,0,4.35-5.39A16.63,16.63,0,0,0,554,75.72v-43Zm-.32,28a10.4,10.4,0,0,1-1.67,4.06,15.49,15.49,0,0,1-3.41,3.65,18.52,18.52,0,0,1-4.64,2.64,14.12,14.12,0,0,1-5.24,1h0a15.23,15.23,0,0,1-6.59-1.46,16.91,16.91,0,0,1-5.37-4,19.14,19.14,0,0,1-3.58-5.76,18.44,18.44,0,0,1-1.3-6.9,20.78,20.78,0,0,1,1.1-6.61,19,19,0,0,1,3.17-5.88,16.41,16.41,0,0,1,5.08-4.22,14.17,14.17,0,0,1,6.83-1.62,14.36,14.36,0,0,1,4.84.85,18.38,18.38,0,0,1,4.47,2.31,17.5,17.5,0,0,1,3.7,3.53,18.29,18.29,0,0,1,2.6,4.5ZM75.66,21.07h0L39.84.4a2.43,2.43,0,0,0-2.67,0L1.34,21.07A2.75,2.75,0,0,0,0,23.33V64.67a2.58,2.58,0,0,0,1.34,2.27L37.16,87.6a2.43,2.43,0,0,0,2.67,0L75.66,66.93A2.75,2.75,0,0,0,77,64.67V23.33A2.58,2.58,0,0,0,75.66,21.07ZM39.3,3.33,71.52,22,30.35,30.27Zm3.48,27.33L52,41.07,47.73,54.13,34.09,57.07l-9.36-10.4,4.41-13.2Zm-7-26.27L22.59,44.13l-19-21.2ZM2.94,26.4,30.88,57.73h0L2.94,63.6ZM37.7,84.53,5.35,66l41.31-8.67h0ZM41,83.6,54.28,43.47l19,21.47Zm33.15-22L46.12,30l28.07-5.6ZM259,53.17a23.31,23.31,0,0,0-1.54-8.43h0A20.85,20.85,0,0,0,253,37.68a22.1,22.1,0,0,0-7.06-4.85A22.59,22.59,0,0,0,236.71,31a23.55,23.55,0,0,0-9.35,1.78,21.29,21.29,0,0,0-7.14,4.9,22.27,22.27,0,0,0-4.59,7.22A23.33,23.33,0,0,0,214,53.58a23,23,0,0,0,1.63,8.63,21.86,21.86,0,0,0,4.59,7.14,21.51,21.51,0,0,0,7.14,4.86A23.34,23.34,0,0,0,236.63,76a24,24,0,0,0,12.15-3.11,19.07,19.07,0,0,0,7.56-8.24h0A1.17,1.17,0,0,0,255.25,63h-5.51c-1.46,0-2.6,1.75-3.18,2.37a11.69,11.69,0,0,1-2.67,2.12,12.83,12.83,0,0,1-3.3,1.33,14.71,14.71,0,0,1-3.63.46,12.86,12.86,0,0,1-8.89-3.53,13.67,13.67,0,0,1-2.92-4,14.81,14.81,0,0,1-1.38-5.23h31.9A3.33,3.33,0,0,0,259,53.17Zm-35.48-3a15.12,15.12,0,0,1,1.34-5.06,12.47,12.47,0,0,1,2.84-3.95,13.13,13.13,0,0,1,8.94-3.45,13.43,13.43,0,0,1,4.92.91,12.88,12.88,0,0,1,4.09,2.53,13.1,13.1,0,0,1,2.88,3.95,14.57,14.57,0,0,1,1.38,5.06ZM139,16h-3.49a3,3,0,0,0-3,3V41.15H102.41V19a3,3,0,0,0-3-3H96a3,3,0,0,0-3,3h0V73a3,3,0,0,0,3,3h3.49a3,3,0,0,0,3-3V49.44h30.18V73a3,3,0,0,0,3,3H139a3,3,0,0,0,3-3V19a3,3,0,0,0-3-3m18.87,16h-3.82A3,3,0,0,0,151,35V73a3,3,0,0,0,3.09,3h3.82A3,3,0,0,0,161,73V35A3,3,0,0,0,157.91,32Zm0-16h-3.82A3,3,0,0,0,151,18.85v3.3A3,3,0,0,0,154.09,25h3.82A3,3,0,0,0,161,22.15v-3.3A3,3,0,0,0,157.91,16Zm43.31,17.93L190,64.22,178.78,33.93A3,3,0,0,0,176,32h-3.07a3,3,0,0,0-2.75,4l14.42,38.07A2.94,2.94,0,0,0,187.37,76h5.26a2.94,2.94,0,0,0,2.75-1.91L209.81,36a3,3,0,0,0-2.75-4H204a3,3,0,0,0-2.76,1.93\" transform=\"translate(0 0)\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-info",
  "use": "icon-info-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-info\">\r\n  <title>info</title>\r\n  <path d=\"M8,14A6,6,0,1,0,2,8,6,6,0,0,0,8,14Zm0,2a8,8,0,1,1,8-8A8,8,0,0,1,8,16ZM7,9.15V8.95a1.31,1.31,0,0,1,.54-1.1c.35-.3.93-.59.93-1a.46.46,0,0,0-.51-.45c-.32,0-.64.16-.64.46V7H5.71V6.76C5.71,5.55,6.86,5,8,5c1.4,0,2.17.66,2.17,1.75a1.66,1.66,0,0,1-.81,1.43c-.28.19-.79.37-.79.76v.22Zm-.1,2.08V9.56H8.64v1.67Z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-instagram-general",
  "use": "icon-instagram-general-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 512 512\" id=\"icon-instagram-general\">\r\n\r\n<path d=\"M352,0H160C71.648,0,0,71.648,0,160v192c0,88.352,71.648,160,160,160h192c88.352,0,160-71.648,160-160V160    C512,71.648,440.352,0,352,0z M464,352c0,61.76-50.24,112-112,112H160c-61.76,0-112-50.24-112-112V160C48,98.24,98.24,48,160,48    h192c61.76,0,112,50.24,112,112V352z\" />\r\n<path d=\"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M256,336    c-44.096,0-80-35.904-80-80c0-44.128,35.904-80,80-80s80,35.872,80,80C336,300.096,300.096,336,256,336z\" />\r\n<circle cx=\"393.6\" cy=\"118.4\" r=\"17.056\" />\r\n\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-instagram",
  "use": "icon-instagram-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 512 512\" id=\"icon-instagram\">\n<g>\n\t<g>\n\t\t<path d=\"M352,0H160C71.648,0,0,71.648,0,160v192c0,88.352,71.648,160,160,160h192c88.352,0,160-71.648,160-160V160    C512,71.648,440.352,0,352,0z M464,352c0,61.76-50.24,112-112,112H160c-61.76,0-112-50.24-112-112V160C48,98.24,98.24,48,160,48    h192c61.76,0,112,50.24,112,112V352z\" fill=\"#FFFFFF\" />\n\t</g>\n</g>\n<g>\n\t<g>\n\t\t<path d=\"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M256,336    c-44.096,0-80-35.904-80-80c0-44.128,35.904-80,80-80s80,35.872,80,80C336,300.096,300.096,336,256,336z\" fill=\"#FFFFFF\" />\n\t</g>\n</g>\n<g>\n\t<g>\n\t\t<circle cx=\"393.6\" cy=\"118.4\" r=\"17.056\" fill=\"#FFFFFF\" />\n\t</g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-jpg",
  "use": "icon-jpg-usage",
  "viewBox": "0 0 21 24",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 24\" id=\"icon-jpg\"><path d=\"M9.52,10.92a2.63,2.63,0,0,0-.65.06v2.07a2.37,2.37,0,0,0,.53,0c.83,0,1.35-.43,1.35-1.15S10.3,10.92,9.52,10.92ZM19.67,8.58H19.1V5.8a.41.41,0,0,0,0-.05.47.47,0,0,0-.11-.3L14.41.16h0L14.32.08l0,0L14.2,0H2.83A.94.94,0,0,0,1.9.94V8.58H1.33A1.34,1.34,0,0,0,0,9.93v7a1.34,1.34,0,0,0,1.33,1.35H1.9v4.79a.94.94,0,0,0,.93.94H18.17a.94.94,0,0,0,.93-.94V18.27h.57A1.34,1.34,0,0,0,21,16.93v-7A1.34,1.34,0,0,0,19.67,8.58ZM2.83.94H13.6V5.76a.47.47,0,0,0,.46.47h4.11V8.58H2.83Zm9.47,11a2.26,2.26,0,0,1-.64,1.67,3.2,3.2,0,0,1-2.26.74,3.9,3.9,0,0,1-.54,0V16.8H7.32V9.86a12.65,12.65,0,0,1,2.12-.15,3.3,3.3,0,0,1,2.12.56A2.06,2.06,0,0,1,12.3,11.91ZM2.39,16.75l.18-1.28a2.55,2.55,0,0,0,.8.13c.66,0,1.07-.3,1.07-1.4V9.77H6v4.44c0,2-.95,2.7-2.47,2.7A4,4,0,0,1,2.39,16.75ZM18.17,22.8H2.83V18.27H18.17V22.8Zm.93-6.33a7.69,7.69,0,0,1-2.32.4A3.84,3.84,0,0,1,14,15.92a3.42,3.42,0,0,1-1-2.55c0-2.34,1.69-3.67,4-3.67a4.73,4.73,0,0,1,1.93.34l-.33,1.27a3.81,3.81,0,0,0-1.62-.3,2.11,2.11,0,0,0-2.3,2.27,2.1,2.1,0,0,0,2.18,2.3,2.07,2.07,0,0,0,.77-.1V14H16.52V12.77H19.1v3.7Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-like",
  "use": "icon-like-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 15 16\" id=\"icon-like\">\r\n<path id=\"icon-like_Stroke-1\" d=\"M13.1,8.3c0.1,0,0.2-0.1,0.3-0.1c0.2-0.1,0.3-0.3,0.3-0.6c0-0.4-0.3-0.6-1-0.6H8.8c-0.3,0-0.6-0.3-0.5-0.6\r\n\tc0-0.1,0-0.2,0.1-0.3c0.1-0.2,0.1-0.5,0.2-0.8c0.1-0.5,0.2-0.9,0.2-1.3c0-0.3,0-0.6,0-0.8c0-1.3-0.4-1.9-1-2.1\r\n\tc-0.2,1.7-1.1,3.7-2.4,5C5,6.5,4.5,6.8,4,7.2C3.4,7.5,2.8,7.8,2.2,8C2,8.1,1.8,8.1,1.6,8.2C1.5,8.3,1.5,8.5,1.4,8.8\r\n\tC1.1,9.5,1,10.4,1,11.4c0,1,0.2,1.7,0.5,2.2c0.1,0.2,0.2,0.3,0.3,0.4h1.9c0.5,0,0.9,0.1,1.5,0.3c0.1,0,0.2,0.1,0.3,0.1\r\n\tc0,0,0.3,0.1,0.3,0.1C6.6,14.9,7.2,15,8,15h2.9c1.7,0,2-0.2,2-0.6c0-0.2-0.1-0.3-0.2-0.3c-0.1,0-0.2-0.1-0.2-0.1c-0.6-0.1-0.6-1,0-1\r\n\tc0.1,0,0.4,0,0.6-0.1c0.3-0.1,0.5-0.3,0.5-0.6c0-0.3-0.1-0.4-0.3-0.5c-0.1-0.1-0.2-0.1-0.3-0.1c-0.7,0-0.6-1,0.1-1\r\n\tc0.1,0,0.3,0,0.4-0.1c0.2-0.1,0.3-0.2,0.3-0.6c0-0.3-0.1-0.5-0.4-0.6c-0.2-0.1-0.3-0.1-0.4-0.1C12.6,9.3,12.5,8.4,13.1,8.3z\r\n\t M12.7,5.9c1.2,0,2,0.6,2,1.6c0,0.4-0.1,0.8-0.4,1C14.8,8.9,15,9.4,15,10c0,0.6-0.2,1-0.6,1.3c0.2,0.3,0.3,0.6,0.3,1\r\n\tc0,0.7-0.3,1.2-0.9,1.4c0.1,0.2,0.2,0.4,0.2,0.7c0,1.2-0.9,1.6-3,1.6H8c-1,0-1.7-0.2-2.6-0.6c-0.1,0-0.3-0.1-0.3-0.1\r\n\tc-0.1,0-0.2-0.1-0.3-0.1C4.3,15,4,15,3.6,15H1.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.4-0.4-0.7-0.8C0.2,13.4,0,12.5,0,11.4\r\n\tc0-1.1,0.2-2.1,0.4-2.9c0.2-0.5,0.3-0.8,0.4-1C0.9,7.4,1,7.3,1.2,7.3c0.1,0,0.4-0.1,0.7-0.2C2.4,6.8,3,6.6,3.5,6.3\r\n\tC4,6,4.4,5.7,4.7,5.4c1.2-1.2,2-3.1,2.1-4.6c0-0.5,0.5-0.9,1-0.8c1.2,0.2,2,1.1,2,3.1c0,0.3,0,0.6-0.1,0.9c0,0.4-0.1,0.9-0.2,1.4\r\n\tc0,0.2-0.1,0.4-0.1,0.5H12.7z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-linkedin",
  "use": "icon-linkedin-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-linkedin\">\r\n  <title>linledin</title>\r\n  <path d=\"M14.82,0H1.18A1.17,1.17,0,0,0,0,1.15V14.85A1.17,1.17,0,0,0,1.18,16H14.82A1.17,1.17,0,0,0,16,14.85V1.15A1.17,1.17,0,0,0,14.82,0ZM4.75,13.63H2.37V6H4.75ZM3.56,5A1.38,1.38,0,1,1,3.48,2.2h.07A1.38,1.38,0,0,1,3.56,5Zm10.08,8.68H11.26V9.92c0-.89,0-2-1.23-2s-1.42,1-1.42,2v3.78H6.24V6H8.51V7h0a2.49,2.49,0,0,1,2.25-1.23c2.4,0,2.85,1.58,2.85,3.64Z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"icon-minus\"><path d=\"M12.5,0A12.5,12.5,0,1,0,25,12.5,12.52,12.52,0,0,0,12.5,0Zm0,22A9.5,9.5,0,1,1,22,12.5,9.51,9.51,0,0,1,12.5,22Z\" /><polygon points=\"18.12 11 18.12 14 6.88 13.99 6.88 11 18.12 11\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-notice",
  "use": "icon-notice-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"icon-notice\">\r\n  <title>notice</title>\r\n  <path d=\"M8,0,0,14H16ZM8,2l6.28,11H1.72Zm-.79,8.42H8.84V12H7.21ZM8.85,5V6.84l-.36,3H7.57l-.37-3V5Z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-outlook",
  "use": "icon-outlook-usage",
  "viewBox": "12 12 37 37",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"12 12 37 37\" id=\"icon-outlook\">\r\n\r\n    <g stroke=\"none\" stroke-width=\"1\">\r\n        <g fill=\"#0072C6\" transform=\"translate(13.000000, 12.000000)\">\r\n            <path d=\"M22,8 L22,15.3641625 L24.4012995,16.9846178 C24.4646305,17.0044139 24.6018474,17.0058287 24.6651784,16.9846178 L35,9.51723249 C35,8.63347624 34.2307922,8 33.7967131,8 L22,8 Z\" id=\"icon-outlook_path3\" /><path d=\"M22.0013192,17.3927246 L24.1923898,18.9414533 C24.5010656,19.1749163 24.8730597,18.9414533 24.8730597,18.9414533 C24.5023848,19.1749163 35,12 35,12 L35,24.9924895 C35,26.4068412 34.1201421,27 33.1307973,27 L22,27 L22,17.3927246 L22.0013192,17.3927246 Z\" id=\"icon-outlook_path5\" /><path d=\"M10.5517241,14 C9.77103448,14 9.14896552,14.3677843 8.68965517,15.1019703 C8.23034483,15.8361562 8,16.8081576 8,18.0179744 C8,19.2457656 8.23034483,20.2163844 8.68965517,20.9298306 C9.14896552,21.6446595 9.75172414,22 10.4965517,22 C11.2648276,22 11.8744828,21.6529554 12.3241379,20.9588662 C12.7737931,20.264777 13,19.3010716 13,18.0691324 C13,16.7846526 12.782069,15.7849983 12.3448276,15.0701694 C11.9075862,14.3567231 11.3103448,14 10.5517241,14 Z\" id=\"icon-outlook_path25\" /><path d=\"M1.2033385e-15,4.05633803 L1.2033385e-15,31.6056338 L21,36 L21,0 L0,4.05633803 L1.2033385e-15,4.05633803 Z M14.0523871,22.488338 C13.1649677,23.6538592 12.0079355,24.2379718 10.5799355,24.2379718 C9.18851613,24.2379718 8.05587097,23.6727887 7.17929032,22.5437746 C6.30406452,21.4134085 5.86509677,19.9423099 5.86509677,18.1277746 C5.86509677,16.211831 6.30948387,14.6623099 7.1996129,13.4792113 C8.08974194,12.2961127 9.26845161,11.7038873 10.7357419,11.7038873 C12.1217419,11.7038873 13.2435484,12.2690704 14.0984516,13.4021408 C14.9547097,14.5352113 15.3828387,16.0279437 15.3828387,17.8816901 C15.3841935,19.7868169 14.9398065,21.3228169 14.0523871,22.488338 Z\" id=\"icon-outlook_path27\" />\r\n        </g>\r\n    </g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-pdf",
  "use": "icon-pdf-usage",
  "viewBox": "0 0 21 24",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 24\" id=\"icon-pdf\"><path d=\"M5.55,12.3c0-.65-.44-1-1.23-1a2.65,2.65,0,0,0-.65.06V13.4a2.4,2.4,0,0,0,.52,0C5,13.44,5.55,13,5.55,12.3Zm4.84-1a3.23,3.23,0,0,0-.71.06v4.6a2.82,2.82,0,0,0,.55,0,2.17,2.17,0,0,0,2.35-2.46A2,2,0,0,0,10.39,11.29Zm9.28-2.7H19.1V5.8a.41.41,0,0,0,0-.05.47.47,0,0,0-.11-.3L14.41.16h0L14.32.08l0,0L14.2,0H2.83A.94.94,0,0,0,1.9.94V8.58H1.33A1.34,1.34,0,0,0,0,9.93v7a1.34,1.34,0,0,0,1.33,1.35H1.9v4.79a.94.94,0,0,0,.93.94H18.17a.94.94,0,0,0,.93-.94V18.27h.57A1.34,1.34,0,0,0,21,16.93v-7A1.34,1.34,0,0,0,19.67,8.58ZM2.83.94H13.6V5.76a.47.47,0,0,0,.46.47h4.11V8.58H2.83ZM14.24,13.47a3.58,3.58,0,0,1-1.15,2.85,4.94,4.94,0,0,1-3.2.91,13.49,13.49,0,0,1-1.78-.1v-6.9a13.88,13.88,0,0,1,2.12-.15,4.43,4.43,0,0,1,2.84.75A3.12,3.12,0,0,1,14.24,13.47ZM2.12,17.15V10.21a12.75,12.75,0,0,1,2.12-.15,3.3,3.3,0,0,1,2.12.56,2.06,2.06,0,0,1,.74,1.63,2.26,2.26,0,0,1-.64,1.67,3.19,3.19,0,0,1-2.26.74,3.88,3.88,0,0,1-.54,0v2.51H2.12ZM18.17,22.8H2.83V18.27H18.17V22.8Zm1.35-11.38H16.85V13h2.49v1.29H16.85v2.83H15.27v-7h4.24Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-play-circle",
  "use": "icon-play-circle-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"icon-play-circle\">\r\n<path d=\"M6,11c2.8,0,5-2.3,5-5S8.8,1,6,1S1,3.2,1,6S3.2,11,6,11z M6,12c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S9.3,12,6,12z M4.2,2.6\r\n\tL9,6L4.2,9.4V2.6z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 60 60\" id=\"icon-play\"><title>play</title><path d=\"M30,60A30,30,0,1,1,60,30,30,30,0,0,1,30,60Zm0-4.44A25.56,25.56,0,1,0,4.44,30,25.57,25.57,0,0,0,30,55.56Z\" fill=\"#fff\" fill-opacity=\"0.4\" /><path d=\"M30,55.56A25.56,25.56,0,1,0,4.44,30,25.57,25.57,0,0,0,30,55.56Z\" fill=\"#091a34\" fill-opacity=\"0.4\" /><path d=\"M21.56,14.2,44,29.88,21.56,45.73Z\" fill=\"#fff\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"icon-plus\"><path d=\"M12.5,0A12.5,12.5,0,1,0,25,12.5,12.52,12.52,0,0,0,12.5,0Zm0,22A9.5,9.5,0,1,1,22,12.5,9.51,9.51,0,0,1,12.5,22Z\" /><polygon class=\"plus-1\" id=\"icon-plus_plus-1\" points=\"18.12 11 18.12 14 6.88 13.99 6.88 11 18.12 11\" /><polygon class=\"plus-2\" id=\"icon-plus_plus-2\" points=\"11 6.88 14 6.88 13.99 18.12 11 18.12 11 6.88\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-png",
  "use": "icon-png-usage",
  "viewBox": "0 0 21 24",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 24\" id=\"icon-png\"><path d=\"M5,12.06c0-.61-.42-1-1.16-1a2.48,2.48,0,0,0-.61.06v2a2.24,2.24,0,0,0,.5,0C4.47,13.14,5,12.74,5,12.06ZM19.67,8.58H19.1V5.8a.41.41,0,0,0,0-.05.47.47,0,0,0-.11-.3L14.41.16h0L14.32.08l0,0L14.2,0H2.83A.94.94,0,0,0,1.9.94V8.58H1.33A1.34,1.34,0,0,0,0,9.93v7a1.34,1.34,0,0,0,1.33,1.35H1.9v4.79a.94.94,0,0,0,.93.94H18.17a.94.94,0,0,0,.93-.94V18.27h.57A1.34,1.34,0,0,0,21,16.93v-7A1.34,1.34,0,0,0,19.67,8.58ZM2.83.94H13.6V5.76a.47.47,0,0,0,.46.47h4.11V8.58H2.83Zm5.9,13.69v2H7.37V10H9.1l1.36,2.43a19.25,19.25,0,0,1,1.07,2.27h0a24.92,24.92,0,0,1-.13-2.76V10H12.8v6.63H11.24l-1.4-2.56A24.73,24.73,0,0,1,8.7,11.73h0C8.71,12.62,8.73,13.55,8.73,14.63Zm-7,2V10.09a12,12,0,0,1,2-.14,3.11,3.11,0,0,1,2,.53A2,2,0,0,1,6.43,12a2.13,2.13,0,0,1-.6,1.57,3,3,0,0,1-2.13.7,3.73,3.73,0,0,1-.51,0v2.37H1.72ZM18.17,22.8H2.83V18.27H18.17V22.8Zm1.38-6.48a7.26,7.26,0,0,1-2.19.37,3.62,3.62,0,0,1-2.66-.9,3.23,3.23,0,0,1-.92-2.41c0-2.2,1.59-3.46,3.74-3.46a4.46,4.46,0,0,1,1.82.32L19,11.46a3.59,3.59,0,0,0-1.53-.29,2,2,0,0,0-2.17,2.14,2,2,0,0,0,2.06,2.17,2,2,0,0,0,.73-.1V14h-1V12.83h2.44v3.49Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-quote-close",
  "use": "icon-quote-close-usage",
  "viewBox": "0 0 33 25",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 25\" id=\"icon-quote-close\"><path d=\"M20.93,25l-.8-1.64a32.27,32.27,0,0,0,4.72-3.88q3.2-3.29,3.2-6,0-1.64-1.45-1.64H25a5.3,5.3,0,0,1-3.42-1.1,5.63,5.63,0,0,1-2-4.71A5.87,5.87,0,0,1,21.3,1.62,5.91,5.91,0,0,1,25.59,0a6.4,6.4,0,0,1,5.56,2.57A9.89,9.89,0,0,1,33,8.51a15.49,15.49,0,0,1-4.58,10.9A33.72,33.72,0,0,1,20.93,25ZM1.31,25l-.8-1.64a32.27,32.27,0,0,0,4.72-3.88q3.2-3.29,3.2-6,0-1.64-1.45-1.64H5.38A5.3,5.3,0,0,1,2,10.75,5.63,5.63,0,0,1,0,6,5.87,5.87,0,0,1,1.67,1.62,5.91,5.91,0,0,1,6,0a6.4,6.4,0,0,1,5.56,2.57,9.89,9.89,0,0,1,1.85,5.93A15.49,15.49,0,0,1,8.8,19.4,33.72,33.72,0,0,1,1.31,25Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-quote-open",
  "use": "icon-quote-open-usage",
  "viewBox": "0 0 33 25",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 25\" id=\"icon-quote-open\"><path d=\"M12.07,0l.8,1.64A32.27,32.27,0,0,0,8.14,5.53q-3.2,3.29-3.2,6,0,1.64,1.45,1.64H8a5.3,5.3,0,0,1,3.42,1.1,5.63,5.63,0,0,1,2,4.71,5.87,5.87,0,0,1-1.67,4.42A5.91,5.91,0,0,1,7.41,25a6.4,6.4,0,0,1-5.56-2.57A9.89,9.89,0,0,1,0,16.49,15.49,15.49,0,0,1,4.58,5.6,33.72,33.72,0,0,1,12.07,0ZM31.69,0l.8,1.64a32.27,32.27,0,0,0-4.72,3.88q-3.2,3.29-3.2,6,0,1.64,1.45,1.64h1.6A5.3,5.3,0,0,1,31,14.25,5.63,5.63,0,0,1,33,19a5.66,5.66,0,0,1-6,6,6.4,6.4,0,0,1-5.56-2.57,9.89,9.89,0,0,1-1.85-5.93A15.49,15.49,0,0,1,24.2,5.6,33.72,33.72,0,0,1,31.69,0Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-quote-square-close",
  "use": "icon-quote-square-close-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 12\" id=\"icon-quote-square-close\">\r\n<path id=\"icon-quote-square-close__x201C_-copy\" d=\"M16,0v6.4L13.3,12h-3.3l1.3-5.3H9V0H16z M7,0v6.4L4.3,12H1.1l1.3-5.3H0V0H7z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-quote-square-open",
  "use": "icon-quote-square-open-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 12\" id=\"icon-quote-square-open\">\r\n<path id=\"icon-quote-square-open__x201C_-copy\" d=\"M0,12V5.6L2.7,0h3.3L4.6,5.3H7V12H0z M9,12V5.6L11.7,0h3.3l-1.3,5.3H16V12H9z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-reply",
  "use": "icon-reply-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-reply\">\r\n<path d=\"M2.8,16l-0.3-3.2H0V0h16v12.8H7.3L2.8,16z M1,11.8h2.4l0.2,2.4l3.3-2.4H15V1H1V11.8z M3,5h2v2H3V5z M7,5h2v2H7V5z M11,5h2v2\r\n\th-2V5z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-report",
  "use": "icon-report-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 14\" id=\"icon-report\">\r\n<path d=\"M16,14H0L8,0L16,14z M1.7,13h12.6L8,2L1.7,13z M7.6,9.8l-0.4-3V5h1.6v1.8l-0.4,3H7.6z M7.2,12v-1.6h1.6V12H7.2z\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 24.96 33.7",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24.96 33.7\" id=\"icon-search\"><path d=\"M23.08,19.1a12.51,12.51,0,0,0-4-17.2,12.45,12.45,0,0,0-17.2,4,12.51,12.51,0,0,0,4,17.2,12.29,12.29,0,0,0,6.6,1.9,8.63,8.63,0,0,0,2.8-.4L19,33.7h4.4l-4.3-10.6A11.78,11.78,0,0,0,23.08,19.1Zm-15.2.8A8.75,8.75,0,0,1,4,14.4a8.12,8.12,0,0,1,1.1-6.6,8.63,8.63,0,0,1,7.4-4.1A9.4,9.4,0,0,1,17.08,5,8.75,8.75,0,0,1,21,10.5a8.12,8.12,0,0,1-1.1,6.6,8.63,8.63,0,0,1-7.4,4.1A7.68,7.68,0,0,1,7.88,19.9Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-tick",
  "use": "icon-tick-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 15\" id=\"icon-tick\">\r\n    <polygon points=\"6.3,9.5 12.7,0 16,2.2 7.4,15 0,10.1 2.2,6.8 \" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-twitter",
  "use": "icon-twitter-usage",
  "viewBox": "0 0 32 26",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 26\" id=\"icon-twitter\"><path d=\"M10.05,26C22.13,26,28.73,16,28.73,7.33c0-.28,0-.56,0-.84A13.37,13.37,0,0,0,32,3.08a13.32,13.32,0,0,1-3.78,1A6.6,6.6,0,0,0,31.12.49a13.07,13.07,0,0,1-4.17,1.59A6.57,6.57,0,0,0,15.58,6.56a7.25,7.25,0,0,0,.17,1.5A18.65,18.65,0,0,1,2.22,1.2a6.58,6.58,0,0,0,2,8.76,6.65,6.65,0,0,1-3-.82v.09a6.58,6.58,0,0,0,5.26,6.44,6.61,6.61,0,0,1-3,.12,6.57,6.57,0,0,0,6.13,4.56,13.18,13.18,0,0,1-8.16,2.81A12.65,12.65,0,0,1,0,23.07,18.69,18.69,0,0,0,10.05,26\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 10\" id=\"icon-user\"><title>user</title><path d=\"M6,0A5.9,5.9,0,0,0,0,5.8,5.69,5.69,0,0,0,1.86,10,4.6,4.6,0,0,1,6,7.48,4.6,4.6,0,0,1,10.14,10,5.69,5.69,0,0,0,12,5.8,5.9,5.9,0,0,0,6,0ZM6,6.81A2.38,2.38,0,0,1,3.58,4.47,2.38,2.38,0,0,1,6,2.13,2.38,2.38,0,0,1,8.42,4.47,2.38,2.38,0,0,1,6,6.81Z\" fill=\"#6b7685\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-verified",
  "use": "icon-verified-usage",
  "viewBox": "0 0 23.87 23.74",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23.87 23.74\" id=\"icon-verified\">\r\n  <title>verified</title>\r\n  <g>\r\n    <path d=\"M11.93,21.14l-2.49,2.6L8.22,20.35,4.88,21.71l.26-3.59L1.54,18l1.7-3.18L0,13.25,2.85,11,.52,8.29,4,7.43,3,4l3.55.64L7.05,1l3,2L11.93,0l1.9,3.06,3-2,.49,3.57L20.85,4l-1,3.46,3.5.86L21,11l2.84,2.21-3.24,1.57L22.33,18l-3.6.11L19,21.71l-3.34-1.36-1.22,3.39Z\" fill=\"#48c2c5\" />\r\n    <path d=\"M11,13.42l3.61-5.36,1.85,1.25L11.59,16.5,7.43,13.76l1.22-1.87Z\" fill=\"#fff\" />\r\n  </g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-xls",
  "use": "icon-xls-usage",
  "viewBox": "0 0 21 24",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 24\" id=\"icon-xls\"><path d=\"M19.67,8.58H19.1V5.8a.46.46,0,0,0,0-.05.47.47,0,0,0-.11-.3L14.41.16h0L14.32.08l0,0L14.2,0H2.83A.94.94,0,0,0,1.9.94V8.58H1.33A1.34,1.34,0,0,0,0,9.93v7a1.34,1.34,0,0,0,1.33,1.35H1.9v4.79a.94.94,0,0,0,.93.94H18.17a.94.94,0,0,0,.93-.94V18.27h.57A1.34,1.34,0,0,0,21,16.93v-7A1.34,1.34,0,0,0,19.67,8.58ZM2.83.94H13.6V5.76a.47.47,0,0,0,.46.47h4.11V8.58H2.83Zm10.43,14.5V16.8H8.83V9.62h1.61v5.82ZM1.84,16.8,3.9,13.17l-2-3.55H3.76l.62,1.31c.21.44.37.79.54,1.19h0c.17-.46.31-.78.48-1.19L6,9.62H7.86l-2,3.51L8,16.8H6.11l-.64-1.3c-.26-.5-.43-.87-.63-1.29h0c-.15.42-.33.79-.55,1.29l-.59,1.3H1.84Zm16.33,6H2.83V18.27H18.17V22.8Zm-2.22-5.89a4.6,4.6,0,0,1-2-.44l.33-1.34a4.06,4.06,0,0,0,1.78.45c.74,0,1.13-.31,1.13-.78s-.34-.7-1.19-1C14.8,13.37,14,12.71,14,11.66c0-1.23,1-2.16,2.69-2.16a4.31,4.31,0,0,1,1.81.36l-.36,1.31a3.34,3.34,0,0,0-1.49-.34c-.7,0-1,.32-1,.69s.4.66,1.32,1c1.25.47,1.84,1.13,1.84,2.14C18.82,15.89,17.9,16.91,15.95,16.91Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-yahoo",
  "use": "icon-yahoo-usage",
  "viewBox": "0 0 342 449",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 342 449\" id=\"icon-yahoo\">\r\n<g>\r\n\t<path fill=\"#6A1B9A\" d=\"M330.7,0h-53.3c-3.9,0-7.5,2.1-9.3,5.5l-97.3,175.2L73.3,5.5C71.5,2.1,67.9,0,64,0H10.7C4.8,0,0,4.8,0,10.7\r\n\t\tc0,1.8,0.5,3.7,1.4,5.3l137.1,242.6L128,436.7c-0.3,5.9,4.1,10.9,10,11.3c0.2,0,0.4,0,0.6,0h64c5.9,0,10.7-4.8,10.7-10.6\r\n\t\tc0-0.2,0-0.4,0-0.6l-10.5-178.2L340,15.9c2.9-5.1,1.1-11.6-4-14.5C334.3,0.5,332.5,0,330.7,0z\" />\r\n</g>\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-youtube",
  "use": "icon-youtube-usage",
  "viewBox": "0 0 32 22.5",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 22.5\" id=\"icon-youtube\"><path d=\"M31.68,4.86A6.92,6.92,0,0,0,30.4,1.68,4.58,4.58,0,0,0,27.2.32C22.72,0,16,0,16,0h0S9.28,0,4.8.32A4.58,4.58,0,0,0,1.6,1.68,6.92,6.92,0,0,0,.32,4.86,48.4,48.4,0,0,0,0,10v2.46a48.4,48.4,0,0,0,.32,5.18A6.92,6.92,0,0,0,1.6,20.82a5.42,5.42,0,0,0,3.52,1.36c2.56.24,10.88.32,10.88.32s6.72,0,11.2-.34a4.58,4.58,0,0,0,3.2-1.36,6.92,6.92,0,0,0,1.28-3.18A48.46,48.46,0,0,0,32,12.46V10a48.46,48.46,0,0,0-.32-5.18M12.7,15.4v-9l8.64,4.52Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./account.svg": 259,
	"./apple.svg": 260,
	"./arrow-red.svg": 261,
	"./arrow-right-circle.svg": 262,
	"./arrow-right-solid.svg": 263,
	"./arrow.svg": 264,
	"./aya.svg": 265,
	"./bootroom.svg": 266,
	"./bye_tag.svg": 267,
	"./calendar.svg": 268,
	"./camera.svg": 269,
	"./check.svg": 270,
	"./chevron-down-thin.svg": 271,
	"./chevron-down.svg": 272,
	"./chevron-left-thin.svg": 273,
	"./chevron-left.svg": 274,
	"./chevron-right-circle.svg": 275,
	"./chevron-right-thin.svg": 276,
	"./chevron-right.svg": 277,
	"./close-thin.svg": 278,
	"./close.svg": 279,
	"./doc.svg": 280,
	"./download.svg": 281,
	"./edit.svg": 282,
	"./external.svg": 283,
	"./facebook.svg": 284,
	"./fail.svg": 285,
	"./gif.svg": 286,
	"./google-calendar.svg": 287,
	"./google-plus.svg": 288,
	"./hive-learning.svg": 289,
	"./info.svg": 290,
	"./instagram-general.svg": 291,
	"./instagram.svg": 292,
	"./jpg.svg": 293,
	"./like.svg": 294,
	"./linkedin.svg": 295,
	"./minus.svg": 296,
	"./notice.svg": 297,
	"./outlook.svg": 298,
	"./pdf.svg": 299,
	"./play-circle.svg": 300,
	"./play.svg": 301,
	"./plus.svg": 302,
	"./png.svg": 303,
	"./quote-close.svg": 304,
	"./quote-open.svg": 305,
	"./quote-square-close.svg": 306,
	"./quote-square-open.svg": 307,
	"./reply.svg": 308,
	"./report.svg": 309,
	"./search.svg": 310,
	"./tick.svg": 311,
	"./twitter.svg": 312,
	"./user.svg": 313,
	"./verified.svg": 314,
	"./xls.svg": 315,
	"./yahoo.svg": 316,
	"./youtube.svg": 317
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 491;

/***/ }),
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ResponsiveImage = function (_Snappy$BaseComponent) {
    _inherits(ResponsiveImage, _Snappy$BaseComponent);

    _createClass(ResponsiveImage, null, [{
        key: 'tagName',
        get: function get() {
            return 'responsive-image';
        }
    }]);

    function ResponsiveImage(element) {
        _classCallCheck(this, ResponsiveImage);

        return _possibleConstructorReturn(this, (ResponsiveImage.__proto__ || Object.getPrototypeOf(ResponsiveImage)).call(this, element));
    }

    _createClass(ResponsiveImage, [{
        key: 'setOptions',
        value: function setOptions() {
            this.Options = {
                smallImage: this.$element.data('small-image'),
                mediumImage: this.$element.data('medium-image'),
                image: this.$element.data('image'),
                largeImage: this.$element.data('large-image')
            };
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            window.addEventListener('resize', this.loadImage.bind(this));
        }
    }, {
        key: 'loadImage',
        value: function loadImage() {
            var defaults = {};
            var settings = _jquery2.default.extend(this.Options, defaults);

            if ((0, _jquery2.default)(window).width() <= 360) {
                this.$element.find("img").attr("src", settings.smallImage);
            } else if ((0, _jquery2.default)(window).width() <= 670 && (0, _jquery2.default)(window).width() > 361) {
                this.$element.find("img").attr("src", settings.mediumImage);
            } else if ((0, _jquery2.default)(window).width() <= 1440 && (0, _jquery2.default)(window).width() > 669) {
                this.$element.find("img").attr("src", settings.image);
            } else if ((0, _jquery2.default)(window).width() >= 1441) {
                this.$element.find("img").attr("src", settings.largeImage);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            this.setOptions();
            this.loadImage();
            this.setEventListeners();
        }
    }]);

    return ResponsiveImage;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.SocialShare = function (_Snappy$BaseComponent) {
    _inherits(SocialShare, _Snappy$BaseComponent);

    _createClass(SocialShare, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-social-share';
        }
    }]);

    function SocialShare(element) {
        _classCallCheck(this, SocialShare);

        return _possibleConstructorReturn(this, (SocialShare.__proto__ || Object.getPrototypeOf(SocialShare)).call(this, element));
    }

    _createClass(SocialShare, [{
        key: 'setVars',
        value: function setVars() {
            this.srcBase = 's7.addthis.com/js/300/addthis_widget.js';
            this.defaultHash = '#pubid=ra-582c3c26b5e577a5';
            this.scriptEl = (0, _jquery2.default)('script[src*="s7.addthis.com/js/300/addthis_widget.js"]');
            this.hash = this.$element.data('hash') || this.defaultHash;
            this.$total = this.$element.find('.total-count__number');
            this.currentSection = this.$element.data('currentSection');
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            window.addthis.addEventListener('addthis.ready', this.onAddThisReady.bind(this));
            window.addthis.addEventListener('addthis.menu.share', this.shareEventHandler.bind(this));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            (0, _underscore.bindAll)(this, 'detectAddThisElements');
            this.setVars();

            if (!this.scriptEl.length) {
                this.loadScript().then(function () {
                    _this2.addEventListeners();
                    _this2.fetchTotalShares();
                }).catch(function () {
                    console.log('cannot load script');
                });
            } else {
                this.addEventListeners();
                this.fetchTotalShares();
            }
        }
    }, {
        key: 'fetchTotalShares',
        value: function fetchTotalShares() {
            window.addthis.sharecounters.getShareCounts({ service: 'facebook', countUrl: window.location.href }, this.onShareServiceResponse.bind(this));
        }
    }, {
        key: 'onAddThisReady',
        value: function onAddThisReady() {
            this.detectAddThisElements();
        }
    }, {
        key: 'detectAddThisElements',
        value: function detectAddThisElements() {
            var $elements = this.$element.find('.at-share-btn');

            if ($elements.length) {
                $elements.attr('tabindex', 0);
            } else {
                window.setTimeout(this.detectAddThisElements, 200);
            }
        }
    }, {
        key: 'onShareServiceResponse',
        value: function onShareServiceResponse(data) {
            var content = void 0;
            if (data && data[0].count) {
                content = data[0].count;
            } else {
                content = 0;
            }

            this.$total.text(content);
        }
    }, {
        key: 'shareEventHandler',
        value: function shareEventHandler(e) {
            var data = e.data;
            this.$window.trigger('gtm:send', [this.currentSection, data.service, data.title]);
        }
    }, {
        key: 'loadScript',
        value: function loadScript() {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                setTimeout(function () {
                    var script = document.createElement('script');
                    script.src = '//' + _this3.srcBase + _this3.hash;
                    script.async = true;
                    script.onload = function () {
                        setTimeout(function () {
                            resolve();
                        }, 500);
                    };

                    script.onerror = function () {
                        reject();
                    };

                    document.body.appendChild(script);
                }, 2000);
            });
        }
    }]);

    return SocialShare;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(597);

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _objectFitImages = __webpack_require__(146);

var _objectFitImages2 = _interopRequireDefault(_objectFitImages);

__webpack_require__(12);

__webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _objectFitImages2.default)(document.querySelectorAll('img:not(.lazyload)'));

__webpack_require__(64);
__webpack_require__(65);
__webpack_require__(143);
__webpack_require__(142);
__webpack_require__(144);
__webpack_require__(63);
__webpack_require__(126);
__webpack_require__(115);
__webpack_require__(141);
__webpack_require__(134);
__webpack_require__(60);
__webpack_require__(61);
__webpack_require__(40);
__webpack_require__(41);
__webpack_require__(38);
__webpack_require__(42);
__webpack_require__(135);
__webpack_require__(59);
__webpack_require__(62);
__webpack_require__(118);
__webpack_require__(137);

__webpack_require__(124);
__webpack_require__(58);
__webpack_require__(131);
__webpack_require__(37);

__webpack_require__(39);

__webpack_require__(116);
__webpack_require__(139);

__webpack_require__(125);
__webpack_require__(579);

__webpack_require__(120);

__webpack_require__(85);
__webpack_require__(121);
__webpack_require__(117);
__webpack_require__(133);
__webpack_require__(136);
__webpack_require__(127);
__webpack_require__(138);
__webpack_require__(140);
__webpack_require__(119);
__webpack_require__(571);

_snappy2.default.init();

// exclude some huge svg from the sprite
var files = __webpack_require__(491);
files.keys().forEach(files);

/***/ })
],[607]);


// WEBPACK FOOTER //
// eduhub-from-fa.js